/* EyeDrive vehicle database — loaded by the popup */
window.EYEDRIVE_VEHICLE_DATA = [
  { type: "car", year: 2026, make: "ACURA", model: "ADX" },
  { type: "car", year: 2026, make: "ACURA", model: "ILX" },
  { type: "car", year: 2026, make: "ACURA", model: "Integra" },
  { type: "car", year: 2026, make: "ACURA", model: "MDX" },
  { type: "car", year: 2026, make: "ACURA", model: "RDX" },
  { type: "car", year: 2026, make: "ACURA", model: "RLX" },
  { type: "car", year: 2026, make: "ACURA", model: "TLX" },
  { type: "car", year: 2026, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2026, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2026, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2026, make: "ALFA ROMEO", model: "Tonale" },
  { type: "car", year: 2026, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2026, make: "ASTON MARTIN", model: "DB12" },
  { type: "car", year: 2026, make: "ASTON MARTIN", model: "DBX" },
  { type: "car", year: 2026, make: "ASTON MARTIN", model: "Valhalla" },
  { type: "car", year: 2026, make: "ASTON MARTIN", model: "Valiant" },
  { type: "car", year: 2026, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2026, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2026, make: "AUDI", model: "A3" },
  { type: "car", year: 2026, make: "AUDI", model: "A4" },
  { type: "car", year: 2026, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2026, make: "AUDI", model: "A5" },
  { type: "car", year: 2026, make: "AUDI", model: "A6" },
  { type: "car", year: 2026, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2026, make: "AUDI", model: "A8 L" },
  { type: "car", year: 2026, make: "AUDI", model: "e-tron GT" },
  { type: "car", year: 2026, make: "AUDI", model: "Q3" },
  { type: "car", year: 2026, make: "AUDI", model: "Q4" },
  { type: "car", year: 2026, make: "AUDI", model: "Q5" },
  { type: "car", year: 2026, make: "AUDI", model: "Q6" },
  { type: "car", year: 2026, make: "AUDI", model: "Q7" },
  { type: "car", year: 2026, make: "AUDI", model: "Q8" },
  { type: "car", year: 2026, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2026, make: "AUDI", model: "RS 6 Avant" },
  { type: "car", year: 2026, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2026, make: "AUDI", model: "RS e-tron GT" },
  { type: "car", year: 2026, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2026, make: "AUDI", model: "S e-tron GT" },
  { type: "car", year: 2026, make: "AUDI", model: "S3" },
  { type: "car", year: 2026, make: "AUDI", model: "S4" },
  { type: "car", year: 2026, make: "AUDI", model: "S5" },
  { type: "car", year: 2026, make: "AUDI", model: "S8" },
  { type: "car", year: 2026, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2026, make: "AUDI", model: "SQ6" },
  { type: "car", year: 2026, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2026, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2026, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2026, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2026, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2026, make: "BMW", model: "228" },
  { type: "car", year: 2026, make: "BMW", model: "230i" },
  { type: "car", year: 2026, make: "BMW", model: "330i" },
  { type: "car", year: 2026, make: "BMW", model: "430i" },
  { type: "car", year: 2026, make: "BMW", model: "530i" },
  { type: "car", year: 2026, make: "BMW", model: "540i" },
  { type: "car", year: 2026, make: "BMW", model: "550e" },
  { type: "car", year: 2026, make: "BMW", model: "740i" },
  { type: "car", year: 2026, make: "BMW", model: "750e" },
  { type: "car", year: 2026, make: "BMW", model: "760i" },
  { type: "car", year: 2026, make: "BMW", model: "840i" },
  { type: "car", year: 2026, make: "BMW", model: "i4" },
  { type: "car", year: 2026, make: "BMW", model: "i5" },
  { type: "car", year: 2026, make: "BMW", model: "i7" },
  { type: "car", year: 2026, make: "BMW", model: "iX" },
  { type: "car", year: 2026, make: "BMW", model: "M2" },
  { type: "car", year: 2026, make: "BMW", model: "M235" },
  { type: "car", year: 2026, make: "BMW", model: "M240i" },
  { type: "car", year: 2026, make: "BMW", model: "M3" },
  { type: "car", year: 2026, make: "BMW", model: "M340i" },
  { type: "car", year: 2026, make: "BMW", model: "M4" },
  { type: "car", year: 2026, make: "BMW", model: "M440i" },
  { type: "car", year: 2026, make: "BMW", model: "M5" },
  { type: "car", year: 2026, make: "BMW", model: "M850i" },
  { type: "car", year: 2026, make: "BMW", model: "X1" },
  { type: "car", year: 2026, make: "BMW", model: "X2" },
  { type: "car", year: 2026, make: "BMW", model: "X3" },
  { type: "car", year: 2026, make: "BMW", model: "X5" },
  { type: "car", year: 2026, make: "BMW", model: "X6" },
  { type: "car", year: 2026, make: "BMW", model: "X7" },
  { type: "car", year: 2026, make: "BMW", model: "XM" },
  { type: "car", year: 2026, make: "BMW", model: "Z4" },
  { type: "car", year: 2026, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2026, make: "BUGATTI", model: "Mistral" },
  { type: "car", year: 2026, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2026, make: "BUICK", model: "Encore" },
  { type: "car", year: 2026, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2026, make: "BUICK", model: "Envision" },
  { type: "car", year: 2026, make: "BUICK", model: "Envista" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Celestiq" },
  { type: "car", year: 2026, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2026, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2026, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Escalade IQ" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Escalade IQL" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Lyriq" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Optiq" },
  { type: "car", year: 2026, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2026, make: "CADILLAC", model: "Vistiq" },
  { type: "car", year: 2026, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2026, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2026, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Onix" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Suburban HD" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Traverse Limited" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2026, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2026, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2026, make: "CHRYSLER", model: "Grand Caravan" },
  { type: "car", year: 2026, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2026, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2026, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2026, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2026, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2026, make: "DODGE", model: "Charger" },
  { type: "car", year: 2026, make: "DODGE", model: "Durango" },
  { type: "car", year: 2026, make: "DODGE", model: "Hornet" },
  { type: "car", year: 2026, make: "FERRARI", model: "12Cilindri" },
  { type: "car", year: 2026, make: "FERRARI", model: "296" },
  { type: "car", year: 2026, make: "FERRARI", model: "296 Speciale" },
  { type: "car", year: 2026, make: "FERRARI", model: "296 Speciale A" },
  { type: "car", year: 2026, make: "FERRARI", model: "849 Testarossa" },
  { type: "car", year: 2026, make: "FERRARI", model: "F80" },
  { type: "car", year: 2026, make: "FERRARI", model: "Purosangue" },
  { type: "car", year: 2026, make: "FERRARI", model: "Roma" },
  { type: "car", year: 2026, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2026, make: "FIAT", model: "500e" },
  { type: "car", year: 2026, make: "FIAT", model: "500X" },
  { type: "car", year: 2026, make: "FISKER", model: "Karma" },
  { type: "car", year: 2026, make: "FISKER", model: "Nina" },
  { type: "car", year: 2026, make: "FISKER", model: "Ocean" },
  { type: "car", year: 2026, make: "FORD", model: "'34" },
  { type: "car", year: 2026, make: "FORD", model: "Bronco" },
  { type: "car", year: 2026, make: "FORD", model: "Bronco Sport" },
  { type: "car", year: 2026, make: "FORD", model: "E-350" },
  { type: "car", year: 2026, make: "FORD", model: "E-450" },
  { type: "car", year: 2026, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2026, make: "FORD", model: "Edge" },
  { type: "car", year: 2026, make: "FORD", model: "Escape" },
  { type: "car", year: 2026, make: "FORD", model: "Expedition" },
  { type: "car", year: 2026, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2026, make: "FORD", model: "Explorer" },
  { type: "car", year: 2026, make: "FORD", model: "F-150" },
  { type: "car", year: 2026, make: "FORD", model: "F-250" },
  { type: "car", year: 2026, make: "FORD", model: "F-350" },
  { type: "car", year: 2026, make: "FORD", model: "F-450" },
  { type: "car", year: 2026, make: "FORD", model: "F-550" },
  { type: "car", year: 2026, make: "FORD", model: "F-600" },
  { type: "car", year: 2026, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2026, make: "FORD", model: "Flex" },
  { type: "car", year: 2026, make: "FORD", model: "Focus" },
  { type: "car", year: 2026, make: "FORD", model: "GT MKII" },
  { type: "car", year: 2026, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2026, make: "FORD", model: "Mustang" },
  { type: "car", year: 2026, make: "FORD", model: "Mustang GTD" },
  { type: "car", year: 2026, make: "FORD", model: "Mustang Mach-E" },
  { type: "car", year: 2026, make: "FORD", model: "Ranger" },
  { type: "car", year: 2026, make: "FORD", model: "Transit" },
  { type: "car", year: 2026, make: "GMC", model: "Acadia" },
  { type: "car", year: 2026, make: "GMC", model: "Canyon" },
  { type: "car", year: 2026, make: "GMC", model: "Cruise Origin AV" },
  { type: "car", year: 2026, make: "GMC", model: "Hummer EV SUV" },
  { type: "car", year: 2026, make: "GMC", model: "Savana" },
  { type: "car", year: 2026, make: "GMC", model: "Sierra" },
  { type: "car", year: 2026, make: "GMC", model: "Terrain" },
  { type: "car", year: 2026, make: "GMC", model: "Yukon" },
  { type: "car", year: 2026, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2026, make: "HONDA", model: "Accord" },
  { type: "car", year: 2026, make: "HONDA", model: "Civic" },
  { type: "car", year: 2026, make: "HONDA", model: "Civic Si" },
  { type: "car", year: 2026, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2026, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2026, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2026, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2026, make: "HONDA", model: "Passport" },
  { type: "car", year: 2026, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2026, make: "HONDA", model: "Prelude" },
  { type: "car", year: 2026, make: "HONDA", model: "Prologue" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Elantra N" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Ioniq 5" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Ioniq 5 N" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Ioniq 6" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Ioniq 6 N" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Ioniq 9" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Kona N" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2026, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2026, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2026, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2026, make: "INFINITI", model: "QX55" },
  { type: "car", year: 2026, make: "INFINITI", model: "QX60" },
  { type: "car", year: 1981, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1982, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1983, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1984, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1985, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1986, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1987, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1988, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1989, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1990, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1991, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1992, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1993, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1994, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1995, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1996, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1997, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1998, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 1999, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2000, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2001, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2002, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2003, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2004, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2005, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2006, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2007, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2008, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2009, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2010, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2011, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2012, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2013, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2014, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2015, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2016, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2017, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2018, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2019, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2020, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2021, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2022, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2023, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2024, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2025, make: "RANGE ROVER", model: "Range Rover" },
{ type: "car", year: 2026, make: "RANGE ROVER", model: "Range Rover" },

{ type: "car", year: 2005, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2006, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2007, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2008, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2009, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2010, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2011, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2012, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2013, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2014, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2015, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2016, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2017, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2018, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2019, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2020, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2021, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2022, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2023, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2024, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2025, make: "RANGE ROVER", model: "Range Rover Sport" },
{ type: "car", year: 2026, make: "RANGE ROVER", model: "Range Rover Sport" },

{ type: "car", year: 2011, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2012, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2013, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2014, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2015, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2016, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2017, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2018, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2019, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2020, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2021, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2022, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2023, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2024, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2025, make: "RANGE ROVER", model: "Range Rover Evoque" },
{ type: "car", year: 2026, make: "RANGE ROVER", model: "Range Rover Evoque" },

{ type: "car", year: 2017, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2018, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2019, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2020, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2021, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2022, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2023, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2024, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2025, make: "RANGE ROVER", model: "Range Rover Velar" },
{ type: "car", year: 2026, make: "RANGE ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2026, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2026, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2026, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2026, make: "JEEP", model: "Compass" },
  { type: "car", year: 2026, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2026, make: "JEEP", model: "Grand Cherokee L" },
  { type: "car", year: 2026, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 2026, make: "JEEP", model: "Grand Wagoneer L" },
  { type: "car", year: 2026, make: "JEEP", model: "Recon" },
  { type: "car", year: 2026, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2026, make: "JEEP", model: "Wagoneer S" },
  { type: "car", year: 2026, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2026, make: "KARMA", model: "GS-6" },
  { type: "car", year: 2026, make: "KARMA", model: "Gyesera" },
  { type: "car", year: 2026, make: "KARMA", model: "Kaveya" },
  { type: "car", year: 2026, make: "KARMA", model: "Revero" },
  { type: "car", year: 2026, make: "KIA", model: "Carnival" },
  { type: "car", year: 2026, make: "KIA", model: "EV6" },
  { type: "car", year: 2026, make: "KIA", model: "EV9" },
  { type: "car", year: 2026, make: "KIA", model: "Forte" },
  { type: "car", year: 2026, make: "KIA", model: "K4" },
  { type: "car", year: 2026, make: "KIA", model: "K5" },
  { type: "car", year: 2026, make: "KIA", model: "Niro" },
  { type: "car", year: 2026, make: "KIA", model: "Seltos" },
  { type: "car", year: 2026, make: "KIA", model: "Sorento" },
  { type: "car", year: 2026, make: "KIA", model: "Soul" },
  { type: "car", year: 2026, make: "KIA", model: "Sportage" },
  { type: "car", year: 2026, make: "KIA", model: "Telluride" },
  { type: "car", year: 2026, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2026, make: "LAMBORGHINI", model: "Revuelto" },
  { type: "car", year: 2026, make: "LAMBORGHINI", model: "Temerario" },
  { type: "car", year: 2026, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2026, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2026, make: "LEXUS", model: "ES" },
  { type: "car", year: 2026, make: "LEXUS", model: "GS" },
  { type: "car", year: 2026, make: "LEXUS", model: "GX" },
  { type: "car", year: 2026, make: "LEXUS", model: "IS" },
  { type: "car", year: 2026, make: "LEXUS", model: "LC" },
  { type: "car", year: 2026, make: "LEXUS", model: "LS" },
  { type: "car", year: 2026, make: "LEXUS", model: "LX" },
  { type: "car", year: 2026, make: "LEXUS", model: "NX" },
  { type: "car", year: 2026, make: "LEXUS", model: "RC" },
  { type: "car", year: 2026, make: "LEXUS", model: "RX" },
  { type: "car", year: 2026, make: "LEXUS", model: "RZ" },
  { type: "car", year: 2026, make: "LEXUS", model: "SC" },
  { type: "car", year: 2026, make: "LEXUS", model: "TX" },
  { type: "car", year: 2026, make: "LEXUS", model: "UX" },
  { type: "car", year: 2026, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2026, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2026, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2026, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2026, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2026, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2026, make: "LOTUS", model: "ELETRE" },
  { type: "car", year: 2026, make: "LOTUS", model: "Emira" },
  { type: "car", year: 2026, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2026, make: "LUCID", model: "Air" },
  { type: "car", year: 2026, make: "LUCID", model: "Gravity" },
  { type: "car", year: 2026, make: "MASERATI", model: "Grancabrio" },
  { type: "car", year: 2026, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2026, make: "MASERATI", model: "Grecale" },
  { type: "car", year: 2026, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2026, make: "MASERATI", model: "MCPura" },
  { type: "car", year: 2026, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2026, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2026, make: "MAZDA", model: "CX-50" },
  { type: "car", year: 2026, make: "MAZDA", model: "CX-70" },
  { type: "car", year: 2026, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2026, make: "MAZDA", model: "CX-90" },
  { type: "car", year: 2026, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2026, make: "MAZDA", model: "MX-30" },
  { type: "car", year: 2026, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2026, make: "MCLAREN", model: "750S" },
  { type: "car", year: 2026, make: "MCLAREN", model: "ARTURA" },
  { type: "car", year: 2026, make: "MCLAREN", model: "GTS" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "CLE" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "EQE-Class Sedan" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "EQE-Class SUV" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "EQS-Class Sedan" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "EQS-Class SUV" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "eSprinter" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2026, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2026, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2026, make: "MINI", model: "Countryman" },
  { type: "car", year: 2026, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2026, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2026, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2026, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2026, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2026, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2026, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2026, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2026, make: "NISSAN", model: "Ariya MPV" },
  { type: "car", year: 2026, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2026, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2026, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2026, make: "NISSAN", model: "Kicks MPV" },
  { type: "car", year: 2026, make: "NISSAN", model: "Kicks Play" },
  { type: "car", year: 2026, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2026, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2026, make: "NISSAN", model: "Nissan Z" },
  { type: "car", year: 2026, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2026, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2026, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2026, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2026, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2026, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2026, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2026, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2026, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2026, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2026, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2026, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2026, make: "PORSCHE", model: "911" },
  { type: "car", year: 2026, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2026, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2026, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2026, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2026, make: "RAM", model: "1500" },
  { type: "car", year: 2026, make: "RAM", model: "2500" },
  { type: "car", year: 2026, make: "RAM", model: "3500" },
  { type: "car", year: 2026, make: "RAM", model: "4500" },
  { type: "car", year: 2026, make: "RAM", model: "5500" },
  { type: "car", year: 2026, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2026, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2026, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2026, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2026, make: "RIVIAN", model: "R1S" },
  { type: "car", year: 2026, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2026, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2026, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2026, make: "ROLLS-ROYCE", model: "Spectre" },
  { type: "car", year: 2026, make: "SAAB", model: "9-3" },
  { type: "car", year: 2026, make: "SAAB", model: "9-5" },
  { type: "car", year: 2026, make: "SHELBY", model: "Cobra" },
  { type: "car", year: 2026, make: "SHELBY", model: "GT" },
  { type: "car", year: 2026, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2026, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2026, make: "SPYKER", model: "C12" },
  { type: "car", year: 2026, make: "SPYKER", model: "C8" },
  { type: "car", year: 2026, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2026, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2026, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2026, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2026, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2026, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2026, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2026, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2026, make: "SUBARU", model: "Solterra" },
  { type: "car", year: 2026, make: "SUBARU", model: "Trailseeker" },
  { type: "car", year: 2026, make: "SUBARU", model: "Uncharted" },
  { type: "car", year: 2026, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2026, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2026, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2026, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2026, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2026, make: "TESLA", model: "Cybercab" },
  { type: "car", year: 2026, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2026, make: "TESLA", model: "Model S" },
  { type: "car", year: 2026, make: "TESLA", model: "Model X" },
  { type: "car", year: 2026, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2026, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2026, make: "TOYOTA", model: "bZ" },
  { type: "car", year: 2026, make: "TOYOTA", model: "bZ Woodland" },
  { type: "car", year: 2026, make: "TOYOTA", model: "C-HR" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Corolla Cross" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Crown" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Crown Signia" },
  { type: "car", year: 2026, make: "TOYOTA", model: "GR Corolla" },
  { type: "car", year: 2026, make: "TOYOTA", model: "GR86" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Grand Highlander" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2026, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2026, make: "TOYOTA", model: "RAV4 Prime (PHEV)" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2026, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2026, make: "VOLVO", model: "EC40" },
  { type: "car", year: 2026, make: "VOLVO", model: "EX30" },
  { type: "car", year: 2026, make: "VOLVO", model: "EX30 CC" },
  { type: "car", year: 2026, make: "VOLVO", model: "EX40" },
  { type: "car", year: 2026, make: "VOLVO", model: "EX90" },
  { type: "car", year: 2026, make: "VOLVO", model: "S60" },
  { type: "car", year: 2026, make: "VOLVO", model: "S90" },
  { type: "car", year: 2026, make: "VOLVO", model: "V60" },
  { type: "car", year: 2026, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2026, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2026, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2026, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2026, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2026, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2025, make: "ACURA", model: "ADX" },
  { type: "car", year: 2025, make: "ACURA", model: "ILX" },
  { type: "car", year: 2025, make: "ACURA", model: "Integra" },
  { type: "car", year: 2025, make: "ACURA", model: "MDX" },
  { type: "car", year: 2025, make: "ACURA", model: "RDX" },
  { type: "car", year: 2025, make: "ACURA", model: "RLX" },
  { type: "car", year: 2025, make: "ACURA", model: "TLX" },
  { type: "car", year: 2025, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2025, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2025, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2025, make: "ALFA ROMEO", model: "Tonale" },
  { type: "car", year: 2025, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2025, make: "ASTON MARTIN", model: "DB12" },
  { type: "car", year: 2025, make: "ASTON MARTIN", model: "DBX" },
  { type: "car", year: 2025, make: "ASTON MARTIN", model: "Valiant" },
  { type: "car", year: 2025, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2025, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2025, make: "AUDI", model: "A3" },
  { type: "car", year: 2025, make: "AUDI", model: "A4" },
  { type: "car", year: 2025, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2025, make: "AUDI", model: "A5" },
  { type: "car", year: 2025, make: "AUDI", model: "A6" },
  { type: "car", year: 2025, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2025, make: "AUDI", model: "A7" },
  { type: "car", year: 2025, make: "AUDI", model: "A8 L" },
  { type: "car", year: 2025, make: "AUDI", model: "e-tron GT" },
  { type: "car", year: 2025, make: "AUDI", model: "Q3" },
  { type: "car", year: 2025, make: "AUDI", model: "Q4" },
  { type: "car", year: 2025, make: "AUDI", model: "Q5" },
  { type: "car", year: 2025, make: "AUDI", model: "Q5 e" },
  { type: "car", year: 2025, make: "AUDI", model: "Q6" },
  { type: "car", year: 2025, make: "AUDI", model: "Q7" },
  { type: "car", year: 2025, make: "AUDI", model: "Q8" },
  { type: "car", year: 2025, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2025, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2025, make: "AUDI", model: "RS 6 Avant" },
  { type: "car", year: 2025, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2025, make: "AUDI", model: "RS e-tron GT" },
  { type: "car", year: 2025, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2025, make: "AUDI", model: "S e-tron GT" },
  { type: "car", year: 2025, make: "AUDI", model: "S3" },
  { type: "car", year: 2025, make: "AUDI", model: "S4" },
  { type: "car", year: 2025, make: "AUDI", model: "S5" },
  { type: "car", year: 2025, make: "AUDI", model: "S6" },
  { type: "car", year: 2025, make: "AUDI", model: "S7" },
  { type: "car", year: 2025, make: "AUDI", model: "S8" },
  { type: "car", year: 2025, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2025, make: "AUDI", model: "SQ6" },
  { type: "car", year: 2025, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2025, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2025, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2025, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2025, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2025, make: "BMW", model: "228i" },
  { type: "car", year: 2025, make: "BMW", model: "230i" },
  { type: "car", year: 2025, make: "BMW", model: "330i" },
  { type: "car", year: 2025, make: "BMW", model: "430i" },
  { type: "car", year: 2025, make: "BMW", model: "530i" },
  { type: "car", year: 2025, make: "BMW", model: "540i" },
  { type: "car", year: 2025, make: "BMW", model: "550e" },
  { type: "car", year: 2025, make: "BMW", model: "740i" },
  { type: "car", year: 2025, make: "BMW", model: "750e" },
  { type: "car", year: 2025, make: "BMW", model: "760i" },
  { type: "car", year: 2025, make: "BMW", model: "840i" },
  { type: "car", year: 2025, make: "BMW", model: "Alpina B8" },
  { type: "car", year: 2025, make: "BMW", model: "i4" },
  { type: "car", year: 2025, make: "BMW", model: "i5" },
  { type: "car", year: 2025, make: "BMW", model: "i7" },
  { type: "car", year: 2025, make: "BMW", model: "iX" },
  { type: "car", year: 2025, make: "BMW", model: "M2" },
  { type: "car", year: 2025, make: "BMW", model: "M235" },
  { type: "car", year: 2025, make: "BMW", model: "M240i" },
  { type: "car", year: 2025, make: "BMW", model: "M3" },
  { type: "car", year: 2025, make: "BMW", model: "M340i" },
  { type: "car", year: 2025, make: "BMW", model: "M4" },
  { type: "car", year: 2025, make: "BMW", model: "M440i" },
  { type: "car", year: 2025, make: "BMW", model: "M5" },
  { type: "car", year: 2025, make: "BMW", model: "M8" },
  { type: "car", year: 2025, make: "BMW", model: "M850i" },
  { type: "car", year: 2025, make: "BMW", model: "X1" },
  { type: "car", year: 2025, make: "BMW", model: "X2" },
  { type: "car", year: 2025, make: "BMW", model: "X3" },
  { type: "car", year: 2025, make: "BMW", model: "X4" },
  { type: "car", year: 2025, make: "BMW", model: "X5" },
  { type: "car", year: 2025, make: "BMW", model: "X6" },
  { type: "car", year: 2025, make: "BMW", model: "X7" },
  { type: "car", year: 2025, make: "BMW", model: "XM" },
  { type: "car", year: 2025, make: "BMW", model: "Z4" },
  { type: "car", year: 2025, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2025, make: "BUGATTI", model: "Mistral" },
  { type: "car", year: 2025, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2025, make: "BUICK", model: "Encore" },
  { type: "car", year: 2025, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2025, make: "BUICK", model: "Envision" },
  { type: "car", year: 2025, make: "BUICK", model: "Envista" },
  { type: "car", year: 2025, make: "CADILLAC", model: "Celestiq" },
  { type: "car", year: 2025, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2025, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2025, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2025, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2025, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2025, make: "CADILLAC", model: "Escalade IQ" },
  { type: "car", year: 2025, make: "CADILLAC", model: "Lyriq" },
  { type: "car", year: 2025, make: "CADILLAC", model: "Optiq" },
  { type: "car", year: 2025, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2025, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2025, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2025, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Onix" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Suburban HD" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Traverse Limited" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2025, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2025, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2025, make: "CHRYSLER", model: "Grand Caravan" },
  { type: "car", year: 2025, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2025, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2025, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2025, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2025, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2025, make: "DODGE", model: "Charger" },
  { type: "car", year: 2025, make: "DODGE", model: "Durango" },
  { type: "car", year: 2025, make: "DODGE", model: "Hornet" },
  { type: "car", year: 2025, make: "FERRARI", model: "12Cilindri" },
  { type: "car", year: 2025, make: "FERRARI", model: "296" },
  { type: "car", year: 2025, make: "FERRARI", model: "Daytona SP3" },
  { type: "car", year: 2025, make: "FERRARI", model: "Purosangue" },
  { type: "car", year: 2025, make: "FERRARI", model: "Roma" },
  { type: "car", year: 2025, make: "FERRARI", model: "SF90" },
  { type: "car", year: 2025, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2025, make: "FIAT", model: "500e" },
  { type: "car", year: 2025, make: "FIAT", model: "500X" },
  { type: "car", year: 2025, make: "FISKER", model: "Karma" },
  { type: "car", year: 2025, make: "FISKER", model: "Nina" },
  { type: "car", year: 2025, make: "FISKER", model: "Ocean" },
  { type: "car", year: 2025, make: "FORD", model: "'34" },
  { type: "car", year: 2025, make: "FORD", model: "Bronco" },
  { type: "car", year: 2025, make: "FORD", model: "Bronco Sport" },
  { type: "car", year: 2025, make: "FORD", model: "E-350" },
  { type: "car", year: 2025, make: "FORD", model: "E-450" },
  { type: "car", year: 2025, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2025, make: "FORD", model: "Edge" },
  { type: "car", year: 2025, make: "FORD", model: "Escape" },
  { type: "car", year: 2025, make: "FORD", model: "Expedition" },
  { type: "car", year: 2025, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2025, make: "FORD", model: "Explorer" },
  { type: "car", year: 2025, make: "FORD", model: "F-150" },
  { type: "car", year: 2025, make: "FORD", model: "F-250" },
  { type: "car", year: 2025, make: "FORD", model: "F-350" },
  { type: "car", year: 2025, make: "FORD", model: "F-450" },
  { type: "car", year: 2025, make: "FORD", model: "F-550" },
  { type: "car", year: 2025, make: "FORD", model: "F-600" },
  { type: "car", year: 2025, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2025, make: "FORD", model: "Flex" },
  { type: "car", year: 2025, make: "FORD", model: "Focus" },
  { type: "car", year: 2025, make: "FORD", model: "GT MKII" },
  { type: "car", year: 2025, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2025, make: "FORD", model: "Mustang" },
  { type: "car", year: 2025, make: "FORD", model: "Mustang GTD" },
  { type: "car", year: 2025, make: "FORD", model: "Mustang Mach-E" },
  { type: "car", year: 2025, make: "FORD", model: "Ranger" },
  { type: "car", year: 2025, make: "FORD", model: "Transit" },
  { type: "car", year: 2025, make: "GMC", model: "Acadia" },
  { type: "car", year: 2025, make: "GMC", model: "Canyon" },
  { type: "car", year: 2025, make: "GMC", model: "Cruise Origin AV" },
  { type: "car", year: 2025, make: "GMC", model: "Hummer EV SUV" },
  { type: "car", year: 2025, make: "GMC", model: "Savana" },
  { type: "car", year: 2025, make: "GMC", model: "Sierra" },
  { type: "car", year: 2025, make: "GMC", model: "Terrain" },
  { type: "car", year: 2025, make: "GMC", model: "Yukon" },
  { type: "car", year: 2025, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2025, make: "HONDA", model: "Accord" },
  { type: "car", year: 2025, make: "HONDA", model: "Civic" },
  { type: "car", year: 2025, make: "HONDA", model: "Civic Si" },
  { type: "car", year: 2025, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2025, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2025, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2025, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2025, make: "HONDA", model: "Passport" },
  { type: "car", year: 2025, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2025, make: "HONDA", model: "Prologue" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Elantra N" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Ioniq 5" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Ioniq 5 N" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Ioniq 6" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Kona N" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2025, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2025, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2025, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2025, make: "INFINITI", model: "QX55" },
  { type: "car", year: 2025, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2025, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2025, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2025, make: "JEEP", model: "Compass" },
  { type: "car", year: 2025, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2025, make: "JEEP", model: "Grand Cherokee L" },
  { type: "car", year: 2025, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 2025, make: "JEEP", model: "Grand Wagoneer L" },
  { type: "car", year: 2025, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2025, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 2025, make: "JEEP", model: "Wagoneer L" },
  { type: "car", year: 2025, make: "JEEP", model: "Wagoneer S" },
  { type: "car", year: 2025, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2025, make: "KARMA", model: "GS-6" },
  { type: "car", year: 2025, make: "KARMA", model: "Gyesera" },
  { type: "car", year: 2025, make: "KARMA", model: "Kaveya" },
  { type: "car", year: 2025, make: "KARMA", model: "Revero" },
  { type: "car", year: 2025, make: "KIA", model: "Carnival" },
  { type: "car", year: 2025, make: "KIA", model: "EV6" },
  { type: "car", year: 2025, make: "KIA", model: "EV9" },
  { type: "car", year: 2025, make: "KIA", model: "Forte" },
  { type: "car", year: 2025, make: "KIA", model: "K4" },
  { type: "car", year: 2025, make: "KIA", model: "K5" },
  { type: "car", year: 2025, make: "KIA", model: "Niro" },
  { type: "car", year: 2025, make: "KIA", model: "Seltos" },
  { type: "car", year: 2025, make: "KIA", model: "Sorento" },
  { type: "car", year: 2025, make: "KIA", model: "Soul" },
  { type: "car", year: 2025, make: "KIA", model: "Sportage" },
  { type: "car", year: 2025, make: "KIA", model: "Telluride" },
  { type: "car", year: 2025, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2025, make: "LAMBORGHINI", model: "Revuelto" },
  { type: "car", year: 2025, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2025, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2025, make: "LEXUS", model: "ES" },
  { type: "car", year: 2025, make: "LEXUS", model: "GS" },
  { type: "car", year: 2025, make: "LEXUS", model: "GX" },
  { type: "car", year: 2025, make: "LEXUS", model: "IS" },
  { type: "car", year: 2025, make: "LEXUS", model: "LC" },
  { type: "car", year: 2025, make: "LEXUS", model: "LS" },
  { type: "car", year: 2025, make: "LEXUS", model: "LX" },
  { type: "car", year: 2025, make: "LEXUS", model: "NX" },
  { type: "car", year: 2025, make: "LEXUS", model: "RC" },
  { type: "car", year: 2025, make: "LEXUS", model: "RX" },
  { type: "car", year: 2025, make: "LEXUS", model: "RZ" },
  { type: "car", year: 2025, make: "LEXUS", model: "SC" },
  { type: "car", year: 2025, make: "LEXUS", model: "TX" },
  { type: "car", year: 2025, make: "LEXUS", model: "UX" },
  { type: "car", year: 2025, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2025, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2025, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2025, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2025, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2025, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2025, make: "LOTUS", model: "ELETRE" },
  { type: "car", year: 2025, make: "LOTUS", model: "Emira" },
  { type: "car", year: 2025, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2025, make: "LUCID", model: "Air" },
  { type: "car", year: 2025, make: "LUCID", model: "Gravity" },
  { type: "car", year: 2025, make: "MASERATI", model: "Grancabrio" },
  { type: "car", year: 2025, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2025, make: "MASERATI", model: "Grecale" },
  { type: "car", year: 2025, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2025, make: "MASERATI", model: "MC20" },
  { type: "car", year: 2025, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2025, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2025, make: "MAZDA", model: "CX-50" },
  { type: "car", year: 2025, make: "MAZDA", model: "CX-70" },
  { type: "car", year: 2025, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2025, make: "MAZDA", model: "CX-90" },
  { type: "car", year: 2025, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2025, make: "MAZDA", model: "MX-30" },
  { type: "car", year: 2025, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2025, make: "MCLAREN", model: "750S" },
  { type: "car", year: 2025, make: "MCLAREN", model: "ARTURA" },
  { type: "car", year: 2025, make: "MCLAREN", model: "GTS" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "CLE" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "EQB-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "EQE-Class Sedan" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "EQE-Class SUV" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "EQS-Class Sedan" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "EQS-Class SUV" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "eSprinter" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2025, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2025, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2025, make: "MINI", model: "Countryman" },
  { type: "car", year: 2025, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2025, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2025, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2025, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2025, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2025, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2025, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2025, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2025, make: "NISSAN", model: "Ariya MPV" },
  { type: "car", year: 2025, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2025, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2025, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2025, make: "NISSAN", model: "Kicks MPV" },
  { type: "car", year: 2025, make: "NISSAN", model: "Kicks Play" },
  { type: "car", year: 2025, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2025, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2025, make: "NISSAN", model: "Nissan Z" },
  { type: "car", year: 2025, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2025, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2025, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2025, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2025, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2025, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2025, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2025, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2025, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2025, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2025, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2025, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2025, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2025, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2025, make: "PORSCHE", model: "718 Spyder" },
  { type: "car", year: 2025, make: "PORSCHE", model: "911" },
  { type: "car", year: 2025, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2025, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2025, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2025, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2025, make: "RAM", model: "1500" },
  { type: "car", year: 2025, make: "RAM", model: "2500" },
  { type: "car", year: 2025, make: "RAM", model: "3500" },
  { type: "car", year: 2025, make: "RAM", model: "4500" },
  { type: "car", year: 2025, make: "RAM", model: "5500" },
  { type: "car", year: 2025, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2025, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2025, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2025, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2025, make: "RIVIAN", model: "R1S" },
  { type: "car", year: 2025, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2025, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2025, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2025, make: "ROLLS-ROYCE", model: "Spectre" },
  { type: "car", year: 2025, make: "SAAB", model: "9-3" },
  { type: "car", year: 2025, make: "SAAB", model: "9-5" },
  { type: "car", year: 2025, make: "SHELBY", model: "Cobra" },
  { type: "car", year: 2025, make: "SHELBY", model: "GT" },
  { type: "car", year: 2025, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2025, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2025, make: "SPYKER", model: "C12" },
  { type: "car", year: 2025, make: "SPYKER", model: "C8" },
  { type: "car", year: 2025, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2025, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2025, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2025, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2025, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2025, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2025, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2025, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2025, make: "SUBARU", model: "Solterra" },
  { type: "car", year: 2025, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2025, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2025, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2025, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2025, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2025, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2025, make: "TESLA", model: "Model S" },
  { type: "car", year: 2025, make: "TESLA", model: "Model X" },
  { type: "car", year: 2025, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2025, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2025, make: "TOYOTA", model: "bZ4X" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Corolla Cross" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Crown" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Crown Signia" },
  { type: "car", year: 2025, make: "TOYOTA", model: "GR Corolla" },
  { type: "car", year: 2025, make: "TOYOTA", model: "GR86" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Grand Highlander" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2025, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2025, make: "TOYOTA", model: "RAV4 Prime (PHEV)" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2025, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2025, make: "VOLVO", model: "EC40" },
  { type: "car", year: 2025, make: "VOLVO", model: "EX30" },
  { type: "car", year: 2025, make: "VOLVO", model: "EX40" },
  { type: "car", year: 2025, make: "VOLVO", model: "EX90" },
  { type: "car", year: 2025, make: "VOLVO", model: "S60" },
  { type: "car", year: 2025, make: "VOLVO", model: "S90" },
  { type: "car", year: 2025, make: "VOLVO", model: "V60" },
  { type: "car", year: 2025, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2025, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2025, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2025, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2025, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2025, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2024, make: "ACURA", model: "ILX" },
  { type: "car", year: 2024, make: "ACURA", model: "Integra" },
  { type: "car", year: 2024, make: "ACURA", model: "MDX" },
  { type: "car", year: 2024, make: "ACURA", model: "RDX" },
  { type: "car", year: 2024, make: "ACURA", model: "RLX" },
  { type: "car", year: 2024, make: "ACURA", model: "TLX" },
  { type: "car", year: 2024, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2024, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2024, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2024, make: "ALFA ROMEO", model: "Tonale" },
  { type: "car", year: 2024, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "DB12" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "DBX" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "Valiant" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "Valour" },
  { type: "car", year: 2024, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2024, make: "AUDI", model: "A3" },
  { type: "car", year: 2024, make: "AUDI", model: "A4" },
  { type: "car", year: 2024, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2024, make: "AUDI", model: "A5" },
  { type: "car", year: 2024, make: "AUDI", model: "A6" },
  { type: "car", year: 2024, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2024, make: "AUDI", model: "A7" },
  { type: "car", year: 2024, make: "AUDI", model: "A8 L" },
  { type: "car", year: 2024, make: "AUDI", model: "e-tron GT" },
  { type: "car", year: 2024, make: "AUDI", model: "Q3" },
  { type: "car", year: 2024, make: "AUDI", model: "Q4" },
  { type: "car", year: 2024, make: "AUDI", model: "Q5" },
  { type: "car", year: 2024, make: "AUDI", model: "Q5 e" },
  { type: "car", year: 2024, make: "AUDI", model: "Q7" },
  { type: "car", year: 2024, make: "AUDI", model: "Q8" },
  { type: "car", year: 2024, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2024, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2024, make: "AUDI", model: "RS 6 Avant" },
  { type: "car", year: 2024, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2024, make: "AUDI", model: "RS e-tron GT" },
  { type: "car", year: 2024, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2024, make: "AUDI", model: "S3" },
  { type: "car", year: 2024, make: "AUDI", model: "S4" },
  { type: "car", year: 2024, make: "AUDI", model: "S5" },
  { type: "car", year: 2024, make: "AUDI", model: "S6" },
  { type: "car", year: 2024, make: "AUDI", model: "S7" },
  { type: "car", year: 2024, make: "AUDI", model: "S8" },
  { type: "car", year: 2024, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2024, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2024, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2024, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2024, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2024, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2024, make: "BMW", model: "228i" },
  { type: "car", year: 2024, make: "BMW", model: "230i" },
  { type: "car", year: 2024, make: "BMW", model: "330e" },
  { type: "car", year: 2024, make: "BMW", model: "330i" },
  { type: "car", year: 2024, make: "BMW", model: "340i" },
  { type: "car", year: 2024, make: "BMW", model: "430i" },
  { type: "car", year: 2024, make: "BMW", model: "530i" },
  { type: "car", year: 2024, make: "BMW", model: "540i" },
  { type: "car", year: 2024, make: "BMW", model: "740i" },
  { type: "car", year: 2024, make: "BMW", model: "750e" },
  { type: "car", year: 2024, make: "BMW", model: "760i" },
  { type: "car", year: 2024, make: "BMW", model: "840i" },
  { type: "car", year: 2024, make: "BMW", model: "Alpina B8" },
  { type: "car", year: 2024, make: "BMW", model: "i4" },
  { type: "car", year: 2024, make: "BMW", model: "i5" },
  { type: "car", year: 2024, make: "BMW", model: "i7" },
  { type: "car", year: 2024, make: "BMW", model: "iX" },
  { type: "car", year: 2024, make: "BMW", model: "M2" },
  { type: "car", year: 2024, make: "BMW", model: "M235i" },
  { type: "car", year: 2024, make: "BMW", model: "M240i" },
  { type: "car", year: 2024, make: "BMW", model: "M3" },
  { type: "car", year: 2024, make: "BMW", model: "M340i" },
  { type: "car", year: 2024, make: "BMW", model: "M4" },
  { type: "car", year: 2024, make: "BMW", model: "M440i" },
  { type: "car", year: 2024, make: "BMW", model: "M8" },
  { type: "car", year: 2024, make: "BMW", model: "M850i" },
  { type: "car", year: 2024, make: "BMW", model: "X1" },
  { type: "car", year: 2024, make: "BMW", model: "X2" },
  { type: "car", year: 2024, make: "BMW", model: "X3" },
  { type: "car", year: 2024, make: "BMW", model: "X4" },
  { type: "car", year: 2024, make: "BMW", model: "X5" },
  { type: "car", year: 2024, make: "BMW", model: "X6" },
  { type: "car", year: 2024, make: "BMW", model: "X7" },
  { type: "car", year: 2024, make: "BMW", model: "XM" },
  { type: "car", year: 2024, make: "BMW", model: "Z4" },
  { type: "car", year: 2024, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2024, make: "BUGATTI", model: "Chiron Pur Sport" },
  { type: "car", year: 2024, make: "BUGATTI", model: "Chiron Supersport" },
  { type: "car", year: 2024, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2024, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2024, make: "BUICK", model: "Encore" },
  { type: "car", year: 2024, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2024, make: "BUICK", model: "Envision" },
  { type: "car", year: 2024, make: "BUICK", model: "Envista" },
  { type: "car", year: 2024, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2024, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2024, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2024, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2024, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2024, make: "CADILLAC", model: "Lyriq" },
  { type: "car", year: 2024, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2024, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2024, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2024, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Onix" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Suburban HD" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Traverse Limited" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2024, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2024, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2024, make: "CHRYSLER", model: "Grand Caravan" },
  { type: "car", year: 2024, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2024, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2024, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2024, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2024, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2024, make: "DODGE", model: "Charger" },
  { type: "car", year: 2024, make: "DODGE", model: "Durango" },
  { type: "car", year: 2024, make: "DODGE", model: "Hornet" },
  { type: "car", year: 2024, make: "FERRARI", model: "296" },
  { type: "car", year: 2024, make: "FERRARI", model: "812" },
  { type: "car", year: 2024, make: "FERRARI", model: "Daytona SP3" },
  { type: "car", year: 2024, make: "FERRARI", model: "Purosangue" },
  { type: "car", year: 2024, make: "FERRARI", model: "Roma" },
  { type: "car", year: 2024, make: "FERRARI", model: "SF90" },
  { type: "car", year: 2024, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2024, make: "FIAT", model: "500e" },
  { type: "car", year: 2024, make: "FIAT", model: "500X" },
  { type: "car", year: 2024, make: "FISKER", model: "Karma" },
  { type: "car", year: 2024, make: "FISKER", model: "Nina" },
  { type: "car", year: 2024, make: "FISKER", model: "Ocean" },
  { type: "car", year: 2024, make: "FORD", model: "'34" },
  { type: "car", year: 2024, make: "FORD", model: "Bronco" },
  { type: "car", year: 2024, make: "FORD", model: "Bronco Sport" },
  { type: "car", year: 2024, make: "FORD", model: "E-350" },
  { type: "car", year: 2024, make: "FORD", model: "E-450" },
  { type: "car", year: 2024, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2024, make: "FORD", model: "Edge" },
  { type: "car", year: 2024, make: "FORD", model: "Escape" },
  { type: "car", year: 2024, make: "FORD", model: "Expedition" },
  { type: "car", year: 2024, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2024, make: "FORD", model: "Explorer" },
  { type: "car", year: 2024, make: "FORD", model: "F-150" },
  { type: "car", year: 2024, make: "FORD", model: "F-250" },
  { type: "car", year: 2024, make: "FORD", model: "F-350" },
  { type: "car", year: 2024, make: "FORD", model: "F-450" },
  { type: "car", year: 2024, make: "FORD", model: "F-550" },
  { type: "car", year: 2024, make: "FORD", model: "F-600" },
  { type: "car", year: 2024, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2024, make: "FORD", model: "Flex" },
  { type: "car", year: 2024, make: "FORD", model: "Focus" },
  { type: "car", year: 2024, make: "FORD", model: "GT MKII" },
  { type: "car", year: 2024, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2024, make: "FORD", model: "Mustang" },
  { type: "car", year: 2024, make: "FORD", model: "Mustang Mach-E" },
  { type: "car", year: 2024, make: "FORD", model: "Ranger" },
  { type: "car", year: 2024, make: "FORD", model: "Transit" },
  { type: "car", year: 2024, make: "GMC", model: "Acadia" },
  { type: "car", year: 2024, make: "GMC", model: "Canyon" },
  { type: "car", year: 2024, make: "GMC", model: "Cruise Origin AV" },
  { type: "car", year: 2024, make: "GMC", model: "Hummer EV SUV" },
  { type: "car", year: 2024, make: "GMC", model: "Savana" },
  { type: "car", year: 2024, make: "GMC", model: "Sierra" },
  { type: "car", year: 2024, make: "GMC", model: "Terrain" },
  { type: "car", year: 2024, make: "GMC", model: "Yukon" },
  { type: "car", year: 2024, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2024, make: "HONDA", model: "Accord" },
  { type: "car", year: 2024, make: "HONDA", model: "Civic" },
  { type: "car", year: 2024, make: "HONDA", model: "Civic Si" },
  { type: "car", year: 2024, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2024, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2024, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2024, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2024, make: "HONDA", model: "Passport" },
  { type: "car", year: 2024, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2024, make: "HONDA", model: "Prologue" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Elantra N" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Ioniq 5" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Ioniq 6" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Kona N" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2024, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2024, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2024, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2024, make: "INFINITI", model: "QX55" },
  { type: "car", year: 2024, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2024, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2024, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2024, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2024, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2024, make: "JAGUAR", model: "I-PACE" },
  { type: "car", year: 2024, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2024, make: "JEEP", model: "Compass" },
  { type: "car", year: 2024, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2024, make: "JEEP", model: "Grand Cherokee L" },
  { type: "car", year: 2024, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 2024, make: "JEEP", model: "Grand Wagoneer L" },
  { type: "car", year: 2024, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2024, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 2024, make: "JEEP", model: "Wagoneer L" },
  { type: "car", year: 2024, make: "JEEP", model: "Wagoneer S" },
  { type: "car", year: 2024, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2024, make: "KARMA", model: "GS-6" },
  { type: "car", year: 2024, make: "KARMA", model: "Revero GT" },
  { type: "car", year: 2024, make: "KIA", model: "Carnival" },
  { type: "car", year: 2024, make: "KIA", model: "EV6" },
  { type: "car", year: 2024, make: "KIA", model: "EV9" },
  { type: "car", year: 2024, make: "KIA", model: "Forte" },
  { type: "car", year: 2024, make: "KIA", model: "K5" },
  { type: "car", year: 2024, make: "KIA", model: "Niro" },
  { type: "car", year: 2024, make: "KIA", model: "Seltos" },
  { type: "car", year: 2024, make: "KIA", model: "Sorento" },
  { type: "car", year: 2024, make: "KIA", model: "Soul" },
  { type: "car", year: 2024, make: "KIA", model: "Sportage" },
  { type: "car", year: 2024, make: "KIA", model: "Telluride" },
  { type: "car", year: 2024, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2024, make: "LAMBORGHINI", model: "Revuelto" },
  { type: "car", year: 2024, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2024, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2024, make: "LEXUS", model: "ES" },
  { type: "car", year: 2024, make: "LEXUS", model: "GS" },
  { type: "car", year: 2024, make: "LEXUS", model: "GX" },
  { type: "car", year: 2024, make: "LEXUS", model: "IS" },
  { type: "car", year: 2024, make: "LEXUS", model: "LC" },
  { type: "car", year: 2024, make: "LEXUS", model: "LS" },
  { type: "car", year: 2024, make: "LEXUS", model: "LX" },
  { type: "car", year: 2024, make: "LEXUS", model: "NX" },
  { type: "car", year: 2024, make: "LEXUS", model: "RC" },
  { type: "car", year: 2024, make: "LEXUS", model: "RX" },
  { type: "car", year: 2024, make: "LEXUS", model: "RZ" },
  { type: "car", year: 2024, make: "LEXUS", model: "SC" },
  { type: "car", year: 2024, make: "LEXUS", model: "TX" },
  { type: "car", year: 2024, make: "LEXUS", model: "UX" },
  { type: "car", year: 2024, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2024, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2024, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2024, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2024, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2024, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2024, make: "LOTUS", model: "Emira" },
  { type: "car", year: 2024, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2024, make: "LUCID", model: "Air" },
  { type: "car", year: 2024, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2024, make: "MASERATI", model: "Grancabrio" },
  { type: "car", year: 2024, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2024, make: "MASERATI", model: "Grecale" },
  { type: "car", year: 2024, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2024, make: "MASERATI", model: "MC20" },
  { type: "car", year: 2024, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2024, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2024, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2024, make: "MAZDA", model: "CX-50" },
  { type: "car", year: 2024, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2024, make: "MAZDA", model: "CX-90" },
  { type: "car", year: 2024, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2024, make: "MAZDA", model: "MX-30" },
  { type: "car", year: 2024, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2024, make: "MCLAREN", model: "750S" },
  { type: "car", year: 2024, make: "MCLAREN", model: "ARTURA" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "CLE" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "EQB-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "EQE-Class Sedan" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "EQE-Class SUV" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "EQS-Class Sedan" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "EQS-Class SUV" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "eSprinter" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2024, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2024, make: "MINI", model: "Clubman" },
  { type: "car", year: 2024, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2024, make: "MINI", model: "Countryman" },
  { type: "car", year: 2024, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2024, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2024, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2024, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2024, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2024, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2024, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2024, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2024, make: "NISSAN", model: "Ariya Hatchback" },
  { type: "car", year: 2024, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2024, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2024, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2024, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2024, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2024, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2024, make: "NISSAN", model: "Nissan Z" },
  { type: "car", year: 2024, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2024, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2024, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2024, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2024, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2024, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2024, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2024, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2024, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2024, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2024, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2024, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2024, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2024, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2024, make: "PORSCHE", model: "718 Spyder" },
  { type: "car", year: 2024, make: "PORSCHE", model: "911" },
  { type: "car", year: 2024, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2024, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2024, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2024, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2024, make: "RAM", model: "1500" },
  { type: "car", year: 2024, make: "RAM", model: "2500" },
  { type: "car", year: 2024, make: "RAM", model: "3500" },
  { type: "car", year: 2024, make: "RAM", model: "4500" },
  { type: "car", year: 2024, make: "RAM", model: "5500" },
  { type: "car", year: 2024, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2024, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2024, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2024, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2024, make: "RIVIAN", model: "R1S" },
  { type: "car", year: 2024, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2024, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2024, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2024, make: "ROLLS-ROYCE", model: "Spectre" },
  { type: "car", year: 2024, make: "SAAB", model: "9-3" },
  { type: "car", year: 2024, make: "SAAB", model: "9-5" },
  { type: "car", year: 2024, make: "SHELBY", model: "Cobra" },
  { type: "car", year: 2024, make: "SHELBY", model: "GT" },
  { type: "car", year: 2024, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2024, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2024, make: "SPYKER", model: "C12" },
  { type: "car", year: 2024, make: "SPYKER", model: "C8" },
  { type: "car", year: 2024, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2024, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2024, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2024, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2024, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2024, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2024, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2024, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2024, make: "SUBARU", model: "Solterra" },
  { type: "car", year: 2024, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2024, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2024, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2024, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2024, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2024, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2024, make: "TESLA", model: "Model S" },
  { type: "car", year: 2024, make: "TESLA", model: "Model X" },
  { type: "car", year: 2024, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2024, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2024, make: "TOYOTA", model: "bZ4X" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Corolla Cross" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Crown" },
  { type: "car", year: 2024, make: "TOYOTA", model: "GR Corolla" },
  { type: "car", year: 2024, make: "TOYOTA", model: "GR86" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Grand Highlander" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2024, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2024, make: "TOYOTA", model: "RAV4 Prime (PHEV)" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2024, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2024, make: "VOLVO", model: "C40" },
  { type: "car", year: 2024, make: "VOLVO", model: "S60" },
  { type: "car", year: 2024, make: "VOLVO", model: "S90" },
  { type: "car", year: 2024, make: "VOLVO", model: "V60" },
  { type: "car", year: 2024, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2024, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2024, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2024, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2024, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2024, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2023, make: "ACURA", model: "ILX" },
  { type: "car", year: 2023, make: "ACURA", model: "Integra" },
  { type: "car", year: 2023, make: "ACURA", model: "MDX" },
  { type: "car", year: 2023, make: "ACURA", model: "RDX" },
  { type: "car", year: 2023, make: "ACURA", model: "RLX" },
  { type: "car", year: 2023, make: "ACURA", model: "TLX" },
  { type: "car", year: 2023, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2023, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2023, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2023, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2023, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2023, make: "ASTON MARTIN", model: "DBX" },
  { type: "car", year: 2023, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2023, make: "AUDI", model: "A3" },
  { type: "car", year: 2023, make: "AUDI", model: "A4" },
  { type: "car", year: 2023, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2023, make: "AUDI", model: "A5" },
  { type: "car", year: 2023, make: "AUDI", model: "A6" },
  { type: "car", year: 2023, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2023, make: "AUDI", model: "A7" },
  { type: "car", year: 2023, make: "AUDI", model: "A8 L" },
  { type: "car", year: 2023, make: "AUDI", model: "e-tron" },
  { type: "car", year: 2023, make: "AUDI", model: "e-tron GT" },
  { type: "car", year: 2023, make: "AUDI", model: "Q3" },
  { type: "car", year: 2023, make: "AUDI", model: "Q4" },
  { type: "car", year: 2023, make: "AUDI", model: "Q5" },
  { type: "car", year: 2023, make: "AUDI", model: "Q5 e" },
  { type: "car", year: 2023, make: "AUDI", model: "Q7" },
  { type: "car", year: 2023, make: "AUDI", model: "Q8" },
  { type: "car", year: 2023, make: "AUDI", model: "R8" },
  { type: "car", year: 2023, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2023, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2023, make: "AUDI", model: "RS 6 Avant" },
  { type: "car", year: 2023, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2023, make: "AUDI", model: "RS e-tron GT" },
  { type: "car", year: 2023, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2023, make: "AUDI", model: "S3" },
  { type: "car", year: 2023, make: "AUDI", model: "S4" },
  { type: "car", year: 2023, make: "AUDI", model: "S5" },
  { type: "car", year: 2023, make: "AUDI", model: "S6" },
  { type: "car", year: 2023, make: "AUDI", model: "S7" },
  { type: "car", year: 2023, make: "AUDI", model: "S8" },
  { type: "car", year: 2023, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2023, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2023, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2023, make: "AUDI", model: "TT" },
  { type: "car", year: 2023, make: "AUDI", model: "TTS" },
  { type: "car", year: 2023, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2023, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2023, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2023, make: "BMW", model: "228i" },
  { type: "car", year: 2023, make: "BMW", model: "230i" },
  { type: "car", year: 2023, make: "BMW", model: "330e" },
  { type: "car", year: 2023, make: "BMW", model: "330i" },
  { type: "car", year: 2023, make: "BMW", model: "340i" },
  { type: "car", year: 2023, make: "BMW", model: "430i" },
  { type: "car", year: 2023, make: "BMW", model: "530e" },
  { type: "car", year: 2023, make: "BMW", model: "530i" },
  { type: "car", year: 2023, make: "BMW", model: "540i" },
  { type: "car", year: 2023, make: "BMW", model: "740i" },
  { type: "car", year: 2023, make: "BMW", model: "760i" },
  { type: "car", year: 2023, make: "BMW", model: "840i" },
  { type: "car", year: 2023, make: "BMW", model: "Alpina B8" },
  { type: "car", year: 2023, make: "BMW", model: "i4" },
  { type: "car", year: 2023, make: "BMW", model: "i7" },
  { type: "car", year: 2023, make: "BMW", model: "iX" },
  { type: "car", year: 2023, make: "BMW", model: "M2" },
  { type: "car", year: 2023, make: "BMW", model: "M235i" },
  { type: "car", year: 2023, make: "BMW", model: "M240i" },
  { type: "car", year: 2023, make: "BMW", model: "M3" },
  { type: "car", year: 2023, make: "BMW", model: "M340i" },
  { type: "car", year: 2023, make: "BMW", model: "M4" },
  { type: "car", year: 2023, make: "BMW", model: "M440i" },
  { type: "car", year: 2023, make: "BMW", model: "M5" },
  { type: "car", year: 2023, make: "BMW", model: "M550i" },
  { type: "car", year: 2023, make: "BMW", model: "M8" },
  { type: "car", year: 2023, make: "BMW", model: "M850i" },
  { type: "car", year: 2023, make: "BMW", model: "X1" },
  { type: "car", year: 2023, make: "BMW", model: "X2" },
  { type: "car", year: 2023, make: "BMW", model: "X3" },
  { type: "car", year: 2023, make: "BMW", model: "X4" },
  { type: "car", year: 2023, make: "BMW", model: "X5" },
  { type: "car", year: 2023, make: "BMW", model: "X6" },
  { type: "car", year: 2023, make: "BMW", model: "X7" },
  { type: "car", year: 2023, make: "BMW", model: "XM" },
  { type: "car", year: 2023, make: "BMW", model: "Z4" },
  { type: "car", year: 2023, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2023, make: "BUGATTI", model: "Chiron Pur Sport" },
  { type: "car", year: 2023, make: "BUGATTI", model: "Chiron Supersport" },
  { type: "car", year: 2023, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2023, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2023, make: "BUICK", model: "Encore" },
  { type: "car", year: 2023, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2023, make: "BUICK", model: "Envision" },
  { type: "car", year: 2023, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2023, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2023, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2023, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2023, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2023, make: "CADILLAC", model: "Lyriq" },
  { type: "car", year: 2023, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2023, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2023, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2023, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Bolt EUV" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Onix" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2023, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2023, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2023, make: "CHRYSLER", model: "Grand Caravan" },
  { type: "car", year: 2023, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2023, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2023, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2023, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2023, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2023, make: "DODGE", model: "Charger" },
  { type: "car", year: 2023, make: "DODGE", model: "Durango" },
  { type: "car", year: 2023, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2023, make: "DODGE", model: "Hornet" },
  { type: "car", year: 2023, make: "DODGE", model: "Journey" },
  { type: "car", year: 2023, make: "FERRARI", model: "296" },
  { type: "car", year: 2023, make: "FERRARI", model: "812" },
  { type: "car", year: 2023, make: "FERRARI", model: "Daytona SP3" },
  { type: "car", year: 2023, make: "FERRARI", model: "F8" },
  { type: "car", year: 2023, make: "FERRARI", model: "Monza SP1/SP2" },
  { type: "car", year: 2023, make: "FERRARI", model: "Portofino M" },
  { type: "car", year: 2023, make: "FERRARI", model: "Purosangue" },
  { type: "car", year: 2023, make: "FERRARI", model: "Roma" },
  { type: "car", year: 2023, make: "FERRARI", model: "SF90" },
  { type: "car", year: 2023, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2023, make: "FIAT", model: "500X" },
  { type: "car", year: 2023, make: "FIAT", model: "Ducato" },
  { type: "car", year: 2023, make: "FISKER", model: "Karma" },
  { type: "car", year: 2023, make: "FISKER", model: "Nina" },
  { type: "car", year: 2023, make: "FISKER", model: "Ocean" },
  { type: "car", year: 2023, make: "FORD", model: "'34" },
  { type: "car", year: 2023, make: "FORD", model: "Bronco" },
  { type: "car", year: 2023, make: "FORD", model: "Bronco Sport" },
  { type: "car", year: 2023, make: "FORD", model: "E-350" },
  { type: "car", year: 2023, make: "FORD", model: "E-450" },
  { type: "car", year: 2023, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2023, make: "FORD", model: "Edge" },
  { type: "car", year: 2023, make: "FORD", model: "Escape" },
  { type: "car", year: 2023, make: "FORD", model: "Expedition" },
  { type: "car", year: 2023, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2023, make: "FORD", model: "Explorer" },
  { type: "car", year: 2023, make: "FORD", model: "F-150" },
  { type: "car", year: 2023, make: "FORD", model: "F-250" },
  { type: "car", year: 2023, make: "FORD", model: "F-350" },
  { type: "car", year: 2023, make: "FORD", model: "F-450" },
  { type: "car", year: 2023, make: "FORD", model: "F-550" },
  { type: "car", year: 2023, make: "FORD", model: "F-600" },
  { type: "car", year: 2023, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2023, make: "FORD", model: "Flex" },
  { type: "car", year: 2023, make: "FORD", model: "Focus" },
  { type: "car", year: 2023, make: "FORD", model: "GT MKII" },
  { type: "car", year: 2023, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2023, make: "FORD", model: "Mustang" },
  { type: "car", year: 2023, make: "FORD", model: "Mustang Mach-E" },
  { type: "car", year: 2023, make: "FORD", model: "Ranger" },
  { type: "car", year: 2023, make: "FORD", model: "Transit" },
  { type: "car", year: 2023, make: "GMC", model: "Acadia" },
  { type: "car", year: 2023, make: "GMC", model: "Canyon" },
  { type: "car", year: 2023, make: "GMC", model: "Savana" },
  { type: "car", year: 2023, make: "GMC", model: "Sierra" },
  { type: "car", year: 2023, make: "GMC", model: "Terrain" },
  { type: "car", year: 2023, make: "GMC", model: "Yukon" },
  { type: "car", year: 2023, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2023, make: "HONDA", model: "Accord" },
  { type: "car", year: 2023, make: "HONDA", model: "Civic" },
  { type: "car", year: 2023, make: "HONDA", model: "Civic Si" },
  { type: "car", year: 2023, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2023, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2023, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2023, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2023, make: "HONDA", model: "Passport" },
  { type: "car", year: 2023, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Elantra N" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Ioniq 5" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Ioniq 6" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Kona N" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2023, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2023, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2023, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2023, make: "INFINITI", model: "QX55" },
  { type: "car", year: 2023, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2023, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2023, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2023, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2023, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2023, make: "JAGUAR", model: "I-PACE" },
  { type: "car", year: 2023, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2023, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2023, make: "JEEP", model: "Compass" },
  { type: "car", year: 2023, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2023, make: "JEEP", model: "Grand Cherokee L" },
  { type: "car", year: 2023, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 2023, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2023, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 2023, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2023, make: "KARMA", model: "GS-6" },
  { type: "car", year: 2023, make: "KARMA", model: "Revero GT" },
  { type: "car", year: 2023, make: "KIA", model: "Carnival" },
  { type: "car", year: 2023, make: "KIA", model: "EV6" },
  { type: "car", year: 2023, make: "KIA", model: "Forte" },
  { type: "car", year: 2023, make: "KIA", model: "K5" },
  { type: "car", year: 2023, make: "KIA", model: "Niro" },
  { type: "car", year: 2023, make: "KIA", model: "Rio" },
  { type: "car", year: 2023, make: "KIA", model: "Seltos" },
  { type: "car", year: 2023, make: "KIA", model: "Sorento" },
  { type: "car", year: 2023, make: "KIA", model: "Soul" },
  { type: "car", year: 2023, make: "KIA", model: "Sportage" },
  { type: "car", year: 2023, make: "KIA", model: "Stinger" },
  { type: "car", year: 2023, make: "KIA", model: "Telluride" },
  { type: "car", year: 2023, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2023, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2023, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2023, make: "LEXUS", model: "ES" },
  { type: "car", year: 2023, make: "LEXUS", model: "GS" },
  { type: "car", year: 2023, make: "LEXUS", model: "GX" },
  { type: "car", year: 2023, make: "LEXUS", model: "IS" },
  { type: "car", year: 2023, make: "LEXUS", model: "LC" },
  { type: "car", year: 2023, make: "LEXUS", model: "LS" },
  { type: "car", year: 2023, make: "LEXUS", model: "LX" },
  { type: "car", year: 2023, make: "LEXUS", model: "NX" },
  { type: "car", year: 2023, make: "LEXUS", model: "RC" },
  { type: "car", year: 2023, make: "LEXUS", model: "RX" },
  { type: "car", year: 2023, make: "LEXUS", model: "RZ" },
  { type: "car", year: 2023, make: "LEXUS", model: "SC" },
  { type: "car", year: 2023, make: "LEXUS", model: "UX" },
  { type: "car", year: 2023, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2023, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2023, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2023, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2023, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2023, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2023, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2023, make: "LUCID", model: "Air" },
  { type: "car", year: 2023, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2023, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2023, make: "MASERATI", model: "Grecale" },
  { type: "car", year: 2023, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2023, make: "MASERATI", model: "MC20" },
  { type: "car", year: 2023, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2023, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2023, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2023, make: "MAZDA", model: "CX-50" },
  { type: "car", year: 2023, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2023, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2023, make: "MAZDA", model: "MX-30" },
  { type: "car", year: 2023, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2023, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2023, make: "MCLAREN", model: "ARTURA" },
  { type: "car", year: 2023, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "EQB-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "EQE-Class Sedan" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "EQE-Class SUV" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "EQS-Class Sedan" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "EQS-Class SUV" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2023, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2023, make: "MINI", model: "Clubman" },
  { type: "car", year: 2023, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2023, make: "MINI", model: "Countryman" },
  { type: "car", year: 2023, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2023, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2023, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2023, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2023, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2023, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2023, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2023, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2023, make: "NISSAN", model: "Ariya Hatchback" },
  { type: "car", year: 2023, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2023, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2023, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2023, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2023, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2023, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2023, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2023, make: "NISSAN", model: "Nissan Z" },
  { type: "car", year: 2023, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2023, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2023, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2023, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2023, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2023, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2023, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2023, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2023, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2023, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2023, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2023, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2023, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2023, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2023, make: "PORSCHE", model: "718 Spyder" },
  { type: "car", year: 2023, make: "PORSCHE", model: "911" },
  { type: "car", year: 2023, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2023, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2023, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2023, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2023, make: "RAM", model: "1500" },
  { type: "car", year: 2023, make: "RAM", model: "2500" },
  { type: "car", year: 2023, make: "RAM", model: "3500" },
  { type: "car", year: 2023, make: "RAM", model: "4000" },
  { type: "car", year: 2023, make: "RAM", model: "4500" },
  { type: "car", year: 2023, make: "RAM", model: "5500" },
  { type: "car", year: 2023, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2023, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2023, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2023, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2023, make: "RIVIAN", model: "R1S" },
  { type: "car", year: 2023, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2023, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2023, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2023, make: "SAAB", model: "9-3" },
  { type: "car", year: 2023, make: "SAAB", model: "9-5" },
  { type: "car", year: 2023, make: "SHELBY", model: "Cobra" },
  { type: "car", year: 2023, make: "SHELBY", model: "GT" },
  { type: "car", year: 2023, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2023, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2023, make: "SPYKER", model: "C12" },
  { type: "car", year: 2023, make: "SPYKER", model: "C8" },
  { type: "car", year: 2023, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2023, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2023, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2023, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2023, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2023, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2023, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2023, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2023, make: "SUBARU", model: "Solterra" },
  { type: "car", year: 2023, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2023, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2023, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2023, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2023, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2023, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2023, make: "TESLA", model: "Model S" },
  { type: "car", year: 2023, make: "TESLA", model: "Model X" },
  { type: "car", year: 2023, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2023, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2023, make: "TOYOTA", model: "bZ4X" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Corolla Cross" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Crown" },
  { type: "car", year: 2023, make: "TOYOTA", model: "GR Corolla" },
  { type: "car", year: 2023, make: "TOYOTA", model: "GR86" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2023, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2023, make: "TOYOTA", model: "RAV4 Prime (PHEV)" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2023, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2023, make: "VOLVO", model: "C40" },
  { type: "car", year: 2023, make: "VOLVO", model: "S60" },
  { type: "car", year: 2023, make: "VOLVO", model: "S90" },
  { type: "car", year: 2023, make: "VOLVO", model: "V60" },
  { type: "car", year: 2023, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2023, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2023, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2023, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2023, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2023, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2022, make: "ACURA", model: "ILX" },
  { type: "car", year: 2022, make: "ACURA", model: "MDX" },
  { type: "car", year: 2022, make: "ACURA", model: "NSX" },
  { type: "car", year: 2022, make: "ACURA", model: "RDX" },
  { type: "car", year: 2022, make: "ACURA", model: "RLX" },
  { type: "car", year: 2022, make: "ACURA", model: "TLX" },
  { type: "car", year: 2022, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2022, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2022, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2022, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2022, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2022, make: "ASTON MARTIN", model: "DBX" },
  { type: "car", year: 2022, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2022, make: "AUDI", model: "A3" },
  { type: "car", year: 2022, make: "AUDI", model: "A4" },
  { type: "car", year: 2022, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2022, make: "AUDI", model: "A5" },
  { type: "car", year: 2022, make: "AUDI", model: "A6" },
  { type: "car", year: 2022, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2022, make: "AUDI", model: "A7" },
  { type: "car", year: 2022, make: "AUDI", model: "A7 e" },
  { type: "car", year: 2022, make: "AUDI", model: "A8 L" },
  { type: "car", year: 2022, make: "AUDI", model: "e-tron" },
  { type: "car", year: 2022, make: "AUDI", model: "e-tron GT" },
  { type: "car", year: 2022, make: "AUDI", model: "e-tron Sportback" },
  { type: "car", year: 2022, make: "AUDI", model: "Q3" },
  { type: "car", year: 2022, make: "AUDI", model: "Q4" },
  { type: "car", year: 2022, make: "AUDI", model: "Q5" },
  { type: "car", year: 2022, make: "AUDI", model: "Q7" },
  { type: "car", year: 2022, make: "AUDI", model: "Q8" },
  { type: "car", year: 2022, make: "AUDI", model: "R8" },
  { type: "car", year: 2022, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2022, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2022, make: "AUDI", model: "RS 6 Avant" },
  { type: "car", year: 2022, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2022, make: "AUDI", model: "RS e-tron GT" },
  { type: "car", year: 2022, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2022, make: "AUDI", model: "S3" },
  { type: "car", year: 2022, make: "AUDI", model: "S4" },
  { type: "car", year: 2022, make: "AUDI", model: "S5" },
  { type: "car", year: 2022, make: "AUDI", model: "S6" },
  { type: "car", year: 2022, make: "AUDI", model: "S7" },
  { type: "car", year: 2022, make: "AUDI", model: "S8" },
  { type: "car", year: 2022, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2022, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2022, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2022, make: "AUDI", model: "TT" },
  { type: "car", year: 2022, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2022, make: "AUDI", model: "TTS" },
  { type: "car", year: 2022, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2022, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2022, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2022, make: "BMW", model: "228i" },
  { type: "car", year: 2022, make: "BMW", model: "230i" },
  { type: "car", year: 2022, make: "BMW", model: "330e" },
  { type: "car", year: 2022, make: "BMW", model: "330i" },
  { type: "car", year: 2022, make: "BMW", model: "430i" },
  { type: "car", year: 2022, make: "BMW", model: "530e" },
  { type: "car", year: 2022, make: "BMW", model: "530i" },
  { type: "car", year: 2022, make: "BMW", model: "540i" },
  { type: "car", year: 2022, make: "BMW", model: "740Li" },
  { type: "car", year: 2022, make: "BMW", model: "745Le" },
  { type: "car", year: 2022, make: "BMW", model: "750i" },
  { type: "car", year: 2022, make: "BMW", model: "750Li" },
  { type: "car", year: 2022, make: "BMW", model: "840i" },
  { type: "car", year: 2022, make: "BMW", model: "Alpina B8" },
  { type: "car", year: 2022, make: "BMW", model: "B7" },
  { type: "car", year: 2022, make: "BMW", model: "i4" },
  { type: "car", year: 2022, make: "BMW", model: "iX" },
  { type: "car", year: 2022, make: "BMW", model: "M2" },
  { type: "car", year: 2022, make: "BMW", model: "M235i" },
  { type: "car", year: 2022, make: "BMW", model: "M240i" },
  { type: "car", year: 2022, make: "BMW", model: "M3" },
  { type: "car", year: 2022, make: "BMW", model: "M340i" },
  { type: "car", year: 2022, make: "BMW", model: "M4" },
  { type: "car", year: 2022, make: "BMW", model: "M440i" },
  { type: "car", year: 2022, make: "BMW", model: "M5" },
  { type: "car", year: 2022, make: "BMW", model: "M550i" },
  { type: "car", year: 2022, make: "BMW", model: "M760Li" },
  { type: "car", year: 2022, make: "BMW", model: "M8" },
  { type: "car", year: 2022, make: "BMW", model: "M850i" },
  { type: "car", year: 2022, make: "BMW", model: "X1" },
  { type: "car", year: 2022, make: "BMW", model: "X2" },
  { type: "car", year: 2022, make: "BMW", model: "X3" },
  { type: "car", year: 2022, make: "BMW", model: "X4" },
  { type: "car", year: 2022, make: "BMW", model: "X5" },
  { type: "car", year: 2022, make: "BMW", model: "X6" },
  { type: "car", year: 2022, make: "BMW", model: "X7" },
  { type: "car", year: 2022, make: "BMW", model: "Z4" },
  { type: "car", year: 2022, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2022, make: "BUGATTI", model: "Chiron Pur Sport" },
  { type: "car", year: 2022, make: "BUGATTI", model: "Chiron Supersport" },
  { type: "car", year: 2022, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2022, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2022, make: "BUICK", model: "Encore" },
  { type: "car", year: 2022, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2022, make: "BUICK", model: "Envision" },
  { type: "car", year: 2022, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2022, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2022, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2022, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2022, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2022, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2022, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2022, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2022, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Bolt EUV" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Onix" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2022, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2022, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2022, make: "CHRYSLER", model: "Grand Caravan" },
  { type: "car", year: 2022, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2022, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2022, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2022, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2022, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2022, make: "DODGE", model: "Charger" },
  { type: "car", year: 2022, make: "DODGE", model: "Durango" },
  { type: "car", year: 2022, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2022, make: "DODGE", model: "Journey" },
  { type: "car", year: 2022, make: "FERRARI", model: "296" },
  { type: "car", year: 2022, make: "FERRARI", model: "812" },
  { type: "car", year: 2022, make: "FERRARI", model: "F8" },
  { type: "car", year: 2022, make: "FERRARI", model: "Portofino M" },
  { type: "car", year: 2022, make: "FERRARI", model: "Roma" },
  { type: "car", year: 2022, make: "FERRARI", model: "SF90" },
  { type: "car", year: 2022, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2022, make: "FIAT", model: "500X" },
  { type: "car", year: 2022, make: "FIAT", model: "Ducato" },
  { type: "car", year: 2022, make: "FISKER", model: "Karma" },
  { type: "car", year: 2022, make: "FISKER", model: "Nina" },
  { type: "car", year: 2022, make: "FORD", model: "'34" },
  { type: "car", year: 2022, make: "FORD", model: "Bronco" },
  { type: "car", year: 2022, make: "FORD", model: "Bronco Sport" },
  { type: "car", year: 2022, make: "FORD", model: "E-350" },
  { type: "car", year: 2022, make: "FORD", model: "E-450" },
  { type: "car", year: 2022, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2022, make: "FORD", model: "Edge" },
  { type: "car", year: 2022, make: "FORD", model: "Escape" },
  { type: "car", year: 2022, make: "FORD", model: "Expedition" },
  { type: "car", year: 2022, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2022, make: "FORD", model: "Explorer" },
  { type: "car", year: 2022, make: "FORD", model: "F-150" },
  { type: "car", year: 2022, make: "FORD", model: "F-250" },
  { type: "car", year: 2022, make: "FORD", model: "F-350" },
  { type: "car", year: 2022, make: "FORD", model: "F-450" },
  { type: "car", year: 2022, make: "FORD", model: "F-550" },
  { type: "car", year: 2022, make: "FORD", model: "F-600" },
  { type: "car", year: 2022, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2022, make: "FORD", model: "Flex" },
  { type: "car", year: 2022, make: "FORD", model: "Focus" },
  { type: "car", year: 2022, make: "FORD", model: "GT" },
  { type: "car", year: 2022, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2022, make: "FORD", model: "Mustang" },
  { type: "car", year: 2022, make: "FORD", model: "Mustang Mach-E" },
  { type: "car", year: 2022, make: "FORD", model: "Ranger" },
  { type: "car", year: 2022, make: "FORD", model: "Transit" },
  { type: "car", year: 2022, make: "GMC", model: "Acadia" },
  { type: "car", year: 2022, make: "GMC", model: "Canyon" },
  { type: "car", year: 2022, make: "GMC", model: "Savana" },
  { type: "car", year: 2022, make: "GMC", model: "Sierra" },
  { type: "car", year: 2022, make: "GMC", model: "Terrain" },
  { type: "car", year: 2022, make: "GMC", model: "Yukon" },
  { type: "car", year: 2022, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2022, make: "HONDA", model: "Accord" },
  { type: "car", year: 2022, make: "HONDA", model: "Civic" },
  { type: "car", year: 2022, make: "HONDA", model: "Civic Si" },
  { type: "car", year: 2022, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2022, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2022, make: "HONDA", model: "Insight" },
  { type: "car", year: 2022, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2022, make: "HONDA", model: "Passport" },
  { type: "car", year: 2022, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Elantra N" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Ioniq" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Ioniq 5" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Kona N" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Veloster N" },
  { type: "car", year: 2022, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2022, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2022, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2022, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2022, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2022, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2022, make: "INFINITI", model: "QX55" },
  { type: "car", year: 2022, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2022, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2022, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2022, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2022, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2022, make: "JAGUAR", model: "I-PACE" },
  { type: "car", year: 2022, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2022, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2022, make: "JEEP", model: "Compass" },
  { type: "car", year: 2022, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2022, make: "JEEP", model: "Grand Cherokee L" },
  { type: "car", year: 2022, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 2022, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2022, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 2022, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2022, make: "KARMA", model: "GS-6" },
  { type: "car", year: 2022, make: "KARMA", model: "Revero GT" },
  { type: "car", year: 2022, make: "KIA", model: "Carnival" },
  { type: "car", year: 2022, make: "KIA", model: "EV6" },
  { type: "car", year: 2022, make: "KIA", model: "Forte" },
  { type: "car", year: 2022, make: "KIA", model: "K5" },
  { type: "car", year: 2022, make: "KIA", model: "Niro" },
  { type: "car", year: 2022, make: "KIA", model: "Rio" },
  { type: "car", year: 2022, make: "KIA", model: "Seltos" },
  { type: "car", year: 2022, make: "KIA", model: "Sorento" },
  { type: "car", year: 2022, make: "KIA", model: "Soul" },
  { type: "car", year: 2022, make: "KIA", model: "Sportage" },
  { type: "car", year: 2022, make: "KIA", model: "Stinger" },
  { type: "car", year: 2022, make: "KIA", model: "Telluride" },
  { type: "car", year: 2022, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2022, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2022, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "New Range Rover" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2022, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2022, make: "LEXUS", model: "ES" },
  { type: "car", year: 2022, make: "LEXUS", model: "GS" },
  { type: "car", year: 2022, make: "LEXUS", model: "GX" },
  { type: "car", year: 2022, make: "LEXUS", model: "IS" },
  { type: "car", year: 2022, make: "LEXUS", model: "LC" },
  { type: "car", year: 2022, make: "LEXUS", model: "LS" },
  { type: "car", year: 2022, make: "LEXUS", model: "LX" },
  { type: "car", year: 2022, make: "LEXUS", model: "NX" },
  { type: "car", year: 2022, make: "LEXUS", model: "RC" },
  { type: "car", year: 2022, make: "LEXUS", model: "RX" },
  { type: "car", year: 2022, make: "LEXUS", model: "SC" },
  { type: "car", year: 2022, make: "LEXUS", model: "UX" },
  { type: "car", year: 2022, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2022, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2022, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2022, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2022, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2022, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2022, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2022, make: "LUCID", model: "Air" },
  { type: "car", year: 2022, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2022, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2022, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2022, make: "MASERATI", model: "MC20" },
  { type: "car", year: 2022, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2022, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2022, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2022, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2022, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2022, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2022, make: "MAZDA", model: "MX-30" },
  { type: "car", year: 2022, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2022, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2022, make: "MCLAREN", model: "765LT" },
  { type: "car", year: 2022, make: "MCLAREN", model: "ELVA" },
  { type: "car", year: 2022, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "A-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "EQB-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "EQS-Class Sedan" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2022, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2022, make: "MINI", model: "Clubman" },
  { type: "car", year: 2022, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2022, make: "MINI", model: "Countryman" },
  { type: "car", year: 2022, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2022, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2022, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2022, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2022, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2022, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2022, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2022, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2022, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2022, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2022, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2022, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2022, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2022, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2022, make: "NISSAN", model: "Rogue Sport" },
  { type: "car", year: 2022, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2022, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2022, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2022, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2022, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2022, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2022, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2022, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2022, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2022, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2022, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2022, make: "PORSCHE", model: "718 Spyder" },
  { type: "car", year: 2022, make: "PORSCHE", model: "911" },
  { type: "car", year: 2022, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2022, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2022, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2022, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2022, make: "RAM", model: "1500" },
  { type: "car", year: 2022, make: "RAM", model: "2500" },
  { type: "car", year: 2022, make: "RAM", model: "3500" },
  { type: "car", year: 2022, make: "RAM", model: "4000" },
  { type: "car", year: 2022, make: "RAM", model: "4500" },
  { type: "car", year: 2022, make: "RAM", model: "5500" },
  { type: "car", year: 2022, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2022, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2022, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2022, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2022, make: "RIVIAN", model: "R1S" },
  { type: "car", year: 2022, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2022, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2022, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2022, make: "SAAB", model: "9-3" },
  { type: "car", year: 2022, make: "SAAB", model: "9-5" },
  { type: "car", year: 2022, make: "SHELBY", model: "GT" },
  { type: "car", year: 2022, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2022, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2022, make: "SPYKER", model: "C12" },
  { type: "car", year: 2022, make: "SPYKER", model: "C8" },
  { type: "car", year: 2022, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2022, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2022, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2022, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2022, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2022, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2022, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2022, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2022, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2022, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2022, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2022, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2022, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2022, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2022, make: "TESLA", model: "Model S" },
  { type: "car", year: 2022, make: "TESLA", model: "Model X" },
  { type: "car", year: 2022, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2022, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2022, make: "TOYOTA", model: "C-HR" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Corolla Cross" },
  { type: "car", year: 2022, make: "TOYOTA", model: "GR86" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2022, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2022, make: "TOYOTA", model: "RAV4 Prime (PHEV)" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2022, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2022, make: "VOLVO", model: "C40" },
  { type: "car", year: 2022, make: "VOLVO", model: "S60" },
  { type: "car", year: 2022, make: "VOLVO", model: "S90" },
  { type: "car", year: 2022, make: "VOLVO", model: "V60" },
  { type: "car", year: 2022, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2022, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2022, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2022, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2022, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2022, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2021, make: "ACURA", model: "ILX" },
  { type: "car", year: 2021, make: "ACURA", model: "MDX" },
  { type: "car", year: 2021, make: "ACURA", model: "NSX" },
  { type: "car", year: 2021, make: "ACURA", model: "RDX" },
  { type: "car", year: 2021, make: "ACURA", model: "RLX" },
  { type: "car", year: 2021, make: "ACURA", model: "TLX" },
  { type: "car", year: 2021, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2021, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2021, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2021, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2021, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2021, make: "ASTON MARTIN", model: "DBX" },
  { type: "car", year: 2021, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2021, make: "AUDI", model: "A4" },
  { type: "car", year: 2021, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2021, make: "AUDI", model: "A5" },
  { type: "car", year: 2021, make: "AUDI", model: "A6" },
  { type: "car", year: 2021, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2021, make: "AUDI", model: "A7" },
  { type: "car", year: 2021, make: "AUDI", model: "A7 e" },
  { type: "car", year: 2021, make: "AUDI", model: "A8 L" },
  { type: "car", year: 2021, make: "AUDI", model: "A8 L e" },
  { type: "car", year: 2021, make: "AUDI", model: "e-tron" },
  { type: "car", year: 2021, make: "AUDI", model: "e-tron Sportback" },
  { type: "car", year: 2021, make: "AUDI", model: "Q3" },
  { type: "car", year: 2021, make: "AUDI", model: "Q5" },
  { type: "car", year: 2021, make: "AUDI", model: "Q5 e" },
  { type: "car", year: 2021, make: "AUDI", model: "Q7" },
  { type: "car", year: 2021, make: "AUDI", model: "Q8" },
  { type: "car", year: 2021, make: "AUDI", model: "R8" },
  { type: "car", year: 2021, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2021, make: "AUDI", model: "RS 6 Avant" },
  { type: "car", year: 2021, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2021, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2021, make: "AUDI", model: "S4" },
  { type: "car", year: 2021, make: "AUDI", model: "S5" },
  { type: "car", year: 2021, make: "AUDI", model: "S6" },
  { type: "car", year: 2021, make: "AUDI", model: "S7" },
  { type: "car", year: 2021, make: "AUDI", model: "S8" },
  { type: "car", year: 2021, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2021, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2021, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2021, make: "AUDI", model: "TT" },
  { type: "car", year: 2021, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2021, make: "AUDI", model: "TTS" },
  { type: "car", year: 2021, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2021, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2021, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2021, make: "BMW", model: "228i" },
  { type: "car", year: 2021, make: "BMW", model: "230i" },
  { type: "car", year: 2021, make: "BMW", model: "330e" },
  { type: "car", year: 2021, make: "BMW", model: "330i" },
  { type: "car", year: 2021, make: "BMW", model: "430i" },
  { type: "car", year: 2021, make: "BMW", model: "530e" },
  { type: "car", year: 2021, make: "BMW", model: "530i" },
  { type: "car", year: 2021, make: "BMW", model: "540i" },
  { type: "car", year: 2021, make: "BMW", model: "740i" },
  { type: "car", year: 2021, make: "BMW", model: "745e" },
  { type: "car", year: 2021, make: "BMW", model: "750i" },
  { type: "car", year: 2021, make: "BMW", model: "840i" },
  { type: "car", year: 2021, make: "BMW", model: "B7" },
  { type: "car", year: 2021, make: "BMW", model: "i3" },
  { type: "car", year: 2021, make: "BMW", model: "M2" },
  { type: "car", year: 2021, make: "BMW", model: "M235i" },
  { type: "car", year: 2021, make: "BMW", model: "M240i" },
  { type: "car", year: 2021, make: "BMW", model: "M3" },
  { type: "car", year: 2021, make: "BMW", model: "M340i" },
  { type: "car", year: 2021, make: "BMW", model: "M4" },
  { type: "car", year: 2021, make: "BMW", model: "M440i" },
  { type: "car", year: 2021, make: "BMW", model: "M5" },
  { type: "car", year: 2021, make: "BMW", model: "M550i" },
  { type: "car", year: 2021, make: "BMW", model: "M760i" },
  { type: "car", year: 2021, make: "BMW", model: "M8" },
  { type: "car", year: 2021, make: "BMW", model: "M850i" },
  { type: "car", year: 2021, make: "BMW", model: "X1" },
  { type: "car", year: 2021, make: "BMW", model: "X2" },
  { type: "car", year: 2021, make: "BMW", model: "X3" },
  { type: "car", year: 2021, make: "BMW", model: "X4" },
  { type: "car", year: 2021, make: "BMW", model: "X5" },
  { type: "car", year: 2021, make: "BMW", model: "X6" },
  { type: "car", year: 2021, make: "BMW", model: "X7" },
  { type: "car", year: 2021, make: "BMW", model: "Z4" },
  { type: "car", year: 2021, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2021, make: "BUGATTI", model: "Chiron Pur Sport" },
  { type: "car", year: 2021, make: "BUGATTI", model: "Chiron Supersport" },
  { type: "car", year: 2021, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2021, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2021, make: "BUICK", model: "Encore" },
  { type: "car", year: 2021, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2021, make: "BUICK", model: "Envision" },
  { type: "car", year: 2021, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2021, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2021, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2021, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2021, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2021, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2021, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2021, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2021, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Onix" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2021, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2021, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2021, make: "CHRYSLER", model: "Grand Caravan" },
  { type: "car", year: 2021, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2021, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2021, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2021, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2021, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2021, make: "DODGE", model: "Charger" },
  { type: "car", year: 2021, make: "DODGE", model: "Durango" },
  { type: "car", year: 2021, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2021, make: "DODGE", model: "Journey" },
  { type: "car", year: 2021, make: "FERRARI", model: "812" },
  { type: "car", year: 2021, make: "FERRARI", model: "F8" },
  { type: "car", year: 2021, make: "FERRARI", model: "Portofino" },
  { type: "car", year: 2021, make: "FERRARI", model: "Portofino M" },
  { type: "car", year: 2021, make: "FERRARI", model: "Roma" },
  { type: "car", year: 2021, make: "FERRARI", model: "SF90" },
  { type: "car", year: 2021, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2021, make: "FIAT", model: "500X" },
  { type: "car", year: 2021, make: "FIAT", model: "Ducato" },
  { type: "car", year: 2021, make: "FISKER", model: "Karma" },
  { type: "car", year: 2021, make: "FISKER", model: "Nina" },
  { type: "car", year: 2021, make: "FORD", model: "'34" },
  { type: "car", year: 2021, make: "FORD", model: "Bronco" },
  { type: "car", year: 2021, make: "FORD", model: "Bronco Sport" },
  { type: "car", year: 2021, make: "FORD", model: "E-350" },
  { type: "car", year: 2021, make: "FORD", model: "E-450" },
  { type: "car", year: 2021, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2021, make: "FORD", model: "Edge" },
  { type: "car", year: 2021, make: "FORD", model: "Escape" },
  { type: "car", year: 2021, make: "FORD", model: "Expedition" },
  { type: "car", year: 2021, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2021, make: "FORD", model: "Explorer" },
  { type: "car", year: 2021, make: "FORD", model: "F-150" },
  { type: "car", year: 2021, make: "FORD", model: "F-250" },
  { type: "car", year: 2021, make: "FORD", model: "F-350" },
  { type: "car", year: 2021, make: "FORD", model: "F-450" },
  { type: "car", year: 2021, make: "FORD", model: "F-550" },
  { type: "car", year: 2021, make: "FORD", model: "F-600" },
  { type: "car", year: 2021, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2021, make: "FORD", model: "Flex" },
  { type: "car", year: 2021, make: "FORD", model: "Focus" },
  { type: "car", year: 2021, make: "FORD", model: "GT" },
  { type: "car", year: 2021, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2021, make: "FORD", model: "Mustang" },
  { type: "car", year: 2021, make: "FORD", model: "Mustang Mach-E" },
  { type: "car", year: 2021, make: "FORD", model: "Ranger" },
  { type: "car", year: 2021, make: "FORD", model: "Transit" },
  { type: "car", year: 2021, make: "GMC", model: "Acadia" },
  { type: "car", year: 2021, make: "GMC", model: "Canyon" },
  { type: "car", year: 2021, make: "GMC", model: "Savana" },
  { type: "car", year: 2021, make: "GMC", model: "Sierra" },
  { type: "car", year: 2021, make: "GMC", model: "Terrain" },
  { type: "car", year: 2021, make: "GMC", model: "Yukon" },
  { type: "car", year: 2021, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2021, make: "HONDA", model: "Accord" },
  { type: "car", year: 2021, make: "HONDA", model: "Civic" },
  { type: "car", year: 2021, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2021, make: "HONDA", model: "Clarity" },
  { type: "car", year: 2021, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2021, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2021, make: "HONDA", model: "Insight" },
  { type: "car", year: 2021, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2021, make: "HONDA", model: "Passport" },
  { type: "car", year: 2021, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Ioniq" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Veloster N" },
  { type: "car", year: 2021, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2021, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2021, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2021, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2021, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2021, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2021, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2021, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2021, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2021, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2021, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2021, make: "JAGUAR", model: "I-PACE" },
  { type: "car", year: 2021, make: "JAGUAR", model: "XE" },
  { type: "car", year: 2021, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2021, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2021, make: "JEEP", model: "Compass" },
  { type: "car", year: 2021, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2021, make: "JEEP", model: "Grand Cherokee L" },
  { type: "car", year: 2021, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2021, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2021, make: "KARMA", model: "GS-6" },
  { type: "car", year: 2021, make: "KARMA", model: "Revero GT" },
  { type: "car", year: 2021, make: "KIA", model: "Forte" },
  { type: "car", year: 2021, make: "KIA", model: "K5" },
  { type: "car", year: 2021, make: "KIA", model: "Niro" },
  { type: "car", year: 2021, make: "KIA", model: "Rio" },
  { type: "car", year: 2021, make: "KIA", model: "Sedona" },
  { type: "car", year: 2021, make: "KIA", model: "Seltos" },
  { type: "car", year: 2021, make: "KIA", model: "Sorento" },
  { type: "car", year: 2021, make: "KIA", model: "Soul" },
  { type: "car", year: 2021, make: "KIA", model: "Sportage" },
  { type: "car", year: 2021, make: "KIA", model: "Stinger" },
  { type: "car", year: 2021, make: "KIA", model: "Telluride" },
  { type: "car", year: 2021, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2021, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2021, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2021, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2021, make: "LEXUS", model: "ES" },
  { type: "car", year: 2021, make: "LEXUS", model: "GS" },
  { type: "car", year: 2021, make: "LEXUS", model: "GX" },
  { type: "car", year: 2021, make: "LEXUS", model: "IS" },
  { type: "car", year: 2021, make: "LEXUS", model: "LC" },
  { type: "car", year: 2021, make: "LEXUS", model: "LS" },
  { type: "car", year: 2021, make: "LEXUS", model: "LX" },
  { type: "car", year: 2021, make: "LEXUS", model: "NX" },
  { type: "car", year: 2021, make: "LEXUS", model: "RC" },
  { type: "car", year: 2021, make: "LEXUS", model: "RX" },
  { type: "car", year: 2021, make: "LEXUS", model: "SC" },
  { type: "car", year: 2021, make: "LEXUS", model: "UX" },
  { type: "car", year: 2021, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2021, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2021, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2021, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2021, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2021, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2021, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2021, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2021, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2021, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2021, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2021, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2021, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2021, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2021, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2021, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2021, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2021, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2021, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2021, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2021, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2021, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2021, make: "MCLAREN", model: "600LT" },
  { type: "car", year: 2021, make: "MCLAREN", model: "620R" },
  { type: "car", year: 2021, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2021, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2021, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2021, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2021, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2021, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2021, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2021, make: "MCLAREN", model: "SENNA" },
  { type: "car", year: 2021, make: "MCLAREN", model: "SENNA GTR" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "A-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2021, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2021, make: "MINI", model: "Clubman" },
  { type: "car", year: 2021, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2021, make: "MINI", model: "Countryman" },
  { type: "car", year: 2021, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2021, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2021, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2021, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2021, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2021, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2021, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2021, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2021, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2021, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2021, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2021, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2021, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2021, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2021, make: "NISSAN", model: "Rogue Sport" },
  { type: "car", year: 2021, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2021, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2021, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2021, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2021, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2021, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2021, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2021, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2021, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2021, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2021, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2021, make: "PORSCHE", model: "911" },
  { type: "car", year: 2021, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2021, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2021, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2021, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2021, make: "RAM", model: "1500" },
  { type: "car", year: 2021, make: "RAM", model: "2500" },
  { type: "car", year: 2021, make: "RAM", model: "3500" },
  { type: "car", year: 2021, make: "RAM", model: "4000" },
  { type: "car", year: 2021, make: "RAM", model: "4500" },
  { type: "car", year: 2021, make: "RAM", model: "5500" },
  { type: "car", year: 2021, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2021, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2021, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2021, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2021, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2021, make: "ROLLS-ROYCE", model: "Dawn" },
  { type: "car", year: 2021, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2021, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2021, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2021, make: "SAAB", model: "9-3" },
  { type: "car", year: 2021, make: "SAAB", model: "9-5" },
  { type: "car", year: 2021, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2021, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2021, make: "SPYKER", model: "C12" },
  { type: "car", year: 2021, make: "SPYKER", model: "C8" },
  { type: "car", year: 2021, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2021, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2021, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2021, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2021, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2021, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2021, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2021, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2021, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2021, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2021, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2021, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2021, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2021, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2021, make: "TESLA", model: "Model S" },
  { type: "car", year: 2021, make: "TESLA", model: "Model X" },
  { type: "car", year: 2021, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2021, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2021, make: "TOYOTA", model: "C-HR" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2021, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2021, make: "TOYOTA", model: "RAV4 Prime (PHEV)" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2021, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2021, make: "VOLVO", model: "S60" },
  { type: "car", year: 2021, make: "VOLVO", model: "S90" },
  { type: "car", year: 2021, make: "VOLVO", model: "V60" },
  { type: "car", year: 2021, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2021, make: "VOLVO", model: "V90" },
  { type: "car", year: 2021, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2021, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2021, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2021, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2021, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2020, make: "ACURA", model: "ILX" },
  { type: "car", year: 2020, make: "ACURA", model: "MDX" },
  { type: "car", year: 2020, make: "ACURA", model: "NSX" },
  { type: "car", year: 2020, make: "ACURA", model: "RDX" },
  { type: "car", year: 2020, make: "ACURA", model: "RLX" },
  { type: "car", year: 2020, make: "ACURA", model: "TLX" },
  { type: "car", year: 2020, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2020, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2020, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2020, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2020, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2020, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2020, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2020, make: "AUDI", model: "A3" },
  { type: "car", year: 2020, make: "AUDI", model: "A4" },
  { type: "car", year: 2020, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2020, make: "AUDI", model: "A5" },
  { type: "car", year: 2020, make: "AUDI", model: "A6" },
  { type: "car", year: 2020, make: "AUDI", model: "A6 allroad" },
  { type: "car", year: 2020, make: "AUDI", model: "A7" },
  { type: "car", year: 2020, make: "AUDI", model: "A8" },
  { type: "car", year: 2020, make: "AUDI", model: "A8 e" },
  { type: "car", year: 2020, make: "AUDI", model: "e-tron Sportback" },
  { type: "car", year: 2020, make: "AUDI", model: "Q3" },
  { type: "car", year: 2020, make: "AUDI", model: "Q5" },
  { type: "car", year: 2020, make: "AUDI", model: "Q5 e" },
  { type: "car", year: 2020, make: "AUDI", model: "Q7" },
  { type: "car", year: 2020, make: "AUDI", model: "Q8" },
  { type: "car", year: 2020, make: "AUDI", model: "R8" },
  { type: "car", year: 2020, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2020, make: "AUDI", model: "RS Q8" },
  { type: "car", year: 2020, make: "AUDI", model: "S3" },
  { type: "car", year: 2020, make: "AUDI", model: "S4" },
  { type: "car", year: 2020, make: "AUDI", model: "S5" },
  { type: "car", year: 2020, make: "AUDI", model: "S6" },
  { type: "car", year: 2020, make: "AUDI", model: "S7" },
  { type: "car", year: 2020, make: "AUDI", model: "S8" },
  { type: "car", year: 2020, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2020, make: "AUDI", model: "SQ7" },
  { type: "car", year: 2020, make: "AUDI", model: "SQ8" },
  { type: "car", year: 2020, make: "AUDI", model: "TT" },
  { type: "car", year: 2020, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2020, make: "AUDI", model: "TTS" },
  { type: "car", year: 2020, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2020, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2020, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2020, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2020, make: "BMW", model: "228i" },
  { type: "car", year: 2020, make: "BMW", model: "230i" },
  { type: "car", year: 2020, make: "BMW", model: "330i" },
  { type: "car", year: 2020, make: "BMW", model: "430i" },
  { type: "car", year: 2020, make: "BMW", model: "440i" },
  { type: "car", year: 2020, make: "BMW", model: "530e" },
  { type: "car", year: 2020, make: "BMW", model: "530i" },
  { type: "car", year: 2020, make: "BMW", model: "540i" },
  { type: "car", year: 2020, make: "BMW", model: "740i" },
  { type: "car", year: 2020, make: "BMW", model: "745e" },
  { type: "car", year: 2020, make: "BMW", model: "750i" },
  { type: "car", year: 2020, make: "BMW", model: "840i" },
  { type: "car", year: 2020, make: "BMW", model: "B7" },
  { type: "car", year: 2020, make: "BMW", model: "i3" },
  { type: "car", year: 2020, make: "BMW", model: "i8" },
  { type: "car", year: 2020, make: "BMW", model: "M2" },
  { type: "car", year: 2020, make: "BMW", model: "M235i" },
  { type: "car", year: 2020, make: "BMW", model: "M240i" },
  { type: "car", year: 2020, make: "BMW", model: "M340i" },
  { type: "car", year: 2020, make: "BMW", model: "M4" },
  { type: "car", year: 2020, make: "BMW", model: "M5" },
  { type: "car", year: 2020, make: "BMW", model: "M550i" },
  { type: "car", year: 2020, make: "BMW", model: "M760i" },
  { type: "car", year: 2020, make: "BMW", model: "M8" },
  { type: "car", year: 2020, make: "BMW", model: "M850i" },
  { type: "car", year: 2020, make: "BMW", model: "X1" },
  { type: "car", year: 2020, make: "BMW", model: "X2" },
  { type: "car", year: 2020, make: "BMW", model: "X3" },
  { type: "car", year: 2020, make: "BMW", model: "X4" },
  { type: "car", year: 2020, make: "BMW", model: "X5" },
  { type: "car", year: 2020, make: "BMW", model: "X6" },
  { type: "car", year: 2020, make: "BMW", model: "X7" },
  { type: "car", year: 2020, make: "BMW", model: "Z4" },
  { type: "car", year: 2020, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2020, make: "BUGATTI", model: "Chiron Pur Sport" },
  { type: "car", year: 2020, make: "BUGATTI", model: "Chiron Supersport" },
  { type: "car", year: 2020, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2020, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2020, make: "BUICK", model: "Encore" },
  { type: "car", year: 2020, make: "BUICK", model: "Encore GX" },
  { type: "car", year: 2020, make: "BUICK", model: "Envision" },
  { type: "car", year: 2020, make: "BUICK", model: "Regal" },
  { type: "car", year: 2020, make: "BUICK", model: "Regal TourX" },
  { type: "car", year: 2020, make: "CADILLAC", model: "CT4" },
  { type: "car", year: 2020, make: "CADILLAC", model: "CT5" },
  { type: "car", year: 2020, make: "CADILLAC", model: "CT6" },
  { type: "car", year: 2020, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2020, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2020, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2020, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2020, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2020, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2020, make: "CADILLAC", model: "XT6" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2020, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2020, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2020, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2020, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2020, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2020, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2020, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2020, make: "DODGE", model: "Charger" },
  { type: "car", year: 2020, make: "DODGE", model: "Durango" },
  { type: "car", year: 2020, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2020, make: "DODGE", model: "Journey" },
  { type: "car", year: 2020, make: "FERRARI", model: "488" },
  { type: "car", year: 2020, make: "FERRARI", model: "812" },
  { type: "car", year: 2020, make: "FERRARI", model: "F8" },
  { type: "car", year: 2020, make: "FERRARI", model: "GTC4Lusso" },
  { type: "car", year: 2020, make: "FERRARI", model: "Portofino" },
  { type: "car", year: 2020, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2020, make: "FIAT", model: "500L" },
  { type: "car", year: 2020, make: "FIAT", model: "500X" },
  { type: "car", year: 2020, make: "FIAT", model: "Ducato" },
  { type: "car", year: 2020, make: "FISKER", model: "Karma" },
  { type: "car", year: 2020, make: "FISKER", model: "Nina" },
  { type: "car", year: 2020, make: "FORD", model: "'34" },
  { type: "car", year: 2020, make: "FORD", model: "E-350" },
  { type: "car", year: 2020, make: "FORD", model: "E-450" },
  { type: "car", year: 2020, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2020, make: "FORD", model: "Edge" },
  { type: "car", year: 2020, make: "FORD", model: "Escape" },
  { type: "car", year: 2020, make: "FORD", model: "Expedition" },
  { type: "car", year: 2020, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2020, make: "FORD", model: "Explorer" },
  { type: "car", year: 2020, make: "FORD", model: "F-150" },
  { type: "car", year: 2020, make: "FORD", model: "F-250" },
  { type: "car", year: 2020, make: "FORD", model: "F-350" },
  { type: "car", year: 2020, make: "FORD", model: "F-450" },
  { type: "car", year: 2020, make: "FORD", model: "F-550" },
  { type: "car", year: 2020, make: "FORD", model: "F-600" },
  { type: "car", year: 2020, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2020, make: "FORD", model: "Flex" },
  { type: "car", year: 2020, make: "FORD", model: "Focus" },
  { type: "car", year: 2020, make: "FORD", model: "Fusion" },
  { type: "car", year: 2020, make: "FORD", model: "GT" },
  { type: "car", year: 2020, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2020, make: "FORD", model: "Mustang" },
  { type: "car", year: 2020, make: "FORD", model: "Ranger" },
  { type: "car", year: 2020, make: "FORD", model: "Transit" },
  { type: "car", year: 2020, make: "GMC", model: "Acadia" },
  { type: "car", year: 2020, make: "GMC", model: "Canyon" },
  { type: "car", year: 2020, make: "GMC", model: "Savana" },
  { type: "car", year: 2020, make: "GMC", model: "Sierra" },
  { type: "car", year: 2020, make: "GMC", model: "Terrain" },
  { type: "car", year: 2020, make: "GMC", model: "Yukon" },
  { type: "car", year: 2020, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2020, make: "HONDA", model: "Accord" },
  { type: "car", year: 2020, make: "HONDA", model: "Civic" },
  { type: "car", year: 2020, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2020, make: "HONDA", model: "Clarity" },
  { type: "car", year: 2020, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2020, make: "HONDA", model: "Fit" },
  { type: "car", year: 2020, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2020, make: "HONDA", model: "Insight" },
  { type: "car", year: 2020, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2020, make: "HONDA", model: "Passport" },
  { type: "car", year: 2020, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Elantra GT" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Ioniq" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Palisade" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Veloster N" },
  { type: "car", year: 2020, make: "HYUNDAI", model: "Venue" },
  { type: "car", year: 2020, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2020, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2020, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2020, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2020, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2020, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2020, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2020, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2020, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2020, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2020, make: "JAGUAR", model: "I-PACE" },
  { type: "car", year: 2020, make: "JAGUAR", model: "XE" },
  { type: "car", year: 2020, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2020, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2020, make: "JEEP", model: "Compass" },
  { type: "car", year: 2020, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2020, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2020, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2020, make: "KARMA", model: "Revero" },
  { type: "car", year: 2020, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2020, make: "KIA", model: "Forte" },
  { type: "car", year: 2020, make: "KIA", model: "K900" },
  { type: "car", year: 2020, make: "KIA", model: "Niro" },
  { type: "car", year: 2020, make: "KIA", model: "Optima" },
  { type: "car", year: 2020, make: "KIA", model: "Rio" },
  { type: "car", year: 2020, make: "KIA", model: "Sedona" },
  { type: "car", year: 2020, make: "KIA", model: "Sorento" },
  { type: "car", year: 2020, make: "KIA", model: "Soul" },
  { type: "car", year: 2020, make: "KIA", model: "Sportage" },
  { type: "car", year: 2020, make: "KIA", model: "Stinger" },
  { type: "car", year: 2020, make: "KIA", model: "Telluride" },
  { type: "car", year: 2020, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2020, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2020, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2020, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2020, make: "LEXUS", model: "ES" },
  { type: "car", year: 2020, make: "LEXUS", model: "GS" },
  { type: "car", year: 2020, make: "LEXUS", model: "GX" },
  { type: "car", year: 2020, make: "LEXUS", model: "IS" },
  { type: "car", year: 2020, make: "LEXUS", model: "LC" },
  { type: "car", year: 2020, make: "LEXUS", model: "LS" },
  { type: "car", year: 2020, make: "LEXUS", model: "LX" },
  { type: "car", year: 2020, make: "LEXUS", model: "NX" },
  { type: "car", year: 2020, make: "LEXUS", model: "RC" },
  { type: "car", year: 2020, make: "LEXUS", model: "RX" },
  { type: "car", year: 2020, make: "LEXUS", model: "SC" },
  { type: "car", year: 2020, make: "LEXUS", model: "UX" },
  { type: "car", year: 2020, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2020, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2020, make: "LINCOLN", model: "Corsair" },
  { type: "car", year: 2020, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2020, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2020, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2020, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2020, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2020, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2020, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2020, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2020, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2020, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2020, make: "MAZDA", model: "CX-30" },
  { type: "car", year: 2020, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2020, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2020, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2020, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2020, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2020, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2020, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2020, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2020, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2020, make: "MCLAREN", model: "600LT" },
  { type: "car", year: 2020, make: "MCLAREN", model: "620R" },
  { type: "car", year: 2020, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2020, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2020, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2020, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2020, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2020, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2020, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2020, make: "MCLAREN", model: "SENNA" },
  { type: "car", year: 2020, make: "MCLAREN", model: "SENNA GTR" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "A-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "GLB-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "SLC-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2020, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2020, make: "MINI", model: "Clubman" },
  { type: "car", year: 2020, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2020, make: "MINI", model: "Countryman" },
  { type: "car", year: 2020, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2020, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2020, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2020, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2020, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2020, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2020, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2020, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2020, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2020, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2020, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2020, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2020, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2020, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2020, make: "NISSAN", model: "Rogue Sport" },
  { type: "car", year: 2020, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2020, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2020, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2020, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2020, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2020, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2020, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2020, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2020, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2020, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2020, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2020, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2020, make: "PORSCHE", model: "718 Spyder" },
  { type: "car", year: 2020, make: "PORSCHE", model: "911" },
  { type: "car", year: 2020, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2020, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2020, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2020, make: "PORSCHE", model: "Taycan" },
  { type: "car", year: 2020, make: "RAM", model: "1500" },
  { type: "car", year: 2020, make: "RAM", model: "2500" },
  { type: "car", year: 2020, make: "RAM", model: "3500" },
  { type: "car", year: 2020, make: "RAM", model: "4000" },
  { type: "car", year: 2020, make: "RAM", model: "4500" },
  { type: "car", year: 2020, make: "RAM", model: "5500" },
  { type: "car", year: 2020, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2020, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2020, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2020, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2020, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2020, make: "ROLLS-ROYCE", model: "Dawn" },
  { type: "car", year: 2020, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2020, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2020, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2020, make: "SAAB", model: "9-3" },
  { type: "car", year: 2020, make: "SAAB", model: "9-5" },
  { type: "car", year: 2020, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2020, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2020, make: "SPYKER", model: "C12" },
  { type: "car", year: 2020, make: "SPYKER", model: "C8" },
  { type: "car", year: 2020, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2020, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2020, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2020, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2020, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2020, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2020, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2020, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2020, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2020, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2020, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2020, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2020, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2020, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2020, make: "TESLA", model: "Model S" },
  { type: "car", year: 2020, make: "TESLA", model: "Model X" },
  { type: "car", year: 2020, make: "TESLA", model: "Model Y" },
  { type: "car", year: 2020, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2020, make: "TOYOTA", model: "86" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2020, make: "TOYOTA", model: "C-HR" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2020, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 2020, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2020, make: "VOLVO", model: "S60" },
  { type: "car", year: 2020, make: "VOLVO", model: "S90" },
  { type: "car", year: 2020, make: "VOLVO", model: "V60" },
  { type: "car", year: 2020, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2020, make: "VOLVO", model: "V90" },
  { type: "car", year: 2020, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2020, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2020, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2020, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2020, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2019, make: "ACURA", model: "ILX" },
  { type: "car", year: 2019, make: "ACURA", model: "MDX" },
  { type: "car", year: 2019, make: "ACURA", model: "NSX" },
  { type: "car", year: 2019, make: "ACURA", model: "RDX" },
  { type: "car", year: 2019, make: "ACURA", model: "RLX" },
  { type: "car", year: 2019, make: "ACURA", model: "TLX" },
  { type: "car", year: 2019, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2019, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2019, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2019, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2019, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2019, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2019, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2019, make: "ASTON MARTIN", model: "Vanquish Zagato" },
  { type: "car", year: 2019, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2019, make: "AUDI", model: "A3" },
  { type: "car", year: 2019, make: "AUDI", model: "A4" },
  { type: "car", year: 2019, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2019, make: "AUDI", model: "A5" },
  { type: "car", year: 2019, make: "AUDI", model: "A6" },
  { type: "car", year: 2019, make: "AUDI", model: "A7" },
  { type: "car", year: 2019, make: "AUDI", model: "A8" },
  { type: "car", year: 2019, make: "AUDI", model: "e-tron" },
  { type: "car", year: 2019, make: "AUDI", model: "Q3" },
  { type: "car", year: 2019, make: "AUDI", model: "Q5" },
  { type: "car", year: 2019, make: "AUDI", model: "Q7" },
  { type: "car", year: 2019, make: "AUDI", model: "Q8" },
  { type: "car", year: 2019, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2019, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2019, make: "AUDI", model: "S3" },
  { type: "car", year: 2019, make: "AUDI", model: "S4" },
  { type: "car", year: 2019, make: "AUDI", model: "S5" },
  { type: "car", year: 2019, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2019, make: "AUDI", model: "TT" },
  { type: "car", year: 2019, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2019, make: "AUDI", model: "TTS" },
  { type: "car", year: 2019, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2019, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2019, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2019, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2019, make: "BMW", model: "230i" },
  { type: "car", year: 2019, make: "BMW", model: "330i" },
  { type: "car", year: 2019, make: "BMW", model: "340i" },
  { type: "car", year: 2019, make: "BMW", model: "430i" },
  { type: "car", year: 2019, make: "BMW", model: "440i" },
  { type: "car", year: 2019, make: "BMW", model: "530e" },
  { type: "car", year: 2019, make: "BMW", model: "530i" },
  { type: "car", year: 2019, make: "BMW", model: "540d" },
  { type: "car", year: 2019, make: "BMW", model: "540i" },
  { type: "car", year: 2019, make: "BMW", model: "640i" },
  { type: "car", year: 2019, make: "BMW", model: "640xi" },
  { type: "car", year: 2019, make: "BMW", model: "650i" },
  { type: "car", year: 2019, make: "BMW", model: "650i, B6" },
  { type: "car", year: 2019, make: "BMW", model: "740e" },
  { type: "car", year: 2019, make: "BMW", model: "740i" },
  { type: "car", year: 2019, make: "BMW", model: "750i" },
  { type: "car", year: 2019, make: "BMW", model: "750i, B7" },
  { type: "car", year: 2019, make: "BMW", model: "850i" },
  { type: "car", year: 2019, make: "BMW", model: "B7" },
  { type: "car", year: 2019, make: "BMW", model: "i3" },
  { type: "car", year: 2019, make: "BMW", model: "i8" },
  { type: "car", year: 2019, make: "BMW", model: "M2" },
  { type: "car", year: 2019, make: "BMW", model: "M240i" },
  { type: "car", year: 2019, make: "BMW", model: "M4" },
  { type: "car", year: 2019, make: "BMW", model: "M5" },
  { type: "car", year: 2019, make: "BMW", model: "M550i" },
  { type: "car", year: 2019, make: "BMW", model: "M6" },
  { type: "car", year: 2019, make: "BMW", model: "M760i" },
  { type: "car", year: 2019, make: "BMW", model: "X1" },
  { type: "car", year: 2019, make: "BMW", model: "X2" },
  { type: "car", year: 2019, make: "BMW", model: "X3" },
  { type: "car", year: 2019, make: "BMW", model: "X4" },
  { type: "car", year: 2019, make: "BMW", model: "X5" },
  { type: "car", year: 2019, make: "BMW", model: "X6" },
  { type: "car", year: 2019, make: "BMW", model: "X7" },
  { type: "car", year: 2019, make: "BMW", model: "Z4" },
  { type: "car", year: 2019, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2019, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2019, make: "BUICK", model: "Cascada" },
  { type: "car", year: 2019, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2019, make: "BUICK", model: "Encore" },
  { type: "car", year: 2019, make: "BUICK", model: "Envision" },
  { type: "car", year: 2019, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2019, make: "BUICK", model: "Regal" },
  { type: "car", year: 2019, make: "BUICK", model: "Regal TourX" },
  { type: "car", year: 2019, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2019, make: "CADILLAC", model: "CT6" },
  { type: "car", year: 2019, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2019, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2019, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2019, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2019, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2019, make: "CADILLAC", model: "XT4" },
  { type: "car", year: 2019, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2019, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2019, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2019, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2019, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2019, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2019, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2019, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2019, make: "DODGE", model: "Charger" },
  { type: "car", year: 2019, make: "DODGE", model: "Durango" },
  { type: "car", year: 2019, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2019, make: "DODGE", model: "Journey" },
  { type: "car", year: 2019, make: "FERRARI", model: "488" },
  { type: "car", year: 2019, make: "FERRARI", model: "812" },
  { type: "car", year: 2019, make: "FERRARI", model: "GTC4Lusso" },
  { type: "car", year: 2019, make: "FERRARI", model: "Portofino" },
  { type: "car", year: 2019, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2019, make: "FIAT", model: "500" },
  { type: "car", year: 2019, make: "FIAT", model: "500L" },
  { type: "car", year: 2019, make: "FIAT", model: "500X" },
  { type: "car", year: 2019, make: "FIAT", model: "Ducato" },
  { type: "car", year: 2019, make: "FISKER", model: "Karma" },
  { type: "car", year: 2019, make: "FISKER", model: "Nina" },
  { type: "car", year: 2019, make: "FORD", model: "'34" },
  { type: "car", year: 2019, make: "FORD", model: "E-350" },
  { type: "car", year: 2019, make: "FORD", model: "E-450" },
  { type: "car", year: 2019, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2019, make: "FORD", model: "Edge" },
  { type: "car", year: 2019, make: "FORD", model: "Escape" },
  { type: "car", year: 2019, make: "FORD", model: "Expedition" },
  { type: "car", year: 2019, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2019, make: "FORD", model: "Explorer" },
  { type: "car", year: 2019, make: "FORD", model: "F-150" },
  { type: "car", year: 2019, make: "FORD", model: "F-250" },
  { type: "car", year: 2019, make: "FORD", model: "F-350" },
  { type: "car", year: 2019, make: "FORD", model: "F-450" },
  { type: "car", year: 2019, make: "FORD", model: "F-550" },
  { type: "car", year: 2019, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2019, make: "FORD", model: "Flex" },
  { type: "car", year: 2019, make: "FORD", model: "Focus" },
  { type: "car", year: 2019, make: "FORD", model: "Fusion" },
  { type: "car", year: 2019, make: "FORD", model: "GT" },
  { type: "car", year: 2019, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2019, make: "FORD", model: "Mustang" },
  { type: "car", year: 2019, make: "FORD", model: "Ranger" },
  { type: "car", year: 2019, make: "FORD", model: "Taurus" },
  { type: "car", year: 2019, make: "FORD", model: "Transit" },
  { type: "car", year: 2019, make: "GMC", model: "Acadia" },
  { type: "car", year: 2019, make: "GMC", model: "Canyon" },
  { type: "car", year: 2019, make: "GMC", model: "Savana" },
  { type: "car", year: 2019, make: "GMC", model: "Sierra" },
  { type: "car", year: 2019, make: "GMC", model: "Terrain" },
  { type: "car", year: 2019, make: "GMC", model: "Yukon" },
  { type: "car", year: 2019, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2019, make: "HONDA", model: "Accord" },
  { type: "car", year: 2019, make: "HONDA", model: "Civic" },
  { type: "car", year: 2019, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2019, make: "HONDA", model: "Clarity" },
  { type: "car", year: 2019, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2019, make: "HONDA", model: "Fit" },
  { type: "car", year: 2019, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2019, make: "HONDA", model: "Insight" },
  { type: "car", year: 2019, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2019, make: "HONDA", model: "Passport" },
  { type: "car", year: 2019, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Elantra GT" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Ioniq" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Nexo" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Santa Fe XL" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2019, make: "HYUNDAI", model: "Veloster N" },
  { type: "car", year: 2019, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2019, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2019, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2019, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2019, make: "INFINITI", model: "QX30" },
  { type: "car", year: 2019, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2019, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2019, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2019, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2019, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2019, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2019, make: "JAGUAR", model: "I-PACE" },
  { type: "car", year: 2019, make: "JAGUAR", model: "XE" },
  { type: "car", year: 2019, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2019, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2019, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2019, make: "JEEP", model: "Compass" },
  { type: "car", year: 2019, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2019, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2019, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2019, make: "KARMA", model: "Revero" },
  { type: "car", year: 2019, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2019, make: "KIA", model: "Forte" },
  { type: "car", year: 2019, make: "KIA", model: "K900" },
  { type: "car", year: 2019, make: "KIA", model: "Niro" },
  { type: "car", year: 2019, make: "KIA", model: "Optima" },
  { type: "car", year: 2019, make: "KIA", model: "Rio" },
  { type: "car", year: 2019, make: "KIA", model: "Sedona" },
  { type: "car", year: 2019, make: "KIA", model: "Sorento" },
  { type: "car", year: 2019, make: "KIA", model: "Soul" },
  { type: "car", year: 2019, make: "KIA", model: "Sportage" },
  { type: "car", year: 2019, make: "KIA", model: "Stinger" },
  { type: "car", year: 2019, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2019, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2019, make: "LAMBORGHINI", model: "URUS" },
  { type: "car", year: 2019, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2019, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2019, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2019, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2019, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2019, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2019, make: "LEXUS", model: "ES" },
  { type: "car", year: 2019, make: "LEXUS", model: "GS" },
  { type: "car", year: 2019, make: "LEXUS", model: "GX" },
  { type: "car", year: 2019, make: "LEXUS", model: "IS" },
  { type: "car", year: 2019, make: "LEXUS", model: "LC" },
  { type: "car", year: 2019, make: "LEXUS", model: "LS" },
  { type: "car", year: 2019, make: "LEXUS", model: "LX" },
  { type: "car", year: 2019, make: "LEXUS", model: "NX" },
  { type: "car", year: 2019, make: "LEXUS", model: "RC" },
  { type: "car", year: 2019, make: "LEXUS", model: "RX" },
  { type: "car", year: 2019, make: "LEXUS", model: "SC" },
  { type: "car", year: 2019, make: "LEXUS", model: "UX" },
  { type: "car", year: 2019, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2019, make: "LINCOLN", model: "MKC" },
  { type: "car", year: 2019, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2019, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2019, make: "LINCOLN", model: "Nautilus" },
  { type: "car", year: 2019, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2019, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2019, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2019, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2019, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2019, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2019, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2019, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2019, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2019, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2019, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2019, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2019, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2019, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2019, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2019, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2019, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2019, make: "MCLAREN", model: "600LT" },
  { type: "car", year: 2019, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2019, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2019, make: "MCLAREN", model: "SENNA" },
  { type: "car", year: 2019, make: "MCLAREN", model: "SENNA GTR" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "A-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "SLC-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2019, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2019, make: "MINI", model: "Clubman" },
  { type: "car", year: 2019, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2019, make: "MINI", model: "Countryman" },
  { type: "car", year: 2019, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2019, make: "MINI", model: "Paceman" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2019, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2019, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2019, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2019, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2019, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2019, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2019, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2019, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2019, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2019, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2019, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2019, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2019, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2019, make: "NISSAN", model: "Rogue Sport" },
  { type: "car", year: 2019, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2019, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2019, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2019, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2019, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2019, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2019, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2019, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2019, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2019, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2019, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2019, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2019, make: "PORSCHE", model: "911" },
  { type: "car", year: 2019, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2019, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2019, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2019, make: "RAM", model: "1500" },
  { type: "car", year: 2019, make: "RAM", model: "2500" },
  { type: "car", year: 2019, make: "RAM", model: "3500" },
  { type: "car", year: 2019, make: "RAM", model: "4000" },
  { type: "car", year: 2019, make: "RAM", model: "4500" },
  { type: "car", year: 2019, make: "RAM", model: "5500" },
  { type: "car", year: 2019, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2019, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2019, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2019, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2019, make: "ROLLS-ROYCE", model: "Cullinan" },
  { type: "car", year: 2019, make: "ROLLS-ROYCE", model: "Dawn" },
  { type: "car", year: 2019, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2019, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2019, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2019, make: "SAAB", model: "9-3" },
  { type: "car", year: 2019, make: "SAAB", model: "9-5" },
  { type: "car", year: 2019, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2019, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2019, make: "SPYKER", model: "C12" },
  { type: "car", year: 2019, make: "SPYKER", model: "C8" },
  { type: "car", year: 2019, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2019, make: "SUBARU", model: "Ascent" },
  { type: "car", year: 2019, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2019, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2019, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2019, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2019, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2019, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2019, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2019, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2019, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2019, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2019, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2019, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2019, make: "TESLA", model: "Model S" },
  { type: "car", year: 2019, make: "TESLA", model: "Model X" },
  { type: "car", year: 2019, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2019, make: "TOYOTA", model: "86" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2019, make: "TOYOTA", model: "C-HR" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2019, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2019, make: "TOYOTA", model: "Yaris iA" },
  { type: "car", year: 2019, make: "VOLVO", model: "S60" },
  { type: "car", year: 2019, make: "VOLVO", model: "S90" },
  { type: "car", year: 2019, make: "VOLVO", model: "V60" },
  { type: "car", year: 2019, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2019, make: "VOLVO", model: "V90" },
  { type: "car", year: 2019, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2019, make: "VOLVO", model: "XC40" },
  { type: "car", year: 2019, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2019, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2019, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2018, make: "ACURA", model: "ILX" },
  { type: "car", year: 2018, make: "ACURA", model: "MDX" },
  { type: "car", year: 2018, make: "ACURA", model: "NSX" },
  { type: "car", year: 2018, make: "ACURA", model: "RDX" },
  { type: "car", year: 2018, make: "ACURA", model: "RLX" },
  { type: "car", year: 2018, make: "ACURA", model: "TLX" },
  { type: "car", year: 2018, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2018, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2018, make: "ALFA ROMEO", model: "Stelvio" },
  { type: "car", year: 2018, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2018, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2018, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2018, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2018, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2018, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2018, make: "ASTON MARTIN", model: "Vanquish Zagato" },
  { type: "car", year: 2018, make: "AUDI", model: "A3" },
  { type: "car", year: 2018, make: "AUDI", model: "A4" },
  { type: "car", year: 2018, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2018, make: "AUDI", model: "A5" },
  { type: "car", year: 2018, make: "AUDI", model: "A6" },
  { type: "car", year: 2018, make: "AUDI", model: "A7" },
  { type: "car", year: 2018, make: "AUDI", model: "A8" },
  { type: "car", year: 2018, make: "AUDI", model: "Q3" },
  { type: "car", year: 2018, make: "AUDI", model: "Q5" },
  { type: "car", year: 2018, make: "AUDI", model: "Q7" },
  { type: "car", year: 2018, make: "AUDI", model: "R8" },
  { type: "car", year: 2018, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2018, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2018, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2018, make: "AUDI", model: "S3" },
  { type: "car", year: 2018, make: "AUDI", model: "S4" },
  { type: "car", year: 2018, make: "AUDI", model: "S5" },
  { type: "car", year: 2018, make: "AUDI", model: "S6" },
  { type: "car", year: 2018, make: "AUDI", model: "S7" },
  { type: "car", year: 2018, make: "AUDI", model: "S8" },
  { type: "car", year: 2018, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2018, make: "AUDI", model: "TT" },
  { type: "car", year: 2018, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2018, make: "AUDI", model: "TTS" },
  { type: "car", year: 2018, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2018, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2018, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2018, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2018, make: "BMW", model: "228i" },
  { type: "car", year: 2018, make: "BMW", model: "230i" },
  { type: "car", year: 2018, make: "BMW", model: "320i" },
  { type: "car", year: 2018, make: "BMW", model: "328d" },
  { type: "car", year: 2018, make: "BMW", model: "330e" },
  { type: "car", year: 2018, make: "BMW", model: "330i" },
  { type: "car", year: 2018, make: "BMW", model: "340i" },
  { type: "car", year: 2018, make: "BMW", model: "430i" },
  { type: "car", year: 2018, make: "BMW", model: "440i" },
  { type: "car", year: 2018, make: "BMW", model: "530e" },
  { type: "car", year: 2018, make: "BMW", model: "530i" },
  { type: "car", year: 2018, make: "BMW", model: "540d" },
  { type: "car", year: 2018, make: "BMW", model: "540i" },
  { type: "car", year: 2018, make: "BMW", model: "640i" },
  { type: "car", year: 2018, make: "BMW", model: "640xi" },
  { type: "car", year: 2018, make: "BMW", model: "650i" },
  { type: "car", year: 2018, make: "BMW", model: "650i, B6" },
  { type: "car", year: 2018, make: "BMW", model: "740e" },
  { type: "car", year: 2018, make: "BMW", model: "740i" },
  { type: "car", year: 2018, make: "BMW", model: "750i" },
  { type: "car", year: 2018, make: "BMW", model: "750i, B7" },
  { type: "car", year: 2018, make: "BMW", model: "ActiveHybrid 5" },
  { type: "car", year: 2018, make: "BMW", model: "i3" },
  { type: "car", year: 2018, make: "BMW", model: "M2" },
  { type: "car", year: 2018, make: "BMW", model: "M240i" },
  { type: "car", year: 2018, make: "BMW", model: "M3" },
  { type: "car", year: 2018, make: "BMW", model: "M4" },
  { type: "car", year: 2018, make: "BMW", model: "M5" },
  { type: "car", year: 2018, make: "BMW", model: "M550i" },
  { type: "car", year: 2018, make: "BMW", model: "M6" },
  { type: "car", year: 2018, make: "BMW", model: "M760i" },
  { type: "car", year: 2018, make: "BMW", model: "X1" },
  { type: "car", year: 2018, make: "BMW", model: "X2" },
  { type: "car", year: 2018, make: "BMW", model: "X3" },
  { type: "car", year: 2018, make: "BMW", model: "X4" },
  { type: "car", year: 2018, make: "BMW", model: "X5" },
  { type: "car", year: 2018, make: "BMW", model: "X6" },
  { type: "car", year: 2018, make: "BUGATTI", model: "Chiron" },
  { type: "car", year: 2018, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2018, make: "BUICK", model: "Cascada" },
  { type: "car", year: 2018, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2018, make: "BUICK", model: "Encore" },
  { type: "car", year: 2018, make: "BUICK", model: "Envision" },
  { type: "car", year: 2018, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2018, make: "BUICK", model: "Regal" },
  { type: "car", year: 2018, make: "BUICK", model: "Regal TourX" },
  { type: "car", year: 2018, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2018, make: "CADILLAC", model: "CT6" },
  { type: "car", year: 2018, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2018, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2018, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2018, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2018, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2018, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2018, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2018, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2018, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2018, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2018, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2018, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2018, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2018, make: "DODGE", model: "Charger" },
  { type: "car", year: 2018, make: "DODGE", model: "Durango" },
  { type: "car", year: 2018, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2018, make: "DODGE", model: "Journey" },
  { type: "car", year: 2018, make: "FERRARI", model: "488" },
  { type: "car", year: 2018, make: "FERRARI", model: "812" },
  { type: "car", year: 2018, make: "FERRARI", model: "California T" },
  { type: "car", year: 2018, make: "FERRARI", model: "GTC4Lusso" },
  { type: "car", year: 2018, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2018, make: "FIAT", model: "500" },
  { type: "car", year: 2018, make: "FIAT", model: "500L" },
  { type: "car", year: 2018, make: "FIAT", model: "500X" },
  { type: "car", year: 2018, make: "FISKER", model: "Karma" },
  { type: "car", year: 2018, make: "FISKER", model: "Nina" },
  { type: "car", year: 2018, make: "FORD", model: "'34" },
  { type: "car", year: 2018, make: "FORD", model: "C-Max" },
  { type: "car", year: 2018, make: "FORD", model: "E-350" },
  { type: "car", year: 2018, make: "FORD", model: "E-450" },
  { type: "car", year: 2018, make: "FORD", model: "Ecosport" },
  { type: "car", year: 2018, make: "FORD", model: "Edge" },
  { type: "car", year: 2018, make: "FORD", model: "Escape" },
  { type: "car", year: 2018, make: "FORD", model: "Expedition" },
  { type: "car", year: 2018, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2018, make: "FORD", model: "Explorer" },
  { type: "car", year: 2018, make: "FORD", model: "F-150" },
  { type: "car", year: 2018, make: "FORD", model: "F-250" },
  { type: "car", year: 2018, make: "FORD", model: "F-350" },
  { type: "car", year: 2018, make: "FORD", model: "F-450" },
  { type: "car", year: 2018, make: "FORD", model: "F-550" },
  { type: "car", year: 2018, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2018, make: "FORD", model: "Flex" },
  { type: "car", year: 2018, make: "FORD", model: "Focus" },
  { type: "car", year: 2018, make: "FORD", model: "Fusion" },
  { type: "car", year: 2018, make: "FORD", model: "GT" },
  { type: "car", year: 2018, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2018, make: "FORD", model: "Mustang" },
  { type: "car", year: 2018, make: "FORD", model: "Taurus" },
  { type: "car", year: 2018, make: "FORD", model: "Transit" },
  { type: "car", year: 2018, make: "GMC", model: "Acadia" },
  { type: "car", year: 2018, make: "GMC", model: "Canyon" },
  { type: "car", year: 2018, make: "GMC", model: "Savana" },
  { type: "car", year: 2018, make: "GMC", model: "Sierra" },
  { type: "car", year: 2018, make: "GMC", model: "Terrain" },
  { type: "car", year: 2018, make: "GMC", model: "Yukon" },
  { type: "car", year: 2018, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2018, make: "HONDA", model: "Accord" },
  { type: "car", year: 2018, make: "HONDA", model: "Civic" },
  { type: "car", year: 2018, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2018, make: "HONDA", model: "Clarity" },
  { type: "car", year: 2018, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2018, make: "HONDA", model: "Fit" },
  { type: "car", year: 2018, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2018, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2018, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Elantra GT" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Ioniq" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Kona" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Santa Fe Sport" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2018, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2018, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2018, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2018, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2018, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2018, make: "INFINITI", model: "QX30" },
  { type: "car", year: 2018, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2018, make: "INFINITI", model: "QX70" },
  { type: "car", year: 2018, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2018, make: "JAGUAR", model: "E-PACE" },
  { type: "car", year: 2018, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2018, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2018, make: "JAGUAR", model: "XE" },
  { type: "car", year: 2018, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2018, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2018, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2018, make: "JEEP", model: "Compass" },
  { type: "car", year: 2018, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2018, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2018, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2018, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2018, make: "JEEP", model: "Wrangler JK" },
  { type: "car", year: 2018, make: "KARMA", model: "Revero" },
  { type: "car", year: 2018, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2018, make: "KIA", model: "Forte" },
  { type: "car", year: 2018, make: "KIA", model: "K900" },
  { type: "car", year: 2018, make: "KIA", model: "Niro" },
  { type: "car", year: 2018, make: "KIA", model: "Optima" },
  { type: "car", year: 2018, make: "KIA", model: "Rio" },
  { type: "car", year: 2018, make: "KIA", model: "Sedona" },
  { type: "car", year: 2018, make: "KIA", model: "Sorento" },
  { type: "car", year: 2018, make: "KIA", model: "Soul" },
  { type: "car", year: 2018, make: "KIA", model: "Sportage" },
  { type: "car", year: 2018, make: "KIA", model: "Stinger" },
  { type: "car", year: 2018, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2018, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2018, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2018, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2018, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2018, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2018, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2018, make: "LAND ROVER", model: "Range Rover Velar" },
  { type: "car", year: 2018, make: "LEXUS", model: "ES" },
  { type: "car", year: 2018, make: "LEXUS", model: "GS" },
  { type: "car", year: 2018, make: "LEXUS", model: "GX" },
  { type: "car", year: 2018, make: "LEXUS", model: "IS" },
  { type: "car", year: 2018, make: "LEXUS", model: "LC" },
  { type: "car", year: 2018, make: "LEXUS", model: "LS" },
  { type: "car", year: 2018, make: "LEXUS", model: "LX" },
  { type: "car", year: 2018, make: "LEXUS", model: "NX" },
  { type: "car", year: 2018, make: "LEXUS", model: "RC" },
  { type: "car", year: 2018, make: "LEXUS", model: "RX" },
  { type: "car", year: 2018, make: "LEXUS", model: "SC" },
  { type: "car", year: 2018, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2018, make: "LINCOLN", model: "MKC" },
  { type: "car", year: 2018, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2018, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2018, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2018, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2018, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2018, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2018, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2018, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2018, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2018, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2018, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2018, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2018, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2018, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2018, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2018, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2018, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2018, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2018, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2018, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2018, make: "MCLAREN", model: "600LT" },
  { type: "car", year: 2018, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2018, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2018, make: "MCLAREN", model: "SENNA" },
  { type: "car", year: 2018, make: "MCLAREN", model: "SENNA GTR" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "SLC-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2018, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2018, make: "MINI", model: "Clubman" },
  { type: "car", year: 2018, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2018, make: "MINI", model: "Countryman" },
  { type: "car", year: 2018, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2018, make: "MINI", model: "Paceman" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "Eclipse Cross" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2018, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2018, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2018, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2018, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2018, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2018, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2018, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2018, make: "NISSAN", model: "Kicks" },
  { type: "car", year: 2018, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2018, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2018, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2018, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2018, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2018, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2018, make: "NISSAN", model: "Rogue Sport" },
  { type: "car", year: 2018, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2018, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2018, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2018, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2018, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2018, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2018, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2018, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2018, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2018, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2018, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2018, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2018, make: "PORSCHE", model: "911" },
  { type: "car", year: 2018, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2018, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2018, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2018, make: "RAM", model: "1500" },
  { type: "car", year: 2018, make: "RAM", model: "2500" },
  { type: "car", year: 2018, make: "RAM", model: "3500" },
  { type: "car", year: 2018, make: "RAM", model: "4000" },
  { type: "car", year: 2018, make: "RAM", model: "4500" },
  { type: "car", year: 2018, make: "RAM", model: "5500" },
  { type: "car", year: 2018, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2018, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2018, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2018, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2018, make: "ROLLS-ROYCE", model: "Dawn" },
  { type: "car", year: 2018, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2018, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2018, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2018, make: "SAAB", model: "9-3" },
  { type: "car", year: 2018, make: "SAAB", model: "9-5" },
  { type: "car", year: 2018, make: "SMART", model: "EQ Fortwo" },
  { type: "car", year: 2018, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2018, make: "SPYKER", model: "C12" },
  { type: "car", year: 2018, make: "SPYKER", model: "C8" },
  { type: "car", year: 2018, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2018, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2018, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2018, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2018, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2018, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2018, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2018, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2018, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2018, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2018, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2018, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2018, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2018, make: "TESLA", model: "Model S" },
  { type: "car", year: 2018, make: "TESLA", model: "Model X" },
  { type: "car", year: 2018, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2018, make: "TOYOTA", model: "86" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2018, make: "TOYOTA", model: "C-HR" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2018, make: "TOYOTA", model: "COROLLA iM" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2018, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2018, make: "TOYOTA", model: "Yaris iA" },
  { type: "car", year: 2018, make: "VOLVO", model: "S60" },
  { type: "car", year: 2018, make: "VOLVO", model: "S60 Cross Country" },
  { type: "car", year: 2018, make: "VOLVO", model: "S90" },
  { type: "car", year: 2018, make: "VOLVO", model: "V60" },
  { type: "car", year: 2018, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2018, make: "VOLVO", model: "V90" },
  { type: "car", year: 2018, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2018, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2018, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2018, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2017, make: "ACURA", model: "ILX" },
  { type: "car", year: 2017, make: "ACURA", model: "MDX" },
  { type: "car", year: 2017, make: "ACURA", model: "NSX" },
  { type: "car", year: 2017, make: "ACURA", model: "RDX" },
  { type: "car", year: 2017, make: "ACURA", model: "RLX" },
  { type: "car", year: 2017, make: "ACURA", model: "TLX" },
  { type: "car", year: 2017, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2017, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2017, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2017, make: "ASTON MARTIN", model: "DB11" },
  { type: "car", year: 2017, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2017, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2017, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2017, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2017, make: "AUDI", model: "A3" },
  { type: "car", year: 2017, make: "AUDI", model: "A4" },
  { type: "car", year: 2017, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2017, make: "AUDI", model: "A5" },
  { type: "car", year: 2017, make: "AUDI", model: "A6" },
  { type: "car", year: 2017, make: "AUDI", model: "A7" },
  { type: "car", year: 2017, make: "AUDI", model: "A8" },
  { type: "car", year: 2017, make: "AUDI", model: "Q3" },
  { type: "car", year: 2017, make: "AUDI", model: "Q5" },
  { type: "car", year: 2017, make: "AUDI", model: "Q7" },
  { type: "car", year: 2017, make: "AUDI", model: "R8" },
  { type: "car", year: 2017, make: "AUDI", model: "RS 3" },
  { type: "car", year: 2017, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2017, make: "AUDI", model: "S3" },
  { type: "car", year: 2017, make: "AUDI", model: "S5" },
  { type: "car", year: 2017, make: "AUDI", model: "S6" },
  { type: "car", year: 2017, make: "AUDI", model: "S7" },
  { type: "car", year: 2017, make: "AUDI", model: "S8" },
  { type: "car", year: 2017, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2017, make: "AUDI", model: "TT" },
  { type: "car", year: 2017, make: "AUDI", model: "TTS" },
  { type: "car", year: 2017, make: "BENTLEY", model: "Bentayga" },
  { type: "car", year: 2017, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2017, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2017, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2017, make: "BMW", model: "228i" },
  { type: "car", year: 2017, make: "BMW", model: "230i" },
  { type: "car", year: 2017, make: "BMW", model: "320i" },
  { type: "car", year: 2017, make: "BMW", model: "328d" },
  { type: "car", year: 2017, make: "BMW", model: "330e" },
  { type: "car", year: 2017, make: "BMW", model: "330i" },
  { type: "car", year: 2017, make: "BMW", model: "335i" },
  { type: "car", year: 2017, make: "BMW", model: "340i" },
  { type: "car", year: 2017, make: "BMW", model: "430i" },
  { type: "car", year: 2017, make: "BMW", model: "440i" },
  { type: "car", year: 2017, make: "BMW", model: "530i" },
  { type: "car", year: 2017, make: "BMW", model: "535i" },
  { type: "car", year: 2017, make: "BMW", model: "540i" },
  { type: "car", year: 2017, make: "BMW", model: "550i" },
  { type: "car", year: 2017, make: "BMW", model: "640i" },
  { type: "car", year: 2017, make: "BMW", model: "650i" },
  { type: "car", year: 2017, make: "BMW", model: "650i, B6" },
  { type: "car", year: 2017, make: "BMW", model: "740e" },
  { type: "car", year: 2017, make: "BMW", model: "740i" },
  { type: "car", year: 2017, make: "BMW", model: "750i, B7" },
  { type: "car", year: 2017, make: "BMW", model: "i3" },
  { type: "car", year: 2017, make: "BMW", model: "i8" },
  { type: "car", year: 2017, make: "BMW", model: "M2" },
  { type: "car", year: 2017, make: "BMW", model: "M240i" },
  { type: "car", year: 2017, make: "BMW", model: "M3" },
  { type: "car", year: 2017, make: "BMW", model: "M4" },
  { type: "car", year: 2017, make: "BMW", model: "M5" },
  { type: "car", year: 2017, make: "BMW", model: "M6" },
  { type: "car", year: 2017, make: "BMW", model: "M760i" },
  { type: "car", year: 2017, make: "BMW", model: "X1" },
  { type: "car", year: 2017, make: "BMW", model: "X3" },
  { type: "car", year: 2017, make: "BMW", model: "X4" },
  { type: "car", year: 2017, make: "BMW", model: "X5" },
  { type: "car", year: 2017, make: "BMW", model: "X6" },
  { type: "car", year: 2017, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2017, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2017, make: "BUICK", model: "Cascada" },
  { type: "car", year: 2017, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2017, make: "BUICK", model: "Encore" },
  { type: "car", year: 2017, make: "BUICK", model: "Envision" },
  { type: "car", year: 2017, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2017, make: "BUICK", model: "Regal" },
  { type: "car", year: 2017, make: "BUICK", model: "Verano" },
  { type: "car", year: 2017, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2017, make: "CADILLAC", model: "CT6" },
  { type: "car", year: 2017, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2017, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2017, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2017, make: "CADILLAC", model: "Escalade ESV" },
  { type: "car", year: 2017, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2017, make: "CADILLAC", model: "XT5" },
  { type: "car", year: 2017, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Bolt EV" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2017, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2017, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2017, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2017, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2017, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2017, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2017, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2017, make: "DODGE", model: "Charger" },
  { type: "car", year: 2017, make: "DODGE", model: "Durango" },
  { type: "car", year: 2017, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2017, make: "DODGE", model: "Journey" },
  { type: "car", year: 2017, make: "DODGE", model: "Viper" },
  { type: "car", year: 2017, make: "FERRARI", model: "458" },
  { type: "car", year: 2017, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2017, make: "FERRARI", model: "488" },
  { type: "car", year: 2017, make: "FERRARI", model: "812" },
  { type: "car", year: 2017, make: "FERRARI", model: "California T" },
  { type: "car", year: 2017, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2017, make: "FERRARI", model: "F12 tdf (Tour de France)" },
  { type: "car", year: 2017, make: "FERRARI", model: "GTC4Lusso" },
  { type: "car", year: 2017, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2017, make: "FIAT", model: "124 Spider" },
  { type: "car", year: 2017, make: "FIAT", model: "500" },
  { type: "car", year: 2017, make: "FIAT", model: "500L" },
  { type: "car", year: 2017, make: "FIAT", model: "500X" },
  { type: "car", year: 2017, make: "FISKER", model: "Karma" },
  { type: "car", year: 2017, make: "FISKER", model: "Nina" },
  { type: "car", year: 2017, make: "FORD", model: "'34" },
  { type: "car", year: 2017, make: "FORD", model: "C-Max" },
  { type: "car", year: 2017, make: "FORD", model: "E-350" },
  { type: "car", year: 2017, make: "FORD", model: "E-450" },
  { type: "car", year: 2017, make: "FORD", model: "Edge" },
  { type: "car", year: 2017, make: "FORD", model: "Escape" },
  { type: "car", year: 2017, make: "FORD", model: "Expedition" },
  { type: "car", year: 2017, make: "FORD", model: "Expedition EL" },
  { type: "car", year: 2017, make: "FORD", model: "Explorer" },
  { type: "car", year: 2017, make: "FORD", model: "F-150" },
  { type: "car", year: 2017, make: "FORD", model: "F-250" },
  { type: "car", year: 2017, make: "FORD", model: "F-350" },
  { type: "car", year: 2017, make: "FORD", model: "F-450" },
  { type: "car", year: 2017, make: "FORD", model: "F-550" },
  { type: "car", year: 2017, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2017, make: "FORD", model: "Flex" },
  { type: "car", year: 2017, make: "FORD", model: "Focus" },
  { type: "car", year: 2017, make: "FORD", model: "Fusion" },
  { type: "car", year: 2017, make: "FORD", model: "GT" },
  { type: "car", year: 2017, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2017, make: "FORD", model: "Mustang" },
  { type: "car", year: 2017, make: "FORD", model: "Taurus" },
  { type: "car", year: 2017, make: "FORD", model: "Transit" },
  { type: "car", year: 2017, make: "GMC", model: "Acadia" },
  { type: "car", year: 2017, make: "GMC", model: "Canyon" },
  { type: "car", year: 2017, make: "GMC", model: "Savana" },
  { type: "car", year: 2017, make: "GMC", model: "Sierra" },
  { type: "car", year: 2017, make: "GMC", model: "Terrain" },
  { type: "car", year: 2017, make: "GMC", model: "Yukon" },
  { type: "car", year: 2017, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2017, make: "HONDA", model: "Accord" },
  { type: "car", year: 2017, make: "HONDA", model: "Civic" },
  { type: "car", year: 2017, make: "HONDA", model: "Civic Type R" },
  { type: "car", year: 2017, make: "HONDA", model: "Clarity" },
  { type: "car", year: 2017, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2017, make: "HONDA", model: "Fit" },
  { type: "car", year: 2017, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2017, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2017, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Elantra GT" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Ioniq" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Santa Fe Sport" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2017, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2017, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2017, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2017, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2017, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2017, make: "INFINITI", model: "QX30" },
  { type: "car", year: 2017, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2017, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2017, make: "INFINITI", model: "QX70" },
  { type: "car", year: 2017, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2017, make: "JAGUAR", model: "F-PACE" },
  { type: "car", year: 2017, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2017, make: "JAGUAR", model: "XE" },
  { type: "car", year: 2017, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2017, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2017, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2017, make: "JEEP", model: "Compass" },
  { type: "car", year: 2017, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2017, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2017, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2017, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2017, make: "KARMA", model: "Revero" },
  { type: "car", year: 2017, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2017, make: "KIA", model: "Forte" },
  { type: "car", year: 2017, make: "KIA", model: "Forte Koup" },
  { type: "car", year: 2017, make: "KIA", model: "K900" },
  { type: "car", year: 2017, make: "KIA", model: "Niro" },
  { type: "car", year: 2017, make: "KIA", model: "Optima" },
  { type: "car", year: 2017, make: "KIA", model: "Rio" },
  { type: "car", year: 2017, make: "KIA", model: "Sedona" },
  { type: "car", year: 2017, make: "KIA", model: "Sorento" },
  { type: "car", year: 2017, make: "KIA", model: "Soul" },
  { type: "car", year: 2017, make: "KIA", model: "Sportage" },
  { type: "car", year: 2017, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2017, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2017, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2017, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2017, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2017, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2017, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2017, make: "LEXUS", model: "CT" },
  { type: "car", year: 2017, make: "LEXUS", model: "ES" },
  { type: "car", year: 2017, make: "LEXUS", model: "GS" },
  { type: "car", year: 2017, make: "LEXUS", model: "GX" },
  { type: "car", year: 2017, make: "LEXUS", model: "IS" },
  { type: "car", year: 2017, make: "LEXUS", model: "LS" },
  { type: "car", year: 2017, make: "LEXUS", model: "LX" },
  { type: "car", year: 2017, make: "LEXUS", model: "NX" },
  { type: "car", year: 2017, make: "LEXUS", model: "RC" },
  { type: "car", year: 2017, make: "LEXUS", model: "RX" },
  { type: "car", year: 2017, make: "LEXUS", model: "SC" },
  { type: "car", year: 2017, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2017, make: "LINCOLN", model: "MKC" },
  { type: "car", year: 2017, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2017, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2017, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2017, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2017, make: "LINCOLN", model: "Navigator L" },
  { type: "car", year: 2017, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2017, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2017, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2017, make: "MASERATI", model: "Levante" },
  { type: "car", year: 2017, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2017, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2017, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2017, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2017, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2017, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2017, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2017, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2017, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2017, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2017, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2017, make: "MCLAREN", model: "600LT" },
  { type: "car", year: 2017, make: "MCLAREN", model: "720S" },
  { type: "car", year: 2017, make: "MCLAREN", model: "GT" },
  { type: "car", year: 2017, make: "MCLAREN", model: "SENNA" },
  { type: "car", year: 2017, make: "MCLAREN", model: "SENNA GTR" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "SLC-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2017, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2017, make: "MINI", model: "Clubman" },
  { type: "car", year: 2017, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2017, make: "MINI", model: "Countryman" },
  { type: "car", year: 2017, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2017, make: "MINI", model: "Paceman" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Mirage G4" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2017, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2017, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2017, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2017, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2017, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2017, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2017, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2017, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2017, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2017, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2017, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2017, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2017, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2017, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2017, make: "NISSAN", model: "Rogue Sport" },
  { type: "car", year: 2017, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2017, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2017, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2017, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2017, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2017, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2017, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2017, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2017, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2017, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2017, make: "PORSCHE", model: "718 Boxster" },
  { type: "car", year: 2017, make: "PORSCHE", model: "718 Cayman" },
  { type: "car", year: 2017, make: "PORSCHE", model: "911" },
  { type: "car", year: 2017, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2017, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2017, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2017, make: "RAM", model: "1500" },
  { type: "car", year: 2017, make: "RAM", model: "2500" },
  { type: "car", year: 2017, make: "RAM", model: "3500" },
  { type: "car", year: 2017, make: "RAM", model: "4000" },
  { type: "car", year: 2017, make: "RAM", model: "4500" },
  { type: "car", year: 2017, make: "RAM", model: "5500" },
  { type: "car", year: 2017, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2017, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2017, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2017, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2017, make: "ROLLS-ROYCE", model: "Dawn" },
  { type: "car", year: 2017, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2017, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2017, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2017, make: "SAAB", model: "9-3" },
  { type: "car", year: 2017, make: "SAAB", model: "9-5" },
  { type: "car", year: 2017, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2017, make: "SPYKER", model: "C12" },
  { type: "car", year: 2017, make: "SPYKER", model: "C8" },
  { type: "car", year: 2017, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2017, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2017, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2017, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2017, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2017, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2017, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2017, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2017, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2017, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2017, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2017, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2017, make: "TESLA", model: "Model 3" },
  { type: "car", year: 2017, make: "TESLA", model: "Model S" },
  { type: "car", year: 2017, make: "TESLA", model: "Model X" },
  { type: "car", year: 2017, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2017, make: "TOYOTA", model: "86" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2017, make: "TOYOTA", model: "COROLLA iM" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Prius Prime (PHEV)" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Prius V" },
  { type: "car", year: 2017, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2017, make: "TOYOTA", model: "Yaris iA" },
  { type: "car", year: 2017, make: "VOLVO", model: "S60" },
  { type: "car", year: 2017, make: "VOLVO", model: "S60 Cross Country" },
  { type: "car", year: 2017, make: "VOLVO", model: "S90" },
  { type: "car", year: 2017, make: "VOLVO", model: "V60" },
  { type: "car", year: 2017, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2017, make: "VOLVO", model: "V90" },
  { type: "car", year: 2017, make: "VOLVO", model: "V90CC" },
  { type: "car", year: 2017, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2017, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2017, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2016, make: "ACURA", model: "ILX" },
  { type: "car", year: 2016, make: "ACURA", model: "MDX" },
  { type: "car", year: 2016, make: "ACURA", model: "NSX" },
  { type: "car", year: 2016, make: "ACURA", model: "RDX" },
  { type: "car", year: 2016, make: "ACURA", model: "RLX" },
  { type: "car", year: 2016, make: "ACURA", model: "TLX" },
  { type: "car", year: 2016, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2016, make: "ALFA ROMEO", model: "Giulia (952)" },
  { type: "car", year: 2016, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2016, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2016, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2016, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2016, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2016, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2016, make: "AUDI", model: "A3" },
  { type: "car", year: 2016, make: "AUDI", model: "A4" },
  { type: "car", year: 2016, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2016, make: "AUDI", model: "A5" },
  { type: "car", year: 2016, make: "AUDI", model: "A6" },
  { type: "car", year: 2016, make: "AUDI", model: "A7" },
  { type: "car", year: 2016, make: "AUDI", model: "A8" },
  { type: "car", year: 2016, make: "AUDI", model: "Q3" },
  { type: "car", year: 2016, make: "AUDI", model: "Q5" },
  { type: "car", year: 2016, make: "AUDI", model: "R8" },
  { type: "car", year: 2016, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2016, make: "AUDI", model: "S3" },
  { type: "car", year: 2016, make: "AUDI", model: "S4" },
  { type: "car", year: 2016, make: "AUDI", model: "S5" },
  { type: "car", year: 2016, make: "AUDI", model: "S6" },
  { type: "car", year: 2016, make: "AUDI", model: "S7" },
  { type: "car", year: 2016, make: "AUDI", model: "S8" },
  { type: "car", year: 2016, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2016, make: "AUDI", model: "TT" },
  { type: "car", year: 2016, make: "AUDI", model: "TTS" },
  { type: "car", year: 2016, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2016, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2016, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2016, make: "BMW", model: "228i" },
  { type: "car", year: 2016, make: "BMW", model: "320i" },
  { type: "car", year: 2016, make: "BMW", model: "328d" },
  { type: "car", year: 2016, make: "BMW", model: "328i" },
  { type: "car", year: 2016, make: "BMW", model: "330e" },
  { type: "car", year: 2016, make: "BMW", model: "335i" },
  { type: "car", year: 2016, make: "BMW", model: "340i" },
  { type: "car", year: 2016, make: "BMW", model: "428i" },
  { type: "car", year: 2016, make: "BMW", model: "435i" },
  { type: "car", year: 2016, make: "BMW", model: "528i" },
  { type: "car", year: 2016, make: "BMW", model: "535d" },
  { type: "car", year: 2016, make: "BMW", model: "535i" },
  { type: "car", year: 2016, make: "BMW", model: "550i" },
  { type: "car", year: 2016, make: "BMW", model: "640i" },
  { type: "car", year: 2016, make: "BMW", model: "650i" },
  { type: "car", year: 2016, make: "BMW", model: "650i, Alpina B6" },
  { type: "car", year: 2016, make: "BMW", model: "740i" },
  { type: "car", year: 2016, make: "BMW", model: "750i" },
  { type: "car", year: 2016, make: "BMW", model: "ActiveHybrid 5" },
  { type: "car", year: 2016, make: "BMW", model: "i3" },
  { type: "car", year: 2016, make: "BMW", model: "i8" },
  { type: "car", year: 2016, make: "BMW", model: "M2" },
  { type: "car", year: 2016, make: "BMW", model: "M235i" },
  { type: "car", year: 2016, make: "BMW", model: "M3" },
  { type: "car", year: 2016, make: "BMW", model: "M4" },
  { type: "car", year: 2016, make: "BMW", model: "M5" },
  { type: "car", year: 2016, make: "BMW", model: "M6" },
  { type: "car", year: 2016, make: "BMW", model: "X1" },
  { type: "car", year: 2016, make: "BMW", model: "X3" },
  { type: "car", year: 2016, make: "BMW", model: "X4" },
  { type: "car", year: 2016, make: "BMW", model: "X5" },
  { type: "car", year: 2016, make: "BMW", model: "X6" },
  { type: "car", year: 2016, make: "BMW", model: "Z4" },
  { type: "car", year: 2016, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2016, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2016, make: "BUICK", model: "Cascada" },
  { type: "car", year: 2016, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2016, make: "BUICK", model: "Encore" },
  { type: "car", year: 2016, make: "BUICK", model: "Envision" },
  { type: "car", year: 2016, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2016, make: "BUICK", model: "Regal" },
  { type: "car", year: 2016, make: "BUICK", model: "Verano" },
  { type: "car", year: 2016, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2016, make: "CADILLAC", model: "CT6" },
  { type: "car", year: 2016, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2016, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2016, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2016, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2016, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Cruze Limited" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Impala Limited" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Malibu Limited" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2016, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2016, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2016, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2016, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2016, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2016, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2016, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2016, make: "DODGE", model: "Charger" },
  { type: "car", year: 2016, make: "DODGE", model: "Dart" },
  { type: "car", year: 2016, make: "DODGE", model: "Durango" },
  { type: "car", year: 2016, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2016, make: "DODGE", model: "Journey" },
  { type: "car", year: 2016, make: "DODGE", model: "Viper" },
  { type: "car", year: 2016, make: "FERRARI", model: "458" },
  { type: "car", year: 2016, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2016, make: "FERRARI", model: "488" },
  { type: "car", year: 2016, make: "FERRARI", model: "California T" },
  { type: "car", year: 2016, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2016, make: "FERRARI", model: "F12 Special Series" },
  { type: "car", year: 2016, make: "FERRARI", model: "F60 America" },
  { type: "car", year: 2016, make: "FERRARI", model: "FF" },
  { type: "car", year: 2016, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2016, make: "FIAT", model: "500" },
  { type: "car", year: 2016, make: "FIAT", model: "500L" },
  { type: "car", year: 2016, make: "FIAT", model: "500X" },
  { type: "car", year: 2016, make: "FIAT", model: "Freemont" },
  { type: "car", year: 2016, make: "FISKER", model: "Karma" },
  { type: "car", year: 2016, make: "FISKER", model: "Nina" },
  { type: "car", year: 2016, make: "FORD", model: "'34" },
  { type: "car", year: 2016, make: "FORD", model: "C-Max" },
  { type: "car", year: 2016, make: "FORD", model: "E-350" },
  { type: "car", year: 2016, make: "FORD", model: "E-450" },
  { type: "car", year: 2016, make: "FORD", model: "Edge" },
  { type: "car", year: 2016, make: "FORD", model: "Escape" },
  { type: "car", year: 2016, make: "FORD", model: "Expedition" },
  { type: "car", year: 2016, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2016, make: "FORD", model: "Explorer" },
  { type: "car", year: 2016, make: "FORD", model: "F-150" },
  { type: "car", year: 2016, make: "FORD", model: "F-250" },
  { type: "car", year: 2016, make: "FORD", model: "F-350" },
  { type: "car", year: 2016, make: "FORD", model: "F-450" },
  { type: "car", year: 2016, make: "FORD", model: "F-550" },
  { type: "car", year: 2016, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2016, make: "FORD", model: "Flex" },
  { type: "car", year: 2016, make: "FORD", model: "Focus" },
  { type: "car", year: 2016, make: "FORD", model: "Fusion" },
  { type: "car", year: 2016, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2016, make: "FORD", model: "Mustang" },
  { type: "car", year: 2016, make: "FORD", model: "Taurus" },
  { type: "car", year: 2016, make: "FORD", model: "Transit" },
  { type: "car", year: 2016, make: "GMC", model: "Acadia" },
  { type: "car", year: 2016, make: "GMC", model: "Canyon" },
  { type: "car", year: 2016, make: "GMC", model: "Savana" },
  { type: "car", year: 2016, make: "GMC", model: "Sierra" },
  { type: "car", year: 2016, make: "GMC", model: "Terrain" },
  { type: "car", year: 2016, make: "GMC", model: "Yukon" },
  { type: "car", year: 2016, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2016, make: "HONDA", model: "Accord" },
  { type: "car", year: 2016, make: "HONDA", model: "Civic" },
  { type: "car", year: 2016, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2016, make: "HONDA", model: "CR-Z" },
  { type: "car", year: 2016, make: "HONDA", model: "Fit" },
  { type: "car", year: 2016, make: "HONDA", model: "HR-V" },
  { type: "car", year: 2016, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2016, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Equus" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Santa Fe Sport" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2016, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2016, make: "INFINITI", model: "Q40" },
  { type: "car", year: 2016, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2016, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2016, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2016, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2016, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2016, make: "INFINITI", model: "QX70" },
  { type: "car", year: 2016, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2016, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2016, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2016, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2016, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2016, make: "JEEP", model: "Compass" },
  { type: "car", year: 2016, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2016, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2016, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2016, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2016, make: "KARMA", model: "Atlantic" },
  { type: "car", year: 2016, make: "KARMA", model: "Revero" },
  { type: "car", year: 2016, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2016, make: "KIA", model: "Forte" },
  { type: "car", year: 2016, make: "KIA", model: "Forte Koup" },
  { type: "car", year: 2016, make: "KIA", model: "K900" },
  { type: "car", year: 2016, make: "KIA", model: "Optima" },
  { type: "car", year: 2016, make: "KIA", model: "Rio" },
  { type: "car", year: 2016, make: "KIA", model: "Rondo" },
  { type: "car", year: 2016, make: "KIA", model: "Sedona" },
  { type: "car", year: 2016, make: "KIA", model: "Sorento" },
  { type: "car", year: 2016, make: "KIA", model: "Soul" },
  { type: "car", year: 2016, make: "KIA", model: "Sportage" },
  { type: "car", year: 2016, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2016, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2016, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2016, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2016, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2016, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2016, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2016, make: "LEXUS", model: "CT" },
  { type: "car", year: 2016, make: "LEXUS", model: "ES" },
  { type: "car", year: 2016, make: "LEXUS", model: "GS" },
  { type: "car", year: 2016, make: "LEXUS", model: "GX" },
  { type: "car", year: 2016, make: "LEXUS", model: "IS" },
  { type: "car", year: 2016, make: "LEXUS", model: "LS" },
  { type: "car", year: 2016, make: "LEXUS", model: "LX" },
  { type: "car", year: 2016, make: "LEXUS", model: "NX" },
  { type: "car", year: 2016, make: "LEXUS", model: "RC" },
  { type: "car", year: 2016, make: "LEXUS", model: "RX" },
  { type: "car", year: 2016, make: "LEXUS", model: "SC" },
  { type: "car", year: 2016, make: "LINCOLN", model: "MKC" },
  { type: "car", year: 2016, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2016, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2016, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2016, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2016, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2016, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2016, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2016, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2016, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2016, make: "MAZDA", model: "CX-3" },
  { type: "car", year: 2016, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2016, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2016, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2016, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2016, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2016, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2016, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2016, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2016, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2016, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2016, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2016, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2016, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2016, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "AMG GT" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "GLC-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "GLE-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "GLS-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "Metris" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2016, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2016, make: "MINI", model: "Clubman" },
  { type: "car", year: 2016, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2016, make: "MINI", model: "Countryman" },
  { type: "car", year: 2016, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2016, make: "MINI", model: "Paceman" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2016, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2016, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2016, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2016, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2016, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2016, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2016, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2016, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2016, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2016, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2016, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2016, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2016, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2016, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2016, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2016, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2016, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2016, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2016, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2016, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2016, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2016, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2016, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2016, make: "PORSCHE", model: "911" },
  { type: "car", year: 2016, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2016, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2016, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2016, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2016, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2016, make: "RAM", model: "1500" },
  { type: "car", year: 2016, make: "RAM", model: "2500" },
  { type: "car", year: 2016, make: "RAM", model: "3500" },
  { type: "car", year: 2016, make: "RAM", model: "4000" },
  { type: "car", year: 2016, make: "RAM", model: "4500" },
  { type: "car", year: 2016, make: "RAM", model: "5500" },
  { type: "car", year: 2016, make: "RAM", model: "Cargo Van" },
  { type: "car", year: 2016, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2016, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2016, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2016, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2016, make: "ROLLS-ROYCE", model: "Dawn" },
  { type: "car", year: 2016, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2016, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2016, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2016, make: "SAAB", model: "9-3" },
  { type: "car", year: 2016, make: "SAAB", model: "9-5" },
  { type: "car", year: 2016, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2016, make: "SPYKER", model: "C12" },
  { type: "car", year: 2016, make: "SPYKER", model: "C8" },
  { type: "car", year: 2016, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2016, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2016, make: "SUBARU", model: "Crosstrek" },
  { type: "car", year: 2016, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2016, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2016, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2016, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2016, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2016, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2016, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2016, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2016, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2016, make: "TESLA", model: "Model S" },
  { type: "car", year: 2016, make: "TESLA", model: "Model X" },
  { type: "car", year: 2016, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Mirai" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Prius V" },
  { type: "car", year: 2016, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Scion FR-S" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Scion iA" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Scion iM" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2016, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2016, make: "VOLVO", model: "S60" },
  { type: "car", year: 2016, make: "VOLVO", model: "S60 Cross Country" },
  { type: "car", year: 2016, make: "VOLVO", model: "S80" },
  { type: "car", year: 2016, make: "VOLVO", model: "V60" },
  { type: "car", year: 2016, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2016, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2016, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2016, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2016, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2015, make: "ACURA", model: "ILX" },
  { type: "car", year: 2015, make: "ACURA", model: "MDX" },
  { type: "car", year: 2015, make: "ACURA", model: "RDX" },
  { type: "car", year: 2015, make: "ACURA", model: "RLX" },
  { type: "car", year: 2015, make: "ACURA", model: "TLX" },
  { type: "car", year: 2015, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2015, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2015, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2015, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2015, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2015, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2015, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2015, make: "AUDI", model: "A3" },
  { type: "car", year: 2015, make: "AUDI", model: "A4" },
  { type: "car", year: 2015, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2015, make: "AUDI", model: "A5" },
  { type: "car", year: 2015, make: "AUDI", model: "A6" },
  { type: "car", year: 2015, make: "AUDI", model: "A7" },
  { type: "car", year: 2015, make: "AUDI", model: "A8" },
  { type: "car", year: 2015, make: "AUDI", model: "Q3" },
  { type: "car", year: 2015, make: "AUDI", model: "Q5" },
  { type: "car", year: 2015, make: "AUDI", model: "Q7" },
  { type: "car", year: 2015, make: "AUDI", model: "R8" },
  { type: "car", year: 2015, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2015, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2015, make: "AUDI", model: "S3" },
  { type: "car", year: 2015, make: "AUDI", model: "S4" },
  { type: "car", year: 2015, make: "AUDI", model: "S5" },
  { type: "car", year: 2015, make: "AUDI", model: "S6" },
  { type: "car", year: 2015, make: "AUDI", model: "S7" },
  { type: "car", year: 2015, make: "AUDI", model: "S8" },
  { type: "car", year: 2015, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2015, make: "AUDI", model: "TT" },
  { type: "car", year: 2015, make: "AUDI", model: "TTS" },
  { type: "car", year: 2015, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2015, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2015, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2015, make: "BMW", model: "228i" },
  { type: "car", year: 2015, make: "BMW", model: "320i" },
  { type: "car", year: 2015, make: "BMW", model: "328d" },
  { type: "car", year: 2015, make: "BMW", model: "328i" },
  { type: "car", year: 2015, make: "BMW", model: "335i" },
  { type: "car", year: 2015, make: "BMW", model: "335is" },
  { type: "car", year: 2015, make: "BMW", model: "428i" },
  { type: "car", year: 2015, make: "BMW", model: "435i" },
  { type: "car", year: 2015, make: "BMW", model: "528i" },
  { type: "car", year: 2015, make: "BMW", model: "535d" },
  { type: "car", year: 2015, make: "BMW", model: "535i" },
  { type: "car", year: 2015, make: "BMW", model: "550i" },
  { type: "car", year: 2015, make: "BMW", model: "640i" },
  { type: "car", year: 2015, make: "BMW", model: "650i" },
  { type: "car", year: 2015, make: "BMW", model: "650i, Alpina B6" },
  { type: "car", year: 2015, make: "BMW", model: "650xi" },
  { type: "car", year: 2015, make: "BMW", model: "740i" },
  { type: "car", year: 2015, make: "BMW", model: "740Li" },
  { type: "car", year: 2015, make: "BMW", model: "750i" },
  { type: "car", year: 2015, make: "BMW", model: "750i, Alpina B7" },
  { type: "car", year: 2015, make: "BMW", model: "750Li" },
  { type: "car", year: 2015, make: "BMW", model: "750Li, Alpina B7" },
  { type: "car", year: 2015, make: "BMW", model: "750Lxi" },
  { type: "car", year: 2015, make: "BMW", model: "750xi" },
  { type: "car", year: 2015, make: "BMW", model: "760Li" },
  { type: "car", year: 2015, make: "BMW", model: "ActiveHybrid 3" },
  { type: "car", year: 2015, make: "BMW", model: "ActiveHybrid 5" },
  { type: "car", year: 2015, make: "BMW", model: "ActiveHybrid 7" },
  { type: "car", year: 2015, make: "BMW", model: "i3" },
  { type: "car", year: 2015, make: "BMW", model: "i8" },
  { type: "car", year: 2015, make: "BMW", model: "M235i" },
  { type: "car", year: 2015, make: "BMW", model: "M3" },
  { type: "car", year: 2015, make: "BMW", model: "M4" },
  { type: "car", year: 2015, make: "BMW", model: "M5" },
  { type: "car", year: 2015, make: "BMW", model: "M6" },
  { type: "car", year: 2015, make: "BMW", model: "X1" },
  { type: "car", year: 2015, make: "BMW", model: "X3" },
  { type: "car", year: 2015, make: "BMW", model: "X4" },
  { type: "car", year: 2015, make: "BMW", model: "X5" },
  { type: "car", year: 2015, make: "BMW", model: "X6" },
  { type: "car", year: 2015, make: "BMW", model: "Z4" },
  { type: "car", year: 2015, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2015, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2015, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2015, make: "BUICK", model: "Encore" },
  { type: "car", year: 2015, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2015, make: "BUICK", model: "Regal" },
  { type: "car", year: 2015, make: "BUICK", model: "Verano" },
  { type: "car", year: 2015, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2015, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2015, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2015, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2015, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2015, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Impala Limited" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2015, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2015, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2015, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2015, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2015, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2015, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2015, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2015, make: "DODGE", model: "Charger" },
  { type: "car", year: 2015, make: "DODGE", model: "Dart" },
  { type: "car", year: 2015, make: "DODGE", model: "Durango" },
  { type: "car", year: 2015, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2015, make: "DODGE", model: "Journey" },
  { type: "car", year: 2015, make: "DODGE", model: "Viper" },
  { type: "car", year: 2015, make: "FERRARI", model: "458" },
  { type: "car", year: 2015, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2015, make: "FERRARI", model: "California T" },
  { type: "car", year: 2015, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2015, make: "FERRARI", model: "FF" },
  { type: "car", year: 2015, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2015, make: "FIAT", model: "500" },
  { type: "car", year: 2015, make: "FIAT", model: "500L" },
  { type: "car", year: 2015, make: "FIAT", model: "Freemont" },
  { type: "car", year: 2015, make: "FISKER", model: "Karma" },
  { type: "car", year: 2015, make: "FISKER", model: "Nina" },
  { type: "car", year: 2015, make: "FORD", model: "'34" },
  { type: "car", year: 2015, make: "FORD", model: "C-Max" },
  { type: "car", year: 2015, make: "FORD", model: "E-350" },
  { type: "car", year: 2015, make: "FORD", model: "E-450" },
  { type: "car", year: 2015, make: "FORD", model: "E-550" },
  { type: "car", year: 2015, make: "FORD", model: "Edge" },
  { type: "car", year: 2015, make: "FORD", model: "Escape" },
  { type: "car", year: 2015, make: "FORD", model: "Expedition" },
  { type: "car", year: 2015, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2015, make: "FORD", model: "Explorer" },
  { type: "car", year: 2015, make: "FORD", model: "F-150" },
  { type: "car", year: 2015, make: "FORD", model: "F-250" },
  { type: "car", year: 2015, make: "FORD", model: "F-350" },
  { type: "car", year: 2015, make: "FORD", model: "F-450" },
  { type: "car", year: 2015, make: "FORD", model: "F-550" },
  { type: "car", year: 2015, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2015, make: "FORD", model: "Flex" },
  { type: "car", year: 2015, make: "FORD", model: "Focus" },
  { type: "car", year: 2015, make: "FORD", model: "Fusion" },
  { type: "car", year: 2015, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2015, make: "FORD", model: "Mustang" },
  { type: "car", year: 2015, make: "FORD", model: "Taurus" },
  { type: "car", year: 2015, make: "FORD", model: "Transit" },
  { type: "car", year: 2015, make: "GMC", model: "Acadia" },
  { type: "car", year: 2015, make: "GMC", model: "Canyon" },
  { type: "car", year: 2015, make: "GMC", model: "Savana" },
  { type: "car", year: 2015, make: "GMC", model: "Sierra" },
  { type: "car", year: 2015, make: "GMC", model: "Terrain" },
  { type: "car", year: 2015, make: "GMC", model: "Yukon" },
  { type: "car", year: 2015, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2015, make: "HONDA", model: "Accord" },
  { type: "car", year: 2015, make: "HONDA", model: "Civic" },
  { type: "car", year: 2015, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2015, make: "HONDA", model: "CR-Z" },
  { type: "car", year: 2015, make: "HONDA", model: "Crosstour" },
  { type: "car", year: 2015, make: "HONDA", model: "Fit" },
  { type: "car", year: 2015, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2015, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Equus" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Santa Fe Sport" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2015, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2015, make: "INFINITI", model: "Q40" },
  { type: "car", year: 2015, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2015, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2015, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2015, make: "INFINITI", model: "Q70L" },
  { type: "car", year: 2015, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2015, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2015, make: "INFINITI", model: "QX70" },
  { type: "car", year: 2015, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2015, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2015, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2015, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2015, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2015, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2015, make: "JEEP", model: "Compass" },
  { type: "car", year: 2015, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2015, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2015, make: "JEEP", model: "Renegade" },
  { type: "car", year: 2015, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2015, make: "KARMA", model: "Atlantic" },
  { type: "car", year: 2015, make: "KARMA", model: "Karma" },
  { type: "car", year: 2015, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2015, make: "KIA", model: "Forte" },
  { type: "car", year: 2015, make: "KIA", model: "K900" },
  { type: "car", year: 2015, make: "KIA", model: "Optima" },
  { type: "car", year: 2015, make: "KIA", model: "Rio" },
  { type: "car", year: 2015, make: "KIA", model: "Rondo" },
  { type: "car", year: 2015, make: "KIA", model: "Sedona" },
  { type: "car", year: 2015, make: "KIA", model: "Sorento" },
  { type: "car", year: 2015, make: "KIA", model: "Soul" },
  { type: "car", year: 2015, make: "KIA", model: "Sportage" },
  { type: "car", year: 2015, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2015, make: "LAMBORGHINI", model: "Huracan" },
  { type: "car", year: 2015, make: "LAND ROVER", model: "Discovery Sport" },
  { type: "car", year: 2015, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2015, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2015, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2015, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2015, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2015, make: "LEXUS", model: "CT" },
  { type: "car", year: 2015, make: "LEXUS", model: "ES" },
  { type: "car", year: 2015, make: "LEXUS", model: "GS" },
  { type: "car", year: 2015, make: "LEXUS", model: "GX" },
  { type: "car", year: 2015, make: "LEXUS", model: "IS" },
  { type: "car", year: 2015, make: "LEXUS", model: "LS" },
  { type: "car", year: 2015, make: "LEXUS", model: "LX" },
  { type: "car", year: 2015, make: "LEXUS", model: "NX" },
  { type: "car", year: 2015, make: "LEXUS", model: "RC" },
  { type: "car", year: 2015, make: "LEXUS", model: "RX" },
  { type: "car", year: 2015, make: "LEXUS", model: "SC" },
  { type: "car", year: 2015, make: "LINCOLN", model: "MKC" },
  { type: "car", year: 2015, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2015, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2015, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2015, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2015, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2015, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2015, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2015, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2015, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2015, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2015, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2015, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2015, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2015, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2015, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2015, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2015, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2015, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2015, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2015, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2015, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2015, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2015, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2015, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "GLA-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "ML-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2015, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2015, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2015, make: "MINI", model: "Cooper Coupe" },
  { type: "car", year: 2015, make: "MINI", model: "Cooper Roadster" },
  { type: "car", year: 2015, make: "MINI", model: "Countryman" },
  { type: "car", year: 2015, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2015, make: "MINI", model: "Paceman" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2015, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2015, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2015, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2015, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2015, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2015, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2015, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2015, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2015, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2015, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2015, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2015, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2015, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2015, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2015, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2015, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2015, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2015, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2015, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2015, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2015, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2015, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2015, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2015, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2015, make: "PORSCHE", model: "911" },
  { type: "car", year: 2015, make: "PORSCHE", model: "918" },
  { type: "car", year: 2015, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2015, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2015, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2015, make: "PORSCHE", model: "Macan" },
  { type: "car", year: 2015, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2015, make: "RAM", model: "1500" },
  { type: "car", year: 2015, make: "RAM", model: "2500" },
  { type: "car", year: 2015, make: "RAM", model: "3500" },
  { type: "car", year: 2015, make: "RAM", model: "4000" },
  { type: "car", year: 2015, make: "RAM", model: "4500" },
  { type: "car", year: 2015, make: "RAM", model: "5500" },
  { type: "car", year: 2015, make: "RAM", model: "Cargo Van" },
  { type: "car", year: 2015, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2015, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2015, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2015, make: "RAM", model: "Promaster City" },
  { type: "car", year: 2015, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2015, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2015, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2015, make: "SAAB", model: "9-3" },
  { type: "car", year: 2015, make: "SAAB", model: "9-5" },
  { type: "car", year: 2015, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2015, make: "SMART", model: "Fortwo Electric Drive" },
  { type: "car", year: 2015, make: "SPYKER", model: "C12" },
  { type: "car", year: 2015, make: "SPYKER", model: "C8" },
  { type: "car", year: 2015, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2015, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2015, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2015, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2015, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2015, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2015, make: "SUBARU", model: "WRX" },
  { type: "car", year: 2015, make: "SUBARU", model: "XV CrossTrek" },
  { type: "car", year: 2015, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2015, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2015, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2015, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2015, make: "TESLA", model: "Model S" },
  { type: "car", year: 2015, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Prius V" },
  { type: "car", year: 2015, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Scion FR-S" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Scion iQ" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2015, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2015, make: "VOLVO", model: "S60" },
  { type: "car", year: 2015, make: "VOLVO", model: "S80" },
  { type: "car", year: 2015, make: "VOLVO", model: "V60" },
  { type: "car", year: 2015, make: "VOLVO", model: "V60CC" },
  { type: "car", year: 2015, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2015, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2015, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2014, make: "ACURA", model: "ILX" },
  { type: "car", year: 2014, make: "ACURA", model: "MDX" },
  { type: "car", year: 2014, make: "ACURA", model: "RDX" },
  { type: "car", year: 2014, make: "ACURA", model: "RLX" },
  { type: "car", year: 2014, make: "ACURA", model: "TL" },
  { type: "car", year: 2014, make: "ACURA", model: "TSX" },
  { type: "car", year: 2014, make: "ALFA ROMEO", model: "4C" },
  { type: "car", year: 2014, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2014, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2014, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2014, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2014, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2014, make: "AUDI", model: "A4" },
  { type: "car", year: 2014, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2014, make: "AUDI", model: "A5" },
  { type: "car", year: 2014, make: "AUDI", model: "A6" },
  { type: "car", year: 2014, make: "AUDI", model: "A7" },
  { type: "car", year: 2014, make: "AUDI", model: "A8" },
  { type: "car", year: 2014, make: "AUDI", model: "Q5" },
  { type: "car", year: 2014, make: "AUDI", model: "Q7" },
  { type: "car", year: 2014, make: "AUDI", model: "R8" },
  { type: "car", year: 2014, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2014, make: "AUDI", model: "RS 7" },
  { type: "car", year: 2014, make: "AUDI", model: "S4" },
  { type: "car", year: 2014, make: "AUDI", model: "S5" },
  { type: "car", year: 2014, make: "AUDI", model: "S6" },
  { type: "car", year: 2014, make: "AUDI", model: "S7" },
  { type: "car", year: 2014, make: "AUDI", model: "S8" },
  { type: "car", year: 2014, make: "AUDI", model: "SQ5" },
  { type: "car", year: 2014, make: "AUDI", model: "TT" },
  { type: "car", year: 2014, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2014, make: "AUDI", model: "TTS" },
  { type: "car", year: 2014, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2014, make: "BENTLEY", model: "Flying Spur" },
  { type: "car", year: 2014, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2014, make: "BMW", model: "128i" },
  { type: "car", year: 2014, make: "BMW", model: "135i" },
  { type: "car", year: 2014, make: "BMW", model: "228i" },
  { type: "car", year: 2014, make: "BMW", model: "320i" },
  { type: "car", year: 2014, make: "BMW", model: "328d" },
  { type: "car", year: 2014, make: "BMW", model: "328i" },
  { type: "car", year: 2014, make: "BMW", model: "335" },
  { type: "car", year: 2014, make: "BMW", model: "335i" },
  { type: "car", year: 2014, make: "BMW", model: "335is" },
  { type: "car", year: 2014, make: "BMW", model: "428i" },
  { type: "car", year: 2014, make: "BMW", model: "435i" },
  { type: "car", year: 2014, make: "BMW", model: "528i" },
  { type: "car", year: 2014, make: "BMW", model: "535d" },
  { type: "car", year: 2014, make: "BMW", model: "535i" },
  { type: "car", year: 2014, make: "BMW", model: "550i" },
  { type: "car", year: 2014, make: "BMW", model: "640i" },
  { type: "car", year: 2014, make: "BMW", model: "650i" },
  { type: "car", year: 2014, make: "BMW", model: "650xi" },
  { type: "car", year: 2014, make: "BMW", model: "740i" },
  { type: "car", year: 2014, make: "BMW", model: "740Li" },
  { type: "car", year: 2014, make: "BMW", model: "750i" },
  { type: "car", year: 2014, make: "BMW", model: "750i, Alpina B7" },
  { type: "car", year: 2014, make: "BMW", model: "750Li" },
  { type: "car", year: 2014, make: "BMW", model: "750Li, Alpina B7" },
  { type: "car", year: 2014, make: "BMW", model: "750Lxi" },
  { type: "car", year: 2014, make: "BMW", model: "750xi" },
  { type: "car", year: 2014, make: "BMW", model: "760Li" },
  { type: "car", year: 2014, make: "BMW", model: "ActiveHybrid 3" },
  { type: "car", year: 2014, make: "BMW", model: "ActiveHybrid 5" },
  { type: "car", year: 2014, make: "BMW", model: "ActiveHybrid 7" },
  { type: "car", year: 2014, make: "BMW", model: "i3" },
  { type: "car", year: 2014, make: "BMW", model: "i8" },
  { type: "car", year: 2014, make: "BMW", model: "M235i" },
  { type: "car", year: 2014, make: "BMW", model: "M5" },
  { type: "car", year: 2014, make: "BMW", model: "M6" },
  { type: "car", year: 2014, make: "BMW", model: "X1" },
  { type: "car", year: 2014, make: "BMW", model: "X3" },
  { type: "car", year: 2014, make: "BMW", model: "X5" },
  { type: "car", year: 2014, make: "BMW", model: "X6" },
  { type: "car", year: 2014, make: "BMW", model: "Z4" },
  { type: "car", year: 2014, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2014, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2014, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2014, make: "BUICK", model: "Encore" },
  { type: "car", year: 2014, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2014, make: "BUICK", model: "Regal" },
  { type: "car", year: 2014, make: "BUICK", model: "Verano" },
  { type: "car", year: 2014, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2014, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2014, make: "CADILLAC", model: "ELR" },
  { type: "car", year: 2014, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2014, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2014, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Impala Limited" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "SS" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2014, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2014, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2014, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2014, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2014, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2014, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2014, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2014, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2014, make: "DODGE", model: "Charger" },
  { type: "car", year: 2014, make: "DODGE", model: "Dart" },
  { type: "car", year: 2014, make: "DODGE", model: "Durango" },
  { type: "car", year: 2014, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2014, make: "DODGE", model: "Journey" },
  { type: "car", year: 2014, make: "DODGE", model: "Viper" },
  { type: "car", year: 2014, make: "FERRARI", model: "458" },
  { type: "car", year: 2014, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2014, make: "FERRARI", model: "California" },
  { type: "car", year: 2014, make: "FERRARI", model: "California T" },
  { type: "car", year: 2014, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2014, make: "FERRARI", model: "FF" },
  { type: "car", year: 2014, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2014, make: "FIAT", model: "500" },
  { type: "car", year: 2014, make: "FIAT", model: "500L" },
  { type: "car", year: 2014, make: "FIAT", model: "Freemont" },
  { type: "car", year: 2014, make: "FISKER", model: "Karma" },
  { type: "car", year: 2014, make: "FISKER", model: "Nina" },
  { type: "car", year: 2014, make: "FORD", model: "'34" },
  { type: "car", year: 2014, make: "FORD", model: "C-Max" },
  { type: "car", year: 2014, make: "FORD", model: "E-150" },
  { type: "car", year: 2014, make: "FORD", model: "E-250" },
  { type: "car", year: 2014, make: "FORD", model: "E-350" },
  { type: "car", year: 2014, make: "FORD", model: "E-450" },
  { type: "car", year: 2014, make: "FORD", model: "Edge" },
  { type: "car", year: 2014, make: "FORD", model: "Escape" },
  { type: "car", year: 2014, make: "FORD", model: "Expedition" },
  { type: "car", year: 2014, make: "FORD", model: "Explorer" },
  { type: "car", year: 2014, make: "FORD", model: "F-150" },
  { type: "car", year: 2014, make: "FORD", model: "F-250" },
  { type: "car", year: 2014, make: "FORD", model: "F-350" },
  { type: "car", year: 2014, make: "FORD", model: "F-450" },
  { type: "car", year: 2014, make: "FORD", model: "F-550" },
  { type: "car", year: 2014, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2014, make: "FORD", model: "Flex" },
  { type: "car", year: 2014, make: "FORD", model: "Focus" },
  { type: "car", year: 2014, make: "FORD", model: "Fusion" },
  { type: "car", year: 2014, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2014, make: "FORD", model: "Mustang" },
  { type: "car", year: 2014, make: "FORD", model: "Taurus" },
  { type: "car", year: 2014, make: "GMC", model: "Acadia" },
  { type: "car", year: 2014, make: "GMC", model: "Canyon" },
  { type: "car", year: 2014, make: "GMC", model: "Savana" },
  { type: "car", year: 2014, make: "GMC", model: "Sierra" },
  { type: "car", year: 2014, make: "GMC", model: "Terrain" },
  { type: "car", year: 2014, make: "GMC", model: "Yukon" },
  { type: "car", year: 2014, make: "HONDA", model: "Accord" },
  { type: "car", year: 2014, make: "HONDA", model: "Civic" },
  { type: "car", year: 2014, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2014, make: "HONDA", model: "CR-Z" },
  { type: "car", year: 2014, make: "HONDA", model: "Crosstour" },
  { type: "car", year: 2014, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2014, make: "HONDA", model: "Fit" },
  { type: "car", year: 2014, make: "HONDA", model: "Insight" },
  { type: "car", year: 2014, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2014, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Equus" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Santa Fe Sport" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2014, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2014, make: "INFINITI", model: "Q50" },
  { type: "car", year: 2014, make: "INFINITI", model: "Q60" },
  { type: "car", year: 2014, make: "INFINITI", model: "Q70" },
  { type: "car", year: 2014, make: "INFINITI", model: "QX50" },
  { type: "car", year: 2014, make: "INFINITI", model: "QX60" },
  { type: "car", year: 2014, make: "INFINITI", model: "QX70" },
  { type: "car", year: 2014, make: "INFINITI", model: "QX80" },
  { type: "car", year: 2014, make: "JAGUAR", model: "F-TYPE" },
  { type: "car", year: 2014, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2014, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2014, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2014, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2014, make: "JEEP", model: "Compass" },
  { type: "car", year: 2014, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2014, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2014, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2014, make: "KIA", model: "Cadenza" },
  { type: "car", year: 2014, make: "KIA", model: "Forte" },
  { type: "car", year: 2014, make: "KIA", model: "Optima" },
  { type: "car", year: 2014, make: "KIA", model: "Rio" },
  { type: "car", year: 2014, make: "KIA", model: "Rondo" },
  { type: "car", year: 2014, make: "KIA", model: "Sedona" },
  { type: "car", year: 2014, make: "KIA", model: "Sorento" },
  { type: "car", year: 2014, make: "KIA", model: "Soul" },
  { type: "car", year: 2014, make: "KIA", model: "Sportage" },
  { type: "car", year: 2014, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2014, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2014, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2014, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2014, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2014, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2014, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2014, make: "LEXUS", model: "CT" },
  { type: "car", year: 2014, make: "LEXUS", model: "ES" },
  { type: "car", year: 2014, make: "LEXUS", model: "GS" },
  { type: "car", year: 2014, make: "LEXUS", model: "GX" },
  { type: "car", year: 2014, make: "LEXUS", model: "IS" },
  { type: "car", year: 2014, make: "LEXUS", model: "LS" },
  { type: "car", year: 2014, make: "LEXUS", model: "LX" },
  { type: "car", year: 2014, make: "LEXUS", model: "RX" },
  { type: "car", year: 2014, make: "LEXUS", model: "SC" },
  { type: "car", year: 2014, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2014, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2014, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2014, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2014, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2014, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2014, make: "MASERATI", model: "Ghibli" },
  { type: "car", year: 2014, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2014, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2014, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2014, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2014, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2014, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2014, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2014, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2014, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2014, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2014, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2014, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2014, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2014, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2014, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2014, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2014, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "CLA-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "ML-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2014, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2014, make: "MINI", model: "Clubman" },
  { type: "car", year: 2014, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2014, make: "MINI", model: "Cooper Coupe" },
  { type: "car", year: 2014, make: "MINI", model: "Cooper Roadster" },
  { type: "car", year: 2014, make: "MINI", model: "Countryman" },
  { type: "car", year: 2014, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2014, make: "MINI", model: "Paceman" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2014, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2014, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2014, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2014, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2014, make: "NISSAN", model: "Cube" },
  { type: "car", year: 2014, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2014, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2014, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2014, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2014, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2014, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2014, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2014, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2014, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2014, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2014, make: "NISSAN", model: "Rogue Select" },
  { type: "car", year: 2014, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2014, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2014, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2014, make: "NISSAN", model: "Versa Note" },
  { type: "car", year: 2014, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2014, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2014, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2014, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2014, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2014, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2014, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2014, make: "PORSCHE", model: "911" },
  { type: "car", year: 2014, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2014, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2014, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2014, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2014, make: "RAM", model: "1500" },
  { type: "car", year: 2014, make: "RAM", model: "2500" },
  { type: "car", year: 2014, make: "RAM", model: "3500" },
  { type: "car", year: 2014, make: "RAM", model: "4000" },
  { type: "car", year: 2014, make: "RAM", model: "4500" },
  { type: "car", year: 2014, make: "RAM", model: "5500" },
  { type: "car", year: 2014, make: "RAM", model: "Cargo Van" },
  { type: "car", year: 2014, make: "RAM", model: "ProMaster 1500" },
  { type: "car", year: 2014, make: "RAM", model: "ProMaster 2500" },
  { type: "car", year: 2014, make: "RAM", model: "ProMaster 3500" },
  { type: "car", year: 2014, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2014, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2014, make: "ROLLS-ROYCE", model: "Wraith" },
  { type: "car", year: 2014, make: "SAAB", model: "9-3" },
  { type: "car", year: 2014, make: "SAAB", model: "9-5" },
  { type: "car", year: 2014, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2014, make: "SMART", model: "Fortwo Electric Drive" },
  { type: "car", year: 2014, make: "SPYKER", model: "C12" },
  { type: "car", year: 2014, make: "SPYKER", model: "C8" },
  { type: "car", year: 2014, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2014, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2014, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2014, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2014, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2014, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2014, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2014, make: "SUBARU", model: "XV CrossTrek" },
  { type: "car", year: 2014, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2014, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2014, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2014, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2014, make: "TESLA", model: "Model S" },
  { type: "car", year: 2014, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2014, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Prius V" },
  { type: "car", year: 2014, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Scion FR-S" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Scion iQ" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2014, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2014, make: "VOLVO", model: "S60" },
  { type: "car", year: 2014, make: "VOLVO", model: "S80" },
  { type: "car", year: 2014, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2014, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2014, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2014, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2013, make: "ACURA", model: "ILX" },
  { type: "car", year: 2013, make: "ACURA", model: "MDX" },
  { type: "car", year: 2013, make: "ACURA", model: "RDX" },
  { type: "car", year: 2013, make: "ACURA", model: "TL" },
  { type: "car", year: 2013, make: "ACURA", model: "TSX" },
  { type: "car", year: 2013, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2013, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2013, make: "AM GENERAL", model: "MV-1" },
  { type: "car", year: 2013, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2013, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2013, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2013, make: "AUDI", model: "A3" },
  { type: "car", year: 2013, make: "AUDI", model: "A4" },
  { type: "car", year: 2013, make: "AUDI", model: "A4 allroad" },
  { type: "car", year: 2013, make: "AUDI", model: "A5" },
  { type: "car", year: 2013, make: "AUDI", model: "A6" },
  { type: "car", year: 2013, make: "AUDI", model: "A7" },
  { type: "car", year: 2013, make: "AUDI", model: "A8" },
  { type: "car", year: 2013, make: "AUDI", model: "Q5" },
  { type: "car", year: 2013, make: "AUDI", model: "Q7" },
  { type: "car", year: 2013, make: "AUDI", model: "RS 5" },
  { type: "car", year: 2013, make: "AUDI", model: "S4" },
  { type: "car", year: 2013, make: "AUDI", model: "S5" },
  { type: "car", year: 2013, make: "AUDI", model: "S6" },
  { type: "car", year: 2013, make: "AUDI", model: "S7" },
  { type: "car", year: 2013, make: "AUDI", model: "S8" },
  { type: "car", year: 2013, make: "AUDI", model: "TT" },
  { type: "car", year: 2013, make: "AUDI", model: "TT RS" },
  { type: "car", year: 2013, make: "AUDI", model: "TTS" },
  { type: "car", year: 2013, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2013, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2013, make: "BMW", model: "128i" },
  { type: "car", year: 2013, make: "BMW", model: "135i" },
  { type: "car", year: 2013, make: "BMW", model: "320i" },
  { type: "car", year: 2013, make: "BMW", model: "328i" },
  { type: "car", year: 2013, make: "BMW", model: "335i" },
  { type: "car", year: 2013, make: "BMW", model: "335is" },
  { type: "car", year: 2013, make: "BMW", model: "528i" },
  { type: "car", year: 2013, make: "BMW", model: "528xi" },
  { type: "car", year: 2013, make: "BMW", model: "535i" },
  { type: "car", year: 2013, make: "BMW", model: "550i" },
  { type: "car", year: 2013, make: "BMW", model: "640i" },
  { type: "car", year: 2013, make: "BMW", model: "650i" },
  { type: "car", year: 2013, make: "BMW", model: "650xi" },
  { type: "car", year: 2013, make: "BMW", model: "740i" },
  { type: "car", year: 2013, make: "BMW", model: "740Li" },
  { type: "car", year: 2013, make: "BMW", model: "750i" },
  { type: "car", year: 2013, make: "BMW", model: "750i, Alpina B7" },
  { type: "car", year: 2013, make: "BMW", model: "750Li" },
  { type: "car", year: 2013, make: "BMW", model: "750Li, Alpina B7" },
  { type: "car", year: 2013, make: "BMW", model: "750Lxi" },
  { type: "car", year: 2013, make: "BMW", model: "750xi" },
  { type: "car", year: 2013, make: "BMW", model: "760Li" },
  { type: "car", year: 2013, make: "BMW", model: "ActiveHybrid 5" },
  { type: "car", year: 2013, make: "BMW", model: "M3" },
  { type: "car", year: 2013, make: "BMW", model: "M5" },
  { type: "car", year: 2013, make: "BMW", model: "M6" },
  { type: "car", year: 2013, make: "BMW", model: "X1" },
  { type: "car", year: 2013, make: "BMW", model: "X3" },
  { type: "car", year: 2013, make: "BMW", model: "X5" },
  { type: "car", year: 2013, make: "BMW", model: "X6" },
  { type: "car", year: 2013, make: "BMW", model: "Z4" },
  { type: "car", year: 2013, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2013, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2013, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2013, make: "BUICK", model: "Encore" },
  { type: "car", year: 2013, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2013, make: "BUICK", model: "Regal" },
  { type: "car", year: 2013, make: "BUICK", model: "Verano" },
  { type: "car", year: 2013, make: "CADILLAC", model: "ATS" },
  { type: "car", year: 2013, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2013, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2013, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2013, make: "CADILLAC", model: "XTS" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Trax" },
  { type: "car", year: 2013, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2013, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2013, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2013, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2013, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2013, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2013, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2013, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2013, make: "DODGE", model: "Charger" },
  { type: "car", year: 2013, make: "DODGE", model: "Dart" },
  { type: "car", year: 2013, make: "DODGE", model: "Durango" },
  { type: "car", year: 2013, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2013, make: "DODGE", model: "Journey" },
  { type: "car", year: 2013, make: "DODGE", model: "Viper" },
  { type: "car", year: 2013, make: "FERRARI", model: "458" },
  { type: "car", year: 2013, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2013, make: "FERRARI", model: "California" },
  { type: "car", year: 2013, make: "FERRARI", model: "California T" },
  { type: "car", year: 2013, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2013, make: "FERRARI", model: "FF" },
  { type: "car", year: 2013, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2013, make: "FIAT", model: "500" },
  { type: "car", year: 2013, make: "FIAT", model: "Freemont" },
  { type: "car", year: 2013, make: "FISKER", model: "Karma" },
  { type: "car", year: 2013, make: "FISKER", model: "Nina" },
  { type: "car", year: 2013, make: "FORD", model: "'34" },
  { type: "car", year: 2013, make: "FORD", model: "C-Max" },
  { type: "car", year: 2013, make: "FORD", model: "E-150" },
  { type: "car", year: 2013, make: "FORD", model: "E-250" },
  { type: "car", year: 2013, make: "FORD", model: "E-350" },
  { type: "car", year: 2013, make: "FORD", model: "E-450" },
  { type: "car", year: 2013, make: "FORD", model: "Edge" },
  { type: "car", year: 2013, make: "FORD", model: "Escape" },
  { type: "car", year: 2013, make: "FORD", model: "Expedition" },
  { type: "car", year: 2013, make: "FORD", model: "Explorer" },
  { type: "car", year: 2013, make: "FORD", model: "F-150" },
  { type: "car", year: 2013, make: "FORD", model: "F-250" },
  { type: "car", year: 2013, make: "FORD", model: "F-350" },
  { type: "car", year: 2013, make: "FORD", model: "F-450" },
  { type: "car", year: 2013, make: "FORD", model: "F-550" },
  { type: "car", year: 2013, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2013, make: "FORD", model: "Flex" },
  { type: "car", year: 2013, make: "FORD", model: "Focus" },
  { type: "car", year: 2013, make: "FORD", model: "Fusion" },
  { type: "car", year: 2013, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2013, make: "FORD", model: "Mustang" },
  { type: "car", year: 2013, make: "FORD", model: "Taurus" },
  { type: "car", year: 2013, make: "GMC", model: "Acadia" },
  { type: "car", year: 2013, make: "GMC", model: "Canyon" },
  { type: "car", year: 2013, make: "GMC", model: "Savana" },
  { type: "car", year: 2013, make: "GMC", model: "Sierra" },
  { type: "car", year: 2013, make: "GMC", model: "Terrain" },
  { type: "car", year: 2013, make: "GMC", model: "Yukon" },
  { type: "car", year: 2013, make: "HONDA", model: "Accord" },
  { type: "car", year: 2013, make: "HONDA", model: "Civic" },
  { type: "car", year: 2013, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2013, make: "HONDA", model: "CR-Z" },
  { type: "car", year: 2013, make: "HONDA", model: "Crosstour" },
  { type: "car", year: 2013, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2013, make: "HONDA", model: "Fit" },
  { type: "car", year: 2013, make: "HONDA", model: "Insight" },
  { type: "car", year: 2013, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2013, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Equus" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Santa Fe Sport" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2013, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2013, make: "INFINITI", model: "EX35" },
  { type: "car", year: 2013, make: "INFINITI", model: "FX37" },
  { type: "car", year: 2013, make: "INFINITI", model: "FX50" },
  { type: "car", year: 2013, make: "INFINITI", model: "G37" },
  { type: "car", year: 2013, make: "INFINITI", model: "JX35" },
  { type: "car", year: 2013, make: "INFINITI", model: "M35h" },
  { type: "car", year: 2013, make: "INFINITI", model: "M37" },
  { type: "car", year: 2013, make: "INFINITI", model: "M56" },
  { type: "car", year: 2013, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2013, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2013, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2013, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2013, make: "JEEP", model: "Compass" },
  { type: "car", year: 2013, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2013, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2013, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2013, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2013, make: "KIA", model: "Forte" },
  { type: "car", year: 2013, make: "KIA", model: "Optima" },
  { type: "car", year: 2013, make: "KIA", model: "Rio" },
  { type: "car", year: 2013, make: "KIA", model: "Rondo" },
  { type: "car", year: 2013, make: "KIA", model: "Sedona" },
  { type: "car", year: 2013, make: "KIA", model: "Sorento" },
  { type: "car", year: 2013, make: "KIA", model: "Soul" },
  { type: "car", year: 2013, make: "KIA", model: "Sportage" },
  { type: "car", year: 2013, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2013, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2013, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2013, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2013, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2013, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2013, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2013, make: "LEXUS", model: "CT" },
  { type: "car", year: 2013, make: "LEXUS", model: "ES" },
  { type: "car", year: 2013, make: "LEXUS", model: "GS" },
  { type: "car", year: 2013, make: "LEXUS", model: "GX" },
  { type: "car", year: 2013, make: "LEXUS", model: "IS" },
  { type: "car", year: 2013, make: "LEXUS", model: "LFA" },
  { type: "car", year: 2013, make: "LEXUS", model: "LS" },
  { type: "car", year: 2013, make: "LEXUS", model: "LX" },
  { type: "car", year: 2013, make: "LEXUS", model: "RX" },
  { type: "car", year: 2013, make: "LEXUS", model: "SC" },
  { type: "car", year: 2013, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2013, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2013, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2013, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2013, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2013, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2013, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2013, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2013, make: "MAZDA", model: "CX-5" },
  { type: "car", year: 2013, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2013, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2013, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2013, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2013, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2013, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2013, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2013, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2013, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2013, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2013, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2013, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2013, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2013, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "ML-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2013, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2013, make: "MINI", model: "Clubman" },
  { type: "car", year: 2013, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2013, make: "MINI", model: "Cooper Coupe" },
  { type: "car", year: 2013, make: "MINI", model: "Cooper Roadster" },
  { type: "car", year: 2013, make: "MINI", model: "Countryman" },
  { type: "car", year: 2013, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2013, make: "MINI", model: "Paceman" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2013, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2013, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2013, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2013, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2013, make: "NISSAN", model: "Cube" },
  { type: "car", year: 2013, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2013, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2013, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2013, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2013, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2013, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2013, make: "NISSAN", model: "NV200" },
  { type: "car", year: 2013, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2013, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2013, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2013, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2013, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2013, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2013, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2013, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2013, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2013, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2013, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2013, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2013, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2013, make: "PORSCHE", model: "911" },
  { type: "car", year: 2013, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2013, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2013, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2013, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2013, make: "RAM", model: "1500" },
  { type: "car", year: 2013, make: "RAM", model: "2500" },
  { type: "car", year: 2013, make: "RAM", model: "3500" },
  { type: "car", year: 2013, make: "RAM", model: "4000" },
  { type: "car", year: 2013, make: "RAM", model: "4500" },
  { type: "car", year: 2013, make: "RAM", model: "5500" },
  { type: "car", year: 2013, make: "RAM", model: "Cargo Van" },
  { type: "car", year: 2013, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2013, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2013, make: "SAAB", model: "9-3" },
  { type: "car", year: 2013, make: "SAAB", model: "9-5" },
  { type: "car", year: 2013, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2013, make: "SMART", model: "Fortwo Electric Drive" },
  { type: "car", year: 2013, make: "SPYKER", model: "C12" },
  { type: "car", year: 2013, make: "SPYKER", model: "C8" },
  { type: "car", year: 2013, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2013, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2013, make: "SUBARU", model: "BRZ" },
  { type: "car", year: 2013, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2013, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2013, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2013, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2013, make: "SUBARU", model: "XV CrossTrek" },
  { type: "car", year: 2013, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2013, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2013, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2013, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2013, make: "TESLA", model: "Model S" },
  { type: "car", year: 2013, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2013, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Prius V" },
  { type: "car", year: 2013, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Scion FR-S" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Scion iQ" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2013, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2013, make: "VOLVO", model: "C30" },
  { type: "car", year: 2013, make: "VOLVO", model: "C70" },
  { type: "car", year: 2013, make: "VOLVO", model: "S60" },
  { type: "car", year: 2013, make: "VOLVO", model: "S80" },
  { type: "car", year: 2013, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2013, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2013, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2013, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2012, make: "ACURA", model: "MDX" },
  { type: "car", year: 2012, make: "ACURA", model: "RDX" },
  { type: "car", year: 2012, make: "ACURA", model: "RL" },
  { type: "car", year: 2012, make: "ACURA", model: "TL" },
  { type: "car", year: 2012, make: "ACURA", model: "TSX" },
  { type: "car", year: 2012, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2012, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2012, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2012, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2012, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2012, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2012, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2012, make: "ASTON MARTIN", model: "Virage" },
  { type: "car", year: 2012, make: "AUDI", model: "A3" },
  { type: "car", year: 2012, make: "AUDI", model: "A4" },
  { type: "car", year: 2012, make: "AUDI", model: "A5" },
  { type: "car", year: 2012, make: "AUDI", model: "A6" },
  { type: "car", year: 2012, make: "AUDI", model: "A7" },
  { type: "car", year: 2012, make: "AUDI", model: "A8" },
  { type: "car", year: 2012, make: "AUDI", model: "Q5" },
  { type: "car", year: 2012, make: "AUDI", model: "Q7" },
  { type: "car", year: 2012, make: "AUDI", model: "R8" },
  { type: "car", year: 2012, make: "AUDI", model: "S4" },
  { type: "car", year: 2012, make: "AUDI", model: "S5" },
  { type: "car", year: 2012, make: "AUDI", model: "TT" },
  { type: "car", year: 2012, make: "AUDI", model: "TTS" },
  { type: "car", year: 2012, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2012, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2012, make: "BMW", model: "128i" },
  { type: "car", year: 2012, make: "BMW", model: "135i" },
  { type: "car", year: 2012, make: "BMW", model: "328i" },
  { type: "car", year: 2012, make: "BMW", model: "335i" },
  { type: "car", year: 2012, make: "BMW", model: "335is" },
  { type: "car", year: 2012, make: "BMW", model: "528i" },
  { type: "car", year: 2012, make: "BMW", model: "528xi" },
  { type: "car", year: 2012, make: "BMW", model: "535i" },
  { type: "car", year: 2012, make: "BMW", model: "550i" },
  { type: "car", year: 2012, make: "BMW", model: "640i" },
  { type: "car", year: 2012, make: "BMW", model: "650i" },
  { type: "car", year: 2012, make: "BMW", model: "650xi" },
  { type: "car", year: 2012, make: "BMW", model: "740i" },
  { type: "car", year: 2012, make: "BMW", model: "740Li" },
  { type: "car", year: 2012, make: "BMW", model: "750i" },
  { type: "car", year: 2012, make: "BMW", model: "750i, Alpina B7" },
  { type: "car", year: 2012, make: "BMW", model: "750Li" },
  { type: "car", year: 2012, make: "BMW", model: "750Li, Alpina B7" },
  { type: "car", year: 2012, make: "BMW", model: "750Lxi, Alpina B7" },
  { type: "car", year: 2012, make: "BMW", model: "750xi, Alpina B7" },
  { type: "car", year: 2012, make: "BMW", model: "760Li" },
  { type: "car", year: 2012, make: "BMW", model: "ActiveE" },
  { type: "car", year: 2012, make: "BMW", model: "ActiveHybrid 5" },
  { type: "car", year: 2012, make: "BMW", model: "M3" },
  { type: "car", year: 2012, make: "BMW", model: "M6" },
  { type: "car", year: 2012, make: "BMW", model: "X1" },
  { type: "car", year: 2012, make: "BMW", model: "X3" },
  { type: "car", year: 2012, make: "BMW", model: "X5" },
  { type: "car", year: 2012, make: "BMW", model: "X6" },
  { type: "car", year: 2012, make: "BMW", model: "Z4" },
  { type: "car", year: 2012, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2012, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2012, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2012, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2012, make: "BUICK", model: "Regal" },
  { type: "car", year: 2012, make: "BUICK", model: "Verano" },
  { type: "car", year: 2012, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2012, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2012, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Matiz" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Sonic" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2012, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2012, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2012, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2012, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2012, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2012, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2012, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2012, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2012, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2012, make: "DODGE", model: "Charger" },
  { type: "car", year: 2012, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2012, make: "DODGE", model: "Durango" },
  { type: "car", year: 2012, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2012, make: "DODGE", model: "Journey" },
  { type: "car", year: 2012, make: "DODGE", model: "Nitro" },
  { type: "car", year: 2012, make: "DODGE", model: "Ram" },
  { type: "car", year: 2012, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2012, make: "FERRARI", model: "458" },
  { type: "car", year: 2012, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2012, make: "FERRARI", model: "California" },
  { type: "car", year: 2012, make: "FERRARI", model: "California T" },
  { type: "car", year: 2012, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2012, make: "FERRARI", model: "FF" },
  { type: "car", year: 2012, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2012, make: "FIAT", model: "500" },
  { type: "car", year: 2012, make: "FIAT", model: "Freemont" },
  { type: "car", year: 2012, make: "FISKER", model: "Karma" },
  { type: "car", year: 2012, make: "FISKER", model: "Nina" },
  { type: "car", year: 2012, make: "FORD", model: "'34" },
  { type: "car", year: 2012, make: "FORD", model: "E-150" },
  { type: "car", year: 2012, make: "FORD", model: "E-250" },
  { type: "car", year: 2012, make: "FORD", model: "E-350" },
  { type: "car", year: 2012, make: "FORD", model: "E-450" },
  { type: "car", year: 2012, make: "FORD", model: "Edge" },
  { type: "car", year: 2012, make: "FORD", model: "Escape" },
  { type: "car", year: 2012, make: "FORD", model: "Expedition" },
  { type: "car", year: 2012, make: "FORD", model: "Explorer" },
  { type: "car", year: 2012, make: "FORD", model: "F-150" },
  { type: "car", year: 2012, make: "FORD", model: "F-250" },
  { type: "car", year: 2012, make: "FORD", model: "F-350" },
  { type: "car", year: 2012, make: "FORD", model: "F-450" },
  { type: "car", year: 2012, make: "FORD", model: "F-550" },
  { type: "car", year: 2012, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2012, make: "FORD", model: "Flex" },
  { type: "car", year: 2012, make: "FORD", model: "Focus" },
  { type: "car", year: 2012, make: "FORD", model: "Fusion" },
  { type: "car", year: 2012, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2012, make: "FORD", model: "Mustang" },
  { type: "car", year: 2012, make: "FORD", model: "Taurus" },
  { type: "car", year: 2012, make: "GMC", model: "Acadia" },
  { type: "car", year: 2012, make: "GMC", model: "Canyon" },
  { type: "car", year: 2012, make: "GMC", model: "Savana" },
  { type: "car", year: 2012, make: "GMC", model: "Sierra" },
  { type: "car", year: 2012, make: "GMC", model: "Terrain" },
  { type: "car", year: 2012, make: "GMC", model: "Yukon" },
  { type: "car", year: 2012, make: "HONDA", model: "Accord" },
  { type: "car", year: 2012, make: "HONDA", model: "Civic" },
  { type: "car", year: 2012, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2012, make: "HONDA", model: "CR-Z" },
  { type: "car", year: 2012, make: "HONDA", model: "Crosstour" },
  { type: "car", year: 2012, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2012, make: "HONDA", model: "Fit" },
  { type: "car", year: 2012, make: "HONDA", model: "Insight" },
  { type: "car", year: 2012, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2012, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Equus" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Veloster" },
  { type: "car", year: 2012, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2012, make: "INFINITI", model: "EX35" },
  { type: "car", year: 2012, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2012, make: "INFINITI", model: "FX50" },
  { type: "car", year: 2012, make: "INFINITI", model: "G25" },
  { type: "car", year: 2012, make: "INFINITI", model: "G37" },
  { type: "car", year: 2012, make: "INFINITI", model: "M35h" },
  { type: "car", year: 2012, make: "INFINITI", model: "M37" },
  { type: "car", year: 2012, make: "INFINITI", model: "M56" },
  { type: "car", year: 2012, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2012, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2012, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2012, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2012, make: "JEEP", model: "Compass" },
  { type: "car", year: 2012, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2012, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2012, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2012, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2012, make: "KIA", model: "Forte" },
  { type: "car", year: 2012, make: "KIA", model: "Optima" },
  { type: "car", year: 2012, make: "KIA", model: "Rio" },
  { type: "car", year: 2012, make: "KIA", model: "Rondo" },
  { type: "car", year: 2012, make: "KIA", model: "Sedona" },
  { type: "car", year: 2012, make: "KIA", model: "Sorento" },
  { type: "car", year: 2012, make: "KIA", model: "Soul" },
  { type: "car", year: 2012, make: "KIA", model: "Sportage" },
  { type: "car", year: 2012, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2012, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2012, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2012, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2012, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2012, make: "LAND ROVER", model: "Range Rover Evoque" },
  { type: "car", year: 2012, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2012, make: "LEXUS", model: "CT" },
  { type: "car", year: 2012, make: "LEXUS", model: "ES" },
  { type: "car", year: 2012, make: "LEXUS", model: "GS" },
  { type: "car", year: 2012, make: "LEXUS", model: "GX" },
  { type: "car", year: 2012, make: "LEXUS", model: "HS" },
  { type: "car", year: 2012, make: "LEXUS", model: "IS" },
  { type: "car", year: 2012, make: "LEXUS", model: "LFA" },
  { type: "car", year: 2012, make: "LEXUS", model: "LS" },
  { type: "car", year: 2012, make: "LEXUS", model: "LX" },
  { type: "car", year: 2012, make: "LEXUS", model: "RX" },
  { type: "car", year: 2012, make: "LEXUS", model: "SC" },
  { type: "car", year: 2012, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2012, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2012, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2012, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2012, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2012, make: "LOTUS", model: "2-Eleven" },
  { type: "car", year: 2012, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2012, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2012, make: "LOTUS", model: "Exige" },
  { type: "car", year: 2012, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2012, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2012, make: "MAYBACH", model: "57" },
  { type: "car", year: 2012, make: "MAYBACH", model: "62" },
  { type: "car", year: 2012, make: "MAZDA", model: "CX-7" },
  { type: "car", year: 2012, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2012, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2012, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2012, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2012, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2012, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2012, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2012, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2012, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2012, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2012, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2012, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2012, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2012, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2012, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "ML-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2012, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2012, make: "MINI", model: "Clubman" },
  { type: "car", year: 2012, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2012, make: "MINI", model: "Cooper Coupe" },
  { type: "car", year: 2012, make: "MINI", model: "Cooper Roadster" },
  { type: "car", year: 2012, make: "MINI", model: "Countryman" },
  { type: "car", year: 2012, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "i-MiEV" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2012, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2012, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2012, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2012, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2012, make: "NISSAN", model: "Cube" },
  { type: "car", year: 2012, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2012, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2012, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2012, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2012, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2012, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2012, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2012, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2012, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2012, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2012, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2012, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2012, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2012, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2012, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2012, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2012, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2012, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2012, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2012, make: "PORSCHE", model: "911" },
  { type: "car", year: 2012, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2012, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2012, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2012, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2012, make: "RAM", model: "3500" },
  { type: "car", year: 2012, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2012, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2012, make: "SAAB", model: "9-3" },
  { type: "car", year: 2012, make: "SAAB", model: "9-4x" },
  { type: "car", year: 2012, make: "SAAB", model: "9-5" },
  { type: "car", year: 2012, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2012, make: "SPYKER", model: "C12" },
  { type: "car", year: 2012, make: "SPYKER", model: "C8" },
  { type: "car", year: 2012, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2012, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2012, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2012, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2012, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2012, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2012, make: "SUBARU", model: "XV CrossTrek" },
  { type: "car", year: 2012, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2012, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2012, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2012, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2012, make: "TESLA", model: "Model S" },
  { type: "car", year: 2012, make: "TESLA", model: "Roadster" },
  { type: "car", year: 2012, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2012, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Prius C" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Prius V" },
  { type: "car", year: 2012, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Scion iQ" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2012, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2012, make: "VOLVO", model: "C30" },
  { type: "car", year: 2012, make: "VOLVO", model: "C70" },
  { type: "car", year: 2012, make: "VOLVO", model: "C70 / C30" },
  { type: "car", year: 2012, make: "VOLVO", model: "S60" },
  { type: "car", year: 2012, make: "VOLVO", model: "S80" },
  { type: "car", year: 2012, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2012, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2012, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2012, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2011, make: "ACURA", model: "MDX" },
  { type: "car", year: 2011, make: "ACURA", model: "RDX" },
  { type: "car", year: 2011, make: "ACURA", model: "RL" },
  { type: "car", year: 2011, make: "ACURA", model: "TL" },
  { type: "car", year: 2011, make: "ACURA", model: "TSX" },
  { type: "car", year: 2011, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2011, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2011, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2011, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2011, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2011, make: "ASTON MARTIN", model: "V12 Vantage" },
  { type: "car", year: 2011, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2011, make: "AUDI", model: "A3" },
  { type: "car", year: 2011, make: "AUDI", model: "A4" },
  { type: "car", year: 2011, make: "AUDI", model: "A5" },
  { type: "car", year: 2011, make: "AUDI", model: "A6" },
  { type: "car", year: 2011, make: "AUDI", model: "A8" },
  { type: "car", year: 2011, make: "AUDI", model: "Q5" },
  { type: "car", year: 2011, make: "AUDI", model: "Q7" },
  { type: "car", year: 2011, make: "AUDI", model: "R8" },
  { type: "car", year: 2011, make: "AUDI", model: "S4" },
  { type: "car", year: 2011, make: "AUDI", model: "S5" },
  { type: "car", year: 2011, make: "AUDI", model: "S6" },
  { type: "car", year: 2011, make: "AUDI", model: "TT" },
  { type: "car", year: 2011, make: "AUDI", model: "TTS" },
  { type: "car", year: 2011, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2011, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 2011, make: "BMW", model: "128i" },
  { type: "car", year: 2011, make: "BMW", model: "135i" },
  { type: "car", year: 2011, make: "BMW", model: "1M" },
  { type: "car", year: 2011, make: "BMW", model: "328i" },
  { type: "car", year: 2011, make: "BMW", model: "335d" },
  { type: "car", year: 2011, make: "BMW", model: "335i" },
  { type: "car", year: 2011, make: "BMW", model: "335is" },
  { type: "car", year: 2011, make: "BMW", model: "528i" },
  { type: "car", year: 2011, make: "BMW", model: "535i" },
  { type: "car", year: 2011, make: "BMW", model: "550i" },
  { type: "car", year: 2011, make: "BMW", model: "740i" },
  { type: "car", year: 2011, make: "BMW", model: "740Li" },
  { type: "car", year: 2011, make: "BMW", model: "750i" },
  { type: "car", year: 2011, make: "BMW", model: "750Li" },
  { type: "car", year: 2011, make: "BMW", model: "750Lxi" },
  { type: "car", year: 2011, make: "BMW", model: "750xi" },
  { type: "car", year: 2011, make: "BMW", model: "760Li" },
  { type: "car", year: 2011, make: "BMW", model: "M3" },
  { type: "car", year: 2011, make: "BMW", model: "X3" },
  { type: "car", year: 2011, make: "BMW", model: "X5" },
  { type: "car", year: 2011, make: "BMW", model: "X6" },
  { type: "car", year: 2011, make: "BMW", model: "Z4" },
  { type: "car", year: 2011, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2011, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2011, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2011, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2011, make: "BUICK", model: "Lucerne" },
  { type: "car", year: 2011, make: "BUICK", model: "Regal" },
  { type: "car", year: 2011, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2011, make: "CADILLAC", model: "DTS" },
  { type: "car", year: 2011, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2011, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2011, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2011, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2011, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Caprice Police Vehicle" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "HHR" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2011, make: "CHEVROLET", model: "Volt" },
  { type: "car", year: 2011, make: "CHRYSLER", model: "200" },
  { type: "car", year: 2011, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2011, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2011, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2011, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2011, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2011, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2011, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2011, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2011, make: "DODGE", model: "Charger" },
  { type: "car", year: 2011, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2011, make: "DODGE", model: "Durango" },
  { type: "car", year: 2011, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2011, make: "DODGE", model: "Journey" },
  { type: "car", year: 2011, make: "DODGE", model: "Nitro" },
  { type: "car", year: 2011, make: "DODGE", model: "Ram" },
  { type: "car", year: 2011, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2011, make: "FERRARI", model: "458" },
  { type: "car", year: 2011, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2011, make: "FERRARI", model: "599" },
  { type: "car", year: 2011, make: "FERRARI", model: "599 GTB Fiorano" },
  { type: "car", year: 2011, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2011, make: "FERRARI", model: "California" },
  { type: "car", year: 2011, make: "FERRARI", model: "California T" },
  { type: "car", year: 2011, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2011, make: "FERRARI", model: "FF" },
  { type: "car", year: 2011, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2011, make: "FIAT", model: "Freemont" },
  { type: "car", year: 2011, make: "FISKER", model: "Karma" },
  { type: "car", year: 2011, make: "FISKER", model: "Nina" },
  { type: "car", year: 2011, make: "FORD", model: "'34" },
  { type: "car", year: 2011, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2011, make: "FORD", model: "E-150" },
  { type: "car", year: 2011, make: "FORD", model: "E-250" },
  { type: "car", year: 2011, make: "FORD", model: "E-350" },
  { type: "car", year: 2011, make: "FORD", model: "E-450" },
  { type: "car", year: 2011, make: "FORD", model: "Edge" },
  { type: "car", year: 2011, make: "FORD", model: "Escape" },
  { type: "car", year: 2011, make: "FORD", model: "Expedition" },
  { type: "car", year: 2011, make: "FORD", model: "Explorer" },
  { type: "car", year: 2011, make: "FORD", model: "F-150" },
  { type: "car", year: 2011, make: "FORD", model: "F-250" },
  { type: "car", year: 2011, make: "FORD", model: "F-350" },
  { type: "car", year: 2011, make: "FORD", model: "F-450" },
  { type: "car", year: 2011, make: "FORD", model: "F-550" },
  { type: "car", year: 2011, make: "FORD", model: "Fiesta" },
  { type: "car", year: 2011, make: "FORD", model: "Flex" },
  { type: "car", year: 2011, make: "FORD", model: "Focus" },
  { type: "car", year: 2011, make: "FORD", model: "Fusion" },
  { type: "car", year: 2011, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2011, make: "FORD", model: "Mustang" },
  { type: "car", year: 2011, make: "FORD", model: "Ranger" },
  { type: "car", year: 2011, make: "FORD", model: "Taurus" },
  { type: "car", year: 2011, make: "GMC", model: "Acadia" },
  { type: "car", year: 2011, make: "GMC", model: "Canyon" },
  { type: "car", year: 2011, make: "GMC", model: "Savana" },
  { type: "car", year: 2011, make: "GMC", model: "Sierra" },
  { type: "car", year: 2011, make: "GMC", model: "Terrain" },
  { type: "car", year: 2011, make: "GMC", model: "Yukon" },
  { type: "car", year: 2011, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2011, make: "HONDA", model: "Accord" },
  { type: "car", year: 2011, make: "HONDA", model: "Accord Crosstour" },
  { type: "car", year: 2011, make: "HONDA", model: "Civic" },
  { type: "car", year: 2011, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2011, make: "HONDA", model: "CR-Z" },
  { type: "car", year: 2011, make: "HONDA", model: "Element" },
  { type: "car", year: 2011, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2011, make: "HONDA", model: "Fit" },
  { type: "car", year: 2011, make: "HONDA", model: "Insight" },
  { type: "car", year: 2011, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2011, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2011, make: "HUMMER", model: "H2" },
  { type: "car", year: 2011, make: "HUMMER", model: "H3" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Equus" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2011, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2011, make: "INFINITI", model: "EX35" },
  { type: "car", year: 2011, make: "INFINITI", model: "FX50" },
  { type: "car", year: 2011, make: "INFINITI", model: "G25" },
  { type: "car", year: 2011, make: "INFINITI", model: "G37" },
  { type: "car", year: 2011, make: "INFINITI", model: "M37" },
  { type: "car", year: 2011, make: "INFINITI", model: "M56" },
  { type: "car", year: 2011, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2011, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2011, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2011, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2011, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2011, make: "JEEP", model: "Compass" },
  { type: "car", year: 2011, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2011, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2011, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2011, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2011, make: "KIA", model: "Borrego" },
  { type: "car", year: 2011, make: "KIA", model: "Forte" },
  { type: "car", year: 2011, make: "KIA", model: "Optima" },
  { type: "car", year: 2011, make: "KIA", model: "Rio" },
  { type: "car", year: 2011, make: "KIA", model: "Rondo" },
  { type: "car", year: 2011, make: "KIA", model: "Sedona" },
  { type: "car", year: 2011, make: "KIA", model: "Sorento" },
  { type: "car", year: 2011, make: "KIA", model: "Soul" },
  { type: "car", year: 2011, make: "KIA", model: "Sportage" },
  { type: "car", year: 2011, make: "LAMBORGHINI", model: "Aventador" },
  { type: "car", year: 2011, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2011, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2011, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2011, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2011, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2011, make: "LEXUS", model: "CT" },
  { type: "car", year: 2011, make: "LEXUS", model: "ES" },
  { type: "car", year: 2011, make: "LEXUS", model: "GS" },
  { type: "car", year: 2011, make: "LEXUS", model: "GX" },
  { type: "car", year: 2011, make: "LEXUS", model: "HS" },
  { type: "car", year: 2011, make: "LEXUS", model: "IS" },
  { type: "car", year: 2011, make: "LEXUS", model: "LS" },
  { type: "car", year: 2011, make: "LEXUS", model: "LX" },
  { type: "car", year: 2011, make: "LEXUS", model: "RX" },
  { type: "car", year: 2011, make: "LEXUS", model: "SC" },
  { type: "car", year: 2011, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2011, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2011, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2011, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2011, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2011, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2011, make: "LOTUS", model: "2-Eleven" },
  { type: "car", year: 2011, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2011, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2011, make: "LOTUS", model: "Exige" },
  { type: "car", year: 2011, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2011, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2011, make: "MAYBACH", model: "57" },
  { type: "car", year: 2011, make: "MAYBACH", model: "62" },
  { type: "car", year: 2011, make: "MAZDA", model: "CX-7" },
  { type: "car", year: 2011, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2011, make: "MAZDA", model: "Mazda2" },
  { type: "car", year: 2011, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2011, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2011, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2011, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2011, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2011, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2011, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2011, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2011, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2011, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2011, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2011, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2011, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2011, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "B-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "SLS-Class" },
  { type: "car", year: 2011, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2011, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2011, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2011, make: "MERCURY", model: "Milan" },
  { type: "car", year: 2011, make: "MINI", model: "Clubman" },
  { type: "car", year: 2011, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2011, make: "MINI", model: "Countryman" },
  { type: "car", year: 2011, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "Outlander Sport" },
  { type: "car", year: 2011, make: "MITSUBISHI", model: "RVR" },
  { type: "car", year: 2011, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2011, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2011, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2011, make: "NISSAN", model: "Cube" },
  { type: "car", year: 2011, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2011, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2011, make: "NISSAN", model: "Juke" },
  { type: "car", year: 2011, make: "NISSAN", model: "Leaf" },
  { type: "car", year: 2011, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2011, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2011, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2011, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2011, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2011, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2011, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2011, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2011, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2011, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2011, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2011, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2011, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2011, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2011, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2011, make: "PORSCHE", model: "911" },
  { type: "car", year: 2011, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2011, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2011, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2011, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2011, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2011, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2011, make: "SAAB", model: "9-3" },
  { type: "car", year: 2011, make: "SAAB", model: "9-4x" },
  { type: "car", year: 2011, make: "SAAB", model: "9-5" },
  { type: "car", year: 2011, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2011, make: "SPYKER", model: "C12" },
  { type: "car", year: 2011, make: "SPYKER", model: "C8" },
  { type: "car", year: 2011, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2011, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2011, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2011, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2011, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2011, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2011, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2011, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2011, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2011, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2011, make: "TESLA", model: "Roadster" },
  { type: "car", year: 2011, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2011, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2011, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Scion iQ" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2011, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2011, make: "VOLVO", model: "C30" },
  { type: "car", year: 2011, make: "VOLVO", model: "C70" },
  { type: "car", year: 2011, make: "VOLVO", model: "S40" },
  { type: "car", year: 2011, make: "VOLVO", model: "S60" },
  { type: "car", year: 2011, make: "VOLVO", model: "S80" },
  { type: "car", year: 2011, make: "VOLVO", model: "V50" },
  { type: "car", year: 2011, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2011, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2011, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2011, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2010, make: "ACURA", model: "MDX" },
  { type: "car", year: 2010, make: "ACURA", model: "RDX" },
  { type: "car", year: 2010, make: "ACURA", model: "RL" },
  { type: "car", year: 2010, make: "ACURA", model: "TL" },
  { type: "car", year: 2010, make: "ACURA", model: "TSX" },
  { type: "car", year: 2010, make: "ACURA", model: "ZDX" },
  { type: "car", year: 2010, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2010, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2010, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2010, make: "ASTON MARTIN", model: "Rapide" },
  { type: "car", year: 2010, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2010, make: "AUDI", model: "A3" },
  { type: "car", year: 2010, make: "AUDI", model: "A4" },
  { type: "car", year: 2010, make: "AUDI", model: "A5" },
  { type: "car", year: 2010, make: "AUDI", model: "A6" },
  { type: "car", year: 2010, make: "AUDI", model: "A8" },
  { type: "car", year: 2010, make: "AUDI", model: "Q5" },
  { type: "car", year: 2010, make: "AUDI", model: "Q7" },
  { type: "car", year: 2010, make: "AUDI", model: "R8" },
  { type: "car", year: 2010, make: "AUDI", model: "S4" },
  { type: "car", year: 2010, make: "AUDI", model: "S5" },
  { type: "car", year: 2010, make: "AUDI", model: "S6" },
  { type: "car", year: 2010, make: "AUDI", model: "TT" },
  { type: "car", year: 2010, make: "AUDI", model: "TTS" },
  { type: "car", year: 2010, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2010, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 2010, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2010, make: "BMW", model: "128i" },
  { type: "car", year: 2010, make: "BMW", model: "135i" },
  { type: "car", year: 2010, make: "BMW", model: "328i" },
  { type: "car", year: 2010, make: "BMW", model: "335d" },
  { type: "car", year: 2010, make: "BMW", model: "335i" },
  { type: "car", year: 2010, make: "BMW", model: "528i" },
  { type: "car", year: 2010, make: "BMW", model: "535i" },
  { type: "car", year: 2010, make: "BMW", model: "550i" },
  { type: "car", year: 2010, make: "BMW", model: "650i" },
  { type: "car", year: 2010, make: "BMW", model: "750i" },
  { type: "car", year: 2010, make: "BMW", model: "750Li" },
  { type: "car", year: 2010, make: "BMW", model: "750Lxi" },
  { type: "car", year: 2010, make: "BMW", model: "750xi" },
  { type: "car", year: 2010, make: "BMW", model: "760Li" },
  { type: "car", year: 2010, make: "BMW", model: "M3" },
  { type: "car", year: 2010, make: "BMW", model: "M5" },
  { type: "car", year: 2010, make: "BMW", model: "M6" },
  { type: "car", year: 2010, make: "BMW", model: "X3" },
  { type: "car", year: 2010, make: "BMW", model: "X5" },
  { type: "car", year: 2010, make: "BMW", model: "X6" },
  { type: "car", year: 2010, make: "BMW", model: "Z4" },
  { type: "car", year: 2010, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2010, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2010, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2010, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2010, make: "BUICK", model: "Lucerne" },
  { type: "car", year: 2010, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2010, make: "CADILLAC", model: "DTS" },
  { type: "car", year: 2010, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2010, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2010, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2010, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2010, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Captiva Sport" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Cobalt" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Cruze" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "HHR" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2010, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2010, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2010, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2010, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2010, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2010, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2010, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2010, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2010, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2010, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2010, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2010, make: "DODGE", model: "Charger" },
  { type: "car", year: 2010, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2010, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2010, make: "DODGE", model: "Journey" },
  { type: "car", year: 2010, make: "DODGE", model: "Nitro" },
  { type: "car", year: 2010, make: "DODGE", model: "Ram" },
  { type: "car", year: 2010, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2010, make: "DODGE", model: "Viper" },
  { type: "car", year: 2010, make: "FERRARI", model: "458" },
  { type: "car", year: 2010, make: "FERRARI", model: "458 Italia" },
  { type: "car", year: 2010, make: "FERRARI", model: "599" },
  { type: "car", year: 2010, make: "FERRARI", model: "599 GTB Fiorano" },
  { type: "car", year: 2010, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2010, make: "FERRARI", model: "California" },
  { type: "car", year: 2010, make: "FERRARI", model: "California T" },
  { type: "car", year: 2010, make: "FERRARI", model: "F12 Berlinetta" },
  { type: "car", year: 2010, make: "FERRARI", model: "FF" },
  { type: "car", year: 2010, make: "FERRARI", model: "La Ferrari" },
  { type: "car", year: 2010, make: "FORD", model: "'34" },
  { type: "car", year: 2010, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2010, make: "FORD", model: "E-150" },
  { type: "car", year: 2010, make: "FORD", model: "E-250" },
  { type: "car", year: 2010, make: "FORD", model: "E-350" },
  { type: "car", year: 2010, make: "FORD", model: "E-450" },
  { type: "car", year: 2010, make: "FORD", model: "Edge" },
  { type: "car", year: 2010, make: "FORD", model: "Escape" },
  { type: "car", year: 2010, make: "FORD", model: "Expedition" },
  { type: "car", year: 2010, make: "FORD", model: "Explorer" },
  { type: "car", year: 2010, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2010, make: "FORD", model: "F-150" },
  { type: "car", year: 2010, make: "FORD", model: "F-250" },
  { type: "car", year: 2010, make: "FORD", model: "F-350" },
  { type: "car", year: 2010, make: "FORD", model: "F-450" },
  { type: "car", year: 2010, make: "FORD", model: "F-550" },
  { type: "car", year: 2010, make: "FORD", model: "Flex" },
  { type: "car", year: 2010, make: "FORD", model: "Focus" },
  { type: "car", year: 2010, make: "FORD", model: "Fusion" },
  { type: "car", year: 2010, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2010, make: "FORD", model: "Mustang" },
  { type: "car", year: 2010, make: "FORD", model: "Ranger" },
  { type: "car", year: 2010, make: "FORD", model: "Taurus" },
  { type: "car", year: 2010, make: "GMC", model: "Acadia" },
  { type: "car", year: 2010, make: "GMC", model: "Canyon" },
  { type: "car", year: 2010, make: "GMC", model: "Savana" },
  { type: "car", year: 2010, make: "GMC", model: "Sierra" },
  { type: "car", year: 2010, make: "GMC", model: "Terrain" },
  { type: "car", year: 2010, make: "GMC", model: "Yukon" },
  { type: "car", year: 2010, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2010, make: "HONDA", model: "Accord" },
  { type: "car", year: 2010, make: "HONDA", model: "Accord Crosstour" },
  { type: "car", year: 2010, make: "HONDA", model: "Civic" },
  { type: "car", year: 2010, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2010, make: "HONDA", model: "Element" },
  { type: "car", year: 2010, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2010, make: "HONDA", model: "Fit" },
  { type: "car", year: 2010, make: "HONDA", model: "Insight" },
  { type: "car", year: 2010, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2010, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2010, make: "HUMMER", model: "H2" },
  { type: "car", year: 2010, make: "HUMMER", model: "H3" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Elantra Touring" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Genesis Coupe" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2010, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2010, make: "INFINITI", model: "EX35" },
  { type: "car", year: 2010, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2010, make: "INFINITI", model: "FX50" },
  { type: "car", year: 2010, make: "INFINITI", model: "G37" },
  { type: "car", year: 2010, make: "INFINITI", model: "M35" },
  { type: "car", year: 2010, make: "INFINITI", model: "M45" },
  { type: "car", year: 2010, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2010, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2010, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2010, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2010, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2010, make: "JEEP", model: "Commander" },
  { type: "car", year: 2010, make: "JEEP", model: "Compass" },
  { type: "car", year: 2010, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2010, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2010, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2010, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2010, make: "KIA", model: "Borrego" },
  { type: "car", year: 2010, make: "KIA", model: "Forte" },
  { type: "car", year: 2010, make: "KIA", model: "Optima" },
  { type: "car", year: 2010, make: "KIA", model: "Rio" },
  { type: "car", year: 2010, make: "KIA", model: "Rondo" },
  { type: "car", year: 2010, make: "KIA", model: "Sedona" },
  { type: "car", year: 2010, make: "KIA", model: "Soul" },
  { type: "car", year: 2010, make: "KIA", model: "Sportage" },
  { type: "car", year: 2010, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2010, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2010, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2010, make: "LAND ROVER", model: "LR4" },
  { type: "car", year: 2010, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2010, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2010, make: "LEXUS", model: "ES" },
  { type: "car", year: 2010, make: "LEXUS", model: "GS" },
  { type: "car", year: 2010, make: "LEXUS", model: "GX" },
  { type: "car", year: 2010, make: "LEXUS", model: "HS" },
  { type: "car", year: 2010, make: "LEXUS", model: "IS" },
  { type: "car", year: 2010, make: "LEXUS", model: "LS" },
  { type: "car", year: 2010, make: "LEXUS", model: "LX" },
  { type: "car", year: 2010, make: "LEXUS", model: "RX" },
  { type: "car", year: 2010, make: "LEXUS", model: "SC" },
  { type: "car", year: 2010, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2010, make: "LINCOLN", model: "MKT" },
  { type: "car", year: 2010, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2010, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2010, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2010, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2010, make: "LOTUS", model: "Eleven" },
  { type: "car", year: 2010, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2010, make: "LOTUS", model: "Evora" },
  { type: "car", year: 2010, make: "LOTUS", model: "Exige" },
  { type: "car", year: 2010, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2010, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2010, make: "MAYBACH", model: "57" },
  { type: "car", year: 2010, make: "MAYBACH", model: "62" },
  { type: "car", year: 2010, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2010, make: "MAZDA", model: "CX-7" },
  { type: "car", year: 2010, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2010, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2010, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2010, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2010, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2010, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2010, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2010, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2010, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2010, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2010, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2010, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2010, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2010, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2010, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "GLK-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2010, make: "MERCEDES-BENZ", model: "Sprinter" },
  { type: "car", year: 2010, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2010, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2010, make: "MERCURY", model: "Milan" },
  { type: "car", year: 2010, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2010, make: "MINI", model: "Clubman" },
  { type: "car", year: 2010, make: "MINI", model: "Cooper" },
  { type: "car", year: 2010, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2010, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2010, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2010, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2010, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2010, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2010, make: "NISSAN", model: "Cube" },
  { type: "car", year: 2010, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2010, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2010, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2010, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2010, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2010, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2010, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2010, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2010, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2010, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2010, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2010, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2010, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2010, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2010, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2010, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2010, make: "PONTIAC", model: "G3" },
  { type: "car", year: 2010, make: "PONTIAC", model: "G5" },
  { type: "car", year: 2010, make: "PONTIAC", model: "G6" },
  { type: "car", year: 2010, make: "PONTIAC", model: "G8" },
  { type: "car", year: 2010, make: "PONTIAC", model: "Matiz" },
  { type: "car", year: 2010, make: "PONTIAC", model: "Solstice" },
  { type: "car", year: 2010, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2010, make: "PORSCHE", model: "911" },
  { type: "car", year: 2010, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2010, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2010, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2010, make: "PORSCHE", model: "Panamera" },
  { type: "car", year: 2010, make: "ROLLS-ROYCE", model: "Ghost" },
  { type: "car", year: 2010, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2010, make: "SAAB", model: "9-3" },
  { type: "car", year: 2010, make: "SAAB", model: "9-5" },
  { type: "car", year: 2010, make: "SATURN", model: "Aura" },
  { type: "car", year: 2010, make: "SATURN", model: "Outlook" },
  { type: "car", year: 2010, make: "SATURN", model: "Sky" },
  { type: "car", year: 2010, make: "SATURN", model: "Vue" },
  { type: "car", year: 2010, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2010, make: "SPYKER", model: "C12" },
  { type: "car", year: 2010, make: "SPYKER", model: "C8" },
  { type: "car", year: 2010, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2010, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2010, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2010, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2010, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2010, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2010, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2010, make: "SUZUKI", model: "Kizashi" },
  { type: "car", year: 2010, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2010, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2010, make: "TESLA", model: "Roadster" },
  { type: "car", year: 2010, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2010, make: "TOYOTA", model: "FCHV-adv" },
  { type: "car", year: 2010, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2010, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2010, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2010, make: "VOLVO", model: "C30" },
  { type: "car", year: 2010, make: "VOLVO", model: "C70" },
  { type: "car", year: 2010, make: "VOLVO", model: "S40" },
  { type: "car", year: 2010, make: "VOLVO", model: "S80" },
  { type: "car", year: 2010, make: "VOLVO", model: "V50" },
  { type: "car", year: 2010, make: "VOLVO", model: "V70" },
  { type: "car", year: 2010, make: "VOLVO", model: "XC60" },
  { type: "car", year: 2010, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2010, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2010, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2009, make: "ACURA", model: "MDX" },
  { type: "car", year: 2009, make: "ACURA", model: "RDX" },
  { type: "car", year: 2009, make: "ACURA", model: "RL" },
  { type: "car", year: 2009, make: "ACURA", model: "TL" },
  { type: "car", year: 2009, make: "ACURA", model: "TSX" },
  { type: "car", year: 2009, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2009, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2009, make: "ASTON MARTIN", model: "DBS" },
  { type: "car", year: 2009, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 2009, make: "AUDI", model: "A3" },
  { type: "car", year: 2009, make: "AUDI", model: "A4" },
  { type: "car", year: 2009, make: "AUDI", model: "A5" },
  { type: "car", year: 2009, make: "AUDI", model: "A6" },
  { type: "car", year: 2009, make: "AUDI", model: "A8" },
  { type: "car", year: 2009, make: "AUDI", model: "Q5" },
  { type: "car", year: 2009, make: "AUDI", model: "Q7" },
  { type: "car", year: 2009, make: "AUDI", model: "R8" },
  { type: "car", year: 2009, make: "AUDI", model: "S4" },
  { type: "car", year: 2009, make: "AUDI", model: "S5" },
  { type: "car", year: 2009, make: "AUDI", model: "S6" },
  { type: "car", year: 2009, make: "AUDI", model: "S8" },
  { type: "car", year: 2009, make: "AUDI", model: "TT" },
  { type: "car", year: 2009, make: "AUDI", model: "TTS" },
  { type: "car", year: 2009, make: "BENTLEY", model: "ARMOURED ARNAGE" },
  { type: "car", year: 2009, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2009, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2009, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 2009, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2009, make: "BENTLEY", model: "Roll Royce Silver Seraph" },
  { type: "car", year: 2009, make: "BENTLEY", model: "Rolls-Royce Park Ward" },
  { type: "car", year: 2009, make: "BMW", model: "128i" },
  { type: "car", year: 2009, make: "BMW", model: "135i" },
  { type: "car", year: 2009, make: "BMW", model: "328i" },
  { type: "car", year: 2009, make: "BMW", model: "335d" },
  { type: "car", year: 2009, make: "BMW", model: "335i" },
  { type: "car", year: 2009, make: "BMW", model: "528i" },
  { type: "car", year: 2009, make: "BMW", model: "535i" },
  { type: "car", year: 2009, make: "BMW", model: "550i" },
  { type: "car", year: 2009, make: "BMW", model: "650i" },
  { type: "car", year: 2009, make: "BMW", model: "750i" },
  { type: "car", year: 2009, make: "BMW", model: "750Li" },
  { type: "car", year: 2009, make: "BMW", model: "M3" },
  { type: "car", year: 2009, make: "BMW", model: "M5" },
  { type: "car", year: 2009, make: "BMW", model: "M6" },
  { type: "car", year: 2009, make: "BMW", model: "X3" },
  { type: "car", year: 2009, make: "BMW", model: "X5" },
  { type: "car", year: 2009, make: "BMW", model: "X6" },
  { type: "car", year: 2009, make: "BMW", model: "Z4" },
  { type: "car", year: 2009, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2009, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2009, make: "BUICK", model: "Allure" },
  { type: "car", year: 2009, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2009, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2009, make: "BUICK", model: "Lucerne" },
  { type: "car", year: 2009, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2009, make: "CADILLAC", model: "DTS" },
  { type: "car", year: 2009, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2009, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2009, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2009, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2009, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2009, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Cobalt" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "HHR" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Optra" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Orlando" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Traverse" },
  { type: "car", year: 2009, make: "CHEVROLET", model: "Uplander" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "Aspen" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2009, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2009, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2009, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2009, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2009, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2009, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2009, make: "DODGE", model: "Charger" },
  { type: "car", year: 2009, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2009, make: "DODGE", model: "Durango" },
  { type: "car", year: 2009, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2009, make: "DODGE", model: "Journey" },
  { type: "car", year: 2009, make: "DODGE", model: "Nitro" },
  { type: "car", year: 2009, make: "DODGE", model: "Ram" },
  { type: "car", year: 2009, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2009, make: "DODGE", model: "Sprinter" },
  { type: "car", year: 2009, make: "DODGE", model: "Viper" },
  { type: "car", year: 2009, make: "FERRARI", model: "430" },
  { type: "car", year: 2009, make: "FERRARI", model: "599 GTB Fiorano" },
  { type: "car", year: 2009, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2009, make: "FERRARI", model: "F430" },
  { type: "car", year: 2009, make: "FORD", model: "'34" },
  { type: "car", year: 2009, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2009, make: "FORD", model: "E-150" },
  { type: "car", year: 2009, make: "FORD", model: "E-250" },
  { type: "car", year: 2009, make: "FORD", model: "E-350" },
  { type: "car", year: 2009, make: "FORD", model: "E-450" },
  { type: "car", year: 2009, make: "FORD", model: "Edge" },
  { type: "car", year: 2009, make: "FORD", model: "Escape" },
  { type: "car", year: 2009, make: "FORD", model: "Expedition" },
  { type: "car", year: 2009, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2009, make: "FORD", model: "Explorer" },
  { type: "car", year: 2009, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2009, make: "FORD", model: "F-150" },
  { type: "car", year: 2009, make: "FORD", model: "F-250" },
  { type: "car", year: 2009, make: "FORD", model: "F-350" },
  { type: "car", year: 2009, make: "FORD", model: "F-450" },
  { type: "car", year: 2009, make: "FORD", model: "F-550" },
  { type: "car", year: 2009, make: "FORD", model: "Flex" },
  { type: "car", year: 2009, make: "FORD", model: "Focus" },
  { type: "car", year: 2009, make: "FORD", model: "Fusion" },
  { type: "car", year: 2009, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2009, make: "FORD", model: "Mustang" },
  { type: "car", year: 2009, make: "FORD", model: "Ranger" },
  { type: "car", year: 2009, make: "FORD", model: "Taurus" },
  { type: "car", year: 2009, make: "FORD", model: "Taurus X" },
  { type: "car", year: 2009, make: "GMC", model: "Acadia" },
  { type: "car", year: 2009, make: "GMC", model: "Canyon" },
  { type: "car", year: 2009, make: "GMC", model: "Envoy" },
  { type: "car", year: 2009, make: "GMC", model: "Savana" },
  { type: "car", year: 2009, make: "GMC", model: "Sierra" },
  { type: "car", year: 2009, make: "GMC", model: "Terrain" },
  { type: "car", year: 2009, make: "GMC", model: "Yukon" },
  { type: "car", year: 2009, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2009, make: "HONDA", model: "Accord" },
  { type: "car", year: 2009, make: "HONDA", model: "Civic" },
  { type: "car", year: 2009, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2009, make: "HONDA", model: "Element" },
  { type: "car", year: 2009, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2009, make: "HONDA", model: "Fit" },
  { type: "car", year: 2009, make: "HONDA", model: "Insight" },
  { type: "car", year: 2009, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2009, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2009, make: "HONDA", model: "S2000" },
  { type: "car", year: 2009, make: "HUMMER", model: "H2" },
  { type: "car", year: 2009, make: "HUMMER", model: "H3" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Genesis" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2009, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2009, make: "INFINITI", model: "EX35" },
  { type: "car", year: 2009, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2009, make: "INFINITI", model: "FX50" },
  { type: "car", year: 2009, make: "INFINITI", model: "G35" },
  { type: "car", year: 2009, make: "INFINITI", model: "G37" },
  { type: "car", year: 2009, make: "INFINITI", model: "M35" },
  { type: "car", year: 2009, make: "INFINITI", model: "M45" },
  { type: "car", year: 2009, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2009, make: "JAGUAR", model: "XF" },
  { type: "car", year: 2009, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2009, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2009, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2009, make: "JEEP", model: "Commander" },
  { type: "car", year: 2009, make: "JEEP", model: "Compass" },
  { type: "car", year: 2009, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2009, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2009, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2009, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2009, make: "KIA", model: "Amanti" },
  { type: "car", year: 2009, make: "KIA", model: "Borrego" },
  { type: "car", year: 2009, make: "KIA", model: "Optima" },
  { type: "car", year: 2009, make: "KIA", model: "Rio" },
  { type: "car", year: 2009, make: "KIA", model: "Rondo" },
  { type: "car", year: 2009, make: "KIA", model: "Sedona" },
  { type: "car", year: 2009, make: "KIA", model: "Sorento" },
  { type: "car", year: 2009, make: "KIA", model: "Spectra" },
  { type: "car", year: 2009, make: "KIA", model: "Sportage" },
  { type: "car", year: 2009, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2009, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2009, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2009, make: "LAND ROVER", model: "LR3" },
  { type: "car", year: 2009, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2009, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2009, make: "LEXUS", model: "ES" },
  { type: "car", year: 2009, make: "LEXUS", model: "GS" },
  { type: "car", year: 2009, make: "LEXUS", model: "GX" },
  { type: "car", year: 2009, make: "LEXUS", model: "IS" },
  { type: "car", year: 2009, make: "LEXUS", model: "LS" },
  { type: "car", year: 2009, make: "LEXUS", model: "LX" },
  { type: "car", year: 2009, make: "LEXUS", model: "RX" },
  { type: "car", year: 2009, make: "LEXUS", model: "SC" },
  { type: "car", year: 2009, make: "LINCOLN", model: "MKS" },
  { type: "car", year: 2009, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2009, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2009, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2009, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2009, make: "LOTUS", model: "2-Eleven" },
  { type: "car", year: 2009, make: "LOTUS", model: "Eagle" },
  { type: "car", year: 2009, make: "LOTUS", model: "Elan" },
  { type: "car", year: 2009, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2009, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2009, make: "LOTUS", model: "Europa" },
  { type: "car", year: 2009, make: "LOTUS", model: "MEL" },
  { type: "car", year: 2009, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2009, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2009, make: "MAYBACH", model: "57" },
  { type: "car", year: 2009, make: "MAYBACH", model: "62" },
  { type: "car", year: 2009, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2009, make: "MAZDA", model: "CX-7" },
  { type: "car", year: 2009, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2009, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2009, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2009, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2009, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2009, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2009, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2009, make: "MCLAREN", model: "540C" },
  { type: "car", year: 2009, make: "MCLAREN", model: "570GT" },
  { type: "car", year: 2009, make: "MCLAREN", model: "570S" },
  { type: "car", year: 2009, make: "MCLAREN", model: "625C" },
  { type: "car", year: 2009, make: "MCLAREN", model: "650S" },
  { type: "car", year: 2009, make: "MCLAREN", model: "675LT" },
  { type: "car", year: 2009, make: "MCLAREN", model: "MP4-12C" },
  { type: "car", year: 2009, make: "MCLAREN", model: "P1" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2009, make: "MERCEDES-BENZ", model: "SLR McLaren" },
  { type: "car", year: 2009, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2009, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2009, make: "MERCURY", model: "Milan" },
  { type: "car", year: 2009, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2009, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2009, make: "MINI", model: "Clubman" },
  { type: "car", year: 2009, make: "MINI", model: "Cooper" },
  { type: "car", year: 2009, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2009, make: "MINI", model: "Hardtop" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2009, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2009, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2009, make: "NISSAN", model: "370Z" },
  { type: "car", year: 2009, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2009, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2009, make: "NISSAN", model: "Cube" },
  { type: "car", year: 2009, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2009, make: "NISSAN", model: "GT-R" },
  { type: "car", year: 2009, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2009, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2009, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2009, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2009, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2009, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2009, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2009, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2009, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2009, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2009, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2009, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2009, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2009, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2009, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2009, make: "PONTIAC", model: "G3" },
  { type: "car", year: 2009, make: "PONTIAC", model: "G5" },
  { type: "car", year: 2009, make: "PONTIAC", model: "G6" },
  { type: "car", year: 2009, make: "PONTIAC", model: "G8" },
  { type: "car", year: 2009, make: "PONTIAC", model: "Montana SV6" },
  { type: "car", year: 2009, make: "PONTIAC", model: "Solstice" },
  { type: "car", year: 2009, make: "PONTIAC", model: "Torrent" },
  { type: "car", year: 2009, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2009, make: "PORSCHE", model: "911" },
  { type: "car", year: 2009, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2009, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2009, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2009, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2009, make: "SAAB", model: "9-2X" },
  { type: "car", year: 2009, make: "SAAB", model: "9-3" },
  { type: "car", year: 2009, make: "SAAB", model: "9-5" },
  { type: "car", year: 2009, make: "SAAB", model: "9-7X" },
  { type: "car", year: 2009, make: "SATURN", model: "Astra" },
  { type: "car", year: 2009, make: "SATURN", model: "Aura" },
  { type: "car", year: 2009, make: "SATURN", model: "Outlook" },
  { type: "car", year: 2009, make: "SATURN", model: "Sky" },
  { type: "car", year: 2009, make: "SATURN", model: "Vue" },
  { type: "car", year: 2009, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2009, make: "SPYKER", model: "C12" },
  { type: "car", year: 2009, make: "SPYKER", model: "C8" },
  { type: "car", year: 2009, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2009, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2009, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2009, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2009, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2009, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2009, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2009, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2009, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2009, make: "TESLA", model: "Roadster" },
  { type: "car", year: 2009, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2009, make: "TOYOTA", model: "FCHV-adv" },
  { type: "car", year: 2009, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2009, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Venza" },
  { type: "car", year: 2009, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2009, make: "VOLVO", model: "C30" },
  { type: "car", year: 2009, make: "VOLVO", model: "C70" },
  { type: "car", year: 2009, make: "VOLVO", model: "S40" },
  { type: "car", year: 2009, make: "VOLVO", model: "S60" },
  { type: "car", year: 2009, make: "VOLVO", model: "S80" },
  { type: "car", year: 2009, make: "VOLVO", model: "V50" },
  { type: "car", year: 2009, make: "VOLVO", model: "V70" },
  { type: "car", year: 2009, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2009, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2009, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2008, make: "ACURA", model: "MDX" },
  { type: "car", year: 2008, make: "ACURA", model: "RDX" },
  { type: "car", year: 2008, make: "ACURA", model: "RL" },
  { type: "car", year: 2008, make: "ACURA", model: "TL" },
  { type: "car", year: 2008, make: "ACURA", model: "TSX" },
  { type: "car", year: 2008, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2008, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2008, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2008, make: "AUDI", model: "A3" },
  { type: "car", year: 2008, make: "AUDI", model: "A4" },
  { type: "car", year: 2008, make: "AUDI", model: "A5" },
  { type: "car", year: 2008, make: "AUDI", model: "A6" },
  { type: "car", year: 2008, make: "AUDI", model: "A8" },
  { type: "car", year: 2008, make: "AUDI", model: "Q7" },
  { type: "car", year: 2008, make: "AUDI", model: "R8" },
  { type: "car", year: 2008, make: "AUDI", model: "RS 4" },
  { type: "car", year: 2008, make: "AUDI", model: "S4" },
  { type: "car", year: 2008, make: "AUDI", model: "S5" },
  { type: "car", year: 2008, make: "AUDI", model: "S6" },
  { type: "car", year: 2008, make: "AUDI", model: "S8" },
  { type: "car", year: 2008, make: "AUDI", model: "TT" },
  { type: "car", year: 2008, make: "BENTLEY", model: "ARMOURED ARNAGE" },
  { type: "car", year: 2008, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2008, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2008, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2008, make: "BMW", model: "128i" },
  { type: "car", year: 2008, make: "BMW", model: "135i" },
  { type: "car", year: 2008, make: "BMW", model: "328i" },
  { type: "car", year: 2008, make: "BMW", model: "328xi" },
  { type: "car", year: 2008, make: "BMW", model: "335i" },
  { type: "car", year: 2008, make: "BMW", model: "335xi" },
  { type: "car", year: 2008, make: "BMW", model: "528i" },
  { type: "car", year: 2008, make: "BMW", model: "528xi" },
  { type: "car", year: 2008, make: "BMW", model: "535i" },
  { type: "car", year: 2008, make: "BMW", model: "535xi" },
  { type: "car", year: 2008, make: "BMW", model: "550i" },
  { type: "car", year: 2008, make: "BMW", model: "650i" },
  { type: "car", year: 2008, make: "BMW", model: "750i" },
  { type: "car", year: 2008, make: "BMW", model: "750Li" },
  { type: "car", year: 2008, make: "BMW", model: "760Li" },
  { type: "car", year: 2008, make: "BMW", model: "M3" },
  { type: "car", year: 2008, make: "BMW", model: "M5" },
  { type: "car", year: 2008, make: "BMW", model: "M6" },
  { type: "car", year: 2008, make: "BMW", model: "X3" },
  { type: "car", year: 2008, make: "BMW", model: "X5" },
  { type: "car", year: 2008, make: "BMW", model: "X6" },
  { type: "car", year: 2008, make: "BMW", model: "Z4" },
  { type: "car", year: 2008, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2008, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2008, make: "BUICK", model: "Allure" },
  { type: "car", year: 2008, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2008, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2008, make: "BUICK", model: "Lucerne" },
  { type: "car", year: 2008, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2008, make: "CADILLAC", model: "DTS" },
  { type: "car", year: 2008, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2008, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2008, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2008, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2008, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2008, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Cobalt" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "HHR" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Kalos" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Matiz" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Optra" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Spark" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2008, make: "CHEVROLET", model: "Uplander" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "Aspen" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "Crossfire" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2008, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2008, make: "DAEWOO", model: "G2X" },
  { type: "car", year: 2008, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2008, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2008, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2008, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2008, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2008, make: "DODGE", model: "Challenger" },
  { type: "car", year: 2008, make: "DODGE", model: "Charger" },
  { type: "car", year: 2008, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2008, make: "DODGE", model: "Durango" },
  { type: "car", year: 2008, make: "DODGE", model: "Magnum" },
  { type: "car", year: 2008, make: "DODGE", model: "Nitro" },
  { type: "car", year: 2008, make: "DODGE", model: "Ram" },
  { type: "car", year: 2008, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2008, make: "DODGE", model: "Sprinter" },
  { type: "car", year: 2008, make: "DODGE", model: "Viper" },
  { type: "car", year: 2008, make: "FERRARI", model: "430" },
  { type: "car", year: 2008, make: "FERRARI", model: "599 GTB Fiorano" },
  { type: "car", year: 2008, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2008, make: "FERRARI", model: "F430" },
  { type: "car", year: 2008, make: "FORD", model: "'34" },
  { type: "car", year: 2008, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2008, make: "FORD", model: "E-150" },
  { type: "car", year: 2008, make: "FORD", model: "E-250" },
  { type: "car", year: 2008, make: "FORD", model: "E-350" },
  { type: "car", year: 2008, make: "FORD", model: "E-450" },
  { type: "car", year: 2008, make: "FORD", model: "Edge" },
  { type: "car", year: 2008, make: "FORD", model: "Escape" },
  { type: "car", year: 2008, make: "FORD", model: "Expedition" },
  { type: "car", year: 2008, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2008, make: "FORD", model: "Explorer" },
  { type: "car", year: 2008, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2008, make: "FORD", model: "F-150" },
  { type: "car", year: 2008, make: "FORD", model: "F-250" },
  { type: "car", year: 2008, make: "FORD", model: "F-350" },
  { type: "car", year: 2008, make: "FORD", model: "F-450" },
  { type: "car", year: 2008, make: "FORD", model: "F-550" },
  { type: "car", year: 2008, make: "FORD", model: "Focus" },
  { type: "car", year: 2008, make: "FORD", model: "Fusion" },
  { type: "car", year: 2008, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2008, make: "FORD", model: "Mustang" },
  { type: "car", year: 2008, make: "FORD", model: "Ranger" },
  { type: "car", year: 2008, make: "FORD", model: "Taurus" },
  { type: "car", year: 2008, make: "FORD", model: "Taurus X" },
  { type: "car", year: 2008, make: "GMC", model: "Acadia" },
  { type: "car", year: 2008, make: "GMC", model: "Canyon" },
  { type: "car", year: 2008, make: "GMC", model: "Envoy" },
  { type: "car", year: 2008, make: "GMC", model: "Savana" },
  { type: "car", year: 2008, make: "GMC", model: "Sierra" },
  { type: "car", year: 2008, make: "GMC", model: "Yukon" },
  { type: "car", year: 2008, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2008, make: "HONDA", model: "Accord" },
  { type: "car", year: 2008, make: "HONDA", model: "Civic" },
  { type: "car", year: 2008, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2008, make: "HONDA", model: "Element" },
  { type: "car", year: 2008, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2008, make: "HONDA", model: "Fit" },
  { type: "car", year: 2008, make: "HONDA", model: "Insight" },
  { type: "car", year: 2008, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2008, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2008, make: "HONDA", model: "S2000" },
  { type: "car", year: 2008, make: "HUMMER", model: "H2" },
  { type: "car", year: 2008, make: "HUMMER", model: "H3" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2008, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2008, make: "INFINITI", model: "EX35" },
  { type: "car", year: 2008, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2008, make: "INFINITI", model: "FX45" },
  { type: "car", year: 2008, make: "INFINITI", model: "G35" },
  { type: "car", year: 2008, make: "INFINITI", model: "G37" },
  { type: "car", year: 2008, make: "INFINITI", model: "M35" },
  { type: "car", year: 2008, make: "INFINITI", model: "M45" },
  { type: "car", year: 2008, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2008, make: "ISUZU", model: "Ascender" },
  { type: "car", year: 2008, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2008, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2008, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2008, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2008, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2008, make: "JEEP", model: "Commander" },
  { type: "car", year: 2008, make: "JEEP", model: "Compass" },
  { type: "car", year: 2008, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2008, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2008, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2008, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2008, make: "KIA", model: "Amanti" },
  { type: "car", year: 2008, make: "KIA", model: "Optima" },
  { type: "car", year: 2008, make: "KIA", model: "Rio" },
  { type: "car", year: 2008, make: "KIA", model: "Rondo" },
  { type: "car", year: 2008, make: "KIA", model: "Sedona" },
  { type: "car", year: 2008, make: "KIA", model: "Sorento" },
  { type: "car", year: 2008, make: "KIA", model: "Spectra" },
  { type: "car", year: 2008, make: "KIA", model: "Sportage" },
  { type: "car", year: 2008, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2008, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2008, make: "LAND ROVER", model: "LR2" },
  { type: "car", year: 2008, make: "LAND ROVER", model: "LR3" },
  { type: "car", year: 2008, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2008, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2008, make: "LEXUS", model: "ES" },
  { type: "car", year: 2008, make: "LEXUS", model: "GS" },
  { type: "car", year: 2008, make: "LEXUS", model: "GX" },
  { type: "car", year: 2008, make: "LEXUS", model: "IS" },
  { type: "car", year: 2008, make: "LEXUS", model: "LS" },
  { type: "car", year: 2008, make: "LEXUS", model: "LX" },
  { type: "car", year: 2008, make: "LEXUS", model: "RX" },
  { type: "car", year: 2008, make: "LEXUS", model: "SC" },
  { type: "car", year: 2008, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2008, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2008, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2008, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2008, make: "LOTUS", model: "2-Eleven" },
  { type: "car", year: 2008, make: "LOTUS", model: "340R" },
  { type: "car", year: 2008, make: "LOTUS", model: "Eagle" },
  { type: "car", year: 2008, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 2008, make: "LOTUS", model: "Elan" },
  { type: "car", year: 2008, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2008, make: "LOTUS", model: "Elite" },
  { type: "car", year: 2008, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2008, make: "LOTUS", model: "Europa" },
  { type: "car", year: 2008, make: "LOTUS", model: "Exige" },
  { type: "car", year: 2008, make: "LOTUS", model: "MEL" },
  { type: "car", year: 2008, make: "LOTUS", model: "Monaco" },
  { type: "car", year: 2008, make: "LOTUS", model: "Monza" },
  { type: "car", year: 2008, make: "LOTUS", model: "Spa" },
  { type: "car", year: 2008, make: "MASERATI", model: "Granturismo" },
  { type: "car", year: 2008, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2008, make: "MAYBACH", model: "57" },
  { type: "car", year: 2008, make: "MAYBACH", model: "62" },
  { type: "car", year: 2008, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2008, make: "MAZDA", model: "CX-7" },
  { type: "car", year: 2008, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2008, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2008, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2008, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2008, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2008, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2008, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2008, make: "MERCEDES-BENZ", model: "SLR McLaren" },
  { type: "car", year: 2008, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2008, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2008, make: "MERCURY", model: "Milan" },
  { type: "car", year: 2008, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2008, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2008, make: "MINI", model: "Clubman" },
  { type: "car", year: 2008, make: "MINI", model: "Cooper" },
  { type: "car", year: 2008, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2008, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2008, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2008, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2008, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2008, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2008, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2008, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2008, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2008, make: "NISSAN", model: "Rogue" },
  { type: "car", year: 2008, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2008, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2008, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2008, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2008, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2008, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2008, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2008, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2008, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2008, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2008, make: "PONTIAC", model: "G3" },
  { type: "car", year: 2008, make: "PONTIAC", model: "G5" },
  { type: "car", year: 2008, make: "PONTIAC", model: "G6" },
  { type: "car", year: 2008, make: "PONTIAC", model: "G8" },
  { type: "car", year: 2008, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2008, make: "PONTIAC", model: "Montana SV6" },
  { type: "car", year: 2008, make: "PONTIAC", model: "Solstice" },
  { type: "car", year: 2008, make: "PONTIAC", model: "Torrent" },
  { type: "car", year: 2008, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2008, make: "PONTIAC", model: "Wave" },
  { type: "car", year: 2008, make: "PORSCHE", model: "911" },
  { type: "car", year: 2008, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2008, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2008, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2008, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2008, make: "SAAB", model: "9-2X" },
  { type: "car", year: 2008, make: "SAAB", model: "9-3" },
  { type: "car", year: 2008, make: "SAAB", model: "9-5" },
  { type: "car", year: 2008, make: "SAAB", model: "9-7X" },
  { type: "car", year: 2008, make: "SATURN", model: "Astra" },
  { type: "car", year: 2008, make: "SATURN", model: "Aura" },
  { type: "car", year: 2008, make: "SATURN", model: "Outlook" },
  { type: "car", year: 2008, make: "SATURN", model: "Sky" },
  { type: "car", year: 2008, make: "SATURN", model: "Vue" },
  { type: "car", year: 2008, make: "SMART", model: "Fortwo" },
  { type: "car", year: 2008, make: "SPYKER", model: "C12" },
  { type: "car", year: 2008, make: "SPYKER", model: "C8" },
  { type: "car", year: 2008, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2008, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2008, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2008, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2008, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2008, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2008, make: "SUZUKI", model: "Forenza" },
  { type: "car", year: 2008, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2008, make: "SUZUKI", model: "Grand Vitara XL-7" },
  { type: "car", year: 2008, make: "SUZUKI", model: "Reno" },
  { type: "car", year: 2008, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2008, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2008, make: "SUZUKI", model: "Verona" },
  { type: "car", year: 2008, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2008, make: "TESLA", model: "Roadster" },
  { type: "car", year: 2008, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2008, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2008, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Scion xD" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2008, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2008, make: "VOLVO", model: "C30" },
  { type: "car", year: 2008, make: "VOLVO", model: "C70" },
  { type: "car", year: 2008, make: "VOLVO", model: "S40" },
  { type: "car", year: 2008, make: "VOLVO", model: "S60" },
  { type: "car", year: 2008, make: "VOLVO", model: "S80" },
  { type: "car", year: 2008, make: "VOLVO", model: "V50" },
  { type: "car", year: 2008, make: "VOLVO", model: "V70" },
  { type: "car", year: 2008, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2008, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2008, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2007, make: "ACURA", model: "MDX" },
  { type: "car", year: 2007, make: "ACURA", model: "RDX" },
  { type: "car", year: 2007, make: "ACURA", model: "RL" },
  { type: "car", year: 2007, make: "ACURA", model: "TL" },
  { type: "car", year: 2007, make: "ACURA", model: "TSX" },
  { type: "car", year: 2007, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2007, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2007, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2007, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2007, make: "AUDI", model: "A3" },
  { type: "car", year: 2007, make: "AUDI", model: "A4" },
  { type: "car", year: 2007, make: "AUDI", model: "A6" },
  { type: "car", year: 2007, make: "AUDI", model: "A8" },
  { type: "car", year: 2007, make: "AUDI", model: "Q7" },
  { type: "car", year: 2007, make: "AUDI", model: "RS 4" },
  { type: "car", year: 2007, make: "AUDI", model: "S4" },
  { type: "car", year: 2007, make: "AUDI", model: "S6" },
  { type: "car", year: 2007, make: "AUDI", model: "S8" },
  { type: "car", year: 2007, make: "BENTLEY", model: "ARMOURED ARNAGE" },
  { type: "car", year: 2007, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2007, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2007, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2007, make: "BMW", model: "328i" },
  { type: "car", year: 2007, make: "BMW", model: "328xi" },
  { type: "car", year: 2007, make: "BMW", model: "335i" },
  { type: "car", year: 2007, make: "BMW", model: "335xi" },
  { type: "car", year: 2007, make: "BMW", model: "525i" },
  { type: "car", year: 2007, make: "BMW", model: "525xi" },
  { type: "car", year: 2007, make: "BMW", model: "530i" },
  { type: "car", year: 2007, make: "BMW", model: "530xi" },
  { type: "car", year: 2007, make: "BMW", model: "550i" },
  { type: "car", year: 2007, make: "BMW", model: "650i" },
  { type: "car", year: 2007, make: "BMW", model: "750i" },
  { type: "car", year: 2007, make: "BMW", model: "750Li" },
  { type: "car", year: 2007, make: "BMW", model: "760Li" },
  { type: "car", year: 2007, make: "BMW", model: "M5" },
  { type: "car", year: 2007, make: "BMW", model: "M6" },
  { type: "car", year: 2007, make: "BMW", model: "X3" },
  { type: "car", year: 2007, make: "BMW", model: "X5" },
  { type: "car", year: 2007, make: "BMW", model: "Z4" },
  { type: "car", year: 2007, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2007, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2007, make: "BUICK", model: "Allure" },
  { type: "car", year: 2007, make: "BUICK", model: "Enclave" },
  { type: "car", year: 2007, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2007, make: "BUICK", model: "Lucerne" },
  { type: "car", year: 2007, make: "BUICK", model: "Rainier" },
  { type: "car", year: 2007, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2007, make: "BUICK", model: "Terraza" },
  { type: "car", year: 2007, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2007, make: "CADILLAC", model: "DTS" },
  { type: "car", year: 2007, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2007, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2007, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2007, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2007, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2007, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Cobalt" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "HHR" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Optra" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2007, make: "CHEVROLET", model: "Uplander" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "Aspen" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "Crossfire" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2007, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2007, make: "DAEWOO", model: "Laganza V-car" },
  { type: "car", year: 2007, make: "DAEWOO", model: "Leganza V-200 & variants/derivatives" },
  { type: "car", year: 2007, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2007, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2007, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2007, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2007, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2007, make: "DODGE", model: "Charger" },
  { type: "car", year: 2007, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2007, make: "DODGE", model: "Durango" },
  { type: "car", year: 2007, make: "DODGE", model: "Magnum" },
  { type: "car", year: 2007, make: "DODGE", model: "Nitro" },
  { type: "car", year: 2007, make: "DODGE", model: "Ram" },
  { type: "car", year: 2007, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2007, make: "DODGE", model: "Sprinter" },
  { type: "car", year: 2007, make: "FERRARI", model: "430" },
  { type: "car", year: 2007, make: "FERRARI", model: "599 GTB Fiorano" },
  { type: "car", year: 2007, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2007, make: "FERRARI", model: "F430" },
  { type: "car", year: 2007, make: "FORD", model: "'34" },
  { type: "car", year: 2007, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2007, make: "FORD", model: "E-150" },
  { type: "car", year: 2007, make: "FORD", model: "E-250" },
  { type: "car", year: 2007, make: "FORD", model: "E-350" },
  { type: "car", year: 2007, make: "FORD", model: "E-450" },
  { type: "car", year: 2007, make: "FORD", model: "Edge" },
  { type: "car", year: 2007, make: "FORD", model: "Escape" },
  { type: "car", year: 2007, make: "FORD", model: "Expedition" },
  { type: "car", year: 2007, make: "FORD", model: "Expedition MAX" },
  { type: "car", year: 2007, make: "FORD", model: "Explorer" },
  { type: "car", year: 2007, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2007, make: "FORD", model: "F-150" },
  { type: "car", year: 2007, make: "FORD", model: "F-250" },
  { type: "car", year: 2007, make: "FORD", model: "F-350" },
  { type: "car", year: 2007, make: "FORD", model: "F-450" },
  { type: "car", year: 2007, make: "FORD", model: "F-550" },
  { type: "car", year: 2007, make: "FORD", model: "Five Hundred" },
  { type: "car", year: 2007, make: "FORD", model: "Focus" },
  { type: "car", year: 2007, make: "FORD", model: "Freestar" },
  { type: "car", year: 2007, make: "FORD", model: "Freestyle" },
  { type: "car", year: 2007, make: "FORD", model: "Fusion" },
  { type: "car", year: 2007, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2007, make: "FORD", model: "Mustang" },
  { type: "car", year: 2007, make: "FORD", model: "Ranger" },
  { type: "car", year: 2007, make: "FORD", model: "Taurus" },
  { type: "car", year: 2007, make: "GMC", model: "Acadia" },
  { type: "car", year: 2007, make: "GMC", model: "Canyon" },
  { type: "car", year: 2007, make: "GMC", model: "Envoy" },
  { type: "car", year: 2007, make: "GMC", model: "Savana" },
  { type: "car", year: 2007, make: "GMC", model: "Sierra" },
  { type: "car", year: 2007, make: "GMC", model: "Yukon" },
  { type: "car", year: 2007, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2007, make: "HONDA", model: "Accord" },
  { type: "car", year: 2007, make: "HONDA", model: "Civic" },
  { type: "car", year: 2007, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2007, make: "HONDA", model: "Element" },
  { type: "car", year: 2007, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2007, make: "HONDA", model: "Fit" },
  { type: "car", year: 2007, make: "HONDA", model: "Insight" },
  { type: "car", year: 2007, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2007, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2007, make: "HONDA", model: "S2000" },
  { type: "car", year: 2007, make: "HUMMER", model: "H2" },
  { type: "car", year: 2007, make: "HUMMER", model: "H3" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2007, make: "HYUNDAI", model: "Veracruz" },
  { type: "car", year: 2007, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2007, make: "INFINITI", model: "FX45" },
  { type: "car", year: 2007, make: "INFINITI", model: "G35" },
  { type: "car", year: 2007, make: "INFINITI", model: "M35" },
  { type: "car", year: 2007, make: "INFINITI", model: "M45" },
  { type: "car", year: 2007, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2007, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2007, make: "ISUZU", model: "Ascender" },
  { type: "car", year: 2007, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2007, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2007, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2007, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2007, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2007, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2007, make: "JEEP", model: "Commander" },
  { type: "car", year: 2007, make: "JEEP", model: "Compass" },
  { type: "car", year: 2007, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2007, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2007, make: "JEEP", model: "Patriot" },
  { type: "car", year: 2007, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2007, make: "KIA", model: "Amanti" },
  { type: "car", year: 2007, make: "KIA", model: "Optima" },
  { type: "car", year: 2007, make: "KIA", model: "Rio" },
  { type: "car", year: 2007, make: "KIA", model: "Rondo" },
  { type: "car", year: 2007, make: "KIA", model: "Sedona" },
  { type: "car", year: 2007, make: "KIA", model: "Sorento" },
  { type: "car", year: 2007, make: "KIA", model: "Spectra" },
  { type: "car", year: 2007, make: "KIA", model: "Sportage" },
  { type: "car", year: 2007, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2007, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2007, make: "LAND ROVER", model: "LR3" },
  { type: "car", year: 2007, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2007, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2007, make: "LEXUS", model: "ES" },
  { type: "car", year: 2007, make: "LEXUS", model: "GS" },
  { type: "car", year: 2007, make: "LEXUS", model: "GX" },
  { type: "car", year: 2007, make: "LEXUS", model: "IS" },
  { type: "car", year: 2007, make: "LEXUS", model: "LS" },
  { type: "car", year: 2007, make: "LEXUS", model: "LX" },
  { type: "car", year: 2007, make: "LEXUS", model: "RX" },
  { type: "car", year: 2007, make: "LEXUS", model: "SC" },
  { type: "car", year: 2007, make: "LINCOLN", model: "MKX" },
  { type: "car", year: 2007, make: "LINCOLN", model: "MKZ" },
  { type: "car", year: 2007, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2007, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2007, make: "LOTUS", model: "340R" },
  { type: "car", year: 2007, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 2007, make: "LOTUS", model: "Elan" },
  { type: "car", year: 2007, make: "LOTUS", model: "Eleven" },
  { type: "car", year: 2007, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2007, make: "LOTUS", model: "Elite" },
  { type: "car", year: 2007, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2007, make: "LOTUS", model: "Europa" },
  { type: "car", year: 2007, make: "LOTUS", model: "MEL" },
  { type: "car", year: 2007, make: "LOTUS", model: "Monaco" },
  { type: "car", year: 2007, make: "LOTUS", model: "Monza" },
  { type: "car", year: 2007, make: "LOTUS", model: "Spa" },
  { type: "car", year: 2007, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2007, make: "MAYBACH", model: "57" },
  { type: "car", year: 2007, make: "MAYBACH", model: "62" },
  { type: "car", year: 2007, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2007, make: "MAZDA", model: "CX-7" },
  { type: "car", year: 2007, make: "MAZDA", model: "CX-9" },
  { type: "car", year: 2007, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2007, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2007, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2007, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2007, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2007, make: "MERCEDES-BENZ", model: "SLR McLaren" },
  { type: "car", year: 2007, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2007, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2007, make: "MERCURY", model: "Milan" },
  { type: "car", year: 2007, make: "MERCURY", model: "Montego" },
  { type: "car", year: 2007, make: "MERCURY", model: "Monterey" },
  { type: "car", year: 2007, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2007, make: "MINI", model: "Cooper" },
  { type: "car", year: 2007, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2007, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2007, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2007, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2007, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2007, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2007, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2007, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2007, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2007, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2007, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2007, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2007, make: "NISSAN", model: "Versa" },
  { type: "car", year: 2007, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2007, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2007, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2007, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2007, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2007, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2007, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2007, make: "PONTIAC", model: "G5" },
  { type: "car", year: 2007, make: "PONTIAC", model: "G6" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Matiz" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Montana SV6" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Solstice" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Torrent" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2007, make: "PONTIAC", model: "Wave" },
  { type: "car", year: 2007, make: "PORSCHE", model: "911" },
  { type: "car", year: 2007, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2007, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2007, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2007, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2007, make: "SAAB", model: "9-2X" },
  { type: "car", year: 2007, make: "SAAB", model: "9-3" },
  { type: "car", year: 2007, make: "SAAB", model: "9-5" },
  { type: "car", year: 2007, make: "SAAB", model: "9-7X" },
  { type: "car", year: 2007, make: "SATURN", model: "Aura" },
  { type: "car", year: 2007, make: "SATURN", model: "Ion" },
  { type: "car", year: 2007, make: "SATURN", model: "Outlook" },
  { type: "car", year: 2007, make: "SATURN", model: "Relay" },
  { type: "car", year: 2007, make: "SATURN", model: "Sky" },
  { type: "car", year: 2007, make: "SATURN", model: "Vue" },
  { type: "car", year: 2007, make: "SPYKER", model: "C12" },
  { type: "car", year: 2007, make: "SPYKER", model: "C8" },
  { type: "car", year: 2007, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2007, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2007, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2007, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2007, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2007, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Aerio" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Forenza" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Grand Vitara XL-7" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Reno" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2007, make: "SUZUKI", model: "SX4" },
  { type: "car", year: 2007, make: "SUZUKI", model: "Verona" },
  { type: "car", year: 2007, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2007, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2007, make: "TOYOTA", model: "FJ Cruiser" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2007, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2007, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2007, make: "TOYOTA", model: "Yaris" },
  { type: "car", year: 2007, make: "VOLVO", model: "C30" },
  { type: "car", year: 2007, make: "VOLVO", model: "C70" },
  { type: "car", year: 2007, make: "VOLVO", model: "S40" },
  { type: "car", year: 2007, make: "VOLVO", model: "S60" },
  { type: "car", year: 2007, make: "VOLVO", model: "S80" },
  { type: "car", year: 2007, make: "VOLVO", model: "V50" },
  { type: "car", year: 2007, make: "VOLVO", model: "V70" },
  { type: "car", year: 2007, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2007, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2007, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2006, make: "ACURA", model: "MDX" },
  { type: "car", year: 2006, make: "ACURA", model: "RL" },
  { type: "car", year: 2006, make: "ACURA", model: "RSX" },
  { type: "car", year: 2006, make: "ACURA", model: "TL" },
  { type: "car", year: 2006, make: "ACURA", model: "TSX" },
  { type: "car", year: 2006, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2006, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2006, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2006, make: "ASTON MARTIN", model: "Vantage" },
  { type: "car", year: 2006, make: "AUDI", model: "A3" },
  { type: "car", year: 2006, make: "AUDI", model: "A4" },
  { type: "car", year: 2006, make: "AUDI", model: "A6" },
  { type: "car", year: 2006, make: "AUDI", model: "A8" },
  { type: "car", year: 2006, make: "AUDI", model: "S4" },
  { type: "car", year: 2006, make: "AUDI", model: "TT" },
  { type: "car", year: 2006, make: "BENTLEY", model: "ARMOURED ARNAGE" },
  { type: "car", year: 2006, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2006, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2006, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2006, make: "BMW", model: "325Ci" },
  { type: "car", year: 2006, make: "BMW", model: "325i" },
  { type: "car", year: 2006, make: "BMW", model: "325xi" },
  { type: "car", year: 2006, make: "BMW", model: "330Ci" },
  { type: "car", year: 2006, make: "BMW", model: "330i" },
  { type: "car", year: 2006, make: "BMW", model: "330xi" },
  { type: "car", year: 2006, make: "BMW", model: "525i" },
  { type: "car", year: 2006, make: "BMW", model: "525xi" },
  { type: "car", year: 2006, make: "BMW", model: "530i" },
  { type: "car", year: 2006, make: "BMW", model: "530xi" },
  { type: "car", year: 2006, make: "BMW", model: "550i" },
  { type: "car", year: 2006, make: "BMW", model: "650i" },
  { type: "car", year: 2006, make: "BMW", model: "750i" },
  { type: "car", year: 2006, make: "BMW", model: "750Li" },
  { type: "car", year: 2006, make: "BMW", model: "760i" },
  { type: "car", year: 2006, make: "BMW", model: "760Li" },
  { type: "car", year: 2006, make: "BMW", model: "M3" },
  { type: "car", year: 2006, make: "BMW", model: "M3Ci" },
  { type: "car", year: 2006, make: "BMW", model: "M5" },
  { type: "car", year: 2006, make: "BMW", model: "M6" },
  { type: "car", year: 2006, make: "BMW", model: "X3" },
  { type: "car", year: 2006, make: "BMW", model: "X5" },
  { type: "car", year: 2006, make: "BMW", model: "Z4" },
  { type: "car", year: 2006, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2006, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2006, make: "BUICK", model: "Allure" },
  { type: "car", year: 2006, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2006, make: "BUICK", model: "Lucerne" },
  { type: "car", year: 2006, make: "BUICK", model: "Rainier" },
  { type: "car", year: 2006, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2006, make: "BUICK", model: "Terraza" },
  { type: "car", year: 2006, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2006, make: "CADILLAC", model: "DTS" },
  { type: "car", year: 2006, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2006, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2006, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2006, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2006, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2006, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Cobalt" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Epica" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "HHR" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Matiz" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Optra" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2006, make: "CHEVROLET", model: "Uplander" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "Crossfire" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2006, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2006, make: "DAEWOO", model: "Laganza V-car" },
  { type: "car", year: 2006, make: "DAEWOO", model: "Leganza V-200 & variants/derivatives" },
  { type: "car", year: 2006, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2006, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2006, make: "DODGE", model: "Caliber" },
  { type: "car", year: 2006, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2006, make: "DODGE", model: "Charger" },
  { type: "car", year: 2006, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2006, make: "DODGE", model: "Durango" },
  { type: "car", year: 2006, make: "DODGE", model: "Magnum" },
  { type: "car", year: 2006, make: "DODGE", model: "Ram" },
  { type: "car", year: 2006, make: "DODGE", model: "Sprinter" },
  { type: "car", year: 2006, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2006, make: "DODGE", model: "Viper" },
  { type: "car", year: 2006, make: "FERRARI", model: "599" },
  { type: "car", year: 2006, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2006, make: "FERRARI", model: "F430" },
  { type: "car", year: 2006, make: "FORD", model: "'34" },
  { type: "car", year: 2006, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2006, make: "FORD", model: "E-150" },
  { type: "car", year: 2006, make: "FORD", model: "E-250" },
  { type: "car", year: 2006, make: "FORD", model: "E-350" },
  { type: "car", year: 2006, make: "FORD", model: "E-450" },
  { type: "car", year: 2006, make: "FORD", model: "Escape" },
  { type: "car", year: 2006, make: "FORD", model: "Expedition" },
  { type: "car", year: 2006, make: "FORD", model: "Explorer" },
  { type: "car", year: 2006, make: "FORD", model: "F-150" },
  { type: "car", year: 2006, make: "FORD", model: "F-250" },
  { type: "car", year: 2006, make: "FORD", model: "F-350" },
  { type: "car", year: 2006, make: "FORD", model: "F-450" },
  { type: "car", year: 2006, make: "FORD", model: "F-550" },
  { type: "car", year: 2006, make: "FORD", model: "Five Hundred" },
  { type: "car", year: 2006, make: "FORD", model: "Focus" },
  { type: "car", year: 2006, make: "FORD", model: "Freestar" },
  { type: "car", year: 2006, make: "FORD", model: "Freestyle" },
  { type: "car", year: 2006, make: "FORD", model: "Fusion" },
  { type: "car", year: 2006, make: "FORD", model: "GT" },
  { type: "car", year: 2006, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2006, make: "FORD", model: "Mustang" },
  { type: "car", year: 2006, make: "FORD", model: "Ranger" },
  { type: "car", year: 2006, make: "FORD", model: "Taurus" },
  { type: "car", year: 2006, make: "GMC", model: "Canyon" },
  { type: "car", year: 2006, make: "GMC", model: "Envoy" },
  { type: "car", year: 2006, make: "GMC", model: "Savana" },
  { type: "car", year: 2006, make: "GMC", model: "Sierra" },
  { type: "car", year: 2006, make: "GMC", model: "Yukon" },
  { type: "car", year: 2006, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2006, make: "HONDA", model: "Accord" },
  { type: "car", year: 2006, make: "HONDA", model: "Civic" },
  { type: "car", year: 2006, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2006, make: "HONDA", model: "Element" },
  { type: "car", year: 2006, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2006, make: "HONDA", model: "Insight" },
  { type: "car", year: 2006, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2006, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2006, make: "HONDA", model: "S2000" },
  { type: "car", year: 2006, make: "HUMMER", model: "H1" },
  { type: "car", year: 2006, make: "HUMMER", model: "H2" },
  { type: "car", year: 2006, make: "HUMMER", model: "H3" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Azera" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Entourage" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2006, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2006, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2006, make: "INFINITI", model: "FX45" },
  { type: "car", year: 2006, make: "INFINITI", model: "G35" },
  { type: "car", year: 2006, make: "INFINITI", model: "M35" },
  { type: "car", year: 2006, make: "INFINITI", model: "M45" },
  { type: "car", year: 2006, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2006, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2006, make: "ISUZU", model: "Ascender" },
  { type: "car", year: 2006, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2006, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2006, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2006, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2006, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2006, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2006, make: "JEEP", model: "Commander" },
  { type: "car", year: 2006, make: "JEEP", model: "Compass" },
  { type: "car", year: 2006, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2006, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2006, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2006, make: "KIA", model: "Amanti" },
  { type: "car", year: 2006, make: "KIA", model: "Optima" },
  { type: "car", year: 2006, make: "KIA", model: "Rio" },
  { type: "car", year: 2006, make: "KIA", model: "Sedona" },
  { type: "car", year: 2006, make: "KIA", model: "Sorento" },
  { type: "car", year: 2006, make: "KIA", model: "Spectra" },
  { type: "car", year: 2006, make: "KIA", model: "Sportage" },
  { type: "car", year: 2006, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2006, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2006, make: "LAND ROVER", model: "LR3" },
  { type: "car", year: 2006, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2006, make: "LAND ROVER", model: "Range Rover Sport" },
  { type: "car", year: 2006, make: "LEXUS", model: "ES" },
  { type: "car", year: 2006, make: "LEXUS", model: "GS" },
  { type: "car", year: 2006, make: "LEXUS", model: "GX" },
  { type: "car", year: 2006, make: "LEXUS", model: "IS" },
  { type: "car", year: 2006, make: "LEXUS", model: "LS" },
  { type: "car", year: 2006, make: "LEXUS", model: "LX" },
  { type: "car", year: 2006, make: "LEXUS", model: "RX" },
  { type: "car", year: 2006, make: "LEXUS", model: "SC" },
  { type: "car", year: 2006, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2006, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2006, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2006, make: "LINCOLN", model: "Zephyr" },
  { type: "car", year: 2006, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2006, make: "MASERATI", model: "Coupe" },
  { type: "car", year: 2006, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2006, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 2006, make: "MAYBACH", model: "57" },
  { type: "car", year: 2006, make: "MAYBACH", model: "62" },
  { type: "car", year: 2006, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2006, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2006, make: "MAZDA", model: "Mazda5" },
  { type: "car", year: 2006, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2006, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2006, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2006, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2006, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "GL-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "R-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2006, make: "MERCEDES-BENZ", model: "SLR McLaren" },
  { type: "car", year: 2006, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2006, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2006, make: "MERCURY", model: "Milan" },
  { type: "car", year: 2006, make: "MERCURY", model: "Montego" },
  { type: "car", year: 2006, make: "MERCURY", model: "Monterey" },
  { type: "car", year: 2006, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2006, make: "MINI", model: "Cooper" },
  { type: "car", year: 2006, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2006, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2006, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2006, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2006, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2006, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2006, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2006, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2006, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2006, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2006, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2006, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2006, make: "NISSAN", model: "X-Trail" },
  { type: "car", year: 2006, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2006, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2006, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2006, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2006, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2006, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2006, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2006, make: "PONTIAC", model: "G6" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2006, make: "PONTIAC", model: "GTO" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Montana SV6" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Pursuit" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Solstice" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Torrent" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2006, make: "PONTIAC", model: "Wave" },
  { type: "car", year: 2006, make: "PORSCHE", model: "911" },
  { type: "car", year: 2006, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2006, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2006, make: "PORSCHE", model: "Cayman" },
  { type: "car", year: 2006, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2006, make: "SAAB", model: "9-2X" },
  { type: "car", year: 2006, make: "SAAB", model: "9-3" },
  { type: "car", year: 2006, make: "SAAB", model: "9-5" },
  { type: "car", year: 2006, make: "SAAB", model: "9-7X" },
  { type: "car", year: 2006, make: "SATURN", model: "Ion" },
  { type: "car", year: 2006, make: "SATURN", model: "Relay" },
  { type: "car", year: 2006, make: "SATURN", model: "Vue" },
  { type: "car", year: 2006, make: "SPYKER", model: "C12" },
  { type: "car", year: 2006, make: "SPYKER", model: "C8" },
  { type: "car", year: 2006, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2006, make: "SUBARU", model: "B9 Tribeca" },
  { type: "car", year: 2006, make: "SUBARU", model: "Baja" },
  { type: "car", year: 2006, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2006, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2006, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2006, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Aerio" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Forenza" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Grand Vitara XL-7" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Reno" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2006, make: "SUZUKI", model: "Verona" },
  { type: "car", year: 2006, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2006, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2006, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Scion xA" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2006, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2006, make: "VOLVO", model: "C70" },
  { type: "car", year: 2006, make: "VOLVO", model: "S40" },
  { type: "car", year: 2006, make: "VOLVO", model: "S60" },
  { type: "car", year: 2006, make: "VOLVO", model: "S80" },
  { type: "car", year: 2006, make: "VOLVO", model: "V50" },
  { type: "car", year: 2006, make: "VOLVO", model: "V70" },
  { type: "car", year: 2006, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2006, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2006, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2005, make: "ACURA", model: "MDX" },
  { type: "car", year: 2005, make: "ACURA", model: "NSX" },
  { type: "car", year: 2005, make: "ACURA", model: "RL" },
  { type: "car", year: 2005, make: "ACURA", model: "RSX" },
  { type: "car", year: 2005, make: "ACURA", model: "TL" },
  { type: "car", year: 2005, make: "ACURA", model: "TSX" },
  { type: "car", year: 2005, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2005, make: "ASTON MARTIN", model: "DB9" },
  { type: "car", year: 2005, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2005, make: "AUDI", model: "A4" },
  { type: "car", year: 2005, make: "AUDI", model: "A6" },
  { type: "car", year: 2005, make: "AUDI", model: "A8" },
  { type: "car", year: 2005, make: "AUDI", model: "allroad" },
  { type: "car", year: 2005, make: "AUDI", model: "S4" },
  { type: "car", year: 2005, make: "AUDI", model: "TT" },
  { type: "car", year: 2005, make: "BENTLEY", model: "ARMOURED ARNAGE" },
  { type: "car", year: 2005, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2005, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2005, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2005, make: "BMW", model: "325Ci" },
  { type: "car", year: 2005, make: "BMW", model: "325i" },
  { type: "car", year: 2005, make: "BMW", model: "325xi" },
  { type: "car", year: 2005, make: "BMW", model: "330Ci" },
  { type: "car", year: 2005, make: "BMW", model: "330i" },
  { type: "car", year: 2005, make: "BMW", model: "330xi" },
  { type: "car", year: 2005, make: "BMW", model: "525i" },
  { type: "car", year: 2005, make: "BMW", model: "530i" },
  { type: "car", year: 2005, make: "BMW", model: "545i" },
  { type: "car", year: 2005, make: "BMW", model: "645Ci" },
  { type: "car", year: 2005, make: "BMW", model: "745i" },
  { type: "car", year: 2005, make: "BMW", model: "745Li" },
  { type: "car", year: 2005, make: "BMW", model: "760i" },
  { type: "car", year: 2005, make: "BMW", model: "760Li" },
  { type: "car", year: 2005, make: "BMW", model: "M3" },
  { type: "car", year: 2005, make: "BMW", model: "M3Ci" },
  { type: "car", year: 2005, make: "BMW", model: "X3" },
  { type: "car", year: 2005, make: "BMW", model: "X5" },
  { type: "car", year: 2005, make: "BMW", model: "Z4" },
  { type: "car", year: 2005, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2005, make: "BUGATTI", model: "Veyron" },
  { type: "car", year: 2005, make: "BUICK", model: "Allure" },
  { type: "car", year: 2005, make: "BUICK", model: "Century" },
  { type: "car", year: 2005, make: "BUICK", model: "LaCrosse" },
  { type: "car", year: 2005, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 2005, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 2005, make: "BUICK", model: "Rainier" },
  { type: "car", year: 2005, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2005, make: "BUICK", model: "Terraza" },
  { type: "car", year: 2005, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2005, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 2005, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2005, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2005, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2005, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2005, make: "CADILLAC", model: "STS" },
  { type: "car", year: 2005, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Cobalt" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Epica" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Equinox" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Malibu Classic" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Matiz" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Optra" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "U100" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Uplander" },
  { type: "car", year: 2005, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "300C" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "Crossfire" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2005, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2005, make: "DAEWOO", model: "Laganza V-car" },
  { type: "car", year: 2005, make: "DAEWOO", model: "Leganza V-200 & variants/derivatives" },
  { type: "car", year: 2005, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2005, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2005, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2005, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2005, make: "DODGE", model: "Durango" },
  { type: "car", year: 2005, make: "DODGE", model: "Magnum" },
  { type: "car", year: 2005, make: "DODGE", model: "Neon" },
  { type: "car", year: 2005, make: "DODGE", model: "Ram" },
  { type: "car", year: 2005, make: "DODGE", model: "Sprinter" },
  { type: "car", year: 2005, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2005, make: "DODGE", model: "Viper" },
  { type: "car", year: 2005, make: "FERRARI", model: "360" },
  { type: "car", year: 2005, make: "FERRARI", model: "575M Maranello" },
  { type: "car", year: 2005, make: "FERRARI", model: "612 Scaglietti" },
  { type: "car", year: 2005, make: "FORD", model: "'34" },
  { type: "car", year: 2005, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2005, make: "FORD", model: "E-150" },
  { type: "car", year: 2005, make: "FORD", model: "E-250" },
  { type: "car", year: 2005, make: "FORD", model: "E-350" },
  { type: "car", year: 2005, make: "FORD", model: "E-450" },
  { type: "car", year: 2005, make: "FORD", model: "Escape" },
  { type: "car", year: 2005, make: "FORD", model: "Excursion" },
  { type: "car", year: 2005, make: "FORD", model: "Expedition" },
  { type: "car", year: 2005, make: "FORD", model: "Explorer" },
  { type: "car", year: 2005, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2005, make: "FORD", model: "F-150" },
  { type: "car", year: 2005, make: "FORD", model: "F-250" },
  { type: "car", year: 2005, make: "FORD", model: "F-350" },
  { type: "car", year: 2005, make: "FORD", model: "F-450" },
  { type: "car", year: 2005, make: "FORD", model: "F-550" },
  { type: "car", year: 2005, make: "FORD", model: "Five Hundred" },
  { type: "car", year: 2005, make: "FORD", model: "Focus" },
  { type: "car", year: 2005, make: "FORD", model: "Freestar" },
  { type: "car", year: 2005, make: "FORD", model: "Freestyle" },
  { type: "car", year: 2005, make: "FORD", model: "GT" },
  { type: "car", year: 2005, make: "FORD", model: "Mustang" },
  { type: "car", year: 2005, make: "FORD", model: "Ranger" },
  { type: "car", year: 2005, make: "FORD", model: "Taurus" },
  { type: "car", year: 2005, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 2005, make: "GMC", model: "Canyon" },
  { type: "car", year: 2005, make: "GMC", model: "Envoy" },
  { type: "car", year: 2005, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 2005, make: "GMC", model: "Safari" },
  { type: "car", year: 2005, make: "GMC", model: "Savana" },
  { type: "car", year: 2005, make: "GMC", model: "Sierra" },
  { type: "car", year: 2005, make: "GMC", model: "Yukon" },
  { type: "car", year: 2005, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2005, make: "HONDA", model: "Accord" },
  { type: "car", year: 2005, make: "HONDA", model: "Civic" },
  { type: "car", year: 2005, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2005, make: "HONDA", model: "Element" },
  { type: "car", year: 2005, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2005, make: "HONDA", model: "Insight" },
  { type: "car", year: 2005, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2005, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2005, make: "HONDA", model: "S2000" },
  { type: "car", year: 2005, make: "HUMMER", model: "H1" },
  { type: "car", year: 2005, make: "HUMMER", model: "H2" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "Tucson" },
  { type: "car", year: 2005, make: "HYUNDAI", model: "XG350" },
  { type: "car", year: 2005, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2005, make: "INFINITI", model: "FX45" },
  { type: "car", year: 2005, make: "INFINITI", model: "G35" },
  { type: "car", year: 2005, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2005, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2005, make: "ISUZU", model: "Ascender" },
  { type: "car", year: 2005, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2005, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2005, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2005, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2005, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2005, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2005, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2005, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2005, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2005, make: "KIA", model: "Amanti" },
  { type: "car", year: 2005, make: "KIA", model: "Optima" },
  { type: "car", year: 2005, make: "KIA", model: "Rio" },
  { type: "car", year: 2005, make: "KIA", model: "Sedona" },
  { type: "car", year: 2005, make: "KIA", model: "Sorento" },
  { type: "car", year: 2005, make: "KIA", model: "Spectra" },
  { type: "car", year: 2005, make: "KIA", model: "Sportage" },
  { type: "car", year: 2005, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2005, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2005, make: "LAND ROVER", model: "Freelander" },
  { type: "car", year: 2005, make: "LAND ROVER", model: "LR3" },
  { type: "car", year: 2005, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2005, make: "LEXUS", model: "ES" },
  { type: "car", year: 2005, make: "LEXUS", model: "GS" },
  { type: "car", year: 2005, make: "LEXUS", model: "GX" },
  { type: "car", year: 2005, make: "LEXUS", model: "IS" },
  { type: "car", year: 2005, make: "LEXUS", model: "LS" },
  { type: "car", year: 2005, make: "LEXUS", model: "LX" },
  { type: "car", year: 2005, make: "LEXUS", model: "RX" },
  { type: "car", year: 2005, make: "LEXUS", model: "SC" },
  { type: "car", year: 2005, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2005, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2005, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2005, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2005, make: "LOTUS", model: "Elise" },
  { type: "car", year: 2005, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 2005, make: "MAYBACH", model: "57" },
  { type: "car", year: 2005, make: "MAYBACH", model: "62" },
  { type: "car", year: 2005, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2005, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2005, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2005, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2005, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2005, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2005, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "CLS-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2005, make: "MERCEDES-BENZ", model: "SLR McLaren" },
  { type: "car", year: 2005, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2005, make: "MERCURY", model: "Mariner" },
  { type: "car", year: 2005, make: "MERCURY", model: "Montego" },
  { type: "car", year: 2005, make: "MERCURY", model: "Monterey" },
  { type: "car", year: 2005, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2005, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2005, make: "MINI", model: "Cooper" },
  { type: "car", year: 2005, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2005, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2005, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2005, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2005, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2005, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2005, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2005, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2005, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2005, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2005, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2005, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2005, make: "NISSAN", model: "X-Trail" },
  { type: "car", year: 2005, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2005, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2005, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2005, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2005, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2005, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2005, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Aztek" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 2005, make: "PONTIAC", model: "G6" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2005, make: "PONTIAC", model: "GTO" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Montana SV6" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Pursuit" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2005, make: "PONTIAC", model: "Wave" },
  { type: "car", year: 2005, make: "PORSCHE", model: "911" },
  { type: "car", year: 2005, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2005, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2005, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2005, make: "SAAB", model: "9-2X" },
  { type: "car", year: 2005, make: "SAAB", model: "9-3" },
  { type: "car", year: 2005, make: "SAAB", model: "9-5" },
  { type: "car", year: 2005, make: "SAAB", model: "9-7X" },
  { type: "car", year: 2005, make: "SATURN", model: "Ion" },
  { type: "car", year: 2005, make: "SATURN", model: "L300" },
  { type: "car", year: 2005, make: "SATURN", model: "Relay" },
  { type: "car", year: 2005, make: "SATURN", model: "Vue" },
  { type: "car", year: 2005, make: "SPYKER", model: "C12" },
  { type: "car", year: 2005, make: "SPYKER", model: "C8" },
  { type: "car", year: 2005, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2005, make: "SUBARU", model: "Baja" },
  { type: "car", year: 2005, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2005, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2005, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2005, make: "SUBARU", model: "Outback" },
  { type: "car", year: 2005, make: "SUZUKI", model: "Aerio" },
  { type: "car", year: 2005, make: "SUZUKI", model: "Forenza" },
  { type: "car", year: 2005, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2005, make: "SUZUKI", model: "Reno" },
  { type: "car", year: 2005, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2005, make: "SUZUKI", model: "Verona" },
  { type: "car", year: 2005, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2005, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Echo" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2005, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2005, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Scion tC" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Scion xA" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2005, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2005, make: "VOLVO", model: "S40" },
  { type: "car", year: 2005, make: "VOLVO", model: "S60" },
  { type: "car", year: 2005, make: "VOLVO", model: "S80" },
  { type: "car", year: 2005, make: "VOLVO", model: "V50" },
  { type: "car", year: 2005, make: "VOLVO", model: "V70" },
  { type: "car", year: 2005, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2005, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2005, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2004, make: "ACURA", model: "MDX" },
  { type: "car", year: 2004, make: "ACURA", model: "NSX" },
  { type: "car", year: 2004, make: "ACURA", model: "RL" },
  { type: "car", year: 2004, make: "ACURA", model: "RSX" },
  { type: "car", year: 2004, make: "ACURA", model: "TL" },
  { type: "car", year: 2004, make: "ACURA", model: "TSX" },
  { type: "car", year: 2004, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2004, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2004, make: "AUDI", model: "A4" },
  { type: "car", year: 2004, make: "AUDI", model: "A6" },
  { type: "car", year: 2004, make: "AUDI", model: "A8" },
  { type: "car", year: 2004, make: "AUDI", model: "allroad" },
  { type: "car", year: 2004, make: "AUDI", model: "RS 6" },
  { type: "car", year: 2004, make: "AUDI", model: "S4" },
  { type: "car", year: 2004, make: "AUDI", model: "TT" },
  { type: "car", year: 2004, make: "BENTLEY", model: "ARMOURED ARNAGE" },
  { type: "car", year: 2004, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2004, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2004, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2004, make: "BMW", model: "325Ci" },
  { type: "car", year: 2004, make: "BMW", model: "325i" },
  { type: "car", year: 2004, make: "BMW", model: "325xi" },
  { type: "car", year: 2004, make: "BMW", model: "330Ci" },
  { type: "car", year: 2004, make: "BMW", model: "330i" },
  { type: "car", year: 2004, make: "BMW", model: "330xi" },
  { type: "car", year: 2004, make: "BMW", model: "525i" },
  { type: "car", year: 2004, make: "BMW", model: "530i" },
  { type: "car", year: 2004, make: "BMW", model: "545i" },
  { type: "car", year: 2004, make: "BMW", model: "645Ci" },
  { type: "car", year: 2004, make: "BMW", model: "645i" },
  { type: "car", year: 2004, make: "BMW", model: "745i" },
  { type: "car", year: 2004, make: "BMW", model: "745Li" },
  { type: "car", year: 2004, make: "BMW", model: "760Li" },
  { type: "car", year: 2004, make: "BMW", model: "M3" },
  { type: "car", year: 2004, make: "BMW", model: "M3Ci" },
  { type: "car", year: 2004, make: "BMW", model: "X3" },
  { type: "car", year: 2004, make: "BMW", model: "X5" },
  { type: "car", year: 2004, make: "BMW", model: "Z4" },
  { type: "car", year: 2004, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2004, make: "BUICK", model: "Century" },
  { type: "car", year: 2004, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 2004, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 2004, make: "BUICK", model: "Rainier" },
  { type: "car", year: 2004, make: "BUICK", model: "Regal" },
  { type: "car", year: 2004, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2004, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2004, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 2004, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2004, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2004, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2004, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 2004, make: "CADILLAC", model: "SRX" },
  { type: "car", year: 2004, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "3 ton" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Aveo" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Epica" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Malibu Classic" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Matiz" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Optra" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "U100" },
  { type: "car", year: 2004, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "Crossfire" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "Pacifica" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2004, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2004, make: "DAEWOO", model: "Laganza V-car" },
  { type: "car", year: 2004, make: "DAEWOO", model: "Leganza V-200 & variants/derivatives" },
  { type: "car", year: 2004, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2004, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2004, make: "DODGE", model: "Caravan" },
  { type: "car", year: 2004, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2004, make: "DODGE", model: "Durango" },
  { type: "car", year: 2004, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2004, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 2004, make: "DODGE", model: "Neon" },
  { type: "car", year: 2004, make: "DODGE", model: "Ram" },
  { type: "car", year: 2004, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2004, make: "DODGE", model: "Viper" },
  { type: "car", year: 2004, make: "FERRARI", model: "360" },
  { type: "car", year: 2004, make: "FERRARI", model: "575M Maranello" },
  { type: "car", year: 2004, make: "FERRARI", model: "Challenge Stradale" },
  { type: "car", year: 2004, make: "FORD", model: "'34" },
  { type: "car", year: 2004, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2004, make: "FORD", model: "E-150" },
  { type: "car", year: 2004, make: "FORD", model: "E-250" },
  { type: "car", year: 2004, make: "FORD", model: "E-350" },
  { type: "car", year: 2004, make: "FORD", model: "E-450" },
  { type: "car", year: 2004, make: "FORD", model: "Escape" },
  { type: "car", year: 2004, make: "FORD", model: "Excursion" },
  { type: "car", year: 2004, make: "FORD", model: "Expedition" },
  { type: "car", year: 2004, make: "FORD", model: "Explorer" },
  { type: "car", year: 2004, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2004, make: "FORD", model: "F-150" },
  { type: "car", year: 2004, make: "FORD", model: "F-250" },
  { type: "car", year: 2004, make: "FORD", model: "F-350" },
  { type: "car", year: 2004, make: "FORD", model: "F-450" },
  { type: "car", year: 2004, make: "FORD", model: "F-550" },
  { type: "car", year: 2004, make: "FORD", model: "Focus" },
  { type: "car", year: 2004, make: "FORD", model: "Freestar" },
  { type: "car", year: 2004, make: "FORD", model: "GT" },
  { type: "car", year: 2004, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2004, make: "FORD", model: "Mustang" },
  { type: "car", year: 2004, make: "FORD", model: "Ranger" },
  { type: "car", year: 2004, make: "FORD", model: "Taurus" },
  { type: "car", year: 2004, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 2004, make: "GMC", model: "Canyon" },
  { type: "car", year: 2004, make: "GMC", model: "Envoy" },
  { type: "car", year: 2004, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 2004, make: "GMC", model: "Safari" },
  { type: "car", year: 2004, make: "GMC", model: "Savana" },
  { type: "car", year: 2004, make: "GMC", model: "Sierra" },
  { type: "car", year: 2004, make: "GMC", model: "Sonoma" },
  { type: "car", year: 2004, make: "GMC", model: "Yukon" },
  { type: "car", year: 2004, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2004, make: "HONDA", model: "Accord" },
  { type: "car", year: 2004, make: "HONDA", model: "Civic" },
  { type: "car", year: 2004, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2004, make: "HONDA", model: "Element" },
  { type: "car", year: 2004, make: "HONDA", model: "FCX Clarity" },
  { type: "car", year: 2004, make: "HONDA", model: "Insight" },
  { type: "car", year: 2004, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2004, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2004, make: "HONDA", model: "S2000" },
  { type: "car", year: 2004, make: "HUMMER", model: "H1" },
  { type: "car", year: 2004, make: "HUMMER", model: "H2" },
  { type: "car", year: 2004, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2004, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2004, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2004, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2004, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2004, make: "HYUNDAI", model: "XG350" },
  { type: "car", year: 2004, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2004, make: "INFINITI", model: "FX45" },
  { type: "car", year: 2004, make: "INFINITI", model: "G35" },
  { type: "car", year: 2004, make: "INFINITI", model: "I35" },
  { type: "car", year: 2004, make: "INFINITI", model: "M45" },
  { type: "car", year: 2004, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2004, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2004, make: "ISUZU", model: "Ascender" },
  { type: "car", year: 2004, make: "ISUZU", model: "Axiom" },
  { type: "car", year: 2004, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 2004, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2004, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 2004, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2004, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2004, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2004, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2004, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 2004, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2004, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2004, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2004, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2004, make: "KIA", model: "Amanti" },
  { type: "car", year: 2004, make: "KIA", model: "Optima" },
  { type: "car", year: 2004, make: "KIA", model: "Rio" },
  { type: "car", year: 2004, make: "KIA", model: "Sedona" },
  { type: "car", year: 2004, make: "KIA", model: "Sorento" },
  { type: "car", year: 2004, make: "KIA", model: "Spectra" },
  { type: "car", year: 2004, make: "KIA", model: "Sportage" },
  { type: "car", year: 2004, make: "LAMBORGHINI", model: "Gallardo" },
  { type: "car", year: 2004, make: "LAMBORGHINI", model: "Murcielago" },
  { type: "car", year: 2004, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2004, make: "LAND ROVER", model: "Freelander" },
  { type: "car", year: 2004, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2004, make: "LEXUS", model: "ES" },
  { type: "car", year: 2004, make: "LEXUS", model: "GS" },
  { type: "car", year: 2004, make: "LEXUS", model: "GX" },
  { type: "car", year: 2004, make: "LEXUS", model: "IS" },
  { type: "car", year: 2004, make: "LEXUS", model: "LS" },
  { type: "car", year: 2004, make: "LEXUS", model: "LX" },
  { type: "car", year: 2004, make: "LEXUS", model: "RX" },
  { type: "car", year: 2004, make: "LEXUS", model: "SC" },
  { type: "car", year: 2004, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2004, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2004, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2004, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2004, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2004, make: "MASERATI", model: "Coupe" },
  { type: "car", year: 2004, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 2004, make: "MAYBACH", model: "57" },
  { type: "car", year: 2004, make: "MAYBACH", model: "62" },
  { type: "car", year: 2004, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2004, make: "MAZDA", model: "Mazda3" },
  { type: "car", year: 2004, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2004, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2004, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2004, make: "MAZDA", model: "RX-8" },
  { type: "car", year: 2004, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2004, make: "MERCEDES-BENZ", model: "SLR McLaren" },
  { type: "car", year: 2004, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2004, make: "MERCURY", model: "Marauder" },
  { type: "car", year: 2004, make: "MERCURY", model: "Monterey" },
  { type: "car", year: 2004, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2004, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2004, make: "MINI", model: "Cooper" },
  { type: "car", year: 2004, make: "MINI", model: "Cooper Convertible" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Endeavor" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Lancer SportBack" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2004, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2004, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2004, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2004, make: "NISSAN", model: "Altra-EV" },
  { type: "car", year: 2004, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2004, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2004, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2004, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2004, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2004, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2004, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2004, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2004, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2004, make: "OLDSMOBILE", model: "Alero" },
  { type: "car", year: 2004, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 2004, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 2004, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2004, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2004, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2004, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2004, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2004, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Aztek" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2004, make: "PONTIAC", model: "GTO" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Montana" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 2004, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2004, make: "PORSCHE", model: "911" },
  { type: "car", year: 2004, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2004, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2004, make: "ROLLS-ROYCE", model: "Phantom" },
  { type: "car", year: 2004, make: "SAAB", model: "9-3" },
  { type: "car", year: 2004, make: "SAAB", model: "9-5" },
  { type: "car", year: 2004, make: "SATURN", model: "Ion" },
  { type: "car", year: 2004, make: "SATURN", model: "L300" },
  { type: "car", year: 2004, make: "SATURN", model: "LW300" },
  { type: "car", year: 2004, make: "SATURN", model: "Vue" },
  { type: "car", year: 2004, make: "SMART", model: "smart" },
  { type: "car", year: 2004, make: "SPYKER", model: "C12" },
  { type: "car", year: 2004, make: "SPYKER", model: "C8" },
  { type: "car", year: 2004, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2004, make: "SUBARU", model: "Baja" },
  { type: "car", year: 2004, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2004, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2004, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2004, make: "SUZUKI", model: "Aerio" },
  { type: "car", year: 2004, make: "SUZUKI", model: "Forenza" },
  { type: "car", year: 2004, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2004, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2004, make: "SUZUKI", model: "Verona" },
  { type: "car", year: 2004, make: "SUZUKI", model: "Vitara" },
  { type: "car", year: 2004, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2004, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Echo" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2004, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2004, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Scion xA" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Scion xB" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2004, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2004, make: "VOLVO", model: "C70" },
  { type: "car", year: 2004, make: "VOLVO", model: "S40" },
  { type: "car", year: 2004, make: "VOLVO", model: "S60" },
  { type: "car", year: 2004, make: "VOLVO", model: "S80" },
  { type: "car", year: 2004, make: "VOLVO", model: "V40" },
  { type: "car", year: 2004, make: "VOLVO", model: "V70" },
  { type: "car", year: 2004, make: "VOLVO", model: "XC70" },
  { type: "car", year: 2004, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2004, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2003, make: "ACURA", model: "CL" },
  { type: "car", year: 2003, make: "ACURA", model: "MDX" },
  { type: "car", year: 2003, make: "ACURA", model: "NSX" },
  { type: "car", year: 2003, make: "ACURA", model: "RL" },
  { type: "car", year: 2003, make: "ACURA", model: "RSX" },
  { type: "car", year: 2003, make: "ACURA", model: "TL" },
  { type: "car", year: 2003, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2003, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 2003, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2003, make: "AUDI", model: "A4" },
  { type: "car", year: 2003, make: "AUDI", model: "A6" },
  { type: "car", year: 2003, make: "AUDI", model: "A8" },
  { type: "car", year: 2003, make: "AUDI", model: "allroad" },
  { type: "car", year: 2003, make: "AUDI", model: "RS 6" },
  { type: "car", year: 2003, make: "AUDI", model: "S6" },
  { type: "car", year: 2003, make: "AUDI", model: "S8" },
  { type: "car", year: 2003, make: "AUDI", model: "TT" },
  { type: "car", year: 2003, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2003, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2003, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2003, make: "BMW", model: "325Ci" },
  { type: "car", year: 2003, make: "BMW", model: "325i" },
  { type: "car", year: 2003, make: "BMW", model: "325xi" },
  { type: "car", year: 2003, make: "BMW", model: "330Ci" },
  { type: "car", year: 2003, make: "BMW", model: "330i" },
  { type: "car", year: 2003, make: "BMW", model: "330xi" },
  { type: "car", year: 2003, make: "BMW", model: "525i" },
  { type: "car", year: 2003, make: "BMW", model: "525iA" },
  { type: "car", year: 2003, make: "BMW", model: "530i" },
  { type: "car", year: 2003, make: "BMW", model: "530iA" },
  { type: "car", year: 2003, make: "BMW", model: "540i" },
  { type: "car", year: 2003, make: "BMW", model: "540iA" },
  { type: "car", year: 2003, make: "BMW", model: "745i" },
  { type: "car", year: 2003, make: "BMW", model: "745Li" },
  { type: "car", year: 2003, make: "BMW", model: "760Li" },
  { type: "car", year: 2003, make: "BMW", model: "Alpina" },
  { type: "car", year: 2003, make: "BMW", model: "M3" },
  { type: "car", year: 2003, make: "BMW", model: "M3Ci" },
  { type: "car", year: 2003, make: "BMW", model: "M5" },
  { type: "car", year: 2003, make: "BMW", model: "X5" },
  { type: "car", year: 2003, make: "BMW", model: "Z4" },
  { type: "car", year: 2003, make: "BMW", model: "Z8" },
  { type: "car", year: 2003, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2003, make: "BUICK", model: "Century" },
  { type: "car", year: 2003, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 2003, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 2003, make: "BUICK", model: "Regal" },
  { type: "car", year: 2003, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2003, make: "CADILLAC", model: "CTS" },
  { type: "car", year: 2003, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 2003, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2003, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2003, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2003, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 2003, make: "CADILLAC", model: "XLR" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "3 ton" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2003, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2003, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2003, make: "DAEWOO", model: "Laganza V-car" },
  { type: "car", year: 2003, make: "DAEWOO", model: "Leganza V-200 & variants/derivatives" },
  { type: "car", year: 2003, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2003, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2003, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2003, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2003, make: "DODGE", model: "Durango" },
  { type: "car", year: 2003, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 2003, make: "DODGE", model: "Neon" },
  { type: "car", year: 2003, make: "DODGE", model: "Ram" },
  { type: "car", year: 2003, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 2003, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 2003, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2003, make: "DODGE", model: "Viper" },
  { type: "car", year: 2003, make: "FERRARI", model: "360" },
  { type: "car", year: 2003, make: "FERRARI", model: "456M" },
  { type: "car", year: 2003, make: "FERRARI", model: "575M Maranello" },
  { type: "car", year: 2003, make: "FERRARI", model: "Enzo" },
  { type: "car", year: 2003, make: "FORD", model: "'34" },
  { type: "car", year: 2003, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2003, make: "FORD", model: "E-150" },
  { type: "car", year: 2003, make: "FORD", model: "E-250" },
  { type: "car", year: 2003, make: "FORD", model: "E-350" },
  { type: "car", year: 2003, make: "FORD", model: "E-450" },
  { type: "car", year: 2003, make: "FORD", model: "E-550" },
  { type: "car", year: 2003, make: "FORD", model: "Escape" },
  { type: "car", year: 2003, make: "FORD", model: "Excursion" },
  { type: "car", year: 2003, make: "FORD", model: "Expedition" },
  { type: "car", year: 2003, make: "FORD", model: "Explorer" },
  { type: "car", year: 2003, make: "FORD", model: "Explorer Sport" },
  { type: "car", year: 2003, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2003, make: "FORD", model: "F-150" },
  { type: "car", year: 2003, make: "FORD", model: "F-250" },
  { type: "car", year: 2003, make: "FORD", model: "F-350" },
  { type: "car", year: 2003, make: "FORD", model: "F-450" },
  { type: "car", year: 2003, make: "FORD", model: "F-550" },
  { type: "car", year: 2003, make: "FORD", model: "Focus" },
  { type: "car", year: 2003, make: "FORD", model: "Mustang" },
  { type: "car", year: 2003, make: "FORD", model: "Ranger" },
  { type: "car", year: 2003, make: "FORD", model: "Taurus" },
  { type: "car", year: 2003, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 2003, make: "FORD", model: "Windstar" },
  { type: "car", year: 2003, make: "FORD", model: "ZX2" },
  { type: "car", year: 2003, make: "GMC", model: "Envoy" },
  { type: "car", year: 2003, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 2003, make: "GMC", model: "Safari" },
  { type: "car", year: 2003, make: "GMC", model: "Savana" },
  { type: "car", year: 2003, make: "GMC", model: "Sierra" },
  { type: "car", year: 2003, make: "GMC", model: "Sonoma" },
  { type: "car", year: 2003, make: "GMC", model: "Yukon" },
  { type: "car", year: 2003, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2003, make: "HONDA", model: "Accord" },
  { type: "car", year: 2003, make: "HONDA", model: "Civic" },
  { type: "car", year: 2003, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2003, make: "HONDA", model: "Element" },
  { type: "car", year: 2003, make: "HONDA", model: "Insight" },
  { type: "car", year: 2003, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2003, make: "HONDA", model: "Pilot" },
  { type: "car", year: 2003, make: "HONDA", model: "S2000" },
  { type: "car", year: 2003, make: "HUMMER", model: "H1" },
  { type: "car", year: 2003, make: "HUMMER", model: "H2" },
  { type: "car", year: 2003, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2003, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2003, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2003, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2003, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2003, make: "HYUNDAI", model: "XG350" },
  { type: "car", year: 2003, make: "INFINITI", model: "FX35" },
  { type: "car", year: 2003, make: "INFINITI", model: "FX45" },
  { type: "car", year: 2003, make: "INFINITI", model: "G35" },
  { type: "car", year: 2003, make: "INFINITI", model: "I35" },
  { type: "car", year: 2003, make: "INFINITI", model: "M45" },
  { type: "car", year: 2003, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2003, make: "INFINITI", model: "QX4" },
  { type: "car", year: 2003, make: "INFINITI", model: "QX56" },
  { type: "car", year: 2003, make: "ISUZU", model: "Ascender" },
  { type: "car", year: 2003, make: "ISUZU", model: "Axiom" },
  { type: "car", year: 2003, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 2003, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2003, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 2003, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2003, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2003, make: "JAGUAR", model: "XJ8" },
  { type: "car", year: 2003, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2003, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2003, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 2003, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2003, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2003, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2003, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2003, make: "KIA", model: "Optima" },
  { type: "car", year: 2003, make: "KIA", model: "Rio" },
  { type: "car", year: 2003, make: "KIA", model: "Sedona" },
  { type: "car", year: 2003, make: "KIA", model: "Sorento" },
  { type: "car", year: 2003, make: "KIA", model: "Spectra" },
  { type: "car", year: 2003, make: "KIA", model: "Sportage" },
  { type: "car", year: 2003, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2003, make: "LAND ROVER", model: "Freelander" },
  { type: "car", year: 2003, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2003, make: "LEXUS", model: "ES" },
  { type: "car", year: 2003, make: "LEXUS", model: "GS" },
  { type: "car", year: 2003, make: "LEXUS", model: "GX" },
  { type: "car", year: 2003, make: "LEXUS", model: "IS" },
  { type: "car", year: 2003, make: "LEXUS", model: "LS" },
  { type: "car", year: 2003, make: "LEXUS", model: "LX" },
  { type: "car", year: 2003, make: "LEXUS", model: "RX" },
  { type: "car", year: 2003, make: "LEXUS", model: "SC" },
  { type: "car", year: 2003, make: "LINCOLN", model: "Aviator" },
  { type: "car", year: 2003, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2003, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2003, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2003, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2003, make: "MASERATI", model: "Coupe" },
  { type: "car", year: 2003, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 2003, make: "MAYBACH", model: "57" },
  { type: "car", year: 2003, make: "MAYBACH", model: "62" },
  { type: "car", year: 2003, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2003, make: "MAZDA", model: "Mazda6" },
  { type: "car", year: 2003, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2003, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2003, make: "MAZDA", model: "Protege" },
  { type: "car", year: 2003, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2003, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2003, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2003, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2003, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2003, make: "MINI", model: "Cooper" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Lancer Evolution" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Outlander" },
  { type: "car", year: 2003, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2003, make: "NISSAN", model: "350Z" },
  { type: "car", year: 2003, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2003, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2003, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2003, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2003, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2003, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2003, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2003, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2003, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2003, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2003, make: "OLDSMOBILE", model: "Alero" },
  { type: "car", year: 2003, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 2003, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 2003, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 2003, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2003, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2003, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2003, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2003, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2003, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Aztek" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Montana" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 2003, make: "PONTIAC", model: "Vibe" },
  { type: "car", year: 2003, make: "PORSCHE", model: "911" },
  { type: "car", year: 2003, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2003, make: "PORSCHE", model: "Cayenne" },
  { type: "car", year: 2003, make: "SAAB", model: "9-3" },
  { type: "car", year: 2003, make: "SAAB", model: "9-5" },
  { type: "car", year: 2003, make: "SATURN", model: "Ion" },
  { type: "car", year: 2003, make: "SATURN", model: "L200" },
  { type: "car", year: 2003, make: "SATURN", model: "L300" },
  { type: "car", year: 2003, make: "SATURN", model: "LW200" },
  { type: "car", year: 2003, make: "SATURN", model: "LW300" },
  { type: "car", year: 2003, make: "SATURN", model: "Vue" },
  { type: "car", year: 2003, make: "SMART", model: "smart" },
  { type: "car", year: 2003, make: "SPYKER", model: "C12" },
  { type: "car", year: 2003, make: "SPYKER", model: "C8" },
  { type: "car", year: 2003, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2003, make: "SUBARU", model: "Baja" },
  { type: "car", year: 2003, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2003, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2003, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2003, make: "SUZUKI", model: "Aerio" },
  { type: "car", year: 2003, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2003, make: "SUZUKI", model: "Vitara" },
  { type: "car", year: 2003, make: "SUZUKI", model: "XL7" },
  { type: "car", year: 2003, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Corolla Matrix" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Echo" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2003, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2003, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2003, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2003, make: "VOLVO", model: "C70" },
  { type: "car", year: 2003, make: "VOLVO", model: "S40" },
  { type: "car", year: 2003, make: "VOLVO", model: "S60" },
  { type: "car", year: 2003, make: "VOLVO", model: "S80" },
  { type: "car", year: 2003, make: "VOLVO", model: "V40" },
  { type: "car", year: 2003, make: "VOLVO", model: "V70" },
  { type: "car", year: 2003, make: "VOLVO", model: "XC90" },
  { type: "car", year: 2003, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2002, make: "ACURA", model: "CL" },
  { type: "car", year: 2002, make: "ACURA", model: "MDX" },
  { type: "car", year: 2002, make: "ACURA", model: "NSX" },
  { type: "car", year: 2002, make: "ACURA", model: "RL" },
  { type: "car", year: 2002, make: "ACURA", model: "RSX" },
  { type: "car", year: 2002, make: "ACURA", model: "TL" },
  { type: "car", year: 2002, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2002, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 2002, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2002, make: "AUDI", model: "A4" },
  { type: "car", year: 2002, make: "AUDI", model: "A6" },
  { type: "car", year: 2002, make: "AUDI", model: "A8" },
  { type: "car", year: 2002, make: "AUDI", model: "allroad" },
  { type: "car", year: 2002, make: "AUDI", model: "S4" },
  { type: "car", year: 2002, make: "AUDI", model: "S6" },
  { type: "car", year: 2002, make: "AUDI", model: "S8" },
  { type: "car", year: 2002, make: "AUDI", model: "TT" },
  { type: "car", year: 2002, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2002, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2002, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2002, make: "BMW", model: "325Ci" },
  { type: "car", year: 2002, make: "BMW", model: "325i" },
  { type: "car", year: 2002, make: "BMW", model: "325xi" },
  { type: "car", year: 2002, make: "BMW", model: "330Ci" },
  { type: "car", year: 2002, make: "BMW", model: "330i" },
  { type: "car", year: 2002, make: "BMW", model: "330xi" },
  { type: "car", year: 2002, make: "BMW", model: "525i" },
  { type: "car", year: 2002, make: "BMW", model: "530i" },
  { type: "car", year: 2002, make: "BMW", model: "540i" },
  { type: "car", year: 2002, make: "BMW", model: "745i" },
  { type: "car", year: 2002, make: "BMW", model: "745Li" },
  { type: "car", year: 2002, make: "BMW", model: "M3" },
  { type: "car", year: 2002, make: "BMW", model: "M3Ci" },
  { type: "car", year: 2002, make: "BMW", model: "M5" },
  { type: "car", year: 2002, make: "BMW", model: "X5" },
  { type: "car", year: 2002, make: "BMW", model: "Z3" },
  { type: "car", year: 2002, make: "BMW", model: "Z8" },
  { type: "car", year: 2002, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2002, make: "BUICK", model: "Century" },
  { type: "car", year: 2002, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 2002, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 2002, make: "BUICK", model: "Regal" },
  { type: "car", year: 2002, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2002, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 2002, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 2002, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2002, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2002, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2002, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "3 ton" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Avalanche" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Trailblazer" },
  { type: "car", year: 2002, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Prowler" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2002, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2002, make: "DAEWOO", model: "LANOS" },
  { type: "car", year: 2002, make: "DAEWOO", model: "LEGANZA" },
  { type: "car", year: 2002, make: "DAEWOO", model: "NUBIRA" },
  { type: "car", year: 2002, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2002, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2002, make: "DODGE", model: "Caravan" },
  { type: "car", year: 2002, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2002, make: "DODGE", model: "Durango" },
  { type: "car", year: 2002, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 2002, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 2002, make: "DODGE", model: "Neon" },
  { type: "car", year: 2002, make: "DODGE", model: "Ram" },
  { type: "car", year: 2002, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2002, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 2002, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 2002, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2002, make: "DODGE", model: "Viper" },
  { type: "car", year: 2002, make: "FERRARI", model: "360" },
  { type: "car", year: 2002, make: "FERRARI", model: "456M" },
  { type: "car", year: 2002, make: "FERRARI", model: "575M Maranello" },
  { type: "car", year: 2002, make: "FORD", model: "'34" },
  { type: "car", year: 2002, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2002, make: "FORD", model: "E-150" },
  { type: "car", year: 2002, make: "FORD", model: "E-250" },
  { type: "car", year: 2002, make: "FORD", model: "E-350" },
  { type: "car", year: 2002, make: "FORD", model: "E-450" },
  { type: "car", year: 2002, make: "FORD", model: "E-550" },
  { type: "car", year: 2002, make: "FORD", model: "Escape" },
  { type: "car", year: 2002, make: "FORD", model: "Escort" },
  { type: "car", year: 2002, make: "FORD", model: "Excursion" },
  { type: "car", year: 2002, make: "FORD", model: "Expedition" },
  { type: "car", year: 2002, make: "FORD", model: "Explorer" },
  { type: "car", year: 2002, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2002, make: "FORD", model: "F-150" },
  { type: "car", year: 2002, make: "FORD", model: "F-250" },
  { type: "car", year: 2002, make: "FORD", model: "F-350" },
  { type: "car", year: 2002, make: "FORD", model: "F-450" },
  { type: "car", year: 2002, make: "FORD", model: "F-550" },
  { type: "car", year: 2002, make: "FORD", model: "F-800" },
  { type: "car", year: 2002, make: "FORD", model: "Focus" },
  { type: "car", year: 2002, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2002, make: "FORD", model: "Mustang" },
  { type: "car", year: 2002, make: "FORD", model: "Ranger" },
  { type: "car", year: 2002, make: "FORD", model: "Taurus" },
  { type: "car", year: 2002, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 2002, make: "FORD", model: "Windstar" },
  { type: "car", year: 2002, make: "FORD", model: "ZX2" },
  { type: "car", year: 2002, make: "GMC", model: "Envoy" },
  { type: "car", year: 2002, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 2002, make: "GMC", model: "Safari" },
  { type: "car", year: 2002, make: "GMC", model: "Savana" },
  { type: "car", year: 2002, make: "GMC", model: "Sierra" },
  { type: "car", year: 2002, make: "GMC", model: "Sonoma" },
  { type: "car", year: 2002, make: "GMC", model: "Yukon" },
  { type: "car", year: 2002, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2002, make: "HONDA", model: "Accord" },
  { type: "car", year: 2002, make: "HONDA", model: "Civic" },
  { type: "car", year: 2002, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2002, make: "HONDA", model: "Insight" },
  { type: "car", year: 2002, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2002, make: "HONDA", model: "Passport" },
  { type: "car", year: 2002, make: "HONDA", model: "S2000" },
  { type: "car", year: 2002, make: "HUMMER", model: "H1" },
  { type: "car", year: 2002, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2002, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2002, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2002, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2002, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2002, make: "HYUNDAI", model: "XG350" },
  { type: "car", year: 2002, make: "INFINITI", model: "G20" },
  { type: "car", year: 2002, make: "INFINITI", model: "I35" },
  { type: "car", year: 2002, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2002, make: "INFINITI", model: "QX4" },
  { type: "car", year: 2002, make: "ISUZU", model: "Axiom" },
  { type: "car", year: 2002, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 2002, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 2002, make: "ISUZU", model: "VehiCross" },
  { type: "car", year: 2002, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2002, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 2002, make: "JAGUAR", model: "X-Type" },
  { type: "car", year: 2002, make: "JAGUAR", model: "XJ" },
  { type: "car", year: 2002, make: "JAGUAR", model: "XJ8" },
  { type: "car", year: 2002, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2002, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2002, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 2002, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2002, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2002, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2002, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2002, make: "KIA", model: "Optima" },
  { type: "car", year: 2002, make: "KIA", model: "Rio" },
  { type: "car", year: 2002, make: "KIA", model: "Sedona" },
  { type: "car", year: 2002, make: "KIA", model: "Sorento" },
  { type: "car", year: 2002, make: "KIA", model: "Spectra" },
  { type: "car", year: 2002, make: "KIA", model: "Sportage" },
  { type: "car", year: 2002, make: "LAMBORGHINI", model: "147" },
  { type: "car", year: 2002, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2002, make: "LAND ROVER", model: "Freelander" },
  { type: "car", year: 2002, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2002, make: "LEXUS", model: "ES" },
  { type: "car", year: 2002, make: "LEXUS", model: "GS" },
  { type: "car", year: 2002, make: "LEXUS", model: "IS" },
  { type: "car", year: 2002, make: "LEXUS", model: "LS" },
  { type: "car", year: 2002, make: "LEXUS", model: "LX" },
  { type: "car", year: 2002, make: "LEXUS", model: "RX" },
  { type: "car", year: 2002, make: "LEXUS", model: "SC" },
  { type: "car", year: 2002, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2002, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2002, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2002, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2002, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2002, make: "MASERATI", model: "Coupe" },
  { type: "car", year: 2002, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 2002, make: "MAZDA", model: "626" },
  { type: "car", year: 2002, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2002, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 2002, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2002, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2002, make: "MAZDA", model: "Protege" },
  { type: "car", year: 2002, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2002, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2002, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 2002, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2002, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2002, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2002, make: "MERCURY", model: "Villager" },
  { type: "car", year: 2002, make: "MINI", model: "Cooper" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Lancer" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 2002, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2002, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2002, make: "NISSAN", model: "Altra-EV" },
  { type: "car", year: 2002, make: "NISSAN", model: "Armada" },
  { type: "car", year: 2002, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2002, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2002, make: "NISSAN", model: "Murano" },
  { type: "car", year: 2002, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2002, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2002, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2002, make: "NISSAN", model: "Titan" },
  { type: "car", year: 2002, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2002, make: "OLDSMOBILE", model: "Alero" },
  { type: "car", year: 2002, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 2002, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 2002, make: "OLDSMOBILE", model: "Intrigue" },
  { type: "car", year: 2002, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 2002, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2002, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2002, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2002, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2002, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2002, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Aztek" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Montana" },
  { type: "car", year: 2002, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 2002, make: "PORSCHE", model: "911" },
  { type: "car", year: 2002, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2002, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 2002, make: "ROLLS-ROYCE", model: "Park Ward" },
  { type: "car", year: 2002, make: "ROLLS-ROYCE", model: "Silver Seraph" },
  { type: "car", year: 2002, make: "SAAB", model: "9-3" },
  { type: "car", year: 2002, make: "SAAB", model: "9-5" },
  { type: "car", year: 2002, make: "SATURN", model: "LS" },
  { type: "car", year: 2002, make: "SATURN", model: "LS1" },
  { type: "car", year: 2002, make: "SATURN", model: "LS2" },
  { type: "car", year: 2002, make: "SATURN", model: "LW1" },
  { type: "car", year: 2002, make: "SATURN", model: "LW2" },
  { type: "car", year: 2002, make: "SATURN", model: "SC1" },
  { type: "car", year: 2002, make: "SATURN", model: "SC2" },
  { type: "car", year: 2002, make: "SATURN", model: "SL" },
  { type: "car", year: 2002, make: "SATURN", model: "SL1" },
  { type: "car", year: 2002, make: "SATURN", model: "SL2" },
  { type: "car", year: 2002, make: "SATURN", model: "Vue" },
  { type: "car", year: 2002, make: "SMART", model: "smart" },
  { type: "car", year: 2002, make: "SPYKER", model: "C12" },
  { type: "car", year: 2002, make: "SPYKER", model: "C8" },
  { type: "car", year: 2002, make: "SPYKER", model: "D8/D12" },
  { type: "car", year: 2002, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2002, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2002, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2002, make: "SUZUKI", model: "Aerio" },
  { type: "car", year: 2002, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 2002, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2002, make: "SUZUKI", model: "Grand Vitara XL-7" },
  { type: "car", year: 2002, make: "SUZUKI", model: "Vitara" },
  { type: "car", year: 2002, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Echo" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2002, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2002, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2002, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2002, make: "VOLVO", model: "C70" },
  { type: "car", year: 2002, make: "VOLVO", model: "S40" },
  { type: "car", year: 2002, make: "VOLVO", model: "S60" },
  { type: "car", year: 2002, make: "VOLVO", model: "S80" },
  { type: "car", year: 2002, make: "VOLVO", model: "V40" },
  { type: "car", year: 2002, make: "VOLVO", model: "V70" },
  { type: "car", year: 2002, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2001, make: "ACURA", model: "CL" },
  { type: "car", year: 2001, make: "ACURA", model: "Integra" },
  { type: "car", year: 2001, make: "ACURA", model: "MDX" },
  { type: "car", year: 2001, make: "ACURA", model: "NSX" },
  { type: "car", year: 2001, make: "ACURA", model: "RL" },
  { type: "car", year: 2001, make: "ACURA", model: "TL" },
  { type: "car", year: 2001, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2001, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 2001, make: "ASTON MARTIN", model: "Vanquish" },
  { type: "car", year: 2001, make: "AUDI", model: "A4" },
  { type: "car", year: 2001, make: "AUDI", model: "A6" },
  { type: "car", year: 2001, make: "AUDI", model: "A8" },
  { type: "car", year: 2001, make: "AUDI", model: "allroad" },
  { type: "car", year: 2001, make: "AUDI", model: "S4" },
  { type: "car", year: 2001, make: "AUDI", model: "S8" },
  { type: "car", year: 2001, make: "AUDI", model: "TT" },
  { type: "car", year: 2001, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2001, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2001, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2001, make: "BMW", model: "325Ci" },
  { type: "car", year: 2001, make: "BMW", model: "325i" },
  { type: "car", year: 2001, make: "BMW", model: "330Ci" },
  { type: "car", year: 2001, make: "BMW", model: "330i" },
  { type: "car", year: 2001, make: "BMW", model: "525i" },
  { type: "car", year: 2001, make: "BMW", model: "530i" },
  { type: "car", year: 2001, make: "BMW", model: "540i" },
  { type: "car", year: 2001, make: "BMW", model: "740i" },
  { type: "car", year: 2001, make: "BMW", model: "740iL" },
  { type: "car", year: 2001, make: "BMW", model: "750i" },
  { type: "car", year: 2001, make: "BMW", model: "M3" },
  { type: "car", year: 2001, make: "BMW", model: "M3Ci" },
  { type: "car", year: 2001, make: "BMW", model: "M5" },
  { type: "car", year: 2001, make: "BMW", model: "X5" },
  { type: "car", year: 2001, make: "BMW", model: "Z3" },
  { type: "car", year: 2001, make: "BMW", model: "Z8" },
  { type: "car", year: 2001, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2001, make: "BUICK", model: "Century" },
  { type: "car", year: 2001, make: "BUICK", model: "Incomplete" },
  { type: "car", year: 2001, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 2001, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 2001, make: "BUICK", model: "Regal" },
  { type: "car", year: 2001, make: "BUICK", model: "Rendezvous" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Catera" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2001, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "3 ton" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Metro" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2001, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Prowler" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2001, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2001, make: "DAEWOO", model: "LANOS" },
  { type: "car", year: 2001, make: "DAEWOO", model: "LEGANZA" },
  { type: "car", year: 2001, make: "DAEWOO", model: "NUBIRA" },
  { type: "car", year: 2001, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2001, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2001, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2001, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2001, make: "DODGE", model: "Durango" },
  { type: "car", year: 2001, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 2001, make: "DODGE", model: "Neon" },
  { type: "car", year: 2001, make: "DODGE", model: "Ram" },
  { type: "car", year: 2001, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2001, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 2001, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 2001, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2001, make: "DODGE", model: "Viper" },
  { type: "car", year: 2001, make: "FERRARI", model: "360" },
  { type: "car", year: 2001, make: "FERRARI", model: "456M" },
  { type: "car", year: 2001, make: "FERRARI", model: "550 Barchetta" },
  { type: "car", year: 2001, make: "FERRARI", model: "550 Maranello" },
  { type: "car", year: 2001, make: "FORD", model: "'34" },
  { type: "car", year: 2001, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2001, make: "FORD", model: "E-150" },
  { type: "car", year: 2001, make: "FORD", model: "E-250" },
  { type: "car", year: 2001, make: "FORD", model: "E-350" },
  { type: "car", year: 2001, make: "FORD", model: "E-450" },
  { type: "car", year: 2001, make: "FORD", model: "Escape" },
  { type: "car", year: 2001, make: "FORD", model: "Escort" },
  { type: "car", year: 2001, make: "FORD", model: "Excursion" },
  { type: "car", year: 2001, make: "FORD", model: "Expedition" },
  { type: "car", year: 2001, make: "FORD", model: "Explorer" },
  { type: "car", year: 2001, make: "FORD", model: "Explorer Sport Trac" },
  { type: "car", year: 2001, make: "FORD", model: "F-150" },
  { type: "car", year: 2001, make: "FORD", model: "F-250" },
  { type: "car", year: 2001, make: "FORD", model: "F-350" },
  { type: "car", year: 2001, make: "FORD", model: "F-450" },
  { type: "car", year: 2001, make: "FORD", model: "F-550" },
  { type: "car", year: 2001, make: "FORD", model: "F-800" },
  { type: "car", year: 2001, make: "FORD", model: "Focus" },
  { type: "car", year: 2001, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2001, make: "FORD", model: "Mustang" },
  { type: "car", year: 2001, make: "FORD", model: "Ranger" },
  { type: "car", year: 2001, make: "FORD", model: "Taurus" },
  { type: "car", year: 2001, make: "FORD", model: "Windstar" },
  { type: "car", year: 2001, make: "FORD", model: "ZX2" },
  { type: "car", year: 2001, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 2001, make: "GMC", model: "Safari" },
  { type: "car", year: 2001, make: "GMC", model: "Savana" },
  { type: "car", year: 2001, make: "GMC", model: "Sierra" },
  { type: "car", year: 2001, make: "GMC", model: "Sonoma" },
  { type: "car", year: 2001, make: "GMC", model: "Yukon" },
  { type: "car", year: 2001, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2001, make: "HONDA", model: "Accord" },
  { type: "car", year: 2001, make: "HONDA", model: "Civic" },
  { type: "car", year: 2001, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2001, make: "HONDA", model: "Insight" },
  { type: "car", year: 2001, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2001, make: "HONDA", model: "Passport" },
  { type: "car", year: 2001, make: "HONDA", model: "Prelude" },
  { type: "car", year: 2001, make: "HONDA", model: "S2000" },
  { type: "car", year: 2001, make: "HUMMER", model: "H1" },
  { type: "car", year: 2001, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2001, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2001, make: "HYUNDAI", model: "Santa Fe" },
  { type: "car", year: 2001, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2001, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2001, make: "HYUNDAI", model: "XG300" },
  { type: "car", year: 2001, make: "INFINITI", model: "G20" },
  { type: "car", year: 2001, make: "INFINITI", model: "I30" },
  { type: "car", year: 2001, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2001, make: "INFINITI", model: "QX4" },
  { type: "car", year: 2001, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 2001, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 2001, make: "ISUZU", model: "VehiCross" },
  { type: "car", year: 2001, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2001, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 2001, make: "JAGUAR", model: "XJ8" },
  { type: "car", year: 2001, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2001, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2001, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 2001, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2001, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2001, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2001, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2001, make: "KIA", model: "Optima" },
  { type: "car", year: 2001, make: "KIA", model: "Rio" },
  { type: "car", year: 2001, make: "KIA", model: "Sedona" },
  { type: "car", year: 2001, make: "KIA", model: "Sephia" },
  { type: "car", year: 2001, make: "KIA", model: "Sorento" },
  { type: "car", year: 2001, make: "KIA", model: "Spectra" },
  { type: "car", year: 2001, make: "KIA", model: "Sportage" },
  { type: "car", year: 2001, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 2001, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2001, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2001, make: "LEXUS", model: "ES" },
  { type: "car", year: 2001, make: "LEXUS", model: "GS" },
  { type: "car", year: 2001, make: "LEXUS", model: "IS" },
  { type: "car", year: 2001, make: "LEXUS", model: "LS" },
  { type: "car", year: 2001, make: "LEXUS", model: "LX" },
  { type: "car", year: 2001, make: "LEXUS", model: "RX" },
  { type: "car", year: 2001, make: "LEXUS", model: "SC" },
  { type: "car", year: 2001, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2001, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2001, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2001, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2001, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 2001, make: "MAZDA", model: "626" },
  { type: "car", year: 2001, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2001, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 2001, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2001, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2001, make: "MAZDA", model: "Protege" },
  { type: "car", year: 2001, make: "MAZDA", model: "Tribute" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2001, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2001, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 2001, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2001, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2001, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2001, make: "MERCURY", model: "Villager" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 2001, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2001, make: "NISSAN", model: "240SX" },
  { type: "car", year: 2001, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2001, make: "NISSAN", model: "Altra-EV" },
  { type: "car", year: 2001, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2001, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2001, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2001, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2001, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2001, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2001, make: "OLDSMOBILE", model: "Alero" },
  { type: "car", year: 2001, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 2001, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 2001, make: "OLDSMOBILE", model: "Intrigue" },
  { type: "car", year: 2001, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 2001, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2001, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2001, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2001, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2001, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2001, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Aztek" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Montana" },
  { type: "car", year: 2001, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 2001, make: "PORSCHE", model: "911" },
  { type: "car", year: 2001, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2001, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 2001, make: "ROLLS-ROYCE", model: "Park Ward" },
  { type: "car", year: 2001, make: "ROLLS-ROYCE", model: "Silver Seraph" },
  { type: "car", year: 2001, make: "SAAB", model: "9-3" },
  { type: "car", year: 2001, make: "SAAB", model: "9-5" },
  { type: "car", year: 2001, make: "SATURN", model: "LS" },
  { type: "car", year: 2001, make: "SATURN", model: "LS1" },
  { type: "car", year: 2001, make: "SATURN", model: "LS2" },
  { type: "car", year: 2001, make: "SATURN", model: "LW1" },
  { type: "car", year: 2001, make: "SATURN", model: "LW2" },
  { type: "car", year: 2001, make: "SATURN", model: "SC1" },
  { type: "car", year: 2001, make: "SATURN", model: "SC2" },
  { type: "car", year: 2001, make: "SATURN", model: "SL" },
  { type: "car", year: 2001, make: "SATURN", model: "SL1" },
  { type: "car", year: 2001, make: "SATURN", model: "SL2" },
  { type: "car", year: 2001, make: "SATURN", model: "SW1" },
  { type: "car", year: 2001, make: "SATURN", model: "SW2" },
  { type: "car", year: 2001, make: "SMART", model: "smart" },
  { type: "car", year: 2001, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2001, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2001, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2001, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 2001, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2001, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2001, make: "SUZUKI", model: "Vitara" },
  { type: "car", year: 2001, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Echo" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Highlander" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2001, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Prius" },
  { type: "car", year: 2001, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2001, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2001, make: "VOLVO", model: "C70" },
  { type: "car", year: 2001, make: "VOLVO", model: "S40" },
  { type: "car", year: 2001, make: "VOLVO", model: "S60" },
  { type: "car", year: 2001, make: "VOLVO", model: "S80" },
  { type: "car", year: 2001, make: "VOLVO", model: "V40" },
  { type: "car", year: 2001, make: "VOLVO", model: "V70" },
  { type: "car", year: 2001, make: "YUGO", model: "102, GV" },
  { type: "car", year: 2000, make: "ACURA", model: "Integra" },
  { type: "car", year: 2000, make: "ACURA", model: "NSX" },
  { type: "car", year: 2000, make: "ACURA", model: "RL" },
  { type: "car", year: 2000, make: "ACURA", model: "TL" },
  { type: "car", year: 2000, make: "ALFA ROMEO", model: "8C Competizione Spider" },
  { type: "car", year: 2000, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 2000, make: "AUDI", model: "A4" },
  { type: "car", year: 2000, make: "AUDI", model: "A6" },
  { type: "car", year: 2000, make: "AUDI", model: "A8" },
  { type: "car", year: 2000, make: "AUDI", model: "S4" },
  { type: "car", year: 2000, make: "AUDI", model: "TT" },
  { type: "car", year: 2000, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 2000, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 2000, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 2000, make: "BMW", model: "318ti" },
  { type: "car", year: 2000, make: "BMW", model: "323i" },
  { type: "car", year: 2000, make: "BMW", model: "323iC" },
  { type: "car", year: 2000, make: "BMW", model: "323is" },
  { type: "car", year: 2000, make: "BMW", model: "325Ci" },
  { type: "car", year: 2000, make: "BMW", model: "328Ci" },
  { type: "car", year: 2000, make: "BMW", model: "328i" },
  { type: "car", year: 2000, make: "BMW", model: "328iC" },
  { type: "car", year: 2000, make: "BMW", model: "328iS" },
  { type: "car", year: 2000, make: "BMW", model: "528i" },
  { type: "car", year: 2000, make: "BMW", model: "540i" },
  { type: "car", year: 2000, make: "BMW", model: "740i" },
  { type: "car", year: 2000, make: "BMW", model: "740iL" },
  { type: "car", year: 2000, make: "BMW", model: "750Li" },
  { type: "car", year: 2000, make: "BMW", model: "M5" },
  { type: "car", year: 2000, make: "BMW", model: "X5" },
  { type: "car", year: 2000, make: "BMW", model: "Z3" },
  { type: "car", year: 2000, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 2000, make: "BUICK", model: "Century" },
  { type: "car", year: 2000, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 2000, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 2000, make: "BUICK", model: "Regal" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Catera" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 2000, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Metro" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 2000, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "300" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Grand Voyager" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 2000, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 2000, make: "DAEWOO", model: "LANOS" },
  { type: "car", year: 2000, make: "DAEWOO", model: "LEGANZA" },
  { type: "car", year: 2000, make: "DAEWOO", model: "NUBIRA" },
  { type: "car", year: 2000, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 2000, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 2000, make: "DODGE", model: "Avenger" },
  { type: "car", year: 2000, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 2000, make: "DODGE", model: "Dakota" },
  { type: "car", year: 2000, make: "DODGE", model: "Durango" },
  { type: "car", year: 2000, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 2000, make: "DODGE", model: "Neon" },
  { type: "car", year: 2000, make: "DODGE", model: "Ram" },
  { type: "car", year: 2000, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 2000, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 2000, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 2000, make: "DODGE", model: "Stratus" },
  { type: "car", year: 2000, make: "DODGE", model: "Viper" },
  { type: "car", year: 2000, make: "FERRARI", model: "360" },
  { type: "car", year: 2000, make: "FERRARI", model: "456M" },
  { type: "car", year: 2000, make: "FERRARI", model: "550 Maranello" },
  { type: "car", year: 2000, make: "FORD", model: "'34" },
  { type: "car", year: 2000, make: "FORD", model: "Contour" },
  { type: "car", year: 2000, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 2000, make: "FORD", model: "E-150" },
  { type: "car", year: 2000, make: "FORD", model: "E-250" },
  { type: "car", year: 2000, make: "FORD", model: "E-350" },
  { type: "car", year: 2000, make: "FORD", model: "E-450" },
  { type: "car", year: 2000, make: "FORD", model: "Escort" },
  { type: "car", year: 2000, make: "FORD", model: "Excursion" },
  { type: "car", year: 2000, make: "FORD", model: "Expedition" },
  { type: "car", year: 2000, make: "FORD", model: "Explorer" },
  { type: "car", year: 2000, make: "FORD", model: "F-150" },
  { type: "car", year: 2000, make: "FORD", model: "F-250" },
  { type: "car", year: 2000, make: "FORD", model: "F-350" },
  { type: "car", year: 2000, make: "FORD", model: "F-450" },
  { type: "car", year: 2000, make: "FORD", model: "F-550" },
  { type: "car", year: 2000, make: "FORD", model: "F-800" },
  { type: "car", year: 2000, make: "FORD", model: "Focus" },
  { type: "car", year: 2000, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 2000, make: "FORD", model: "Mustang" },
  { type: "car", year: 2000, make: "FORD", model: "Ranger" },
  { type: "car", year: 2000, make: "FORD", model: "Taurus" },
  { type: "car", year: 2000, make: "FORD", model: "Windstar" },
  { type: "car", year: 2000, make: "FORD", model: "ZX2" },
  { type: "car", year: 2000, make: "GMC", model: "Electric Vehicle" },
  { type: "car", year: 2000, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 2000, make: "GMC", model: "Safari" },
  { type: "car", year: 2000, make: "GMC", model: "Savana" },
  { type: "car", year: 2000, make: "GMC", model: "Sierra" },
  { type: "car", year: 2000, make: "GMC", model: "Sonoma" },
  { type: "car", year: 2000, make: "GMC", model: "Suburban" },
  { type: "car", year: 2000, make: "GMC", model: "Yukon" },
  { type: "car", year: 2000, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 2000, make: "HONDA", model: "Accord" },
  { type: "car", year: 2000, make: "HONDA", model: "Civic" },
  { type: "car", year: 2000, make: "HONDA", model: "CR-V" },
  { type: "car", year: 2000, make: "HONDA", model: "Insight" },
  { type: "car", year: 2000, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 2000, make: "HONDA", model: "Passport" },
  { type: "car", year: 2000, make: "HONDA", model: "Prelude" },
  { type: "car", year: 2000, make: "HONDA", model: "S2000" },
  { type: "car", year: 2000, make: "HUMMER", model: "H1" },
  { type: "car", year: 2000, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 2000, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 2000, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 2000, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 2000, make: "INFINITI", model: "G20" },
  { type: "car", year: 2000, make: "INFINITI", model: "I30" },
  { type: "car", year: 2000, make: "INFINITI", model: "Q45" },
  { type: "car", year: 2000, make: "INFINITI", model: "QX4" },
  { type: "car", year: 2000, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 2000, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 2000, make: "ISUZU", model: "VehiCross" },
  { type: "car", year: 2000, make: "JAGUAR", model: "S-Type" },
  { type: "car", year: 2000, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 2000, make: "JAGUAR", model: "XJ8" },
  { type: "car", year: 2000, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 2000, make: "JAGUAR", model: "XK" },
  { type: "car", year: 2000, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 2000, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 2000, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 2000, make: "JEEP", model: "Liberty" },
  { type: "car", year: 2000, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 2000, make: "KIA", model: "Sephia" },
  { type: "car", year: 2000, make: "KIA", model: "Spectra" },
  { type: "car", year: 2000, make: "KIA", model: "Sportage" },
  { type: "car", year: 2000, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 2000, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 2000, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 2000, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 2000, make: "LEXUS", model: "ES" },
  { type: "car", year: 2000, make: "LEXUS", model: "GS" },
  { type: "car", year: 2000, make: "LEXUS", model: "LS" },
  { type: "car", year: 2000, make: "LEXUS", model: "LX" },
  { type: "car", year: 2000, make: "LEXUS", model: "RX" },
  { type: "car", year: 2000, make: "LEXUS", model: "SC" },
  { type: "car", year: 2000, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 2000, make: "LINCOLN", model: "LS" },
  { type: "car", year: 2000, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 2000, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 2000, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 2000, make: "MAZDA", model: "626" },
  { type: "car", year: 2000, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 2000, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 2000, make: "MAZDA", model: "MPV" },
  { type: "car", year: 2000, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 2000, make: "MAZDA", model: "Protege" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 2000, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 2000, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 2000, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 2000, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 2000, make: "MERCURY", model: "Mystique" },
  { type: "car", year: 2000, make: "MERCURY", model: "Sable" },
  { type: "car", year: 2000, make: "MERCURY", model: "Villager" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 2000, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 2000, make: "NISSAN", model: "240SX" },
  { type: "car", year: 2000, make: "NISSAN", model: "Altima" },
  { type: "car", year: 2000, make: "NISSAN", model: "Altra-EV" },
  { type: "car", year: 2000, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 2000, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 2000, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 2000, make: "NISSAN", model: "Quest" },
  { type: "car", year: 2000, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 2000, make: "NISSAN", model: "Xterra" },
  { type: "car", year: 2000, make: "OLDSMOBILE", model: "Alero" },
  { type: "car", year: 2000, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 2000, make: "OLDSMOBILE", model: "Intrigue" },
  { type: "car", year: 2000, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 2000, make: "PEUGEOT", model: "405" },
  { type: "car", year: 2000, make: "PEUGEOT", model: "505" },
  { type: "car", year: 2000, make: "PLYMOUTH", model: "Breeze" },
  { type: "car", year: 2000, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 2000, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 2000, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 2000, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Aztek" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Montana" },
  { type: "car", year: 2000, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 2000, make: "PORSCHE", model: "911" },
  { type: "car", year: 2000, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 2000, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 2000, make: "ROLLS-ROYCE", model: "Silver Seraph" },
  { type: "car", year: 2000, make: "SAAB", model: "9-3" },
  { type: "car", year: 2000, make: "SAAB", model: "9-5" },
  { type: "car", year: 2000, make: "SATURN", model: "LS" },
  { type: "car", year: 2000, make: "SATURN", model: "LS1" },
  { type: "car", year: 2000, make: "SATURN", model: "LS2" },
  { type: "car", year: 2000, make: "SATURN", model: "LW1" },
  { type: "car", year: 2000, make: "SATURN", model: "LW2" },
  { type: "car", year: 2000, make: "SATURN", model: "SC1" },
  { type: "car", year: 2000, make: "SATURN", model: "SC2" },
  { type: "car", year: 2000, make: "SATURN", model: "SL" },
  { type: "car", year: 2000, make: "SATURN", model: "SL1" },
  { type: "car", year: 2000, make: "SATURN", model: "SL2" },
  { type: "car", year: 2000, make: "SATURN", model: "SW1" },
  { type: "car", year: 2000, make: "SATURN", model: "SW2" },
  { type: "car", year: 2000, make: "SMART", model: "smart" },
  { type: "car", year: 2000, make: "SUBARU", model: "Forester" },
  { type: "car", year: 2000, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 2000, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 2000, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 2000, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 2000, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 2000, make: "SUZUKI", model: "Vitara" },
  { type: "car", year: 2000, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Echo" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 2000, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 2000, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Sequoia" },
  { type: "car", year: 2000, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 2000, make: "VOLVO", model: "C70" },
  { type: "car", year: 2000, make: "VOLVO", model: "S40" },
  { type: "car", year: 2000, make: "VOLVO", model: "S70" },
  { type: "car", year: 2000, make: "VOLVO", model: "S80" },
  { type: "car", year: 2000, make: "VOLVO", model: "V40" },
  { type: "car", year: 2000, make: "VOLVO", model: "V70" },
  { type: "car", year: 2000, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1999, make: "ACURA", model: "CL" },
  { type: "car", year: 1999, make: "ACURA", model: "Integra" },
  { type: "car", year: 1999, make: "ACURA", model: "NSX" },
  { type: "car", year: 1999, make: "ACURA", model: "RL" },
  { type: "car", year: 1999, make: "ACURA", model: "SLX" },
  { type: "car", year: 1999, make: "ACURA", model: "TL" },
  { type: "car", year: 1999, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 1999, make: "AUDI", model: "A4" },
  { type: "car", year: 1999, make: "AUDI", model: "A6" },
  { type: "car", year: 1999, make: "AUDI", model: "A8" },
  { type: "car", year: 1999, make: "BENTLEY", model: "Arnage" },
  { type: "car", year: 1999, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 1999, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1999, make: "BMW", model: "318ti" },
  { type: "car", year: 1999, make: "BMW", model: "323i" },
  { type: "car", year: 1999, make: "BMW", model: "323iC" },
  { type: "car", year: 1999, make: "BMW", model: "323is" },
  { type: "car", year: 1999, make: "BMW", model: "328Ci" },
  { type: "car", year: 1999, make: "BMW", model: "328i" },
  { type: "car", year: 1999, make: "BMW", model: "328iC" },
  { type: "car", year: 1999, make: "BMW", model: "328iS" },
  { type: "car", year: 1999, make: "BMW", model: "528i" },
  { type: "car", year: 1999, make: "BMW", model: "540i" },
  { type: "car", year: 1999, make: "BMW", model: "740i" },
  { type: "car", year: 1999, make: "BMW", model: "740iL" },
  { type: "car", year: 1999, make: "BMW", model: "750iL" },
  { type: "car", year: 1999, make: "BMW", model: "M3" },
  { type: "car", year: 1999, make: "BMW", model: "Z3" },
  { type: "car", year: 1999, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 1999, make: "BUICK", model: "Century" },
  { type: "car", year: 1999, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1999, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1999, make: "BUICK", model: "Regal" },
  { type: "car", year: 1999, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Catera" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Escalade" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 1999, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Alero" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Metro" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Silverado" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 1999, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "300" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1999, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 1999, make: "DAEWOO", model: "LANOS" },
  { type: "car", year: 1999, make: "DAEWOO", model: "LEGANZA" },
  { type: "car", year: 1999, make: "DAEWOO", model: "NUBIRA" },
  { type: "car", year: 1999, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1999, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1999, make: "DODGE", model: "Avenger" },
  { type: "car", year: 1999, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 1999, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1999, make: "DODGE", model: "Durango" },
  { type: "car", year: 1999, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1999, make: "DODGE", model: "Neon" },
  { type: "car", year: 1999, make: "DODGE", model: "Ram" },
  { type: "car", year: 1999, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1999, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1999, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1999, make: "DODGE", model: "Stratus" },
  { type: "car", year: 1999, make: "DODGE", model: "Viper" },
  { type: "car", year: 1999, make: "FERRARI", model: "456" },
  { type: "car", year: 1999, make: "FERRARI", model: "550 Maranello" },
  { type: "car", year: 1999, make: "FERRARI", model: "F355" },
  { type: "car", year: 1999, make: "FORD", model: "'34" },
  { type: "car", year: 1999, make: "FORD", model: "Contour" },
  { type: "car", year: 1999, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1999, make: "FORD", model: "E-150" },
  { type: "car", year: 1999, make: "FORD", model: "E-250" },
  { type: "car", year: 1999, make: "FORD", model: "E-350" },
  { type: "car", year: 1999, make: "FORD", model: "E-450" },
  { type: "car", year: 1999, make: "FORD", model: "Escort" },
  { type: "car", year: 1999, make: "FORD", model: "Expedition" },
  { type: "car", year: 1999, make: "FORD", model: "Explorer" },
  { type: "car", year: 1999, make: "FORD", model: "F-150" },
  { type: "car", year: 1999, make: "FORD", model: "F-250" },
  { type: "car", year: 1999, make: "FORD", model: "F-350" },
  { type: "car", year: 1999, make: "FORD", model: "F-450" },
  { type: "car", year: 1999, make: "FORD", model: "F-550" },
  { type: "car", year: 1999, make: "FORD", model: "F-800" },
  { type: "car", year: 1999, make: "FORD", model: "Motorhome Chassis" },
  { type: "car", year: 1999, make: "FORD", model: "Mustang" },
  { type: "car", year: 1999, make: "FORD", model: "Ranger" },
  { type: "car", year: 1999, make: "FORD", model: "Taurus" },
  { type: "car", year: 1999, make: "FORD", model: "Windstar" },
  { type: "car", year: 1999, make: "FORD", model: "ZX2" },
  { type: "car", year: 1999, make: "GMC", model: "Electric Vehicle" },
  { type: "car", year: 1999, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1999, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1999, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1999, make: "GMC", model: "Safari" },
  { type: "car", year: 1999, make: "GMC", model: "Savana" },
  { type: "car", year: 1999, make: "GMC", model: "Sierra" },
  { type: "car", year: 1999, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1999, make: "GMC", model: "Suburban" },
  { type: "car", year: 1999, make: "GMC", model: "Yukon" },
  { type: "car", year: 1999, make: "HONDA", model: "Accord" },
  { type: "car", year: 1999, make: "HONDA", model: "Civic" },
  { type: "car", year: 1999, make: "HONDA", model: "CR-V" },
  { type: "car", year: 1999, make: "HONDA", model: "EV Plus" },
  { type: "car", year: 1999, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 1999, make: "HONDA", model: "Passport" },
  { type: "car", year: 1999, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1999, make: "HUMMER", model: "H1" },
  { type: "car", year: 1999, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 1999, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1999, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1999, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 1999, make: "INFINITI", model: "G20" },
  { type: "car", year: 1999, make: "INFINITI", model: "I30" },
  { type: "car", year: 1999, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1999, make: "INFINITI", model: "QX4" },
  { type: "car", year: 1999, make: "ISUZU", model: "Oasis" },
  { type: "car", year: 1999, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1999, make: "ISUZU", model: "Rodeo/Amigo" },
  { type: "car", year: 1999, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1999, make: "ISUZU", model: "VehiCross" },
  { type: "car", year: 1999, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1999, make: "JAGUAR", model: "XJ8" },
  { type: "car", year: 1999, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 1999, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 1999, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1999, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1999, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1999, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1999, make: "KIA", model: "Sephia" },
  { type: "car", year: 1999, make: "KIA", model: "Sportage" },
  { type: "car", year: 1999, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1999, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1999, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 1999, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1999, make: "LEXUS", model: "ES" },
  { type: "car", year: 1999, make: "LEXUS", model: "GS" },
  { type: "car", year: 1999, make: "LEXUS", model: "LS" },
  { type: "car", year: 1999, make: "LEXUS", model: "LX" },
  { type: "car", year: 1999, make: "LEXUS", model: "RX" },
  { type: "car", year: 1999, make: "LEXUS", model: "SC" },
  { type: "car", year: 1999, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1999, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 1999, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1999, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1999, make: "MAZDA", model: "626" },
  { type: "car", year: 1999, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1999, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 1999, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1999, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1999, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "G-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 1999, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 1999, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1999, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1999, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 1999, make: "MERCURY", model: "Mystique" },
  { type: "car", year: 1999, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1999, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1999, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 1999, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1999, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1999, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1999, make: "NISSAN", model: "Altra-EV" },
  { type: "car", year: 1999, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 1999, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1999, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1999, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1999, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Alero" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Cutlass" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Intrigue" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "LSS" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Regency" },
  { type: "car", year: 1999, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1999, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1999, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1999, make: "PLYMOUTH", model: "Breeze" },
  { type: "car", year: 1999, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1999, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 1999, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 1999, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Montana" },
  { type: "car", year: 1999, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 1999, make: "PORSCHE", model: "911" },
  { type: "car", year: 1999, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 1999, make: "ROLLS-ROYCE", model: "Park Ward" },
  { type: "car", year: 1999, make: "ROLLS-ROYCE", model: "Silver Seraph" },
  { type: "car", year: 1999, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1999, make: "SAAB", model: "9-3" },
  { type: "car", year: 1999, make: "SAAB", model: "9-5" },
  { type: "car", year: 1999, make: "SATURN", model: "SC1" },
  { type: "car", year: 1999, make: "SATURN", model: "SC2" },
  { type: "car", year: 1999, make: "SATURN", model: "SL" },
  { type: "car", year: 1999, make: "SATURN", model: "SL1" },
  { type: "car", year: 1999, make: "SATURN", model: "SL2" },
  { type: "car", year: 1999, make: "SATURN", model: "SW1" },
  { type: "car", year: 1999, make: "SATURN", model: "SW2" },
  { type: "car", year: 1999, make: "SUBARU", model: "Forester" },
  { type: "car", year: 1999, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1999, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1999, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 1999, make: "SUZUKI", model: "Grand Vitara" },
  { type: "car", year: 1999, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1999, make: "SUZUKI", model: "Vitara" },
  { type: "car", year: 1999, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Camry Solara" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1999, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 1999, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1999, make: "VOLVO", model: "C70" },
  { type: "car", year: 1999, make: "VOLVO", model: "S40" },
  { type: "car", year: 1999, make: "VOLVO", model: "S70" },
  { type: "car", year: 1999, make: "VOLVO", model: "S80" },
  { type: "car", year: 1999, make: "VOLVO", model: "V70" },
  { type: "car", year: 1999, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1998, make: "ACURA", model: "CL" },
  { type: "car", year: 1998, make: "ACURA", model: "Integra" },
  { type: "car", year: 1998, make: "ACURA", model: "NSX" },
  { type: "car", year: 1998, make: "ACURA", model: "RL" },
  { type: "car", year: 1998, make: "ACURA", model: "SLX" },
  { type: "car", year: 1998, make: "ACURA", model: "TL" },
  { type: "car", year: 1998, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 1998, make: "AUDI", model: "A4" },
  { type: "car", year: 1998, make: "AUDI", model: "A6" },
  { type: "car", year: 1998, make: "AUDI", model: "A8" },
  { type: "car", year: 1998, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1998, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 1998, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 1998, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1998, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1998, make: "BMW", model: "318i" },
  { type: "car", year: 1998, make: "BMW", model: "323iC" },
  { type: "car", year: 1998, make: "BMW", model: "323is" },
  { type: "car", year: 1998, make: "BMW", model: "328i" },
  { type: "car", year: 1998, make: "BMW", model: "328iC" },
  { type: "car", year: 1998, make: "BMW", model: "328iS" },
  { type: "car", year: 1998, make: "BMW", model: "528i" },
  { type: "car", year: 1998, make: "BMW", model: "540i" },
  { type: "car", year: 1998, make: "BMW", model: "740i" },
  { type: "car", year: 1998, make: "BMW", model: "740iL" },
  { type: "car", year: 1998, make: "BMW", model: "750iL" },
  { type: "car", year: 1998, make: "BMW", model: "M3" },
  { type: "car", year: 1998, make: "BMW", model: "Z3" },
  { type: "car", year: 1998, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 1998, make: "BUICK", model: "Century" },
  { type: "car", year: 1998, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1998, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1998, make: "BUICK", model: "Regal" },
  { type: "car", year: 1998, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1998, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Catera" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Limousine" },
  { type: "car", year: 1998, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Geo Prizm" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Metro" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 1998, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1998, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 1998, make: "DAEWOO", model: "LANOS" },
  { type: "car", year: 1998, make: "DAEWOO", model: "LEGANZA" },
  { type: "car", year: 1998, make: "DAEWOO", model: "NUBIRA" },
  { type: "car", year: 1998, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1998, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1998, make: "DODGE", model: "Avenger" },
  { type: "car", year: 1998, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 1998, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1998, make: "DODGE", model: "Durango" },
  { type: "car", year: 1998, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1998, make: "DODGE", model: "Neon" },
  { type: "car", year: 1998, make: "DODGE", model: "Ram" },
  { type: "car", year: 1998, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1998, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1998, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1998, make: "DODGE", model: "Stratus" },
  { type: "car", year: 1998, make: "DODGE", model: "Viper" },
  { type: "car", year: 1998, make: "FERRARI", model: "456" },
  { type: "car", year: 1998, make: "FERRARI", model: "550 Maranello" },
  { type: "car", year: 1998, make: "FERRARI", model: "F355" },
  { type: "car", year: 1998, make: "FORD", model: "'34" },
  { type: "car", year: 1998, make: "FORD", model: "A8513" },
  { type: "car", year: 1998, make: "FORD", model: "A9513" },
  { type: "car", year: 1998, make: "FORD", model: "A9522" },
  { type: "car", year: 1998, make: "FORD", model: "AT8513" },
  { type: "car", year: 1998, make: "FORD", model: "AT9513" },
  { type: "car", year: 1998, make: "FORD", model: "AT9522" },
  { type: "car", year: 1998, make: "FORD", model: "Contour" },
  { type: "car", year: 1998, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1998, make: "FORD", model: "E-150" },
  { type: "car", year: 1998, make: "FORD", model: "E-250" },
  { type: "car", year: 1998, make: "FORD", model: "E-350" },
  { type: "car", year: 1998, make: "FORD", model: "E-450" },
  { type: "car", year: 1998, make: "FORD", model: "Escort" },
  { type: "car", year: 1998, make: "FORD", model: "Expedition" },
  { type: "car", year: 1998, make: "FORD", model: "Explorer" },
  { type: "car", year: 1998, make: "FORD", model: "F-150" },
  { type: "car", year: 1998, make: "FORD", model: "F-250" },
  { type: "car", year: 1998, make: "FORD", model: "F-700" },
  { type: "car", year: 1998, make: "FORD", model: "F-800" },
  { type: "car", year: 1998, make: "FORD", model: "FT900" },
  { type: "car", year: 1998, make: "FORD", model: "L8501" },
  { type: "car", year: 1998, make: "FORD", model: "L8511" },
  { type: "car", year: 1998, make: "FORD", model: "L8513" },
  { type: "car", year: 1998, make: "FORD", model: "L9501" },
  { type: "car", year: 1998, make: "FORD", model: "L9511" },
  { type: "car", year: 1998, make: "FORD", model: "L9513" },
  { type: "car", year: 1998, make: "FORD", model: "L9522" },
  { type: "car", year: 1998, make: "FORD", model: "LT8501" },
  { type: "car", year: 1998, make: "FORD", model: "LT8511" },
  { type: "car", year: 1998, make: "FORD", model: "LT8513" },
  { type: "car", year: 1998, make: "FORD", model: "LT9501" },
  { type: "car", year: 1998, make: "FORD", model: "LT9511" },
  { type: "car", year: 1998, make: "FORD", model: "LT9513" },
  { type: "car", year: 1998, make: "FORD", model: "LT9522" },
  { type: "car", year: 1998, make: "FORD", model: "Mustang" },
  { type: "car", year: 1998, make: "FORD", model: "Ranger" },
  { type: "car", year: 1998, make: "FORD", model: "Taurus" },
  { type: "car", year: 1998, make: "FORD", model: "Windstar" },
  { type: "car", year: 1998, make: "GMC", model: "Electric Vehicle" },
  { type: "car", year: 1998, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1998, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1998, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1998, make: "GMC", model: "Safari" },
  { type: "car", year: 1998, make: "GMC", model: "Savana" },
  { type: "car", year: 1998, make: "GMC", model: "Sierra" },
  { type: "car", year: 1998, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1998, make: "GMC", model: "Suburban" },
  { type: "car", year: 1998, make: "GMC", model: "Yukon" },
  { type: "car", year: 1998, make: "HONDA", model: "Accord" },
  { type: "car", year: 1998, make: "HONDA", model: "Civic" },
  { type: "car", year: 1998, make: "HONDA", model: "CR-V" },
  { type: "car", year: 1998, make: "HONDA", model: "EV Plus" },
  { type: "car", year: 1998, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 1998, make: "HONDA", model: "Passport" },
  { type: "car", year: 1998, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1998, make: "HUMMER", model: "H1" },
  { type: "car", year: 1998, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 1998, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1998, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1998, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 1998, make: "INFINITI", model: "I30" },
  { type: "car", year: 1998, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1998, make: "INFINITI", model: "QX4" },
  { type: "car", year: 1998, make: "ISUZU", model: "Oasis" },
  { type: "car", year: 1998, make: "ISUZU", model: "Rodeo/Amigo" },
  { type: "car", year: 1998, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1998, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1998, make: "JAGUAR", model: "XJ8" },
  { type: "car", year: 1998, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 1998, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 1998, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1998, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1998, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1998, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1998, make: "KIA", model: "Sephia" },
  { type: "car", year: 1998, make: "KIA", model: "Sportage" },
  { type: "car", year: 1998, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1998, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1998, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 1998, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1998, make: "LEXUS", model: "ES" },
  { type: "car", year: 1998, make: "LEXUS", model: "GS" },
  { type: "car", year: 1998, make: "LEXUS", model: "LS" },
  { type: "car", year: 1998, make: "LEXUS", model: "LX" },
  { type: "car", year: 1998, make: "LEXUS", model: "SC" },
  { type: "car", year: 1998, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1998, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1998, make: "LINCOLN", model: "Navigator" },
  { type: "car", year: 1998, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1998, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1998, make: "MAZDA", model: "626" },
  { type: "car", year: 1998, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1998, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 1998, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1998, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "CL-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "CLK-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 1998, make: "MERCEDES-BENZ", model: "SLK-Class" },
  { type: "car", year: 1998, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1998, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 1998, make: "MERCURY", model: "Mystique" },
  { type: "car", year: 1998, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1998, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1998, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 1998, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1998, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1998, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1998, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1998, make: "NISSAN", model: "Altra" },
  { type: "car", year: 1998, make: "NISSAN", model: "Frontier" },
  { type: "car", year: 1998, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1998, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1998, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1998, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Cutlass" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Intrigue" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "LSS" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Regency" },
  { type: "car", year: 1998, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1998, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1998, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1998, make: "PLYMOUTH", model: "Breeze" },
  { type: "car", year: 1998, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1998, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 1998, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 1998, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1998, make: "PORSCHE", model: "911" },
  { type: "car", year: 1998, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 1998, make: "ROLLS-ROYCE", model: "Park Ward" },
  { type: "car", year: 1998, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1998, make: "ROLLS-ROYCE", model: "Touring Limousine" },
  { type: "car", year: 1998, make: "SAAB", model: "900" },
  { type: "car", year: 1998, make: "SAAB", model: "9000" },
  { type: "car", year: 1998, make: "SATURN", model: "SC1" },
  { type: "car", year: 1998, make: "SATURN", model: "SC2" },
  { type: "car", year: 1998, make: "SATURN", model: "SL" },
  { type: "car", year: 1998, make: "SATURN", model: "SL1" },
  { type: "car", year: 1998, make: "SATURN", model: "SL2" },
  { type: "car", year: 1998, make: "SATURN", model: "SW1" },
  { type: "car", year: 1998, make: "SATURN", model: "SW2" },
  { type: "car", year: 1998, make: "SUBARU", model: "Forester" },
  { type: "car", year: 1998, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1998, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1998, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 1998, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1998, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1998, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1998, make: "SUZUKI", model: "X-90" },
  { type: "car", year: 1998, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1998, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1998, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1998, make: "VOLVO", model: "C70" },
  { type: "car", year: 1998, make: "VOLVO", model: "S70" },
  { type: "car", year: 1998, make: "VOLVO", model: "S90" },
  { type: "car", year: 1998, make: "VOLVO", model: "V70" },
  { type: "car", year: 1998, make: "VOLVO", model: "V90" },
  { type: "car", year: 1998, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1997, make: "ACURA", model: "CL" },
  { type: "car", year: 1997, make: "ACURA", model: "Integra" },
  { type: "car", year: 1997, make: "ACURA", model: "NSX" },
  { type: "car", year: 1997, make: "ACURA", model: "RL" },
  { type: "car", year: 1997, make: "ACURA", model: "SLX" },
  { type: "car", year: 1997, make: "ACURA", model: "TL" },
  { type: "car", year: 1997, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 1997, make: "AUDI", model: "A4" },
  { type: "car", year: 1997, make: "AUDI", model: "A6" },
  { type: "car", year: 1997, make: "AUDI", model: "A8" },
  { type: "car", year: 1997, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1997, make: "AUDI", model: "S6" },
  { type: "car", year: 1997, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 1997, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 1997, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1997, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1997, make: "BMW", model: "318i" },
  { type: "car", year: 1997, make: "BMW", model: "328i" },
  { type: "car", year: 1997, make: "BMW", model: "328iC" },
  { type: "car", year: 1997, make: "BMW", model: "328iS" },
  { type: "car", year: 1997, make: "BMW", model: "528i" },
  { type: "car", year: 1997, make: "BMW", model: "540i" },
  { type: "car", year: 1997, make: "BMW", model: "740i" },
  { type: "car", year: 1997, make: "BMW", model: "740iL" },
  { type: "car", year: 1997, make: "BMW", model: "750iL" },
  { type: "car", year: 1997, make: "BMW", model: "M3" },
  { type: "car", year: 1997, make: "BMW", model: "Z3" },
  { type: "car", year: 1997, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 1997, make: "BUICK", model: "Century" },
  { type: "car", year: 1997, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1997, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1997, make: "BUICK", model: "Regal" },
  { type: "car", year: 1997, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1997, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1997, make: "CADILLAC", model: "Catera" },
  { type: "car", year: 1997, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1997, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1997, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1997, make: "CADILLAC", model: "Hearse" },
  { type: "car", year: 1997, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Express" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 1997, make: "CHEVROLET", model: "Venture" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Stratus" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1997, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 1997, make: "DAEWOO", model: "LANOS" },
  { type: "car", year: 1997, make: "DAEWOO", model: "LEGANZA" },
  { type: "car", year: 1997, make: "DAEWOO", model: "NUBIRA" },
  { type: "car", year: 1997, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1997, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1997, make: "DODGE", model: "Avenger" },
  { type: "car", year: 1997, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 1997, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1997, make: "DODGE", model: "Durango" },
  { type: "car", year: 1997, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1997, make: "DODGE", model: "Neon" },
  { type: "car", year: 1997, make: "DODGE", model: "Ram" },
  { type: "car", year: 1997, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1997, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1997, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1997, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1997, make: "DODGE", model: "Stratus" },
  { type: "car", year: 1997, make: "DODGE", model: "Viper" },
  { type: "car", year: 1997, make: "FERRARI", model: "355 Berlinetta" },
  { type: "car", year: 1997, make: "FERRARI", model: "355 GTS" },
  { type: "car", year: 1997, make: "FERRARI", model: "355 Spider" },
  { type: "car", year: 1997, make: "FERRARI", model: "456" },
  { type: "car", year: 1997, make: "FERRARI", model: "550 Maranello" },
  { type: "car", year: 1997, make: "FORD", model: "'34" },
  { type: "car", year: 1997, make: "FORD", model: "A8513" },
  { type: "car", year: 1997, make: "FORD", model: "A9513" },
  { type: "car", year: 1997, make: "FORD", model: "A9522" },
  { type: "car", year: 1997, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1997, make: "FORD", model: "Aspire" },
  { type: "car", year: 1997, make: "FORD", model: "AT8513" },
  { type: "car", year: 1997, make: "FORD", model: "AT9513" },
  { type: "car", year: 1997, make: "FORD", model: "AT9522" },
  { type: "car", year: 1997, make: "FORD", model: "B800" },
  { type: "car", year: 1997, make: "FORD", model: "CF8000" },
  { type: "car", year: 1997, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1997, make: "FORD", model: "Contour" },
  { type: "car", year: 1997, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1997, make: "FORD", model: "E-150" },
  { type: "car", year: 1997, make: "FORD", model: "E-250" },
  { type: "car", year: 1997, make: "FORD", model: "E-350" },
  { type: "car", year: 1997, make: "FORD", model: "E-450" },
  { type: "car", year: 1997, make: "FORD", model: "Escort" },
  { type: "car", year: 1997, make: "FORD", model: "Expedition" },
  { type: "car", year: 1997, make: "FORD", model: "Explorer" },
  { type: "car", year: 1997, make: "FORD", model: "F-150" },
  { type: "car", year: 1997, make: "FORD", model: "F-250" },
  { type: "car", year: 1997, make: "FORD", model: "F-350" },
  { type: "car", year: 1997, make: "FORD", model: "F-700" },
  { type: "car", year: 1997, make: "FORD", model: "F-800" },
  { type: "car", year: 1997, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1997, make: "FORD", model: "FT900" },
  { type: "car", year: 1997, make: "FORD", model: "L8000" },
  { type: "car", year: 1997, make: "FORD", model: "L8501" },
  { type: "car", year: 1997, make: "FORD", model: "L8513" },
  { type: "car", year: 1997, make: "FORD", model: "L9000" },
  { type: "car", year: 1997, make: "FORD", model: "L9501" },
  { type: "car", year: 1997, make: "FORD", model: "L9513" },
  { type: "car", year: 1997, make: "FORD", model: "LA8000" },
  { type: "car", year: 1997, make: "FORD", model: "LA9000" },
  { type: "car", year: 1997, make: "FORD", model: "LL9000" },
  { type: "car", year: 1997, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1997, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1997, make: "FORD", model: "LN7000" },
  { type: "car", year: 1997, make: "FORD", model: "LN8000" },
  { type: "car", year: 1997, make: "FORD", model: "LN9000" },
  { type: "car", year: 1997, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1997, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1997, make: "FORD", model: "LS8000" },
  { type: "car", year: 1997, make: "FORD", model: "LS9000" },
  { type: "car", year: 1997, make: "FORD", model: "LT8000" },
  { type: "car", year: 1997, make: "FORD", model: "LT8501" },
  { type: "car", year: 1997, make: "FORD", model: "LT8513" },
  { type: "car", year: 1997, make: "FORD", model: "LT9000" },
  { type: "car", year: 1997, make: "FORD", model: "LT9501" },
  { type: "car", year: 1997, make: "FORD", model: "LT9513" },
  { type: "car", year: 1997, make: "FORD", model: "LT9522" },
  { type: "car", year: 1997, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1997, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1997, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1997, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1997, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1997, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1997, make: "FORD", model: "Mustang" },
  { type: "car", year: 1997, make: "FORD", model: "P700" },
  { type: "car", year: 1997, make: "FORD", model: "P800" },
  { type: "car", year: 1997, make: "FORD", model: "Probe" },
  { type: "car", year: 1997, make: "FORD", model: "Ranger" },
  { type: "car", year: 1997, make: "FORD", model: "Taurus" },
  { type: "car", year: 1997, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1997, make: "FORD", model: "Windstar" },
  { type: "car", year: 1997, make: "GEO", model: "Metro" },
  { type: "car", year: 1997, make: "GEO", model: "Prizm" },
  { type: "car", year: 1997, make: "GMC", model: "Electric Vehicle" },
  { type: "car", year: 1997, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1997, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1997, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1997, make: "GMC", model: "Safari" },
  { type: "car", year: 1997, make: "GMC", model: "Savana" },
  { type: "car", year: 1997, make: "GMC", model: "Sierra" },
  { type: "car", year: 1997, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1997, make: "GMC", model: "Suburban" },
  { type: "car", year: 1997, make: "GMC", model: "Yukon" },
  { type: "car", year: 1997, make: "HONDA", model: "Accord" },
  { type: "car", year: 1997, make: "HONDA", model: "Civic" },
  { type: "car", year: 1997, make: "HONDA", model: "CR-V" },
  { type: "car", year: 1997, make: "HONDA", model: "del Sol" },
  { type: "car", year: 1997, make: "HONDA", model: "EV Plus" },
  { type: "car", year: 1997, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 1997, make: "HONDA", model: "Passport" },
  { type: "car", year: 1997, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1997, make: "HUMMER", model: "H1" },
  { type: "car", year: 1997, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 1997, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1997, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1997, make: "HYUNDAI", model: "Tiburon" },
  { type: "car", year: 1997, make: "INFINITI", model: "I30" },
  { type: "car", year: 1997, make: "INFINITI", model: "J30" },
  { type: "car", year: 1997, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1997, make: "INFINITI", model: "QX4" },
  { type: "car", year: 1997, make: "ISUZU", model: "Oasis" },
  { type: "car", year: 1997, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1997, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1997, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1997, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1997, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1997, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 1997, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1997, make: "JAGUAR", model: "XK8" },
  { type: "car", year: 1997, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1997, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1997, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1997, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1997, make: "KIA", model: "Sephia" },
  { type: "car", year: 1997, make: "KIA", model: "Sportage" },
  { type: "car", year: 1997, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1997, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1997, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 1997, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 1997, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1997, make: "LEXUS", model: "ES" },
  { type: "car", year: 1997, make: "LEXUS", model: "GS" },
  { type: "car", year: 1997, make: "LEXUS", model: "LS" },
  { type: "car", year: 1997, make: "LEXUS", model: "LX" },
  { type: "car", year: 1997, make: "LEXUS", model: "SC" },
  { type: "car", year: 1997, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1997, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1997, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1997, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1997, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1997, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1997, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1997, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1997, make: "MAZDA", model: "626" },
  { type: "car", year: 1997, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1997, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 1997, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1997, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1997, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1997, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1997, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 1997, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 1997, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 1997, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 1997, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 1997, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1997, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1997, make: "MERCURY", model: "Mountaineer" },
  { type: "car", year: 1997, make: "MERCURY", model: "Mystique" },
  { type: "car", year: 1997, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1997, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1997, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 1997, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1997, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1997, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1997, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1997, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1997, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1997, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1997, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1997, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Cutlass" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "LSS" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Regency" },
  { type: "car", year: 1997, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1997, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1997, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1997, make: "PLYMOUTH", model: "Breeze" },
  { type: "car", year: 1997, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1997, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 1997, make: "PLYMOUTH", model: "Prowler" },
  { type: "car", year: 1997, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 1997, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1997, make: "PORSCHE", model: "911" },
  { type: "car", year: 1997, make: "PORSCHE", model: "Boxster" },
  { type: "car", year: 1997, make: "ROLLS-ROYCE", model: "Silver Dawn" },
  { type: "car", year: 1997, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1997, make: "ROLLS-ROYCE", model: "Touring Limousine" },
  { type: "car", year: 1997, make: "SAAB", model: "900" },
  { type: "car", year: 1997, make: "SAAB", model: "9000" },
  { type: "car", year: 1997, make: "SATURN", model: "SC1" },
  { type: "car", year: 1997, make: "SATURN", model: "SC2" },
  { type: "car", year: 1997, make: "SATURN", model: "SL1" },
  { type: "car", year: 1997, make: "SATURN", model: "SL2" },
  { type: "car", year: 1997, make: "SATURN", model: "SW1" },
  { type: "car", year: 1997, make: "SATURN", model: "SW2" },
  { type: "car", year: 1997, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1997, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1997, make: "SUBARU", model: "SVX" },
  { type: "car", year: 1997, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 1997, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1997, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1997, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1997, make: "SUZUKI", model: "X-90" },
  { type: "car", year: 1997, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1997, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1997, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1997, make: "VOLVO", model: "850 Series" },
  { type: "car", year: 1997, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1997, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1996, make: "ACURA", model: "CL" },
  { type: "car", year: 1996, make: "ACURA", model: "Integra" },
  { type: "car", year: 1996, make: "ACURA", model: "NSX" },
  { type: "car", year: 1996, make: "ACURA", model: "RL" },
  { type: "car", year: 1996, make: "ACURA", model: "SLX" },
  { type: "car", year: 1996, make: "ACURA", model: "TL" },
  { type: "car", year: 1996, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 1996, make: "AUDI", model: "A4" },
  { type: "car", year: 1996, make: "AUDI", model: "A6" },
  { type: "car", year: 1996, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1996, make: "AUDI", model: "S6" },
  { type: "car", year: 1996, make: "BENTLEY", model: "Azure" },
  { type: "car", year: 1996, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 1996, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1996, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1996, make: "BMW", model: "318i" },
  { type: "car", year: 1996, make: "BMW", model: "318iC" },
  { type: "car", year: 1996, make: "BMW", model: "318iS" },
  { type: "car", year: 1996, make: "BMW", model: "318ti" },
  { type: "car", year: 1996, make: "BMW", model: "328i" },
  { type: "car", year: 1996, make: "BMW", model: "328iC" },
  { type: "car", year: 1996, make: "BMW", model: "328iS" },
  { type: "car", year: 1996, make: "BMW", model: "740iL" },
  { type: "car", year: 1996, make: "BMW", model: "750iL" },
  { type: "car", year: 1996, make: "BMW", model: "840Ci" },
  { type: "car", year: 1996, make: "BMW", model: "850Ci" },
  { type: "car", year: 1996, make: "BMW", model: "M3" },
  { type: "car", year: 1996, make: "BMW", model: "Z3" },
  { type: "car", year: 1996, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 1996, make: "BUICK", model: "Century" },
  { type: "car", year: 1996, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1996, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1996, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1996, make: "BUICK", model: "Regal" },
  { type: "car", year: 1996, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1996, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1996, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1996, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1996, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1996, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1996, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1996, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 1996, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Stratus" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1996, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 1996, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1996, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1996, make: "DODGE", model: "Avenger" },
  { type: "car", year: 1996, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 1996, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1996, make: "DODGE", model: "Durango" },
  { type: "car", year: 1996, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1996, make: "DODGE", model: "Neon" },
  { type: "car", year: 1996, make: "DODGE", model: "Ram" },
  { type: "car", year: 1996, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1996, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1996, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1996, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1996, make: "DODGE", model: "Stealth" },
  { type: "car", year: 1996, make: "DODGE", model: "Stratus" },
  { type: "car", year: 1996, make: "DODGE", model: "Viper" },
  { type: "car", year: 1996, make: "FERRARI", model: "456" },
  { type: "car", year: 1996, make: "FERRARI", model: "F355" },
  { type: "car", year: 1996, make: "FERRARI", model: "F50" },
  { type: "car", year: 1996, make: "FORD", model: "'34" },
  { type: "car", year: 1996, make: "FORD", model: "A8513" },
  { type: "car", year: 1996, make: "FORD", model: "A9513" },
  { type: "car", year: 1996, make: "FORD", model: "A9522" },
  { type: "car", year: 1996, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1996, make: "FORD", model: "Aspire" },
  { type: "car", year: 1996, make: "FORD", model: "AT8513" },
  { type: "car", year: 1996, make: "FORD", model: "AT9513" },
  { type: "car", year: 1996, make: "FORD", model: "AT9522" },
  { type: "car", year: 1996, make: "FORD", model: "B800" },
  { type: "car", year: 1996, make: "FORD", model: "Bronco" },
  { type: "car", year: 1996, make: "FORD", model: "CF7000" },
  { type: "car", year: 1996, make: "FORD", model: "CF8000" },
  { type: "car", year: 1996, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1996, make: "FORD", model: "Contour" },
  { type: "car", year: 1996, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1996, make: "FORD", model: "E-150" },
  { type: "car", year: 1996, make: "FORD", model: "E-250" },
  { type: "car", year: 1996, make: "FORD", model: "E-350" },
  { type: "car", year: 1996, make: "FORD", model: "E-450" },
  { type: "car", year: 1996, make: "FORD", model: "Escort" },
  { type: "car", year: 1996, make: "FORD", model: "Explorer" },
  { type: "car", year: 1996, make: "FORD", model: "F-150" },
  { type: "car", year: 1996, make: "FORD", model: "F-250" },
  { type: "car", year: 1996, make: "FORD", model: "F-350" },
  { type: "car", year: 1996, make: "FORD", model: "F-700" },
  { type: "car", year: 1996, make: "FORD", model: "F-800" },
  { type: "car", year: 1996, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1996, make: "FORD", model: "FT900" },
  { type: "car", year: 1996, make: "FORD", model: "L8000" },
  { type: "car", year: 1996, make: "FORD", model: "L8513" },
  { type: "car", year: 1996, make: "FORD", model: "L9000" },
  { type: "car", year: 1996, make: "FORD", model: "L9513" },
  { type: "car", year: 1996, make: "FORD", model: "LA8000" },
  { type: "car", year: 1996, make: "FORD", model: "LA9000" },
  { type: "car", year: 1996, make: "FORD", model: "LL9000" },
  { type: "car", year: 1996, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1996, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1996, make: "FORD", model: "LN7000" },
  { type: "car", year: 1996, make: "FORD", model: "LN8000" },
  { type: "car", year: 1996, make: "FORD", model: "LN9000" },
  { type: "car", year: 1996, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1996, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1996, make: "FORD", model: "LS8000" },
  { type: "car", year: 1996, make: "FORD", model: "LS9000" },
  { type: "car", year: 1996, make: "FORD", model: "LT8000" },
  { type: "car", year: 1996, make: "FORD", model: "LT8501" },
  { type: "car", year: 1996, make: "FORD", model: "LT8513" },
  { type: "car", year: 1996, make: "FORD", model: "LT9000" },
  { type: "car", year: 1996, make: "FORD", model: "LT9501" },
  { type: "car", year: 1996, make: "FORD", model: "LT9513" },
  { type: "car", year: 1996, make: "FORD", model: "LT9522" },
  { type: "car", year: 1996, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1996, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1996, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1996, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1996, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1996, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1996, make: "FORD", model: "Mustang" },
  { type: "car", year: 1996, make: "FORD", model: "P700" },
  { type: "car", year: 1996, make: "FORD", model: "P800" },
  { type: "car", year: 1996, make: "FORD", model: "Probe" },
  { type: "car", year: 1996, make: "FORD", model: "Ranger" },
  { type: "car", year: 1996, make: "FORD", model: "Taurus" },
  { type: "car", year: 1996, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1996, make: "FORD", model: "Windstar" },
  { type: "car", year: 1996, make: "GEO", model: "Metro" },
  { type: "car", year: 1996, make: "GEO", model: "Prizm" },
  { type: "car", year: 1996, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1996, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1996, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1996, make: "GMC", model: "Rally" },
  { type: "car", year: 1996, make: "GMC", model: "Safari" },
  { type: "car", year: 1996, make: "GMC", model: "Savana" },
  { type: "car", year: 1996, make: "GMC", model: "Sierra" },
  { type: "car", year: 1996, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1996, make: "GMC", model: "Suburban" },
  { type: "car", year: 1996, make: "GMC", model: "Yukon" },
  { type: "car", year: 1996, make: "HONDA", model: "Accord" },
  { type: "car", year: 1996, make: "HONDA", model: "Civic" },
  { type: "car", year: 1996, make: "HONDA", model: "del Sol" },
  { type: "car", year: 1996, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 1996, make: "HONDA", model: "Passport" },
  { type: "car", year: 1996, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1996, make: "HUMMER", model: "H1" },
  { type: "car", year: 1996, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 1996, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1996, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1996, make: "INFINITI", model: "G20" },
  { type: "car", year: 1996, make: "INFINITI", model: "I30" },
  { type: "car", year: 1996, make: "INFINITI", model: "J30" },
  { type: "car", year: 1996, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1996, make: "ISUZU", model: "Oasis" },
  { type: "car", year: 1996, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1996, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1996, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1996, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1996, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1996, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 1996, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1996, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1996, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1996, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1996, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1996, make: "KIA", model: "Sephia" },
  { type: "car", year: 1996, make: "KIA", model: "Sportage" },
  { type: "car", year: 1996, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1996, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1996, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 1996, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1996, make: "LEXUS", model: "ES" },
  { type: "car", year: 1996, make: "LEXUS", model: "GS" },
  { type: "car", year: 1996, make: "LEXUS", model: "LS" },
  { type: "car", year: 1996, make: "LEXUS", model: "LX" },
  { type: "car", year: 1996, make: "LEXUS", model: "SC" },
  { type: "car", year: 1996, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1996, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1996, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1996, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1996, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1996, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1996, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1996, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1996, make: "MAZDA", model: "626" },
  { type: "car", year: 1996, make: "MAZDA", model: "929" },
  { type: "car", year: 1996, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1996, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 1996, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1996, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1996, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1996, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1996, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1996, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1996, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 1996, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 1996, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 1996, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 1996, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 1996, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1996, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1996, make: "MERCURY", model: "Mystique" },
  { type: "car", year: 1996, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1996, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1996, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Expo" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1996, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1996, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1996, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1996, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1996, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1996, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1996, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1996, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1996, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1996, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "LSS" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1996, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1996, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1996, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1996, make: "PLYMOUTH", model: "Breeze" },
  { type: "car", year: 1996, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1996, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 1996, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Sunfire" },
  { type: "car", year: 1996, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1996, make: "PORSCHE", model: "911" },
  { type: "car", year: 1996, make: "ROLLS-ROYCE", model: "Silver Dawn" },
  { type: "car", year: 1996, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1996, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1996, make: "ROLLS-ROYCE", model: "Touring Limousine" },
  { type: "car", year: 1996, make: "SAAB", model: "900" },
  { type: "car", year: 1996, make: "SAAB", model: "9000" },
  { type: "car", year: 1996, make: "SATURN", model: "SC1" },
  { type: "car", year: 1996, make: "SATURN", model: "SC2" },
  { type: "car", year: 1996, make: "SATURN", model: "SL" },
  { type: "car", year: 1996, make: "SATURN", model: "SL1" },
  { type: "car", year: 1996, make: "SATURN", model: "SL2" },
  { type: "car", year: 1996, make: "SATURN", model: "SW1" },
  { type: "car", year: 1996, make: "SATURN", model: "SW2" },
  { type: "car", year: 1996, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1996, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1996, make: "SUBARU", model: "SVX" },
  { type: "car", year: 1996, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 1996, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1996, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1996, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1996, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1996, make: "SUZUKI", model: "X-90" },
  { type: "car", year: 1996, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1996, make: "TOYOTA", model: "RAV4" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1996, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1996, make: "VOLVO", model: "850 Series" },
  { type: "car", year: 1996, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1996, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1995, make: "ACURA", model: "CL" },
  { type: "car", year: 1995, make: "ACURA", model: "Integra" },
  { type: "car", year: 1995, make: "ACURA", model: "Legend" },
  { type: "car", year: 1995, make: "ACURA", model: "NSX" },
  { type: "car", year: 1995, make: "ACURA", model: "RL" },
  { type: "car", year: 1995, make: "ACURA", model: "TL" },
  { type: "car", year: 1995, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1995, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 1995, make: "AUDI", model: "90" },
  { type: "car", year: 1995, make: "AUDI", model: "A6" },
  { type: "car", year: 1995, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1995, make: "AUDI", model: "S6" },
  { type: "car", year: 1995, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 1995, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1995, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1995, make: "BMW", model: "318i" },
  { type: "car", year: 1995, make: "BMW", model: "318iC" },
  { type: "car", year: 1995, make: "BMW", model: "318iS" },
  { type: "car", year: 1995, make: "BMW", model: "318ti" },
  { type: "car", year: 1995, make: "BMW", model: "325i" },
  { type: "car", year: 1995, make: "BMW", model: "325iC" },
  { type: "car", year: 1995, make: "BMW", model: "325iS" },
  { type: "car", year: 1995, make: "BMW", model: "525i" },
  { type: "car", year: 1995, make: "BMW", model: "530i" },
  { type: "car", year: 1995, make: "BMW", model: "540i" },
  { type: "car", year: 1995, make: "BMW", model: "740i" },
  { type: "car", year: 1995, make: "BMW", model: "740iL" },
  { type: "car", year: 1995, make: "BMW", model: "750iL" },
  { type: "car", year: 1995, make: "BMW", model: "840Ci" },
  { type: "car", year: 1995, make: "BMW", model: "850Ci" },
  { type: "car", year: 1995, make: "BMW", model: "850CSi" },
  { type: "car", year: 1995, make: "BMW", model: "M3" },
  { type: "car", year: 1995, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 1995, make: "BUICK", model: "Century" },
  { type: "car", year: 1995, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1995, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1995, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1995, make: "BUICK", model: "Regal" },
  { type: "car", year: 1995, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1995, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1995, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1995, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1995, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1995, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1995, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1995, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Hearse/Limo" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Tahoe" },
  { type: "car", year: 1995, make: "CHEVROLET", model: "Tracker" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Cirrus" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Concorde/LHS" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Neon" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "PT Cruiser" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Sebring" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Stratus" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1995, make: "CHRYSLER", model: "Voyager" },
  { type: "car", year: 1995, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1995, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1995, make: "DODGE", model: "Avenger" },
  { type: "car", year: 1995, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1995, make: "DODGE", model: "Caravan/Grand Caravan" },
  { type: "car", year: 1995, make: "DODGE", model: "Colt" },
  { type: "car", year: 1995, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1995, make: "DODGE", model: "Durango" },
  { type: "car", year: 1995, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1995, make: "DODGE", model: "Neon" },
  { type: "car", year: 1995, make: "DODGE", model: "Ram" },
  { type: "car", year: 1995, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1995, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1995, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1995, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1995, make: "DODGE", model: "Stealth" },
  { type: "car", year: 1995, make: "DODGE", model: "Stratus" },
  { type: "car", year: 1995, make: "DODGE", model: "Viper" },
  { type: "car", year: 1995, make: "FERRARI", model: "348 Spider" },
  { type: "car", year: 1995, make: "FERRARI", model: "348 tb" },
  { type: "car", year: 1995, make: "FERRARI", model: "348 ts" },
  { type: "car", year: 1995, make: "FERRARI", model: "355 Berlinetta" },
  { type: "car", year: 1995, make: "FERRARI", model: "355 GTS" },
  { type: "car", year: 1995, make: "FERRARI", model: "355 Spider" },
  { type: "car", year: 1995, make: "FERRARI", model: "456" },
  { type: "car", year: 1995, make: "FERRARI", model: "512 TR" },
  { type: "car", year: 1995, make: "FORD", model: "'34" },
  { type: "car", year: 1995, make: "FORD", model: "A8513" },
  { type: "car", year: 1995, make: "FORD", model: "A9513" },
  { type: "car", year: 1995, make: "FORD", model: "A9522" },
  { type: "car", year: 1995, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1995, make: "FORD", model: "Aspire" },
  { type: "car", year: 1995, make: "FORD", model: "AT8513" },
  { type: "car", year: 1995, make: "FORD", model: "AT9513" },
  { type: "car", year: 1995, make: "FORD", model: "AT9522" },
  { type: "car", year: 1995, make: "FORD", model: "B800" },
  { type: "car", year: 1995, make: "FORD", model: "Bronco" },
  { type: "car", year: 1995, make: "FORD", model: "CF7000" },
  { type: "car", year: 1995, make: "FORD", model: "CF8000" },
  { type: "car", year: 1995, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1995, make: "FORD", model: "Contour" },
  { type: "car", year: 1995, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1995, make: "FORD", model: "E-150" },
  { type: "car", year: 1995, make: "FORD", model: "E-250" },
  { type: "car", year: 1995, make: "FORD", model: "E-350" },
  { type: "car", year: 1995, make: "FORD", model: "E-450" },
  { type: "car", year: 1995, make: "FORD", model: "Escort" },
  { type: "car", year: 1995, make: "FORD", model: "Explorer" },
  { type: "car", year: 1995, make: "FORD", model: "F-150" },
  { type: "car", year: 1995, make: "FORD", model: "F-250" },
  { type: "car", year: 1995, make: "FORD", model: "F-350" },
  { type: "car", year: 1995, make: "FORD", model: "F-700" },
  { type: "car", year: 1995, make: "FORD", model: "F-800" },
  { type: "car", year: 1995, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1995, make: "FORD", model: "FT900" },
  { type: "car", year: 1995, make: "FORD", model: "L8000" },
  { type: "car", year: 1995, make: "FORD", model: "L8513" },
  { type: "car", year: 1995, make: "FORD", model: "L9000" },
  { type: "car", year: 1995, make: "FORD", model: "L9513" },
  { type: "car", year: 1995, make: "FORD", model: "LA8000" },
  { type: "car", year: 1995, make: "FORD", model: "LA9000" },
  { type: "car", year: 1995, make: "FORD", model: "LL9000" },
  { type: "car", year: 1995, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1995, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1995, make: "FORD", model: "LN7000" },
  { type: "car", year: 1995, make: "FORD", model: "LN8000" },
  { type: "car", year: 1995, make: "FORD", model: "LN9000" },
  { type: "car", year: 1995, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1995, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1995, make: "FORD", model: "LS8000" },
  { type: "car", year: 1995, make: "FORD", model: "LS9000" },
  { type: "car", year: 1995, make: "FORD", model: "LT8000" },
  { type: "car", year: 1995, make: "FORD", model: "LT8501" },
  { type: "car", year: 1995, make: "FORD", model: "LT8513" },
  { type: "car", year: 1995, make: "FORD", model: "LT9000" },
  { type: "car", year: 1995, make: "FORD", model: "LT9501" },
  { type: "car", year: 1995, make: "FORD", model: "LT9513" },
  { type: "car", year: 1995, make: "FORD", model: "LT9522" },
  { type: "car", year: 1995, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1995, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1995, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1995, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1995, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1995, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1995, make: "FORD", model: "Mustang" },
  { type: "car", year: 1995, make: "FORD", model: "P700" },
  { type: "car", year: 1995, make: "FORD", model: "P800" },
  { type: "car", year: 1995, make: "FORD", model: "Probe" },
  { type: "car", year: 1995, make: "FORD", model: "Ranger" },
  { type: "car", year: 1995, make: "FORD", model: "Taurus" },
  { type: "car", year: 1995, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1995, make: "FORD", model: "Windstar" },
  { type: "car", year: 1995, make: "GEO", model: "Metro" },
  { type: "car", year: 1995, make: "GEO", model: "Prizm" },
  { type: "car", year: 1995, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1995, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1995, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1995, make: "GMC", model: "Rally" },
  { type: "car", year: 1995, make: "GMC", model: "Safari" },
  { type: "car", year: 1995, make: "GMC", model: "Sierra" },
  { type: "car", year: 1995, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1995, make: "GMC", model: "Suburban" },
  { type: "car", year: 1995, make: "GMC", model: "Yukon" },
  { type: "car", year: 1995, make: "GMC", model: "Yukon XL" },
  { type: "car", year: 1995, make: "HONDA", model: "Accord" },
  { type: "car", year: 1995, make: "HONDA", model: "Civic" },
  { type: "car", year: 1995, make: "HONDA", model: "del Sol" },
  { type: "car", year: 1995, make: "HONDA", model: "Odyssey" },
  { type: "car", year: 1995, make: "HONDA", model: "Passport" },
  { type: "car", year: 1995, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1995, make: "HUMMER", model: "H1" },
  { type: "car", year: 1995, make: "HYUNDAI", model: "Accent" },
  { type: "car", year: 1995, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1995, make: "HYUNDAI", model: "Scoupe" },
  { type: "car", year: 1995, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1995, make: "INFINITI", model: "G20" },
  { type: "car", year: 1995, make: "INFINITI", model: "J30" },
  { type: "car", year: 1995, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1995, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1995, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1995, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1995, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1995, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1995, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1995, make: "JAGUAR", model: "XJR" },
  { type: "car", year: 1995, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1995, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1995, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1995, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1995, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1995, make: "KIA", model: "Sephia" },
  { type: "car", year: 1995, make: "KIA", model: "Sportage" },
  { type: "car", year: 1995, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1995, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1995, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 1995, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 1995, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1995, make: "LEXUS", model: "ES" },
  { type: "car", year: 1995, make: "LEXUS", model: "GS" },
  { type: "car", year: 1995, make: "LEXUS", model: "LS" },
  { type: "car", year: 1995, make: "LEXUS", model: "SC" },
  { type: "car", year: 1995, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1995, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1995, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1995, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1995, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1995, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1995, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1995, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1995, make: "MAZDA", model: "626" },
  { type: "car", year: 1995, make: "MAZDA", model: "929" },
  { type: "car", year: 1995, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1995, make: "MAZDA", model: "Millenia" },
  { type: "car", year: 1995, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1995, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1995, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1995, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1995, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1995, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 1995, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 1995, make: "MERCEDES-BENZ", model: "M-Class" },
  { type: "car", year: 1995, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 1995, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 1995, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1995, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1995, make: "MERCURY", model: "Mystique" },
  { type: "car", year: 1995, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1995, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1995, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Expo" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1995, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1995, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1995, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1995, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1995, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1995, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1995, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1995, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1995, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1995, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1995, make: "NISSAN", model: "Sentra Classic" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Aurora" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1995, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1995, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1995, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1995, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1995, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1995, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 1995, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1995, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1995, make: "PORSCHE", model: "911" },
  { type: "car", year: 1995, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1995, make: "ROLLS-ROYCE", model: "Flying Spur" },
  { type: "car", year: 1995, make: "ROLLS-ROYCE", model: "Silver Dawn" },
  { type: "car", year: 1995, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1995, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1995, make: "ROLLS-ROYCE", model: "Touring Limousine" },
  { type: "car", year: 1995, make: "SAAB", model: "900" },
  { type: "car", year: 1995, make: "SAAB", model: "9000" },
  { type: "car", year: 1995, make: "SATURN", model: "SC1" },
  { type: "car", year: 1995, make: "SATURN", model: "SC2" },
  { type: "car", year: 1995, make: "SATURN", model: "SL" },
  { type: "car", year: 1995, make: "SATURN", model: "SL1" },
  { type: "car", year: 1995, make: "SATURN", model: "SL2" },
  { type: "car", year: 1995, make: "SATURN", model: "SW1" },
  { type: "car", year: 1995, make: "SATURN", model: "SW2" },
  { type: "car", year: 1995, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1995, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1995, make: "SUBARU", model: "SVX" },
  { type: "car", year: 1995, make: "SUZUKI", model: "Esteem" },
  { type: "car", year: 1995, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1995, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1995, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1995, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1995, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Avalon" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1995, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Sienna" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1995, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1995, make: "VOLVO", model: "850 Series" },
  { type: "car", year: 1995, make: "VOLVO", model: "940 Series" },
  { type: "car", year: 1995, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1995, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1994, make: "ACURA", model: "CL" },
  { type: "car", year: 1994, make: "ACURA", model: "Integra" },
  { type: "car", year: 1994, make: "ACURA", model: "Legend" },
  { type: "car", year: 1994, make: "ACURA", model: "NSX" },
  { type: "car", year: 1994, make: "ACURA", model: "RL" },
  { type: "car", year: 1994, make: "ACURA", model: "TL" },
  { type: "car", year: 1994, make: "ACURA", model: "Vigor" },
  { type: "car", year: 1994, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1994, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1994, make: "ASTON MARTIN", model: "DB7" },
  { type: "car", year: 1994, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1994, make: "ASTON MARTIN", model: "Virage" },
  { type: "car", year: 1994, make: "AUDI", model: "100" },
  { type: "car", year: 1994, make: "AUDI", model: "90" },
  { type: "car", year: 1994, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1994, make: "AUDI", model: "S4" },
  { type: "car", year: 1994, make: "AUDI", model: "V8" },
  { type: "car", year: 1994, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 1994, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1994, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1994, make: "BMW", model: "318i" },
  { type: "car", year: 1994, make: "BMW", model: "318iC" },
  { type: "car", year: 1994, make: "BMW", model: "318iS" },
  { type: "car", year: 1994, make: "BMW", model: "318ti" },
  { type: "car", year: 1994, make: "BMW", model: "325i" },
  { type: "car", year: 1994, make: "BMW", model: "325iC" },
  { type: "car", year: 1994, make: "BMW", model: "325iS" },
  { type: "car", year: 1994, make: "BMW", model: "525i" },
  { type: "car", year: 1994, make: "BMW", model: "530i" },
  { type: "car", year: 1994, make: "BMW", model: "540i" },
  { type: "car", year: 1994, make: "BMW", model: "730i" },
  { type: "car", year: 1994, make: "BMW", model: "740i" },
  { type: "car", year: 1994, make: "BMW", model: "740iL" },
  { type: "car", year: 1994, make: "BMW", model: "750iL" },
  { type: "car", year: 1994, make: "BMW", model: "840Ci" },
  { type: "car", year: 1994, make: "BMW", model: "850Ci" },
  { type: "car", year: 1994, make: "BMW", model: "850CSi" },
  { type: "car", year: 1994, make: "BUGATTI", model: "EB110" },
  { type: "car", year: 1994, make: "BUICK", model: "Century" },
  { type: "car", year: 1994, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1994, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1994, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1994, make: "BUICK", model: "Regal" },
  { type: "car", year: 1994, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1994, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1994, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1994, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1994, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1994, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1994, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1994, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "LHS" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "Shadow" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1994, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1994, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1994, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1994, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1994, make: "DODGE", model: "Colt" },
  { type: "car", year: 1994, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1994, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1994, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1994, make: "DODGE", model: "Neon" },
  { type: "car", year: 1994, make: "DODGE", model: "Ram" },
  { type: "car", year: 1994, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1994, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1994, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1994, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1994, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1994, make: "DODGE", model: "Stealth" },
  { type: "car", year: 1994, make: "DODGE", model: "Viper" },
  { type: "car", year: 1994, make: "FERRARI", model: "348 Spider" },
  { type: "car", year: 1994, make: "FERRARI", model: "348 tb" },
  { type: "car", year: 1994, make: "FERRARI", model: "348 ts" },
  { type: "car", year: 1994, make: "FERRARI", model: "512 TR" },
  { type: "car", year: 1994, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1994, make: "FORD", model: "'34" },
  { type: "car", year: 1994, make: "FORD", model: "A8513" },
  { type: "car", year: 1994, make: "FORD", model: "A9513" },
  { type: "car", year: 1994, make: "FORD", model: "A9522" },
  { type: "car", year: 1994, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1994, make: "FORD", model: "Aspire" },
  { type: "car", year: 1994, make: "FORD", model: "AT8513" },
  { type: "car", year: 1994, make: "FORD", model: "AT9513" },
  { type: "car", year: 1994, make: "FORD", model: "AT9522" },
  { type: "car", year: 1994, make: "FORD", model: "B600" },
  { type: "car", year: 1994, make: "FORD", model: "B700" },
  { type: "car", year: 1994, make: "FORD", model: "Bronco" },
  { type: "car", year: 1994, make: "FORD", model: "CF7000" },
  { type: "car", year: 1994, make: "FORD", model: "CF8000" },
  { type: "car", year: 1994, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1994, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1994, make: "FORD", model: "E-150" },
  { type: "car", year: 1994, make: "FORD", model: "E-250" },
  { type: "car", year: 1994, make: "FORD", model: "E-350" },
  { type: "car", year: 1994, make: "FORD", model: "Escort" },
  { type: "car", year: 1994, make: "FORD", model: "Explorer" },
  { type: "car", year: 1994, make: "FORD", model: "F-150" },
  { type: "car", year: 1994, make: "FORD", model: "F-250" },
  { type: "car", year: 1994, make: "FORD", model: "F-350" },
  { type: "car", year: 1994, make: "FORD", model: "F-590" },
  { type: "car", year: 1994, make: "FORD", model: "F-600" },
  { type: "car", year: 1994, make: "FORD", model: "F-700" },
  { type: "car", year: 1994, make: "FORD", model: "F-800" },
  { type: "car", year: 1994, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1994, make: "FORD", model: "Festiva" },
  { type: "car", year: 1994, make: "FORD", model: "FT900" },
  { type: "car", year: 1994, make: "FORD", model: "L8000" },
  { type: "car", year: 1994, make: "FORD", model: "L8513" },
  { type: "car", year: 1994, make: "FORD", model: "L9000" },
  { type: "car", year: 1994, make: "FORD", model: "L9513" },
  { type: "car", year: 1994, make: "FORD", model: "LA8000" },
  { type: "car", year: 1994, make: "FORD", model: "LA9000" },
  { type: "car", year: 1994, make: "FORD", model: "LL9000" },
  { type: "car", year: 1994, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1994, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1994, make: "FORD", model: "LN7000" },
  { type: "car", year: 1994, make: "FORD", model: "LN8000" },
  { type: "car", year: 1994, make: "FORD", model: "LN9000" },
  { type: "car", year: 1994, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1994, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1994, make: "FORD", model: "LS8000" },
  { type: "car", year: 1994, make: "FORD", model: "LS9000" },
  { type: "car", year: 1994, make: "FORD", model: "LT8000" },
  { type: "car", year: 1994, make: "FORD", model: "LT8501" },
  { type: "car", year: 1994, make: "FORD", model: "LT8513" },
  { type: "car", year: 1994, make: "FORD", model: "LT9000" },
  { type: "car", year: 1994, make: "FORD", model: "LT9501" },
  { type: "car", year: 1994, make: "FORD", model: "LT9513" },
  { type: "car", year: 1994, make: "FORD", model: "LT9522" },
  { type: "car", year: 1994, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1994, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1994, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1994, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1994, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1994, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1994, make: "FORD", model: "Mustang" },
  { type: "car", year: 1994, make: "FORD", model: "P600" },
  { type: "car", year: 1994, make: "FORD", model: "Probe" },
  { type: "car", year: 1994, make: "FORD", model: "Ranger" },
  { type: "car", year: 1994, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1994, make: "FORD", model: "Taurus" },
  { type: "car", year: 1994, make: "FORD", model: "Tempo" },
  { type: "car", year: 1994, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1994, make: "GEO", model: "Metro" },
  { type: "car", year: 1994, make: "GEO", model: "Prizm" },
  { type: "car", year: 1994, make: "GEO", model: "Tracker" },
  { type: "car", year: 1994, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1994, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1994, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1994, make: "GMC", model: "Rally" },
  { type: "car", year: 1994, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1994, make: "GMC", model: "Safari" },
  { type: "car", year: 1994, make: "GMC", model: "Sierra" },
  { type: "car", year: 1994, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1994, make: "GMC", model: "Suburban" },
  { type: "car", year: 1994, make: "GMC", model: "Yukon" },
  { type: "car", year: 1994, make: "HONDA", model: "Accord" },
  { type: "car", year: 1994, make: "HONDA", model: "Civic" },
  { type: "car", year: 1994, make: "HONDA", model: "del Sol" },
  { type: "car", year: 1994, make: "HONDA", model: "Passport" },
  { type: "car", year: 1994, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1994, make: "HUMMER", model: "H1" },
  { type: "car", year: 1994, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1994, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1994, make: "HYUNDAI", model: "Scoupe" },
  { type: "car", year: 1994, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1994, make: "INFINITI", model: "G20" },
  { type: "car", year: 1994, make: "INFINITI", model: "J30" },
  { type: "car", year: 1994, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1994, make: "ISUZU", model: "Amigo" },
  { type: "car", year: 1994, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1994, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1994, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1994, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1994, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1994, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1994, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1994, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1994, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1994, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1994, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1994, make: "KIA", model: "Sephia" },
  { type: "car", year: 1994, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1994, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1994, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 1994, make: "LAND ROVER", model: "Discovery" },
  { type: "car", year: 1994, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1994, make: "LEXUS", model: "ES" },
  { type: "car", year: 1994, make: "LEXUS", model: "GS" },
  { type: "car", year: 1994, make: "LEXUS", model: "LS" },
  { type: "car", year: 1994, make: "LEXUS", model: "SC" },
  { type: "car", year: 1994, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1994, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1994, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1994, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1994, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1994, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1994, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1994, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1994, make: "MAZDA", model: "323" },
  { type: "car", year: 1994, make: "MAZDA", model: "626" },
  { type: "car", year: 1994, make: "MAZDA", model: "929" },
  { type: "car", year: 1994, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1994, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1994, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1994, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1994, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1994, make: "MAZDA", model: "Navajo" },
  { type: "car", year: 1994, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1994, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1994, make: "MERCEDES-BENZ", model: "C-Class" },
  { type: "car", year: 1994, make: "MERCEDES-BENZ", model: "E-Class" },
  { type: "car", year: 1994, make: "MERCEDES-BENZ", model: "S-Class" },
  { type: "car", year: 1994, make: "MERCEDES-BENZ", model: "SL-Class" },
  { type: "car", year: 1994, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1994, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1994, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1994, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1994, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1994, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1994, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Expo" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1994, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1994, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1994, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1994, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1994, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1994, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1994, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1994, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1994, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1994, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1994, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1994, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Laser" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Neon" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1994, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1994, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1994, make: "PORSCHE", model: "911" },
  { type: "car", year: 1994, make: "PORSCHE", model: "928" },
  { type: "car", year: 1994, make: "PORSCHE", model: "968" },
  { type: "car", year: 1994, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1994, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1994, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1994, make: "ROLLS-ROYCE", model: "Touring Limousine" },
  { type: "car", year: 1994, make: "SAAB", model: "900" },
  { type: "car", year: 1994, make: "SAAB", model: "9000" },
  { type: "car", year: 1994, make: "SATURN", model: "SC1" },
  { type: "car", year: 1994, make: "SATURN", model: "SC2" },
  { type: "car", year: 1994, make: "SATURN", model: "SL" },
  { type: "car", year: 1994, make: "SATURN", model: "SL1" },
  { type: "car", year: 1994, make: "SATURN", model: "SL2" },
  { type: "car", year: 1994, make: "SATURN", model: "SW1" },
  { type: "car", year: 1994, make: "SATURN", model: "SW2" },
  { type: "car", year: 1994, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1994, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1994, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1994, make: "SUBARU", model: "Loyale" },
  { type: "car", year: 1994, make: "SUBARU", model: "SVX" },
  { type: "car", year: 1994, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1994, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1994, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1994, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1994, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1994, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1994, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1994, make: "VOLVO", model: "850 Series" },
  { type: "car", year: 1994, make: "VOLVO", model: "940 Series" },
  { type: "car", year: 1994, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1994, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1993, make: "ACURA", model: "CL" },
  { type: "car", year: 1993, make: "ACURA", model: "Integra" },
  { type: "car", year: 1993, make: "ACURA", model: "Legend" },
  { type: "car", year: 1993, make: "ACURA", model: "NSX" },
  { type: "car", year: 1993, make: "ACURA", model: "RL" },
  { type: "car", year: 1993, make: "ACURA", model: "TL" },
  { type: "car", year: 1993, make: "ACURA", model: "Vigor" },
  { type: "car", year: 1993, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1993, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1993, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1993, make: "ASTON MARTIN", model: "Virage" },
  { type: "car", year: 1993, make: "AUDI", model: "100" },
  { type: "car", year: 1993, make: "AUDI", model: "90" },
  { type: "car", year: 1993, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1993, make: "AUDI", model: "S4" },
  { type: "car", year: 1993, make: "AUDI", model: "V8" },
  { type: "car", year: 1993, make: "BENTLEY", model: "Brooklands" },
  { type: "car", year: 1993, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1993, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1993, make: "BMW", model: "318i" },
  { type: "car", year: 1993, make: "BMW", model: "318iC" },
  { type: "car", year: 1993, make: "BMW", model: "318iS" },
  { type: "car", year: 1993, make: "BMW", model: "318ti" },
  { type: "car", year: 1993, make: "BMW", model: "325i" },
  { type: "car", year: 1993, make: "BMW", model: "325iC" },
  { type: "car", year: 1993, make: "BMW", model: "325iS" },
  { type: "car", year: 1993, make: "BMW", model: "525i" },
  { type: "car", year: 1993, make: "BMW", model: "535i" },
  { type: "car", year: 1993, make: "BMW", model: "740i" },
  { type: "car", year: 1993, make: "BMW", model: "740iL" },
  { type: "car", year: 1993, make: "BMW", model: "750iL" },
  { type: "car", year: 1993, make: "BMW", model: "840Ci" },
  { type: "car", year: 1993, make: "BMW", model: "850Ci" },
  { type: "car", year: 1993, make: "BMW", model: "850CSi" },
  { type: "car", year: 1993, make: "BMW", model: "M5" },
  { type: "car", year: 1993, make: "BUICK", model: "Century" },
  { type: "car", year: 1993, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1993, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1993, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1993, make: "BUICK", model: "Regal" },
  { type: "car", year: 1993, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1993, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1993, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1993, make: "CADILLAC", model: "60 Special" },
  { type: "car", year: 1993, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1993, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1993, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1993, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1993, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1993, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1993, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Concorde" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Intrepid" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Shadow" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1993, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1993, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1993, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1993, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1993, make: "DODGE", model: "Colt" },
  { type: "car", year: 1993, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1993, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1993, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1993, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1993, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1993, make: "DODGE", model: "Intrepid" },
  { type: "car", year: 1993, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1993, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1993, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1993, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1993, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1993, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1993, make: "DODGE", model: "Stealth" },
  { type: "car", year: 1993, make: "DODGE", model: "Viper" },
  { type: "car", year: 1993, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1993, make: "FERRARI", model: "348 tb" },
  { type: "car", year: 1993, make: "FERRARI", model: "348 ts" },
  { type: "car", year: 1993, make: "FERRARI", model: "512 TR" },
  { type: "car", year: 1993, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1993, make: "FORD", model: "'34" },
  { type: "car", year: 1993, make: "FORD", model: "A8513" },
  { type: "car", year: 1993, make: "FORD", model: "A9513" },
  { type: "car", year: 1993, make: "FORD", model: "A9522" },
  { type: "car", year: 1993, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1993, make: "FORD", model: "AT8513" },
  { type: "car", year: 1993, make: "FORD", model: "AT9513" },
  { type: "car", year: 1993, make: "FORD", model: "AT9522" },
  { type: "car", year: 1993, make: "FORD", model: "B600" },
  { type: "car", year: 1993, make: "FORD", model: "B700" },
  { type: "car", year: 1993, make: "FORD", model: "Bronco" },
  { type: "car", year: 1993, make: "FORD", model: "CF7000" },
  { type: "car", year: 1993, make: "FORD", model: "CF8000" },
  { type: "car", year: 1993, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1993, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1993, make: "FORD", model: "E-150" },
  { type: "car", year: 1993, make: "FORD", model: "E-250" },
  { type: "car", year: 1993, make: "FORD", model: "E-350" },
  { type: "car", year: 1993, make: "FORD", model: "Escort" },
  { type: "car", year: 1993, make: "FORD", model: "Explorer" },
  { type: "car", year: 1993, make: "FORD", model: "F-150" },
  { type: "car", year: 1993, make: "FORD", model: "F-250" },
  { type: "car", year: 1993, make: "FORD", model: "F-350" },
  { type: "car", year: 1993, make: "FORD", model: "F-590" },
  { type: "car", year: 1993, make: "FORD", model: "F-600" },
  { type: "car", year: 1993, make: "FORD", model: "F-700" },
  { type: "car", year: 1993, make: "FORD", model: "F-800" },
  { type: "car", year: 1993, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1993, make: "FORD", model: "Festiva" },
  { type: "car", year: 1993, make: "FORD", model: "FT900" },
  { type: "car", year: 1993, make: "FORD", model: "L8000" },
  { type: "car", year: 1993, make: "FORD", model: "L8513" },
  { type: "car", year: 1993, make: "FORD", model: "L9000" },
  { type: "car", year: 1993, make: "FORD", model: "L9513" },
  { type: "car", year: 1993, make: "FORD", model: "LA8000" },
  { type: "car", year: 1993, make: "FORD", model: "LA9000" },
  { type: "car", year: 1993, make: "FORD", model: "LL9000" },
  { type: "car", year: 1993, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1993, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1993, make: "FORD", model: "LN7000" },
  { type: "car", year: 1993, make: "FORD", model: "LN8000" },
  { type: "car", year: 1993, make: "FORD", model: "LN9000" },
  { type: "car", year: 1993, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1993, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1993, make: "FORD", model: "LS8000" },
  { type: "car", year: 1993, make: "FORD", model: "LS9000" },
  { type: "car", year: 1993, make: "FORD", model: "LT8000" },
  { type: "car", year: 1993, make: "FORD", model: "LT8501" },
  { type: "car", year: 1993, make: "FORD", model: "LT8513" },
  { type: "car", year: 1993, make: "FORD", model: "LT9000" },
  { type: "car", year: 1993, make: "FORD", model: "LT9501" },
  { type: "car", year: 1993, make: "FORD", model: "LT9513" },
  { type: "car", year: 1993, make: "FORD", model: "LT9522" },
  { type: "car", year: 1993, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1993, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1993, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1993, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1993, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1993, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1993, make: "FORD", model: "Mustang" },
  { type: "car", year: 1993, make: "FORD", model: "P600" },
  { type: "car", year: 1993, make: "FORD", model: "Probe" },
  { type: "car", year: 1993, make: "FORD", model: "Ranger" },
  { type: "car", year: 1993, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1993, make: "FORD", model: "Taurus" },
  { type: "car", year: 1993, make: "FORD", model: "Tempo" },
  { type: "car", year: 1993, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1993, make: "GEO", model: "Metro" },
  { type: "car", year: 1993, make: "GEO", model: "Prizm" },
  { type: "car", year: 1993, make: "GEO", model: "Sprint" },
  { type: "car", year: 1993, make: "GEO", model: "Storm" },
  { type: "car", year: 1993, make: "GEO", model: "Tracker" },
  { type: "car", year: 1993, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1993, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1993, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1993, make: "GMC", model: "Rally" },
  { type: "car", year: 1993, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1993, make: "GMC", model: "Safari" },
  { type: "car", year: 1993, make: "GMC", model: "Sierra" },
  { type: "car", year: 1993, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1993, make: "GMC", model: "Suburban" },
  { type: "car", year: 1993, make: "GMC", model: "Yukon" },
  { type: "car", year: 1993, make: "HONDA", model: "Accord" },
  { type: "car", year: 1993, make: "HONDA", model: "Civic" },
  { type: "car", year: 1993, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1993, make: "HUMMER", model: "H1" },
  { type: "car", year: 1993, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1993, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1993, make: "HYUNDAI", model: "Scoupe" },
  { type: "car", year: 1993, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1993, make: "INFINITI", model: "G20" },
  { type: "car", year: 1993, make: "INFINITI", model: "J30" },
  { type: "car", year: 1993, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1993, make: "ISUZU", model: "Amigo" },
  { type: "car", year: 1993, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1993, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1993, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1993, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1993, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1993, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1993, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1993, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1993, make: "JEEP", model: "Grand Cherokee" },
  { type: "car", year: 1993, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1993, make: "JEEP", model: "Liberty" },
  { type: "car", year: 1993, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1993, make: "KIA", model: "Sephia" },
  { type: "car", year: 1993, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1993, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1993, make: "LAND ROVER", model: "Defender" },
  { type: "car", year: 1993, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1993, make: "LEXUS", model: "ES" },
  { type: "car", year: 1993, make: "LEXUS", model: "GS" },
  { type: "car", year: 1993, make: "LEXUS", model: "LS" },
  { type: "car", year: 1993, make: "LEXUS", model: "SC" },
  { type: "car", year: 1993, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1993, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1993, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1993, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1993, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1993, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1993, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1993, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1993, make: "MAZDA", model: "323" },
  { type: "car", year: 1993, make: "MAZDA", model: "626" },
  { type: "car", year: 1993, make: "MAZDA", model: "929" },
  { type: "car", year: 1993, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1993, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1993, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1993, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1993, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1993, make: "MAZDA", model: "Navajo" },
  { type: "car", year: 1993, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1993, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1993, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1993, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1993, make: "MERCEDES-BENZ", model: "400" },
  { type: "car", year: 1993, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1993, make: "MERCEDES-BENZ", model: "600" },
  { type: "car", year: 1993, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1993, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1993, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1993, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1993, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1993, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1993, make: "MERCURY", model: "Villager" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Expo" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1993, make: "MITSUBISHI", model: "Raider" },
  { type: "car", year: 1993, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1993, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1993, make: "NISSAN", model: "Altima" },
  { type: "car", year: 1993, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1993, make: "NISSAN", model: "NX" },
  { type: "car", year: 1993, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1993, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1993, make: "NISSAN", model: "Quest" },
  { type: "car", year: 1993, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1993, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1993, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1993, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1993, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1993, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1993, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1993, make: "PLYMOUTH", model: "Laser" },
  { type: "car", year: 1993, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1993, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1993, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1993, make: "PORSCHE", model: "911" },
  { type: "car", year: 1993, make: "PORSCHE", model: "928" },
  { type: "car", year: 1993, make: "PORSCHE", model: "968" },
  { type: "car", year: 1993, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1993, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1993, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1993, make: "ROLLS-ROYCE", model: "Touring Limousine" },
  { type: "car", year: 1993, make: "SAAB", model: "900" },
  { type: "car", year: 1993, make: "SAAB", model: "9000" },
  { type: "car", year: 1993, make: "SATURN", model: "SC1" },
  { type: "car", year: 1993, make: "SATURN", model: "SC2" },
  { type: "car", year: 1993, make: "SATURN", model: "SL1" },
  { type: "car", year: 1993, make: "SATURN", model: "SL2" },
  { type: "car", year: 1993, make: "SATURN", model: "SL3" },
  { type: "car", year: 1993, make: "SATURN", model: "SW1" },
  { type: "car", year: 1993, make: "SATURN", model: "SW2" },
  { type: "car", year: 1993, make: "SUBARU", model: "Impreza" },
  { type: "car", year: 1993, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1993, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1993, make: "SUBARU", model: "Loyale" },
  { type: "car", year: 1993, make: "SUBARU", model: "SVX" },
  { type: "car", year: 1993, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1993, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1993, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1993, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1993, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1993, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1993, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1993, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1993, make: "VOLVO", model: "850 Series" },
  { type: "car", year: 1993, make: "VOLVO", model: "940 Series" },
  { type: "car", year: 1993, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1993, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1992, make: "ACURA", model: "CL" },
  { type: "car", year: 1992, make: "ACURA", model: "Integra" },
  { type: "car", year: 1992, make: "ACURA", model: "Legend" },
  { type: "car", year: 1992, make: "ACURA", model: "NSX" },
  { type: "car", year: 1992, make: "ACURA", model: "RL" },
  { type: "car", year: 1992, make: "ACURA", model: "TL" },
  { type: "car", year: 1992, make: "ACURA", model: "Vigor" },
  { type: "car", year: 1992, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1992, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1992, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1992, make: "ASTON MARTIN", model: "Virage" },
  { type: "car", year: 1992, make: "AUDI", model: "100" },
  { type: "car", year: 1992, make: "AUDI", model: "90" },
  { type: "car", year: 1992, make: "AUDI", model: "Cabriolet" },
  { type: "car", year: 1992, make: "AUDI", model: "S4" },
  { type: "car", year: 1992, make: "AUDI", model: "V8" },
  { type: "car", year: 1992, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1992, make: "BENTLEY", model: "Eight" },
  { type: "car", year: 1992, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1992, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1992, make: "BMW", model: "318i" },
  { type: "car", year: 1992, make: "BMW", model: "318iC" },
  { type: "car", year: 1992, make: "BMW", model: "318iS" },
  { type: "car", year: 1992, make: "BMW", model: "318ti" },
  { type: "car", year: 1992, make: "BMW", model: "325i" },
  { type: "car", year: 1992, make: "BMW", model: "325iC" },
  { type: "car", year: 1992, make: "BMW", model: "325iS" },
  { type: "car", year: 1992, make: "BMW", model: "525i" },
  { type: "car", year: 1992, make: "BMW", model: "535i" },
  { type: "car", year: 1992, make: "BMW", model: "735i" },
  { type: "car", year: 1992, make: "BMW", model: "735iL" },
  { type: "car", year: 1992, make: "BMW", model: "750iL" },
  { type: "car", year: 1992, make: "BMW", model: "840Ci" },
  { type: "car", year: 1992, make: "BMW", model: "850Ci" },
  { type: "car", year: 1992, make: "BMW", model: "850CSi" },
  { type: "car", year: 1992, make: "BMW", model: "850i" },
  { type: "car", year: 1992, make: "BMW", model: "M5" },
  { type: "car", year: 1992, make: "BUICK", model: "Century" },
  { type: "car", year: 1992, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1992, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1992, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1992, make: "BUICK", model: "Regal" },
  { type: "car", year: 1992, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1992, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1992, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1992, make: "CADILLAC", model: "60 Special" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Brougham" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1992, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1992, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Shadow" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1992, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1992, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1992, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1992, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1992, make: "DODGE", model: "Colt" },
  { type: "car", year: 1992, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1992, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1992, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1992, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1992, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1992, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1992, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1992, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1992, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1992, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1992, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1992, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1992, make: "DODGE", model: "Stealth" },
  { type: "car", year: 1992, make: "DODGE", model: "Viper" },
  { type: "car", year: 1992, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1992, make: "FERRARI", model: "348 tb" },
  { type: "car", year: 1992, make: "FERRARI", model: "348 ts" },
  { type: "car", year: 1992, make: "FERRARI", model: "F40" },
  { type: "car", year: 1992, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1992, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1992, make: "FORD", model: "'34" },
  { type: "car", year: 1992, make: "FORD", model: "A8513" },
  { type: "car", year: 1992, make: "FORD", model: "A9513" },
  { type: "car", year: 1992, make: "FORD", model: "A9522" },
  { type: "car", year: 1992, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1992, make: "FORD", model: "AT8513" },
  { type: "car", year: 1992, make: "FORD", model: "AT9513" },
  { type: "car", year: 1992, make: "FORD", model: "AT9522" },
  { type: "car", year: 1992, make: "FORD", model: "B600" },
  { type: "car", year: 1992, make: "FORD", model: "B700" },
  { type: "car", year: 1992, make: "FORD", model: "Bronco" },
  { type: "car", year: 1992, make: "FORD", model: "CF7000" },
  { type: "car", year: 1992, make: "FORD", model: "CF8000" },
  { type: "car", year: 1992, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1992, make: "FORD", model: "CL9000" },
  { type: "car", year: 1992, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1992, make: "FORD", model: "E-150" },
  { type: "car", year: 1992, make: "FORD", model: "E-250" },
  { type: "car", year: 1992, make: "FORD", model: "E-350" },
  { type: "car", year: 1992, make: "FORD", model: "Escort" },
  { type: "car", year: 1992, make: "FORD", model: "Explorer" },
  { type: "car", year: 1992, make: "FORD", model: "F-150" },
  { type: "car", year: 1992, make: "FORD", model: "F-250" },
  { type: "car", year: 1992, make: "FORD", model: "F-350" },
  { type: "car", year: 1992, make: "FORD", model: "F-590" },
  { type: "car", year: 1992, make: "FORD", model: "F-600" },
  { type: "car", year: 1992, make: "FORD", model: "F-700" },
  { type: "car", year: 1992, make: "FORD", model: "F-800" },
  { type: "car", year: 1992, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1992, make: "FORD", model: "Festiva" },
  { type: "car", year: 1992, make: "FORD", model: "FT900" },
  { type: "car", year: 1992, make: "FORD", model: "L8000" },
  { type: "car", year: 1992, make: "FORD", model: "L8513" },
  { type: "car", year: 1992, make: "FORD", model: "L9000" },
  { type: "car", year: 1992, make: "FORD", model: "L9513" },
  { type: "car", year: 1992, make: "FORD", model: "LA8000" },
  { type: "car", year: 1992, make: "FORD", model: "LA9000" },
  { type: "car", year: 1992, make: "FORD", model: "LL9000" },
  { type: "car", year: 1992, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1992, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1992, make: "FORD", model: "LN7000" },
  { type: "car", year: 1992, make: "FORD", model: "LN8000" },
  { type: "car", year: 1992, make: "FORD", model: "LN9000" },
  { type: "car", year: 1992, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1992, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1992, make: "FORD", model: "LS8000" },
  { type: "car", year: 1992, make: "FORD", model: "LS9000" },
  { type: "car", year: 1992, make: "FORD", model: "LT8000" },
  { type: "car", year: 1992, make: "FORD", model: "LT8501" },
  { type: "car", year: 1992, make: "FORD", model: "LT8513" },
  { type: "car", year: 1992, make: "FORD", model: "LT9000" },
  { type: "car", year: 1992, make: "FORD", model: "LT9501" },
  { type: "car", year: 1992, make: "FORD", model: "LT9513" },
  { type: "car", year: 1992, make: "FORD", model: "LT9522" },
  { type: "car", year: 1992, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1992, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1992, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1992, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1992, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1992, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1992, make: "FORD", model: "Mustang" },
  { type: "car", year: 1992, make: "FORD", model: "P600" },
  { type: "car", year: 1992, make: "FORD", model: "Probe" },
  { type: "car", year: 1992, make: "FORD", model: "Ranger" },
  { type: "car", year: 1992, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1992, make: "FORD", model: "Taurus" },
  { type: "car", year: 1992, make: "FORD", model: "Tempo" },
  { type: "car", year: 1992, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1992, make: "GEO", model: "Metro" },
  { type: "car", year: 1992, make: "GEO", model: "Prizm" },
  { type: "car", year: 1992, make: "GEO", model: "Sprint" },
  { type: "car", year: 1992, make: "GEO", model: "Storm" },
  { type: "car", year: 1992, make: "GEO", model: "Tracker" },
  { type: "car", year: 1992, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1992, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1992, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1992, make: "GMC", model: "Rally" },
  { type: "car", year: 1992, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1992, make: "GMC", model: "Safari" },
  { type: "car", year: 1992, make: "GMC", model: "Sierra" },
  { type: "car", year: 1992, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1992, make: "GMC", model: "Suburban" },
  { type: "car", year: 1992, make: "GMC", model: "Yukon" },
  { type: "car", year: 1992, make: "HONDA", model: "Accord" },
  { type: "car", year: 1992, make: "HONDA", model: "Civic" },
  { type: "car", year: 1992, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1992, make: "HUMMER", model: "H1" },
  { type: "car", year: 1992, make: "HYUNDAI", model: "Elantra" },
  { type: "car", year: 1992, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1992, make: "HYUNDAI", model: "Scoupe" },
  { type: "car", year: 1992, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1992, make: "INFINITI", model: "G20" },
  { type: "car", year: 1992, make: "INFINITI", model: "M30" },
  { type: "car", year: 1992, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1992, make: "ISUZU", model: "Amigo" },
  { type: "car", year: 1992, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1992, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1992, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1992, make: "ISUZU", model: "Stylus" },
  { type: "car", year: 1992, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1992, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1992, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1992, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1992, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1992, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1992, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1992, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1992, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1992, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1992, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1992, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1992, make: "LEXUS", model: "ES" },
  { type: "car", year: 1992, make: "LEXUS", model: "LS" },
  { type: "car", year: 1992, make: "LEXUS", model: "SC" },
  { type: "car", year: 1992, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1992, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1992, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1992, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1992, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1992, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1992, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1992, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1992, make: "MAZDA", model: "323" },
  { type: "car", year: 1992, make: "MAZDA", model: "626" },
  { type: "car", year: 1992, make: "MAZDA", model: "929" },
  { type: "car", year: 1992, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1992, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1992, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1992, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1992, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1992, make: "MAZDA", model: "Navajo" },
  { type: "car", year: 1992, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1992, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1992, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1992, make: "MERCEDES-BENZ", model: "400" },
  { type: "car", year: 1992, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1992, make: "MERCEDES-BENZ", model: "600" },
  { type: "car", year: 1992, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1992, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1992, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1992, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1992, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1992, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Diamante" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Expo" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 1992, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1992, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1992, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1992, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1992, make: "NISSAN", model: "NX" },
  { type: "car", year: 1992, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1992, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1992, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1992, make: "NISSAN", model: "Sentra Classic" },
  { type: "car", year: 1992, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Achieva" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1992, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1992, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1992, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1992, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1992, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1992, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1992, make: "PLYMOUTH", model: "Laser" },
  { type: "car", year: 1992, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1992, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1992, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1992, make: "PORSCHE", model: "911" },
  { type: "car", year: 1992, make: "PORSCHE", model: "928" },
  { type: "car", year: 1992, make: "PORSCHE", model: "968" },
  { type: "car", year: 1992, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1992, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1992, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1992, make: "SAAB", model: "900" },
  { type: "car", year: 1992, make: "SAAB", model: "9000" },
  { type: "car", year: 1992, make: "SATURN", model: "SC1" },
  { type: "car", year: 1992, make: "SATURN", model: "SC2" },
  { type: "car", year: 1992, make: "SATURN", model: "SL1" },
  { type: "car", year: 1992, make: "SATURN", model: "SL2" },
  { type: "car", year: 1992, make: "SATURN", model: "SL3" },
  { type: "car", year: 1992, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1992, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1992, make: "SUBARU", model: "Loyale" },
  { type: "car", year: 1992, make: "SUBARU", model: "SVX" },
  { type: "car", year: 1992, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1992, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1992, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1992, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1992, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1992, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Paseo" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1992, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1992, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1992, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1992, make: "VOLVO", model: "940 Series" },
  { type: "car", year: 1992, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1992, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1991, make: "ACURA", model: "CL" },
  { type: "car", year: 1991, make: "ACURA", model: "Integra" },
  { type: "car", year: 1991, make: "ACURA", model: "Legend" },
  { type: "car", year: 1991, make: "ACURA", model: "NSX" },
  { type: "car", year: 1991, make: "ACURA", model: "RL" },
  { type: "car", year: 1991, make: "ACURA", model: "TL" },
  { type: "car", year: 1991, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1991, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1991, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1991, make: "ASTON MARTIN", model: "Virage" },
  { type: "car", year: 1991, make: "AUDI", model: "100" },
  { type: "car", year: 1991, make: "AUDI", model: "200" },
  { type: "car", year: 1991, make: "AUDI", model: "80" },
  { type: "car", year: 1991, make: "AUDI", model: "90" },
  { type: "car", year: 1991, make: "AUDI", model: "Coupe" },
  { type: "car", year: 1991, make: "AUDI", model: "V8" },
  { type: "car", year: 1991, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1991, make: "BENTLEY", model: "Eight" },
  { type: "car", year: 1991, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1991, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1991, make: "BMW", model: "318i" },
  { type: "car", year: 1991, make: "BMW", model: "318iC" },
  { type: "car", year: 1991, make: "BMW", model: "318iS" },
  { type: "car", year: 1991, make: "BMW", model: "318ti" },
  { type: "car", year: 1991, make: "BMW", model: "325i" },
  { type: "car", year: 1991, make: "BMW", model: "325iC" },
  { type: "car", year: 1991, make: "BMW", model: "325iS" },
  { type: "car", year: 1991, make: "BMW", model: "325ix" },
  { type: "car", year: 1991, make: "BMW", model: "525i" },
  { type: "car", year: 1991, make: "BMW", model: "535i" },
  { type: "car", year: 1991, make: "BMW", model: "735i" },
  { type: "car", year: 1991, make: "BMW", model: "735iL" },
  { type: "car", year: 1991, make: "BMW", model: "750iL" },
  { type: "car", year: 1991, make: "BMW", model: "840Ci" },
  { type: "car", year: 1991, make: "BMW", model: "850Ci" },
  { type: "car", year: 1991, make: "BMW", model: "850CSi" },
  { type: "car", year: 1991, make: "BMW", model: "850i" },
  { type: "car", year: 1991, make: "BMW", model: "M3" },
  { type: "car", year: 1991, make: "BMW", model: "M5" },
  { type: "car", year: 1991, make: "BUICK", model: "Century" },
  { type: "car", year: 1991, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1991, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1991, make: "BUICK", model: "Park Avenue" },
  { type: "car", year: 1991, make: "BUICK", model: "Reatta" },
  { type: "car", year: 1991, make: "BUICK", model: "Regal" },
  { type: "car", year: 1991, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1991, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1991, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1991, make: "CADILLAC", model: "60 Special" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Brougham" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1991, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "R Conventional" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1991, make: "CHEVROLET", model: "V Conventional" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Shadow" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "TC" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1991, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1991, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1991, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1991, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1991, make: "DODGE", model: "Colt" },
  { type: "car", year: 1991, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1991, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1991, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1991, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1991, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1991, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1991, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1991, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1991, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1991, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1991, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1991, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1991, make: "DODGE", model: "Stealth" },
  { type: "car", year: 1991, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1991, make: "FERRARI", model: "348 tb" },
  { type: "car", year: 1991, make: "FERRARI", model: "348 ts" },
  { type: "car", year: 1991, make: "FERRARI", model: "F40" },
  { type: "car", year: 1991, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1991, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1991, make: "FORD", model: "'34" },
  { type: "car", year: 1991, make: "FORD", model: "A8513" },
  { type: "car", year: 1991, make: "FORD", model: "A9513" },
  { type: "car", year: 1991, make: "FORD", model: "A9522" },
  { type: "car", year: 1991, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1991, make: "FORD", model: "AT8513" },
  { type: "car", year: 1991, make: "FORD", model: "AT9513" },
  { type: "car", year: 1991, make: "FORD", model: "AT9522" },
  { type: "car", year: 1991, make: "FORD", model: "B600" },
  { type: "car", year: 1991, make: "FORD", model: "B700" },
  { type: "car", year: 1991, make: "FORD", model: "Bronco" },
  { type: "car", year: 1991, make: "FORD", model: "CF7000" },
  { type: "car", year: 1991, make: "FORD", model: "CF8000" },
  { type: "car", year: 1991, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1991, make: "FORD", model: "CL9000" },
  { type: "car", year: 1991, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1991, make: "FORD", model: "E-150" },
  { type: "car", year: 1991, make: "FORD", model: "E-250" },
  { type: "car", year: 1991, make: "FORD", model: "E-350" },
  { type: "car", year: 1991, make: "FORD", model: "Escort" },
  { type: "car", year: 1991, make: "FORD", model: "Explorer" },
  { type: "car", year: 1991, make: "FORD", model: "F-150" },
  { type: "car", year: 1991, make: "FORD", model: "F-250" },
  { type: "car", year: 1991, make: "FORD", model: "F-350" },
  { type: "car", year: 1991, make: "FORD", model: "F-590" },
  { type: "car", year: 1991, make: "FORD", model: "F-600" },
  { type: "car", year: 1991, make: "FORD", model: "F-700" },
  { type: "car", year: 1991, make: "FORD", model: "F-800" },
  { type: "car", year: 1991, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1991, make: "FORD", model: "Festiva" },
  { type: "car", year: 1991, make: "FORD", model: "FT900" },
  { type: "car", year: 1991, make: "FORD", model: "L8000" },
  { type: "car", year: 1991, make: "FORD", model: "L8513" },
  { type: "car", year: 1991, make: "FORD", model: "L9000" },
  { type: "car", year: 1991, make: "FORD", model: "L9513" },
  { type: "car", year: 1991, make: "FORD", model: "LA8000" },
  { type: "car", year: 1991, make: "FORD", model: "LA9000" },
  { type: "car", year: 1991, make: "FORD", model: "LL9000" },
  { type: "car", year: 1991, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1991, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1991, make: "FORD", model: "LN7000" },
  { type: "car", year: 1991, make: "FORD", model: "LN8000" },
  { type: "car", year: 1991, make: "FORD", model: "LN9000" },
  { type: "car", year: 1991, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1991, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1991, make: "FORD", model: "LS8000" },
  { type: "car", year: 1991, make: "FORD", model: "LS9000" },
  { type: "car", year: 1991, make: "FORD", model: "LT8000" },
  { type: "car", year: 1991, make: "FORD", model: "LT8501" },
  { type: "car", year: 1991, make: "FORD", model: "LT8513" },
  { type: "car", year: 1991, make: "FORD", model: "LT9000" },
  { type: "car", year: 1991, make: "FORD", model: "LT9501" },
  { type: "car", year: 1991, make: "FORD", model: "LT9513" },
  { type: "car", year: 1991, make: "FORD", model: "LT9522" },
  { type: "car", year: 1991, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1991, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1991, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1991, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1991, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1991, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1991, make: "FORD", model: "Mustang" },
  { type: "car", year: 1991, make: "FORD", model: "P600" },
  { type: "car", year: 1991, make: "FORD", model: "Probe" },
  { type: "car", year: 1991, make: "FORD", model: "Ranger" },
  { type: "car", year: 1991, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1991, make: "FORD", model: "Taurus" },
  { type: "car", year: 1991, make: "FORD", model: "Tempo" },
  { type: "car", year: 1991, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1991, make: "GEO", model: "Metro" },
  { type: "car", year: 1991, make: "GEO", model: "Prizm" },
  { type: "car", year: 1991, make: "GEO", model: "Sprint" },
  { type: "car", year: 1991, make: "GEO", model: "Storm" },
  { type: "car", year: 1991, make: "GEO", model: "Tracker" },
  { type: "car", year: 1991, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1991, make: "GMC", model: "Jimmy" },
  { type: "car", year: 1991, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1991, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1991, make: "GMC", model: "R Conventional" },
  { type: "car", year: 1991, make: "GMC", model: "Rally" },
  { type: "car", year: 1991, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1991, make: "GMC", model: "Safari" },
  { type: "car", year: 1991, make: "GMC", model: "Sierra" },
  { type: "car", year: 1991, make: "GMC", model: "Sonoma" },
  { type: "car", year: 1991, make: "GMC", model: "Suburban" },
  { type: "car", year: 1991, make: "GMC", model: "V Conventional" },
  { type: "car", year: 1991, make: "HONDA", model: "Accord" },
  { type: "car", year: 1991, make: "HONDA", model: "Civic" },
  { type: "car", year: 1991, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1991, make: "HUMMER", model: "H1" },
  { type: "car", year: 1991, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1991, make: "HYUNDAI", model: "Scoupe" },
  { type: "car", year: 1991, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1991, make: "INFINITI", model: "G20" },
  { type: "car", year: 1991, make: "INFINITI", model: "M30" },
  { type: "car", year: 1991, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1991, make: "ISUZU", model: "Amigo" },
  { type: "car", year: 1991, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1991, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1991, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1991, make: "ISUZU", model: "Stylus" },
  { type: "car", year: 1991, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1991, make: "ISUZU", model: "Trooper II" },
  { type: "car", year: 1991, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1991, make: "JAGUAR", model: "XJ12" },
  { type: "car", year: 1991, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1991, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1991, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1991, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1991, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1991, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1991, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1991, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1991, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1991, make: "LEXUS", model: "ES" },
  { type: "car", year: 1991, make: "LEXUS", model: "LS" },
  { type: "car", year: 1991, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1991, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1991, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1991, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1991, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1991, make: "MASERATI", model: "228" },
  { type: "car", year: 1991, make: "MASERATI", model: "430" },
  { type: "car", year: 1991, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1991, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1991, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1991, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1991, make: "MASERATI", model: "TC" },
  { type: "car", year: 1991, make: "MAZDA", model: "323" },
  { type: "car", year: 1991, make: "MAZDA", model: "626" },
  { type: "car", year: 1991, make: "MAZDA", model: "929" },
  { type: "car", year: 1991, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1991, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1991, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1991, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1991, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1991, make: "MAZDA", model: "Navajo" },
  { type: "car", year: 1991, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1991, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1991, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1991, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1991, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1991, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1991, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1991, make: "MERCEDES-BENZ", model: "560" },
  { type: "car", year: 1991, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1991, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1991, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1991, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1991, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1991, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "3000GT" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "Montero Sport" },
  { type: "car", year: 1991, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1991, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1991, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1991, make: "NISSAN", model: "Axxess" },
  { type: "car", year: 1991, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1991, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1991, make: "NISSAN", model: "NX" },
  { type: "car", year: 1991, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1991, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1991, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1991, make: "NISSAN", model: "Sentra Classic" },
  { type: "car", year: 1991, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Bravada" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1991, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1991, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1991, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1991, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1991, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1991, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1991, make: "PLYMOUTH", model: "Laser" },
  { type: "car", year: 1991, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1991, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1991, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Tempest" },
  { type: "car", year: 1991, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1991, make: "PORSCHE", model: "911" },
  { type: "car", year: 1991, make: "PORSCHE", model: "928" },
  { type: "car", year: 1991, make: "PORSCHE", model: "944" },
  { type: "car", year: 1991, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1991, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1991, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1991, make: "SAAB", model: "900" },
  { type: "car", year: 1991, make: "SAAB", model: "9000" },
  { type: "car", year: 1991, make: "SATURN", model: "SC1" },
  { type: "car", year: 1991, make: "SATURN", model: "SC2" },
  { type: "car", year: 1991, make: "SATURN", model: "SL1" },
  { type: "car", year: 1991, make: "SATURN", model: "SL2" },
  { type: "car", year: 1991, make: "SATURN", model: "SL3" },
  { type: "car", year: 1991, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1991, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1991, make: "SUBARU", model: "Loyale" },
  { type: "car", year: 1991, make: "SUBARU", model: "XT" },
  { type: "car", year: 1991, make: "SUBARU", model: "XT6" },
  { type: "car", year: 1991, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1991, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1991, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1991, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1991, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1991, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Previa" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1991, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1991, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1991, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1991, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1991, make: "VOLVO", model: "940 Series" },
  { type: "car", year: 1991, make: "VOLVO", model: "960 Series" },
  { type: "car", year: 1991, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1990, make: "ACURA", model: "CL" },
  { type: "car", year: 1990, make: "ACURA", model: "Integra" },
  { type: "car", year: 1990, make: "ACURA", model: "Legend" },
  { type: "car", year: 1990, make: "ACURA", model: "NSX" },
  { type: "car", year: 1990, make: "ACURA", model: "RL" },
  { type: "car", year: 1990, make: "ACURA", model: "TL" },
  { type: "car", year: 1990, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1990, make: "ALFA ROMEO", model: "Milano" },
  { type: "car", year: 1990, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1990, make: "ASTON MARTIN", model: "Virage" },
  { type: "car", year: 1990, make: "AUDI", model: "100" },
  { type: "car", year: 1990, make: "AUDI", model: "200" },
  { type: "car", year: 1990, make: "AUDI", model: "80" },
  { type: "car", year: 1990, make: "AUDI", model: "90" },
  { type: "car", year: 1990, make: "AUDI", model: "Coupe" },
  { type: "car", year: 1990, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1990, make: "BENTLEY", model: "Eight" },
  { type: "car", year: 1990, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1990, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1990, make: "BMW", model: "318i" },
  { type: "car", year: 1990, make: "BMW", model: "318iC" },
  { type: "car", year: 1990, make: "BMW", model: "318iS" },
  { type: "car", year: 1990, make: "BMW", model: "318ti" },
  { type: "car", year: 1990, make: "BMW", model: "325i" },
  { type: "car", year: 1990, make: "BMW", model: "325iC" },
  { type: "car", year: 1990, make: "BMW", model: "325iS" },
  { type: "car", year: 1990, make: "BMW", model: "325ix" },
  { type: "car", year: 1990, make: "BMW", model: "525i" },
  { type: "car", year: 1990, make: "BMW", model: "535i" },
  { type: "car", year: 1990, make: "BMW", model: "735i" },
  { type: "car", year: 1990, make: "BMW", model: "735iL" },
  { type: "car", year: 1990, make: "BMW", model: "750iL" },
  { type: "car", year: 1990, make: "BMW", model: "840Ci" },
  { type: "car", year: 1990, make: "BMW", model: "850Ci" },
  { type: "car", year: 1990, make: "BMW", model: "850CSi" },
  { type: "car", year: 1990, make: "BMW", model: "M3" },
  { type: "car", year: 1990, make: "BUICK", model: "Century" },
  { type: "car", year: 1990, make: "BUICK", model: "Coachbuilder" },
  { type: "car", year: 1990, make: "BUICK", model: "Electra" },
  { type: "car", year: 1990, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1990, make: "BUICK", model: "Reatta" },
  { type: "car", year: 1990, make: "BUICK", model: "Regal" },
  { type: "car", year: 1990, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1990, make: "BUICK", model: "Roadmaster" },
  { type: "car", year: 1990, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1990, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Brougham" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1990, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Lumina" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Lumina APV" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "R Conventional" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1990, make: "CHEVROLET", model: "V Conventional" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "TC" },
  { type: "car", year: 1990, make: "CHRYSLER", model: "Town and Country" },
  { type: "car", year: 1990, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1990, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1990, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1990, make: "DODGE", model: "Colt" },
  { type: "car", year: 1990, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1990, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1990, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1990, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1990, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1990, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1990, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1990, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1990, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1990, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1990, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1990, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1990, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1990, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1990, make: "FERRARI", model: "348 tb" },
  { type: "car", year: 1990, make: "FERRARI", model: "348 ts" },
  { type: "car", year: 1990, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1990, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1990, make: "FORD", model: "'34" },
  { type: "car", year: 1990, make: "FORD", model: "A8513" },
  { type: "car", year: 1990, make: "FORD", model: "A9513" },
  { type: "car", year: 1990, make: "FORD", model: "A9522" },
  { type: "car", year: 1990, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1990, make: "FORD", model: "AT8513" },
  { type: "car", year: 1990, make: "FORD", model: "AT9513" },
  { type: "car", year: 1990, make: "FORD", model: "AT9522" },
  { type: "car", year: 1990, make: "FORD", model: "B600" },
  { type: "car", year: 1990, make: "FORD", model: "B700" },
  { type: "car", year: 1990, make: "FORD", model: "Bronco" },
  { type: "car", year: 1990, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1990, make: "FORD", model: "C800" },
  { type: "car", year: 1990, make: "FORD", model: "C8000" },
  { type: "car", year: 1990, make: "FORD", model: "CF6000" },
  { type: "car", year: 1990, make: "FORD", model: "CF7000" },
  { type: "car", year: 1990, make: "FORD", model: "CF8000" },
  { type: "car", year: 1990, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1990, make: "FORD", model: "CL9000" },
  { type: "car", year: 1990, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1990, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1990, make: "FORD", model: "CT8000" },
  { type: "car", year: 1990, make: "FORD", model: "E-150" },
  { type: "car", year: 1990, make: "FORD", model: "E-250" },
  { type: "car", year: 1990, make: "FORD", model: "E-350" },
  { type: "car", year: 1990, make: "FORD", model: "Escort" },
  { type: "car", year: 1990, make: "FORD", model: "F-150" },
  { type: "car", year: 1990, make: "FORD", model: "F-250" },
  { type: "car", year: 1990, make: "FORD", model: "F-350" },
  { type: "car", year: 1990, make: "FORD", model: "F-590" },
  { type: "car", year: 1990, make: "FORD", model: "F-600" },
  { type: "car", year: 1990, make: "FORD", model: "F-700" },
  { type: "car", year: 1990, make: "FORD", model: "F-800" },
  { type: "car", year: 1990, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1990, make: "FORD", model: "Festiva" },
  { type: "car", year: 1990, make: "FORD", model: "FT800" },
  { type: "car", year: 1990, make: "FORD", model: "FT900" },
  { type: "car", year: 1990, make: "FORD", model: "L8000" },
  { type: "car", year: 1990, make: "FORD", model: "L8513" },
  { type: "car", year: 1990, make: "FORD", model: "L9000" },
  { type: "car", year: 1990, make: "FORD", model: "L9513" },
  { type: "car", year: 1990, make: "FORD", model: "LA8000" },
  { type: "car", year: 1990, make: "FORD", model: "LA9000" },
  { type: "car", year: 1990, make: "FORD", model: "LL9000" },
  { type: "car", year: 1990, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1990, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1990, make: "FORD", model: "LN7000" },
  { type: "car", year: 1990, make: "FORD", model: "LN8000" },
  { type: "car", year: 1990, make: "FORD", model: "LN9000" },
  { type: "car", year: 1990, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1990, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1990, make: "FORD", model: "LS8000" },
  { type: "car", year: 1990, make: "FORD", model: "LS9000" },
  { type: "car", year: 1990, make: "FORD", model: "LT8000" },
  { type: "car", year: 1990, make: "FORD", model: "LT8501" },
  { type: "car", year: 1990, make: "FORD", model: "LT8513" },
  { type: "car", year: 1990, make: "FORD", model: "LT9000" },
  { type: "car", year: 1990, make: "FORD", model: "LT9501" },
  { type: "car", year: 1990, make: "FORD", model: "LT9513" },
  { type: "car", year: 1990, make: "FORD", model: "LT9522" },
  { type: "car", year: 1990, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1990, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1990, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1990, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1990, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1990, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1990, make: "FORD", model: "Mustang" },
  { type: "car", year: 1990, make: "FORD", model: "P600" },
  { type: "car", year: 1990, make: "FORD", model: "Probe" },
  { type: "car", year: 1990, make: "FORD", model: "Ranger" },
  { type: "car", year: 1990, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1990, make: "FORD", model: "Taurus" },
  { type: "car", year: 1990, make: "FORD", model: "Tempo" },
  { type: "car", year: 1990, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1990, make: "GEO", model: "Metro" },
  { type: "car", year: 1990, make: "GEO", model: "Prizm" },
  { type: "car", year: 1990, make: "GEO", model: "Sprint" },
  { type: "car", year: 1990, make: "GEO", model: "Storm" },
  { type: "car", year: 1990, make: "GEO", model: "Tracker" },
  { type: "car", year: 1990, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1990, make: "GMC", model: "Jimmy" },
  { type: "car", year: 1990, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1990, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1990, make: "GMC", model: "R Conventional" },
  { type: "car", year: 1990, make: "GMC", model: "Rally" },
  { type: "car", year: 1990, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1990, make: "GMC", model: "Safari" },
  { type: "car", year: 1990, make: "GMC", model: "Sierra" },
  { type: "car", year: 1990, make: "GMC", model: "Suburban" },
  { type: "car", year: 1990, make: "GMC", model: "V Conventional" },
  { type: "car", year: 1990, make: "HONDA", model: "Accord" },
  { type: "car", year: 1990, make: "HONDA", model: "Civic" },
  { type: "car", year: 1990, make: "HONDA", model: "Civic Si" },
  { type: "car", year: 1990, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1990, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1990, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1990, make: "INFINITI", model: "M30" },
  { type: "car", year: 1990, make: "INFINITI", model: "Q45" },
  { type: "car", year: 1990, make: "ISUZU", model: "Amigo" },
  { type: "car", year: 1990, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1990, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1990, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1990, make: "ISUZU", model: "Stylus" },
  { type: "car", year: 1990, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1990, make: "ISUZU", model: "Trooper II" },
  { type: "car", year: 1990, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1990, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1990, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1990, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1990, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1990, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1990, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1990, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1990, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1990, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1990, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1990, make: "LEXUS", model: "ES" },
  { type: "car", year: 1990, make: "LEXUS", model: "LS" },
  { type: "car", year: 1990, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1990, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1990, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1990, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1990, make: "LOTUS", model: "Elan" },
  { type: "car", year: 1990, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1990, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1990, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1990, make: "MASERATI", model: "228" },
  { type: "car", year: 1990, make: "MASERATI", model: "430" },
  { type: "car", year: 1990, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1990, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1990, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1990, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1990, make: "MASERATI", model: "TC" },
  { type: "car", year: 1990, make: "MAZDA", model: "323" },
  { type: "car", year: 1990, make: "MAZDA", model: "626" },
  { type: "car", year: 1990, make: "MAZDA", model: "929" },
  { type: "car", year: 1990, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1990, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1990, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1990, make: "MAZDA", model: "MX-5" },
  { type: "car", year: 1990, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1990, make: "MAZDA", model: "Protege" },
  { type: "car", year: 1990, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1990, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1990, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1990, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1990, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1990, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1990, make: "MERCEDES-BENZ", model: "560" },
  { type: "car", year: 1990, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1990, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1990, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1990, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1990, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1990, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Eclipse" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Sigma" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "SPX" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Van" },
  { type: "car", year: 1990, make: "MITSUBISHI", model: "Wagon" },
  { type: "car", year: 1990, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1990, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1990, make: "NISSAN", model: "Axxess" },
  { type: "car", year: 1990, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1990, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1990, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1990, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1990, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1990, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1990, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1990, make: "NISSAN", model: "Van" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Silhouette" },
  { type: "car", year: 1990, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1990, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1990, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "Laser" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1990, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1990, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Tempest" },
  { type: "car", year: 1990, make: "PONTIAC", model: "Trans Sport" },
  { type: "car", year: 1990, make: "PORSCHE", model: "911" },
  { type: "car", year: 1990, make: "PORSCHE", model: "928" },
  { type: "car", year: 1990, make: "PORSCHE", model: "944" },
  { type: "car", year: 1990, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1990, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1990, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1990, make: "SAAB", model: "900" },
  { type: "car", year: 1990, make: "SAAB", model: "9000" },
  { type: "car", year: 1990, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1990, make: "SUBARU", model: "Legacy" },
  { type: "car", year: 1990, make: "SUBARU", model: "Loyale" },
  { type: "car", year: 1990, make: "SUBARU", model: "XT" },
  { type: "car", year: 1990, make: "SUBARU", model: "XT6" },
  { type: "car", year: 1990, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1990, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1990, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1990, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1990, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1990, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1990, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1990, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1990, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1990, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1990, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1989, make: "ACURA", model: "CL" },
  { type: "car", year: 1989, make: "ACURA", model: "Integra" },
  { type: "car", year: 1989, make: "ACURA", model: "Legend" },
  { type: "car", year: 1989, make: "ACURA", model: "NSX" },
  { type: "car", year: 1989, make: "ACURA", model: "RL" },
  { type: "car", year: 1989, make: "ACURA", model: "TL" },
  { type: "car", year: 1989, make: "ALFA ROMEO", model: "Milano" },
  { type: "car", year: 1989, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1989, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1989, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1989, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1989, make: "AUDI", model: "100" },
  { type: "car", year: 1989, make: "AUDI", model: "200" },
  { type: "car", year: 1989, make: "AUDI", model: "80" },
  { type: "car", year: 1989, make: "AUDI", model: "90" },
  { type: "car", year: 1989, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1989, make: "BENTLEY", model: "Eight" },
  { type: "car", year: 1989, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1989, make: "BENTLEY", model: "Turbo" },
  { type: "car", year: 1989, make: "BMW", model: "325i" },
  { type: "car", year: 1989, make: "BMW", model: "325i/325is" },
  { type: "car", year: 1989, make: "BMW", model: "325iC" },
  { type: "car", year: 1989, make: "BMW", model: "325ix" },
  { type: "car", year: 1989, make: "BMW", model: "525i" },
  { type: "car", year: 1989, make: "BMW", model: "535i" },
  { type: "car", year: 1989, make: "BMW", model: "635CSi" },
  { type: "car", year: 1989, make: "BMW", model: "735i" },
  { type: "car", year: 1989, make: "BMW", model: "735iL" },
  { type: "car", year: 1989, make: "BMW", model: "750iL" },
  { type: "car", year: 1989, make: "BMW", model: "840Ci" },
  { type: "car", year: 1989, make: "BMW", model: "850Ci" },
  { type: "car", year: 1989, make: "BMW", model: "850CSi" },
  { type: "car", year: 1989, make: "BMW", model: "M3" },
  { type: "car", year: 1989, make: "BUICK", model: "Century" },
  { type: "car", year: 1989, make: "BUICK", model: "Electra" },
  { type: "car", year: 1989, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1989, make: "BUICK", model: "Reatta" },
  { type: "car", year: 1989, make: "BUICK", model: "Regal" },
  { type: "car", year: 1989, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1989, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1989, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Brougham" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1989, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Geo Spectrum" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "R Conventional" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1989, make: "CHEVROLET", model: "V Conventional" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "Conquest" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "FIFTH AVENUE" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1989, make: "CHRYSLER", model: "TC" },
  { type: "car", year: 1989, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1989, make: "DAIHATSU", model: "Rocky" },
  { type: "car", year: 1989, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1989, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1989, make: "DODGE", model: "Colt" },
  { type: "car", year: 1989, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1989, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1989, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1989, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1989, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1989, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1989, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1989, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1989, make: "DODGE", model: "Raider" },
  { type: "car", year: 1989, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1989, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1989, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1989, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1989, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1989, make: "DODGE", model: "Spirit" },
  { type: "car", year: 1989, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1989, make: "FERRARI", model: "3.2 Mondial" },
  { type: "car", year: 1989, make: "FERRARI", model: "328" },
  { type: "car", year: 1989, make: "FERRARI", model: "328 GTB" },
  { type: "car", year: 1989, make: "FERRARI", model: "328 GTS" },
  { type: "car", year: 1989, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1989, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1989, make: "FORD", model: "'34" },
  { type: "car", year: 1989, make: "FORD", model: "A9513" },
  { type: "car", year: 1989, make: "FORD", model: "A9522" },
  { type: "car", year: 1989, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1989, make: "FORD", model: "AT8513" },
  { type: "car", year: 1989, make: "FORD", model: "AT9513" },
  { type: "car", year: 1989, make: "FORD", model: "AT9522" },
  { type: "car", year: 1989, make: "FORD", model: "B600" },
  { type: "car", year: 1989, make: "FORD", model: "B700" },
  { type: "car", year: 1989, make: "FORD", model: "Bronco" },
  { type: "car", year: 1989, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1989, make: "FORD", model: "C800" },
  { type: "car", year: 1989, make: "FORD", model: "C8000" },
  { type: "car", year: 1989, make: "FORD", model: "CF6000" },
  { type: "car", year: 1989, make: "FORD", model: "CF7000" },
  { type: "car", year: 1989, make: "FORD", model: "CF8000" },
  { type: "car", year: 1989, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1989, make: "FORD", model: "CL9000" },
  { type: "car", year: 1989, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1989, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1989, make: "FORD", model: "CT8000" },
  { type: "car", year: 1989, make: "FORD", model: "E-150" },
  { type: "car", year: 1989, make: "FORD", model: "E-250" },
  { type: "car", year: 1989, make: "FORD", model: "E-350" },
  { type: "car", year: 1989, make: "FORD", model: "Escort" },
  { type: "car", year: 1989, make: "FORD", model: "F-150" },
  { type: "car", year: 1989, make: "FORD", model: "F-250" },
  { type: "car", year: 1989, make: "FORD", model: "F-350" },
  { type: "car", year: 1989, make: "FORD", model: "F-590" },
  { type: "car", year: 1989, make: "FORD", model: "F-600" },
  { type: "car", year: 1989, make: "FORD", model: "F-700" },
  { type: "car", year: 1989, make: "FORD", model: "F-800" },
  { type: "car", year: 1989, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1989, make: "FORD", model: "Festiva" },
  { type: "car", year: 1989, make: "FORD", model: "FT800" },
  { type: "car", year: 1989, make: "FORD", model: "FT900" },
  { type: "car", year: 1989, make: "FORD", model: "L8000" },
  { type: "car", year: 1989, make: "FORD", model: "L9000" },
  { type: "car", year: 1989, make: "FORD", model: "L9513" },
  { type: "car", year: 1989, make: "FORD", model: "LA8000" },
  { type: "car", year: 1989, make: "FORD", model: "LA9000" },
  { type: "car", year: 1989, make: "FORD", model: "LL9000" },
  { type: "car", year: 1989, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1989, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1989, make: "FORD", model: "LN7000" },
  { type: "car", year: 1989, make: "FORD", model: "LN8000" },
  { type: "car", year: 1989, make: "FORD", model: "LN9000" },
  { type: "car", year: 1989, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1989, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1989, make: "FORD", model: "LS8000" },
  { type: "car", year: 1989, make: "FORD", model: "LS9000" },
  { type: "car", year: 1989, make: "FORD", model: "LT8000" },
  { type: "car", year: 1989, make: "FORD", model: "LT8501" },
  { type: "car", year: 1989, make: "FORD", model: "LT8513" },
  { type: "car", year: 1989, make: "FORD", model: "LT9000" },
  { type: "car", year: 1989, make: "FORD", model: "LT9501" },
  { type: "car", year: 1989, make: "FORD", model: "LT9513" },
  { type: "car", year: 1989, make: "FORD", model: "LT9522" },
  { type: "car", year: 1989, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1989, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1989, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1989, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1989, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1989, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1989, make: "FORD", model: "Mustang" },
  { type: "car", year: 1989, make: "FORD", model: "P600" },
  { type: "car", year: 1989, make: "FORD", model: "Probe" },
  { type: "car", year: 1989, make: "FORD", model: "Ranger" },
  { type: "car", year: 1989, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1989, make: "FORD", model: "Taurus" },
  { type: "car", year: 1989, make: "FORD", model: "Tempo" },
  { type: "car", year: 1989, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1989, make: "GEO", model: "Metro" },
  { type: "car", year: 1989, make: "GEO", model: "Prizm" },
  { type: "car", year: 1989, make: "GEO", model: "Spectrum" },
  { type: "car", year: 1989, make: "GEO", model: "Sprint" },
  { type: "car", year: 1989, make: "GEO", model: "Storm" },
  { type: "car", year: 1989, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1989, make: "GMC", model: "Jimmy" },
  { type: "car", year: 1989, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1989, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1989, make: "GMC", model: "R Conventional" },
  { type: "car", year: 1989, make: "GMC", model: "Rally" },
  { type: "car", year: 1989, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1989, make: "GMC", model: "Safari" },
  { type: "car", year: 1989, make: "GMC", model: "Sierra" },
  { type: "car", year: 1989, make: "GMC", model: "Suburban" },
  { type: "car", year: 1989, make: "GMC", model: "V Conventional" },
  { type: "car", year: 1989, make: "HONDA", model: "Accord" },
  { type: "car", year: 1989, make: "HONDA", model: "Civic" },
  { type: "car", year: 1989, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1989, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1989, make: "HYUNDAI", model: "Pony" },
  { type: "car", year: 1989, make: "HYUNDAI", model: "Sonata" },
  { type: "car", year: 1989, make: "HYUNDAI", model: "Stellar" },
  { type: "car", year: 1989, make: "ISUZU", model: "Amigo" },
  { type: "car", year: 1989, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1989, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1989, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1989, make: "ISUZU", model: "Rodeo" },
  { type: "car", year: 1989, make: "ISUZU", model: "Stylus" },
  { type: "car", year: 1989, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1989, make: "ISUZU", model: "Trooper II" },
  { type: "car", year: 1989, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1989, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1989, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1989, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1989, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1989, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1989, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1989, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1989, make: "LAMBORGHINI", model: "Diablo" },
  { type: "car", year: 1989, make: "LAMBORGHINI", model: "Roadster" },
  { type: "car", year: 1989, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1989, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1989, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1989, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1989, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1989, make: "MASERATI", model: "228" },
  { type: "car", year: 1989, make: "MASERATI", model: "430" },
  { type: "car", year: 1989, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1989, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1989, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1989, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1989, make: "MASERATI", model: "TC" },
  { type: "car", year: 1989, make: "MAZDA", model: "323" },
  { type: "car", year: 1989, make: "MAZDA", model: "626" },
  { type: "car", year: 1989, make: "MAZDA", model: "929" },
  { type: "car", year: 1989, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1989, make: "MAZDA", model: "MPV" },
  { type: "car", year: 1989, make: "MAZDA", model: "MX-3" },
  { type: "car", year: 1989, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1989, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1989, make: "MERCEDES-BENZ", model: "560" },
  { type: "car", year: 1989, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1989, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1989, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1989, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1989, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1989, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Sigma" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "SPX" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Van" },
  { type: "car", year: 1989, make: "MITSUBISHI", model: "Wagon" },
  { type: "car", year: 1989, make: "NISSAN", model: "240SX" },
  { type: "car", year: 1989, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1989, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1989, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1989, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1989, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1989, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1989, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1989, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1989, make: "NISSAN", model: "Stanza Wagon" },
  { type: "car", year: 1989, make: "NISSAN", model: "Van" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Eighty Eight (88)" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1989, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1989, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1989, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1989, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1989, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Safari" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1989, make: "PONTIAC", model: "Tempest" },
  { type: "car", year: 1989, make: "PORSCHE", model: "911" },
  { type: "car", year: 1989, make: "PORSCHE", model: "928" },
  { type: "car", year: 1989, make: "PORSCHE", model: "944" },
  { type: "car", year: 1989, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1989, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1989, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1989, make: "SAAB", model: "900" },
  { type: "car", year: 1989, make: "SAAB", model: "9000" },
  { type: "car", year: 1989, make: "SUBARU", model: "DL" },
  { type: "car", year: 1989, make: "SUBARU", model: "GL" },
  { type: "car", year: 1989, make: "SUBARU", model: "GL-10" },
  { type: "car", year: 1989, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1989, make: "SUBARU", model: "RX" },
  { type: "car", year: 1989, make: "SUBARU", model: "XT" },
  { type: "car", year: 1989, make: "SUBARU", model: "XT6" },
  { type: "car", year: 1989, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1989, make: "SUZUKI", model: "Sidekick" },
  { type: "car", year: 1989, make: "SUZUKI", model: "Sidekick Sport" },
  { type: "car", year: 1989, make: "SUZUKI", model: "Swift" },
  { type: "car", year: 1989, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1989, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1989, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1989, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1989, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1989, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1989, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1989, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1988, make: "ACURA", model: "CL" },
  { type: "car", year: 1988, make: "ACURA", model: "Integra" },
  { type: "car", year: 1988, make: "ACURA", model: "Legend" },
  { type: "car", year: 1988, make: "ACURA", model: "NSX" },
  { type: "car", year: 1988, make: "ACURA", model: "RL" },
  { type: "car", year: 1988, make: "ACURA", model: "TL" },
  { type: "car", year: 1988, make: "ALFA ROMEO", model: "Milano" },
  { type: "car", year: 1988, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1988, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1988, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1988, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1988, make: "AUDI", model: "5000" },
  { type: "car", year: 1988, make: "AUDI", model: "80" },
  { type: "car", year: 1988, make: "AUDI", model: "90" },
  { type: "car", year: 1988, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1988, make: "BENTLEY", model: "Eight" },
  { type: "car", year: 1988, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1988, make: "BMW", model: "325/325e" },
  { type: "car", year: 1988, make: "BMW", model: "325/325eS" },
  { type: "car", year: 1988, make: "BMW", model: "325i" },
  { type: "car", year: 1988, make: "BMW", model: "325iC" },
  { type: "car", year: 1988, make: "BMW", model: "325iS" },
  { type: "car", year: 1988, make: "BMW", model: "325ix" },
  { type: "car", year: 1988, make: "BMW", model: "528e" },
  { type: "car", year: 1988, make: "BMW", model: "535i" },
  { type: "car", year: 1988, make: "BMW", model: "535i/535is" },
  { type: "car", year: 1988, make: "BMW", model: "635CSi" },
  { type: "car", year: 1988, make: "BMW", model: "735i" },
  { type: "car", year: 1988, make: "BMW", model: "735iL" },
  { type: "car", year: 1988, make: "BMW", model: "750iL" },
  { type: "car", year: 1988, make: "BMW", model: "840Ci" },
  { type: "car", year: 1988, make: "BMW", model: "850Ci" },
  { type: "car", year: 1988, make: "BMW", model: "850CSi" },
  { type: "car", year: 1988, make: "BMW", model: "L7" },
  { type: "car", year: 1988, make: "BMW", model: "M3" },
  { type: "car", year: 1988, make: "BMW", model: "M5" },
  { type: "car", year: 1988, make: "BMW", model: "M6" },
  { type: "car", year: 1988, make: "BUICK", model: "Century" },
  { type: "car", year: 1988, make: "BUICK", model: "Electra" },
  { type: "car", year: 1988, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1988, make: "BUICK", model: "Reatta" },
  { type: "car", year: 1988, make: "BUICK", model: "Regal" },
  { type: "car", year: 1988, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1988, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1988, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Brougham" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1988, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Geo Spectrum" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Geo Sprint" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Nova" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "R Conventional" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1988, make: "CHEVROLET", model: "V Conventional" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "Conquest" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "FIFTH AVENUE" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "Shadow" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1988, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1988, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1988, make: "DODGE", model: "600" },
  { type: "car", year: 1988, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1988, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1988, make: "DODGE", model: "Colt" },
  { type: "car", year: 1988, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1988, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1988, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1988, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1988, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1988, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1988, make: "DODGE", model: "Grand Caravan" },
  { type: "car", year: 1988, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1988, make: "DODGE", model: "Mini Ram" },
  { type: "car", year: 1988, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1988, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1988, make: "DODGE", model: "Raider" },
  { type: "car", year: 1988, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1988, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1988, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1988, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1988, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1988, make: "DODGE", model: "Shelby Charger" },
  { type: "car", year: 1988, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1988, make: "FERRARI", model: "3.2 Mondial" },
  { type: "car", year: 1988, make: "FERRARI", model: "328" },
  { type: "car", year: 1988, make: "FERRARI", model: "328 GTB" },
  { type: "car", year: 1988, make: "FERRARI", model: "328 GTS" },
  { type: "car", year: 1988, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1988, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1988, make: "FORD", model: "'34" },
  { type: "car", year: 1988, make: "FORD", model: "A9513" },
  { type: "car", year: 1988, make: "FORD", model: "A9522" },
  { type: "car", year: 1988, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1988, make: "FORD", model: "AT8513" },
  { type: "car", year: 1988, make: "FORD", model: "AT9513" },
  { type: "car", year: 1988, make: "FORD", model: "AT9522" },
  { type: "car", year: 1988, make: "FORD", model: "B600" },
  { type: "car", year: 1988, make: "FORD", model: "B700" },
  { type: "car", year: 1988, make: "FORD", model: "Bronco" },
  { type: "car", year: 1988, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1988, make: "FORD", model: "C800" },
  { type: "car", year: 1988, make: "FORD", model: "C8000" },
  { type: "car", year: 1988, make: "FORD", model: "CF6000" },
  { type: "car", year: 1988, make: "FORD", model: "CF7000" },
  { type: "car", year: 1988, make: "FORD", model: "CF8000" },
  { type: "car", year: 1988, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1988, make: "FORD", model: "CL9000" },
  { type: "car", year: 1988, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1988, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1988, make: "FORD", model: "CT8000" },
  { type: "car", year: 1988, make: "FORD", model: "E-150" },
  { type: "car", year: 1988, make: "FORD", model: "E-250" },
  { type: "car", year: 1988, make: "FORD", model: "E-350" },
  { type: "car", year: 1988, make: "FORD", model: "Escort" },
  { type: "car", year: 1988, make: "FORD", model: "F-150" },
  { type: "car", year: 1988, make: "FORD", model: "F-250" },
  { type: "car", year: 1988, make: "FORD", model: "F-350" },
  { type: "car", year: 1988, make: "FORD", model: "F-590" },
  { type: "car", year: 1988, make: "FORD", model: "F-600" },
  { type: "car", year: 1988, make: "FORD", model: "F-700" },
  { type: "car", year: 1988, make: "FORD", model: "F-800" },
  { type: "car", year: 1988, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1988, make: "FORD", model: "Festiva" },
  { type: "car", year: 1988, make: "FORD", model: "FT800" },
  { type: "car", year: 1988, make: "FORD", model: "FT900" },
  { type: "car", year: 1988, make: "FORD", model: "L8000" },
  { type: "car", year: 1988, make: "FORD", model: "L9000" },
  { type: "car", year: 1988, make: "FORD", model: "L9513" },
  { type: "car", year: 1988, make: "FORD", model: "LA8000" },
  { type: "car", year: 1988, make: "FORD", model: "LA9000" },
  { type: "car", year: 1988, make: "FORD", model: "LL9000" },
  { type: "car", year: 1988, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1988, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1988, make: "FORD", model: "LN7000" },
  { type: "car", year: 1988, make: "FORD", model: "LN8000" },
  { type: "car", year: 1988, make: "FORD", model: "LN9000" },
  { type: "car", year: 1988, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1988, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1988, make: "FORD", model: "LS8000" },
  { type: "car", year: 1988, make: "FORD", model: "LS9000" },
  { type: "car", year: 1988, make: "FORD", model: "LT8000" },
  { type: "car", year: 1988, make: "FORD", model: "LT8501" },
  { type: "car", year: 1988, make: "FORD", model: "LT8513" },
  { type: "car", year: 1988, make: "FORD", model: "LT9000" },
  { type: "car", year: 1988, make: "FORD", model: "LT9501" },
  { type: "car", year: 1988, make: "FORD", model: "LT9513" },
  { type: "car", year: 1988, make: "FORD", model: "LT9522" },
  { type: "car", year: 1988, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1988, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1988, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1988, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1988, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1988, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1988, make: "FORD", model: "Mustang" },
  { type: "car", year: 1988, make: "FORD", model: "P600" },
  { type: "car", year: 1988, make: "FORD", model: "Probe" },
  { type: "car", year: 1988, make: "FORD", model: "Ranger" },
  { type: "car", year: 1988, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1988, make: "FORD", model: "Taurus" },
  { type: "car", year: 1988, make: "FORD", model: "Tempo" },
  { type: "car", year: 1988, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1988, make: "GEO", model: "Storm" },
  { type: "car", year: 1988, make: "GMC", model: "GMT-400" },
  { type: "car", year: 1988, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1988, make: "GMC", model: "Jimmy" },
  { type: "car", year: 1988, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1988, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1988, make: "GMC", model: "R Conventional" },
  { type: "car", year: 1988, make: "GMC", model: "Rally" },
  { type: "car", year: 1988, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1988, make: "GMC", model: "Safari" },
  { type: "car", year: 1988, make: "GMC", model: "Suburban" },
  { type: "car", year: 1988, make: "GMC", model: "V Conventional" },
  { type: "car", year: 1988, make: "HONDA", model: "Accord" },
  { type: "car", year: 1988, make: "HONDA", model: "Civic" },
  { type: "car", year: 1988, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1988, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1988, make: "HYUNDAI", model: "Pony" },
  { type: "car", year: 1988, make: "HYUNDAI", model: "Stellar" },
  { type: "car", year: 1988, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1988, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1988, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1988, make: "ISUZU", model: "Stylus" },
  { type: "car", year: 1988, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1988, make: "ISUZU", model: "Trooper II" },
  { type: "car", year: 1988, make: "JAGUAR", model: "Vanden Plas" },
  { type: "car", year: 1988, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1988, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1988, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1988, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1988, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1988, make: "JEEP", model: "J-10" },
  { type: "car", year: 1988, make: "JEEP", model: "J-20" },
  { type: "car", year: 1988, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1988, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1988, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1988, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1988, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1988, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1988, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1988, make: "MASERATI", model: "228" },
  { type: "car", year: 1988, make: "MASERATI", model: "430" },
  { type: "car", year: 1988, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1988, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1988, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1988, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1988, make: "MASERATI", model: "TC" },
  { type: "car", year: 1988, make: "MAZDA", model: "323" },
  { type: "car", year: 1988, make: "MAZDA", model: "626" },
  { type: "car", year: 1988, make: "MAZDA", model: "929" },
  { type: "car", year: 1988, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1988, make: "MAZDA", model: "MX-6" },
  { type: "car", year: 1988, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1988, make: "MERCEDES-BENZ", model: "560" },
  { type: "car", year: 1988, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1988, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1988, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1988, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1988, make: "MERCURY", model: "Tracer" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Cordia" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Precis" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Space Wagon" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "SPX" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Tredia" },
  { type: "car", year: 1988, make: "MITSUBISHI", model: "Van" },
  { type: "car", year: 1988, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1988, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1988, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1988, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1988, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1988, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1988, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1988, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1988, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1988, make: "NISSAN", model: "Stanza Wagon" },
  { type: "car", year: 1988, make: "NISSAN", model: "Van" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1988, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1988, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1988, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "Grand Voyager" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "TURISMO" },
  { type: "car", year: 1988, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1988, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Fiero" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Safari" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1988, make: "PONTIAC", model: "Tempest" },
  { type: "car", year: 1988, make: "PORSCHE", model: "911" },
  { type: "car", year: 1988, make: "PORSCHE", model: "924" },
  { type: "car", year: 1988, make: "PORSCHE", model: "944" },
  { type: "car", year: 1988, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1988, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1988, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1988, make: "SAAB", model: "900" },
  { type: "car", year: 1988, make: "SAAB", model: "9000" },
  { type: "car", year: 1988, make: "SUBARU", model: "DL" },
  { type: "car", year: 1988, make: "SUBARU", model: "GL" },
  { type: "car", year: 1988, make: "SUBARU", model: "GL-10" },
  { type: "car", year: 1988, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1988, make: "SUBARU", model: "RX" },
  { type: "car", year: 1988, make: "SUBARU", model: "XT" },
  { type: "car", year: 1988, make: "SUBARU", model: "XT6" },
  { type: "car", year: 1988, make: "SUZUKI", model: "Forsa" },
  { type: "car", year: 1988, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1988, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1988, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1988, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1988, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1988, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1988, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1988, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1988, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1987, make: "ACURA", model: "CL" },
  { type: "car", year: 1987, make: "ACURA", model: "Integra" },
  { type: "car", year: 1987, make: "ACURA", model: "Legend" },
  { type: "car", year: 1987, make: "ACURA", model: "NSX" },
  { type: "car", year: 1987, make: "ACURA", model: "RL" },
  { type: "car", year: 1987, make: "ACURA", model: "TL" },
  { type: "car", year: 1987, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1987, make: "ALFA ROMEO", model: "Milano" },
  { type: "car", year: 1987, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1987, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1987, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1987, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1987, make: "AUDI", model: "4000" },
  { type: "car", year: 1987, make: "AUDI", model: "5000" },
  { type: "car", year: 1987, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1987, make: "BENTLEY", model: "Eight" },
  { type: "car", year: 1987, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1987, make: "BMW", model: "318ti" },
  { type: "car", year: 1987, make: "BMW", model: "320i" },
  { type: "car", year: 1987, make: "BMW", model: "325/325e" },
  { type: "car", year: 1987, make: "BMW", model: "325/325eS" },
  { type: "car", year: 1987, make: "BMW", model: "325i" },
  { type: "car", year: 1987, make: "BMW", model: "325iC" },
  { type: "car", year: 1987, make: "BMW", model: "325iS" },
  { type: "car", year: 1987, make: "BMW", model: "528e" },
  { type: "car", year: 1987, make: "BMW", model: "535i" },
  { type: "car", year: 1987, make: "BMW", model: "535i/535is" },
  { type: "car", year: 1987, make: "BMW", model: "635CSi" },
  { type: "car", year: 1987, make: "BMW", model: "735i" },
  { type: "car", year: 1987, make: "BMW", model: "840Ci" },
  { type: "car", year: 1987, make: "BMW", model: "850Ci" },
  { type: "car", year: 1987, make: "BMW", model: "850CSi" },
  { type: "car", year: 1987, make: "BMW", model: "L7" },
  { type: "car", year: 1987, make: "BMW", model: "M6" },
  { type: "car", year: 1987, make: "BUICK", model: "Century" },
  { type: "car", year: 1987, make: "BUICK", model: "Electra" },
  { type: "car", year: 1987, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1987, make: "BUICK", model: "Regal" },
  { type: "car", year: 1987, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1987, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1987, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1987, make: "BUICK", model: "Somerset" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Allante" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Brougham" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1987, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Geo Spectrum" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Geo Sprint" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "GMT-400" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Nova" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "R Conventional" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1987, make: "CHEVROLET", model: "V Conventional" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "Conquest" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "FIFTH AVENUE" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "Shadow" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1987, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1987, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1987, make: "DODGE", model: "600" },
  { type: "car", year: 1987, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1987, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1987, make: "DODGE", model: "Charger" },
  { type: "car", year: 1987, make: "DODGE", model: "Colt" },
  { type: "car", year: 1987, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1987, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1987, make: "DODGE", model: "Dakota" },
  { type: "car", year: 1987, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1987, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1987, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1987, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1987, make: "DODGE", model: "Mini Ram" },
  { type: "car", year: 1987, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1987, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1987, make: "DODGE", model: "Raider" },
  { type: "car", year: 1987, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1987, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1987, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1987, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1987, make: "DODGE", model: "Shadow" },
  { type: "car", year: 1987, make: "DODGE", model: "Shelby Charger" },
  { type: "car", year: 1987, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1987, make: "FERRARI", model: "3.2 Mondial" },
  { type: "car", year: 1987, make: "FERRARI", model: "328" },
  { type: "car", year: 1987, make: "FERRARI", model: "328 GTB" },
  { type: "car", year: 1987, make: "FERRARI", model: "328 GTS" },
  { type: "car", year: 1987, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1987, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1987, make: "FORD", model: "'34" },
  { type: "car", year: 1987, make: "FORD", model: "A9513" },
  { type: "car", year: 1987, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1987, make: "FORD", model: "AT8513" },
  { type: "car", year: 1987, make: "FORD", model: "AT9513" },
  { type: "car", year: 1987, make: "FORD", model: "AT9522" },
  { type: "car", year: 1987, make: "FORD", model: "B600" },
  { type: "car", year: 1987, make: "FORD", model: "B700" },
  { type: "car", year: 1987, make: "FORD", model: "B7000" },
  { type: "car", year: 1987, make: "FORD", model: "Bronco" },
  { type: "car", year: 1987, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1987, make: "FORD", model: "C7000" },
  { type: "car", year: 1987, make: "FORD", model: "C800" },
  { type: "car", year: 1987, make: "FORD", model: "C8000" },
  { type: "car", year: 1987, make: "FORD", model: "CF6000" },
  { type: "car", year: 1987, make: "FORD", model: "CF7000" },
  { type: "car", year: 1987, make: "FORD", model: "CF8000" },
  { type: "car", year: 1987, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1987, make: "FORD", model: "CL9000" },
  { type: "car", year: 1987, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1987, make: "FORD", model: "Crown Victoria" },
  { type: "car", year: 1987, make: "FORD", model: "CT8000" },
  { type: "car", year: 1987, make: "FORD", model: "E-150" },
  { type: "car", year: 1987, make: "FORD", model: "E-250" },
  { type: "car", year: 1987, make: "FORD", model: "E-350" },
  { type: "car", year: 1987, make: "FORD", model: "Escort" },
  { type: "car", year: 1987, make: "FORD", model: "F-150" },
  { type: "car", year: 1987, make: "FORD", model: "F-250" },
  { type: "car", year: 1987, make: "FORD", model: "F-350" },
  { type: "car", year: 1987, make: "FORD", model: "F-590" },
  { type: "car", year: 1987, make: "FORD", model: "F-600" },
  { type: "car", year: 1987, make: "FORD", model: "F-700" },
  { type: "car", year: 1987, make: "FORD", model: "F-800" },
  { type: "car", year: 1987, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1987, make: "FORD", model: "F7000" },
  { type: "car", year: 1987, make: "FORD", model: "F8000" },
  { type: "car", year: 1987, make: "FORD", model: "FT800" },
  { type: "car", year: 1987, make: "FORD", model: "FT8000" },
  { type: "car", year: 1987, make: "FORD", model: "FT900" },
  { type: "car", year: 1987, make: "FORD", model: "L8000" },
  { type: "car", year: 1987, make: "FORD", model: "L9000" },
  { type: "car", year: 1987, make: "FORD", model: "L9513" },
  { type: "car", year: 1987, make: "FORD", model: "LA8000" },
  { type: "car", year: 1987, make: "FORD", model: "LA9000" },
  { type: "car", year: 1987, make: "FORD", model: "Laser" },
  { type: "car", year: 1987, make: "FORD", model: "LL9000" },
  { type: "car", year: 1987, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1987, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1987, make: "FORD", model: "LN7000" },
  { type: "car", year: 1987, make: "FORD", model: "LN8000" },
  { type: "car", year: 1987, make: "FORD", model: "LN9000" },
  { type: "car", year: 1987, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1987, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1987, make: "FORD", model: "LS8000" },
  { type: "car", year: 1987, make: "FORD", model: "LS9000" },
  { type: "car", year: 1987, make: "FORD", model: "LT8000" },
  { type: "car", year: 1987, make: "FORD", model: "LT8501" },
  { type: "car", year: 1987, make: "FORD", model: "LT8513" },
  { type: "car", year: 1987, make: "FORD", model: "LT9000" },
  { type: "car", year: 1987, make: "FORD", model: "LT9501" },
  { type: "car", year: 1987, make: "FORD", model: "LT9513" },
  { type: "car", year: 1987, make: "FORD", model: "LT9522" },
  { type: "car", year: 1987, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1987, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1987, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1987, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1987, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1987, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1987, make: "FORD", model: "Mustang" },
  { type: "car", year: 1987, make: "FORD", model: "P600" },
  { type: "car", year: 1987, make: "FORD", model: "Ranger" },
  { type: "car", year: 1987, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1987, make: "FORD", model: "Taurus" },
  { type: "car", year: 1987, make: "FORD", model: "Tempo" },
  { type: "car", year: 1987, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1987, make: "GEO", model: "Storm" },
  { type: "car", year: 1987, make: "GMC", model: "GMT-400" },
  { type: "car", year: 1987, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1987, make: "GMC", model: "Jimmy" },
  { type: "car", year: 1987, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1987, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1987, make: "GMC", model: "R Conventional" },
  { type: "car", year: 1987, make: "GMC", model: "Rally" },
  { type: "car", year: 1987, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1987, make: "GMC", model: "Safari" },
  { type: "car", year: 1987, make: "GMC", model: "Suburban" },
  { type: "car", year: 1987, make: "GMC", model: "V Conventional" },
  { type: "car", year: 1987, make: "HONDA", model: "Accord" },
  { type: "car", year: 1987, make: "HONDA", model: "Civic" },
  { type: "car", year: 1987, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1987, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1987, make: "HYUNDAI", model: "Pony" },
  { type: "car", year: 1987, make: "HYUNDAI", model: "Stellar" },
  { type: "car", year: 1987, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1987, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1987, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1987, make: "ISUZU", model: "Stylus" },
  { type: "car", year: 1987, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1987, make: "ISUZU", model: "Trooper II" },
  { type: "car", year: 1987, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1987, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1987, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1987, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1987, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1987, make: "JEEP", model: "J-10" },
  { type: "car", year: 1987, make: "JEEP", model: "J-20" },
  { type: "car", year: 1987, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1987, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1987, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1987, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1987, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1987, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1987, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1987, make: "MASERATI", model: "228" },
  { type: "car", year: 1987, make: "MASERATI", model: "430" },
  { type: "car", year: 1987, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1987, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1987, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1987, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1987, make: "MASERATI", model: "TC" },
  { type: "car", year: 1987, make: "MAZDA", model: "323" },
  { type: "car", year: 1987, make: "MAZDA", model: "626" },
  { type: "car", year: 1987, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1987, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1987, make: "MERCEDES-BENZ", model: "560" },
  { type: "car", year: 1987, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1987, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1987, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1987, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1987, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Cordia" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Space Wagon" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "SPX" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Tredia" },
  { type: "car", year: 1987, make: "MITSUBISHI", model: "Van" },
  { type: "car", year: 1987, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1987, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1987, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1987, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1987, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1987, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1987, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1987, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1987, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1987, make: "NISSAN", model: "Stanza Wagon" },
  { type: "car", year: 1987, make: "NISSAN", model: "Van" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Cutlass Salon" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1987, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1987, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1987, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "Sundance" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "TURISMO" },
  { type: "car", year: 1987, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1987, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Fiero" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Safari" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Sunburst" },
  { type: "car", year: 1987, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1987, make: "PONTIAC", model: "Tempest" },
  { type: "car", year: 1987, make: "PORSCHE", model: "911" },
  { type: "car", year: 1987, make: "PORSCHE", model: "924" },
  { type: "car", year: 1987, make: "PORSCHE", model: "944" },
  { type: "car", year: 1987, make: "RENAULT", model: "Alliance" },
  { type: "car", year: 1987, make: "RENAULT", model: "Encore" },
  { type: "car", year: 1987, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1987, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1987, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1987, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1987, make: "SAAB", model: "900" },
  { type: "car", year: 1987, make: "SAAB", model: "9000" },
  { type: "car", year: 1987, make: "SUBARU", model: "DL" },
  { type: "car", year: 1987, make: "SUBARU", model: "GL" },
  { type: "car", year: 1987, make: "SUBARU", model: "GL-10" },
  { type: "car", year: 1987, make: "SUBARU", model: "Justy" },
  { type: "car", year: 1987, make: "SUBARU", model: "RX" },
  { type: "car", year: 1987, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1987, make: "SUBARU", model: "XT" },
  { type: "car", year: 1987, make: "SUZUKI", model: "Forsa" },
  { type: "car", year: 1987, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1987, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1987, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1987, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1987, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1987, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1987, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1987, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1987, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1986, make: "ACURA", model: "Integra" },
  { type: "car", year: 1986, make: "ACURA", model: "Legend" },
  { type: "car", year: 1986, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1986, make: "ALFA ROMEO", model: "GTV6" },
  { type: "car", year: 1986, make: "ALFA ROMEO", model: "Milano" },
  { type: "car", year: 1986, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1986, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1986, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1986, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1986, make: "AUDI", model: "4000" },
  { type: "car", year: 1986, make: "AUDI", model: "5000" },
  { type: "car", year: 1986, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1986, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1986, make: "BMW", model: "318ti" },
  { type: "car", year: 1986, make: "BMW", model: "325/325e" },
  { type: "car", year: 1986, make: "BMW", model: "325/325eS" },
  { type: "car", year: 1986, make: "BMW", model: "325ix" },
  { type: "car", year: 1986, make: "BMW", model: "524td" },
  { type: "car", year: 1986, make: "BMW", model: "528e" },
  { type: "car", year: 1986, make: "BMW", model: "535i/535is" },
  { type: "car", year: 1986, make: "BMW", model: "635CSi" },
  { type: "car", year: 1986, make: "BMW", model: "735i" },
  { type: "car", year: 1986, make: "BMW", model: "735iL" },
  { type: "car", year: 1986, make: "BMW", model: "840Ci" },
  { type: "car", year: 1986, make: "BMW", model: "850Ci" },
  { type: "car", year: 1986, make: "BMW", model: "850CSi" },
  { type: "car", year: 1986, make: "BMW", model: "L7" },
  { type: "car", year: 1986, make: "BMW", model: "M6" },
  { type: "car", year: 1986, make: "BUICK", model: "Century" },
  { type: "car", year: 1986, make: "BUICK", model: "Electra" },
  { type: "car", year: 1986, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1986, make: "BUICK", model: "Regal" },
  { type: "car", year: 1986, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1986, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1986, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1986, make: "BUICK", model: "Somerset" },
  { type: "car", year: 1986, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1986, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1986, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1986, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1986, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Geo Spectrum" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Geo Sprint" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Nova" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1986, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "FIFTH AVENUE" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "Laser" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "Stratus" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1986, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1986, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1986, make: "DELOREAN", model: "DMC-12" },
  { type: "car", year: 1986, make: "DODGE", model: "600" },
  { type: "car", year: 1986, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1986, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1986, make: "DODGE", model: "Charger" },
  { type: "car", year: 1986, make: "DODGE", model: "Colt" },
  { type: "car", year: 1986, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1986, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1986, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1986, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1986, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1986, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1986, make: "DODGE", model: "Mini Ram" },
  { type: "car", year: 1986, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1986, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1986, make: "DODGE", model: "Raider" },
  { type: "car", year: 1986, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1986, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1986, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1986, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1986, make: "DODGE", model: "Shelby Charger" },
  { type: "car", year: 1986, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1986, make: "FERRARI", model: "3.2 Mondial" },
  { type: "car", year: 1986, make: "FERRARI", model: "328" },
  { type: "car", year: 1986, make: "FERRARI", model: "328 GTB" },
  { type: "car", year: 1986, make: "FERRARI", model: "328 GTS" },
  { type: "car", year: 1986, make: "FERRARI", model: "Mondial T" },
  { type: "car", year: 1986, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1986, make: "FORD", model: "'34" },
  { type: "car", year: 1986, make: "FORD", model: "A9513" },
  { type: "car", year: 1986, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1986, make: "FORD", model: "AT8513" },
  { type: "car", year: 1986, make: "FORD", model: "AT9513" },
  { type: "car", year: 1986, make: "FORD", model: "AT9522" },
  { type: "car", year: 1986, make: "FORD", model: "B600" },
  { type: "car", year: 1986, make: "FORD", model: "B6000" },
  { type: "car", year: 1986, make: "FORD", model: "B700" },
  { type: "car", year: 1986, make: "FORD", model: "B7000" },
  { type: "car", year: 1986, make: "FORD", model: "Bronco" },
  { type: "car", year: 1986, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1986, make: "FORD", model: "C600" },
  { type: "car", year: 1986, make: "FORD", model: "C700" },
  { type: "car", year: 1986, make: "FORD", model: "C7000" },
  { type: "car", year: 1986, make: "FORD", model: "C800" },
  { type: "car", year: 1986, make: "FORD", model: "C8000" },
  { type: "car", year: 1986, make: "FORD", model: "CF6000" },
  { type: "car", year: 1986, make: "FORD", model: "CF7000" },
  { type: "car", year: 1986, make: "FORD", model: "CF8000" },
  { type: "car", year: 1986, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1986, make: "FORD", model: "CL9000" },
  { type: "car", year: 1986, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1986, make: "FORD", model: "CT8000" },
  { type: "car", year: 1986, make: "FORD", model: "E-150" },
  { type: "car", year: 1986, make: "FORD", model: "E-250" },
  { type: "car", year: 1986, make: "FORD", model: "E-350" },
  { type: "car", year: 1986, make: "FORD", model: "Escort" },
  { type: "car", year: 1986, make: "FORD", model: "F-150" },
  { type: "car", year: 1986, make: "FORD", model: "F-250" },
  { type: "car", year: 1986, make: "FORD", model: "F-350" },
  { type: "car", year: 1986, make: "FORD", model: "F-590" },
  { type: "car", year: 1986, make: "FORD", model: "F-600" },
  { type: "car", year: 1986, make: "FORD", model: "F-700" },
  { type: "car", year: 1986, make: "FORD", model: "F-800" },
  { type: "car", year: 1986, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1986, make: "FORD", model: "F7000" },
  { type: "car", year: 1986, make: "FORD", model: "F8000" },
  { type: "car", year: 1986, make: "FORD", model: "FT800" },
  { type: "car", year: 1986, make: "FORD", model: "FT8000" },
  { type: "car", year: 1986, make: "FORD", model: "FT900" },
  { type: "car", year: 1986, make: "FORD", model: "L8000" },
  { type: "car", year: 1986, make: "FORD", model: "L9000" },
  { type: "car", year: 1986, make: "FORD", model: "L9513" },
  { type: "car", year: 1986, make: "FORD", model: "LA8000" },
  { type: "car", year: 1986, make: "FORD", model: "LA9000" },
  { type: "car", year: 1986, make: "FORD", model: "Laser" },
  { type: "car", year: 1986, make: "FORD", model: "LL9000" },
  { type: "car", year: 1986, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1986, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1986, make: "FORD", model: "LN700" },
  { type: "car", year: 1986, make: "FORD", model: "LN7000" },
  { type: "car", year: 1986, make: "FORD", model: "LN8000" },
  { type: "car", year: 1986, make: "FORD", model: "LN9000" },
  { type: "car", year: 1986, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1986, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1986, make: "FORD", model: "LS8000" },
  { type: "car", year: 1986, make: "FORD", model: "LS9000" },
  { type: "car", year: 1986, make: "FORD", model: "LT8000" },
  { type: "car", year: 1986, make: "FORD", model: "LT8501" },
  { type: "car", year: 1986, make: "FORD", model: "LT8513" },
  { type: "car", year: 1986, make: "FORD", model: "LT9000" },
  { type: "car", year: 1986, make: "FORD", model: "LT9501" },
  { type: "car", year: 1986, make: "FORD", model: "LT9513" },
  { type: "car", year: 1986, make: "FORD", model: "LT9522" },
  { type: "car", year: 1986, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1986, make: "FORD", model: "LTD" },
  { type: "car", year: 1986, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1986, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1986, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1986, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1986, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1986, make: "FORD", model: "Mustang" },
  { type: "car", year: 1986, make: "FORD", model: "P600" },
  { type: "car", year: 1986, make: "FORD", model: "Ranger" },
  { type: "car", year: 1986, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1986, make: "FORD", model: "Taurus" },
  { type: "car", year: 1986, make: "FORD", model: "Tempo" },
  { type: "car", year: 1986, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1986, make: "GEO", model: "Storm" },
  { type: "car", year: 1986, make: "GMC", model: "C/K Pickup" },
  { type: "car", year: 1986, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1986, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1986, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1986, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1986, make: "GMC", model: "Rally" },
  { type: "car", year: 1986, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1986, make: "GMC", model: "Safari" },
  { type: "car", year: 1986, make: "GMC", model: "Suburban" },
  { type: "car", year: 1986, make: "HONDA", model: "Accord" },
  { type: "car", year: 1986, make: "HONDA", model: "Civic" },
  { type: "car", year: 1986, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1986, make: "HYUNDAI", model: "Excel" },
  { type: "car", year: 1986, make: "HYUNDAI", model: "Pony" },
  { type: "car", year: 1986, make: "HYUNDAI", model: "Stellar" },
  { type: "car", year: 1986, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1986, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1986, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1986, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1986, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1986, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1986, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1986, make: "JEEP", model: "CJ-7" },
  { type: "car", year: 1986, make: "JEEP", model: "Comanche" },
  { type: "car", year: 1986, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1986, make: "JEEP", model: "J-10" },
  { type: "car", year: 1986, make: "JEEP", model: "J-20" },
  { type: "car", year: 1986, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1986, make: "JEEP", model: "Wrangler" },
  { type: "car", year: 1986, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1986, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1986, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1986, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1986, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1986, make: "MASERATI", model: "228" },
  { type: "car", year: 1986, make: "MASERATI", model: "430" },
  { type: "car", year: 1986, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1986, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1986, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1986, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1986, make: "MASERATI", model: "TC" },
  { type: "car", year: 1986, make: "MAZDA", model: "323" },
  { type: "car", year: 1986, make: "MAZDA", model: "626" },
  { type: "car", year: 1986, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1986, make: "MAZDA", model: "GLC" },
  { type: "car", year: 1986, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1986, make: "MERCEDES-BENZ", model: "560" },
  { type: "car", year: 1986, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1986, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1986, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1986, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1986, make: "MERCURY", model: "MARQUIS" },
  { type: "car", year: 1986, make: "MERCURY", model: "Sable" },
  { type: "car", year: 1986, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Cordia" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "SP" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1986, make: "MITSUBISHI", model: "Tredia" },
  { type: "car", year: 1986, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1986, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1986, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1986, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1986, make: "NISSAN", model: "Pathfinder" },
  { type: "car", year: 1986, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1986, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1986, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1986, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1986, make: "NISSAN", model: "Stanza Wagon" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Cutlass Salon" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1986, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1986, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1986, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "Conquest" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "TURISMO" },
  { type: "car", year: 1986, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1986, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Fiero" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1986, make: "PONTIAC", model: "Sunburst" },
  { type: "car", year: 1986, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1986, make: "PORSCHE", model: "911" },
  { type: "car", year: 1986, make: "PORSCHE", model: "924" },
  { type: "car", year: 1986, make: "PORSCHE", model: "944" },
  { type: "car", year: 1986, make: "RENAULT", model: "18i" },
  { type: "car", year: 1986, make: "RENAULT", model: "Alliance" },
  { type: "car", year: 1986, make: "RENAULT", model: "Encore" },
  { type: "car", year: 1986, make: "RENAULT", model: "Fuego" },
  { type: "car", year: 1986, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1986, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1986, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1986, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1986, make: "SAAB", model: "900" },
  { type: "car", year: 1986, make: "SUBARU", model: "Brat" },
  { type: "car", year: 1986, make: "SUBARU", model: "DL" },
  { type: "car", year: 1986, make: "SUBARU", model: "GL" },
  { type: "car", year: 1986, make: "SUBARU", model: "GL-10" },
  { type: "car", year: 1986, make: "SUBARU", model: "RX" },
  { type: "car", year: 1986, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1986, make: "SUBARU", model: "XT" },
  { type: "car", year: 1986, make: "SUZUKI", model: "Forsa" },
  { type: "car", year: 1986, make: "SUZUKI", model: "Samurai" },
  { type: "car", year: 1986, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1986, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1986, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1986, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1986, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1986, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1986, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1986, make: "YUGO", model: "102, GV" },
  { type: "car", year: 1985, make: "ACURA", model: "Integra" },
  { type: "car", year: 1985, make: "ALFA ROMEO", model: "164" },
  { type: "car", year: 1985, make: "ALFA ROMEO", model: "GTV6" },
  { type: "car", year: 1985, make: "ALFA ROMEO", model: "Milano" },
  { type: "car", year: 1985, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1985, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1985, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1985, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1985, make: "AUDI", model: "4000" },
  { type: "car", year: 1985, make: "AUDI", model: "5000" },
  { type: "car", year: 1985, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1985, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1985, make: "BMW", model: "318i" },
  { type: "car", year: 1985, make: "BMW", model: "318iC" },
  { type: "car", year: 1985, make: "BMW", model: "318iS" },
  { type: "car", year: 1985, make: "BMW", model: "318ti" },
  { type: "car", year: 1985, make: "BMW", model: "325/325e" },
  { type: "car", year: 1985, make: "BMW", model: "524td" },
  { type: "car", year: 1985, make: "BMW", model: "528e" },
  { type: "car", year: 1985, make: "BMW", model: "535i" },
  { type: "car", year: 1985, make: "BMW", model: "635CSi" },
  { type: "car", year: 1985, make: "BMW", model: "735i" },
  { type: "car", year: 1985, make: "BMW", model: "735iL" },
  { type: "car", year: 1985, make: "BMW", model: "840Ci" },
  { type: "car", year: 1985, make: "BMW", model: "850Ci" },
  { type: "car", year: 1985, make: "BMW", model: "850CSi" },
  { type: "car", year: 1985, make: "BMW", model: "L7" },
  { type: "car", year: 1985, make: "BMW", model: "M6" },
  { type: "car", year: 1985, make: "BUICK", model: "Century" },
  { type: "car", year: 1985, make: "BUICK", model: "Electra" },
  { type: "car", year: 1985, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1985, make: "BUICK", model: "Regal" },
  { type: "car", year: 1985, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1985, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1985, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1985, make: "BUICK", model: "Somerset" },
  { type: "car", year: 1985, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1985, make: "CADILLAC", model: "Commercial Chassis" },
  { type: "car", year: 1985, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1985, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1985, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1985, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Astro Van" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Beretta" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Citation" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Corsica" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Geo Spectrum" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Geo Sprint" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Hearse/Limo Commercial Chassis" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Nova" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1985, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "FIFTH AVENUE" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "Laser" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "Stratus" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1985, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1985, make: "DAIHATSU", model: "Charade" },
  { type: "car", year: 1985, make: "DELOREAN", model: "DMC-12" },
  { type: "car", year: 1985, make: "DODGE", model: "600" },
  { type: "car", year: 1985, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1985, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1985, make: "DODGE", model: "Charger" },
  { type: "car", year: 1985, make: "DODGE", model: "Colt" },
  { type: "car", year: 1985, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1985, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1985, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1985, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1985, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1985, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1985, make: "DODGE", model: "Mini Ram" },
  { type: "car", year: 1985, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1985, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1985, make: "DODGE", model: "Raider" },
  { type: "car", year: 1985, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1985, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1985, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1985, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1985, make: "DODGE", model: "Shelby Charger" },
  { type: "car", year: 1985, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1985, make: "FERRARI", model: "3.2 Mondial" },
  { type: "car", year: 1985, make: "FERRARI", model: "308 Convertible" },
  { type: "car", year: 1985, make: "FERRARI", model: "308GTB Quattrovalvole" },
  { type: "car", year: 1985, make: "FERRARI", model: "308GTS Quattrovalvole" },
  { type: "car", year: 1985, make: "FERRARI", model: "Mondial 8" },
  { type: "car", year: 1985, make: "FERRARI", model: "Testarossa" },
  { type: "car", year: 1985, make: "FORD", model: "'34" },
  { type: "car", year: 1985, make: "FORD", model: "A9513" },
  { type: "car", year: 1985, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1985, make: "FORD", model: "AT8513" },
  { type: "car", year: 1985, make: "FORD", model: "AT9513" },
  { type: "car", year: 1985, make: "FORD", model: "AT9522" },
  { type: "car", year: 1985, make: "FORD", model: "B600" },
  { type: "car", year: 1985, make: "FORD", model: "B700" },
  { type: "car", year: 1985, make: "FORD", model: "B7000" },
  { type: "car", year: 1985, make: "FORD", model: "Bronco" },
  { type: "car", year: 1985, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1985, make: "FORD", model: "C600" },
  { type: "car", year: 1985, make: "FORD", model: "C700" },
  { type: "car", year: 1985, make: "FORD", model: "C7000" },
  { type: "car", year: 1985, make: "FORD", model: "C800" },
  { type: "car", year: 1985, make: "FORD", model: "C8000" },
  { type: "car", year: 1985, make: "FORD", model: "CF6000" },
  { type: "car", year: 1985, make: "FORD", model: "CF7000" },
  { type: "car", year: 1985, make: "FORD", model: "CF8000" },
  { type: "car", year: 1985, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1985, make: "FORD", model: "CL9000" },
  { type: "car", year: 1985, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1985, make: "FORD", model: "CT8000" },
  { type: "car", year: 1985, make: "FORD", model: "E-150" },
  { type: "car", year: 1985, make: "FORD", model: "E-250" },
  { type: "car", year: 1985, make: "FORD", model: "E-350" },
  { type: "car", year: 1985, make: "FORD", model: "Escort" },
  { type: "car", year: 1985, make: "FORD", model: "F-150" },
  { type: "car", year: 1985, make: "FORD", model: "F-250" },
  { type: "car", year: 1985, make: "FORD", model: "F-350" },
  { type: "car", year: 1985, make: "FORD", model: "F-590" },
  { type: "car", year: 1985, make: "FORD", model: "F-600" },
  { type: "car", year: 1985, make: "FORD", model: "F-700" },
  { type: "car", year: 1985, make: "FORD", model: "F-800" },
  { type: "car", year: 1985, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1985, make: "FORD", model: "F6000" },
  { type: "car", year: 1985, make: "FORD", model: "F7000" },
  { type: "car", year: 1985, make: "FORD", model: "F8000" },
  { type: "car", year: 1985, make: "FORD", model: "FT800" },
  { type: "car", year: 1985, make: "FORD", model: "FT8000" },
  { type: "car", year: 1985, make: "FORD", model: "FT900" },
  { type: "car", year: 1985, make: "FORD", model: "L8000" },
  { type: "car", year: 1985, make: "FORD", model: "L9000" },
  { type: "car", year: 1985, make: "FORD", model: "L9513" },
  { type: "car", year: 1985, make: "FORD", model: "LA8000" },
  { type: "car", year: 1985, make: "FORD", model: "LA9000" },
  { type: "car", year: 1985, make: "FORD", model: "Laser" },
  { type: "car", year: 1985, make: "FORD", model: "LL9000" },
  { type: "car", year: 1985, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1985, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1985, make: "FORD", model: "LN600" },
  { type: "car", year: 1985, make: "FORD", model: "LN700" },
  { type: "car", year: 1985, make: "FORD", model: "LN7000" },
  { type: "car", year: 1985, make: "FORD", model: "LN8000" },
  { type: "car", year: 1985, make: "FORD", model: "LN9000" },
  { type: "car", year: 1985, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1985, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1985, make: "FORD", model: "LS8000" },
  { type: "car", year: 1985, make: "FORD", model: "LS9000" },
  { type: "car", year: 1985, make: "FORD", model: "LT8000" },
  { type: "car", year: 1985, make: "FORD", model: "LT8501" },
  { type: "car", year: 1985, make: "FORD", model: "LT8513" },
  { type: "car", year: 1985, make: "FORD", model: "LT9000" },
  { type: "car", year: 1985, make: "FORD", model: "LT9501" },
  { type: "car", year: 1985, make: "FORD", model: "LT9513" },
  { type: "car", year: 1985, make: "FORD", model: "LT9522" },
  { type: "car", year: 1985, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1985, make: "FORD", model: "LTD" },
  { type: "car", year: 1985, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1985, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1985, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1985, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1985, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1985, make: "FORD", model: "Mustang" },
  { type: "car", year: 1985, make: "FORD", model: "P600" },
  { type: "car", year: 1985, make: "FORD", model: "Ranger" },
  { type: "car", year: 1985, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1985, make: "FORD", model: "Tempo" },
  { type: "car", year: 1985, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1985, make: "GEO", model: "Storm" },
  { type: "car", year: 1985, make: "GMC", model: "C/K Pickup" },
  { type: "car", year: 1985, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1985, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1985, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1985, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1985, make: "GMC", model: "Rally" },
  { type: "car", year: 1985, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1985, make: "GMC", model: "Safari" },
  { type: "car", year: 1985, make: "GMC", model: "Suburban" },
  { type: "car", year: 1985, make: "HONDA", model: "Accord" },
  { type: "car", year: 1985, make: "HONDA", model: "Civic" },
  { type: "car", year: 1985, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1985, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1985, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1985, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1985, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1985, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1985, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1985, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1985, make: "JEEP", model: "CJ-7" },
  { type: "car", year: 1985, make: "JEEP", model: "CJ-8 Scrambler" },
  { type: "car", year: 1985, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1985, make: "JEEP", model: "J-10" },
  { type: "car", year: 1985, make: "JEEP", model: "J-20" },
  { type: "car", year: 1985, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1985, make: "LAND ROVER", model: "Range Rover" },
  { type: "car", year: 1985, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1985, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1985, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1985, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1985, make: "MASERATI", model: "228" },
  { type: "car", year: 1985, make: "MASERATI", model: "430" },
  { type: "car", year: 1985, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1985, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1985, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1985, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1985, make: "MASERATI", model: "TC" },
  { type: "car", year: 1985, make: "MAZDA", model: "626" },
  { type: "car", year: 1985, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1985, make: "MAZDA", model: "GLC" },
  { type: "car", year: 1985, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "380" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1985, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1985, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1985, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1985, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1985, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1985, make: "MERCURY", model: "MARQUIS" },
  { type: "car", year: 1985, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Cordia" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Galant" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Mighty Max" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Mirage" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Montero" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "SP" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1985, make: "MITSUBISHI", model: "Tredia" },
  { type: "car", year: 1985, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1985, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1985, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1985, make: "NISSAN", model: "Micra" },
  { type: "car", year: 1985, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1985, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1985, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1985, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Cutlass Salon" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1985, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1985, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1985, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "Conquest" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "TURISMO" },
  { type: "car", year: 1985, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1985, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Fiero" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Firefly" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Grand AM" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Sunbird" },
  { type: "car", year: 1985, make: "PONTIAC", model: "Sunburst" },
  { type: "car", year: 1985, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1985, make: "PORSCHE", model: "911" },
  { type: "car", year: 1985, make: "PORSCHE", model: "924" },
  { type: "car", year: 1985, make: "PORSCHE", model: "944" },
  { type: "car", year: 1985, make: "RENAULT", model: "18i" },
  { type: "car", year: 1985, make: "RENAULT", model: "Alliance" },
  { type: "car", year: 1985, make: "RENAULT", model: "Encore" },
  { type: "car", year: 1985, make: "RENAULT", model: "Fuego" },
  { type: "car", year: 1985, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1985, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1985, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1985, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1985, make: "SAAB", model: "900" },
  { type: "car", year: 1985, make: "SAAB", model: "9000" },
  { type: "car", year: 1985, make: "SUBARU", model: "Brat" },
  { type: "car", year: 1985, make: "SUBARU", model: "DL" },
  { type: "car", year: 1985, make: "SUBARU", model: "GL" },
  { type: "car", year: 1985, make: "SUBARU", model: "GL-10" },
  { type: "car", year: 1985, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1985, make: "SUBARU", model: "XT" },
  { type: "car", year: 1985, make: "SUZUKI", model: "Forsa" },
  { type: "car", year: 1985, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1985, make: "TOYOTA", model: "MR2" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1985, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1985, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1985, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1985, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1985, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1985, make: "YUGO", model: "Yugo 45" },
  { type: "car", year: 1985, make: "YUGO", model: "Yugo 55" },
  { type: "car", year: 1985, make: "YUGO", model: "Yugo 65" },
  { type: "car", year: 1984, make: "ALFA ROMEO", model: "GTV6" },
  { type: "car", year: 1984, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1984, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1984, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1984, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1984, make: "AUDI", model: "4000" },
  { type: "car", year: 1984, make: "AUDI", model: "5000" },
  { type: "car", year: 1984, make: "BENTLEY", model: "Continental" },
  { type: "car", year: 1984, make: "BENTLEY", model: "Mulsanne" },
  { type: "car", year: 1984, make: "BMW", model: "318i" },
  { type: "car", year: 1984, make: "BMW", model: "318iC" },
  { type: "car", year: 1984, make: "BMW", model: "318iS" },
  { type: "car", year: 1984, make: "BMW", model: "318ti" },
  { type: "car", year: 1984, make: "BMW", model: "524td" },
  { type: "car", year: 1984, make: "BMW", model: "528e" },
  { type: "car", year: 1984, make: "BMW", model: "533i" },
  { type: "car", year: 1984, make: "BMW", model: "633 csi" },
  { type: "car", year: 1984, make: "BMW", model: "635CSi" },
  { type: "car", year: 1984, make: "BMW", model: "733i" },
  { type: "car", year: 1984, make: "BMW", model: "735i" },
  { type: "car", year: 1984, make: "BMW", model: "735iL" },
  { type: "car", year: 1984, make: "BMW", model: "840Ci" },
  { type: "car", year: 1984, make: "BMW", model: "850Ci" },
  { type: "car", year: 1984, make: "BMW", model: "850CSi" },
  { type: "car", year: 1984, make: "BMW", model: "L7" },
  { type: "car", year: 1984, make: "BMW", model: "M6" },
  { type: "car", year: 1984, make: "BUICK", model: "Century" },
  { type: "car", year: 1984, make: "BUICK", model: "Electra" },
  { type: "car", year: 1984, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1984, make: "BUICK", model: "Regal" },
  { type: "car", year: 1984, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1984, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1984, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1984, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1984, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1984, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1984, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1984, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Celebrity" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Citation" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1984, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "Daytona" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "E-CLASS" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "EXECUTIVE" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "FIFTH AVENUE" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "Laser" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "Stratus" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "Viper" },
  { type: "car", year: 1984, make: "CHRYSLER", model: "Vision" },
  { type: "car", year: 1984, make: "DELOREAN", model: "DMC-12" },
  { type: "car", year: 1984, make: "DODGE", model: "600" },
  { type: "car", year: 1984, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1984, make: "DODGE", model: "Caravan" },
  { type: "car", year: 1984, make: "DODGE", model: "Charger" },
  { type: "car", year: 1984, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1984, make: "DODGE", model: "Daytona" },
  { type: "car", year: 1984, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1984, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1984, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1984, make: "DODGE", model: "Mini Ram" },
  { type: "car", year: 1984, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1984, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1984, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1984, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1984, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1984, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1984, make: "DODGE", model: "Shelby Charger" },
  { type: "car", year: 1984, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1984, make: "FERRARI", model: "308GTBi" },
  { type: "car", year: 1984, make: "FERRARI", model: "308GTSi" },
  { type: "car", year: 1984, make: "FERRARI", model: "Mondial 8" },
  { type: "car", year: 1984, make: "FORD", model: "A9513" },
  { type: "car", year: 1984, make: "FORD", model: "Aerostar" },
  { type: "car", year: 1984, make: "FORD", model: "AT8513" },
  { type: "car", year: 1984, make: "FORD", model: "AT9513" },
  { type: "car", year: 1984, make: "FORD", model: "AT9522" },
  { type: "car", year: 1984, make: "FORD", model: "B600" },
  { type: "car", year: 1984, make: "FORD", model: "B700" },
  { type: "car", year: 1984, make: "FORD", model: "B7000" },
  { type: "car", year: 1984, make: "FORD", model: "Bronco" },
  { type: "car", year: 1984, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1984, make: "FORD", model: "C600" },
  { type: "car", year: 1984, make: "FORD", model: "C700" },
  { type: "car", year: 1984, make: "FORD", model: "C7000" },
  { type: "car", year: 1984, make: "FORD", model: "C800" },
  { type: "car", year: 1984, make: "FORD", model: "C8000" },
  { type: "car", year: 1984, make: "FORD", model: "CF6000" },
  { type: "car", year: 1984, make: "FORD", model: "CF7000" },
  { type: "car", year: 1984, make: "FORD", model: "CF8000" },
  { type: "car", year: 1984, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1984, make: "FORD", model: "CL9000" },
  { type: "car", year: 1984, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1984, make: "FORD", model: "CT8000" },
  { type: "car", year: 1984, make: "FORD", model: "E-150" },
  { type: "car", year: 1984, make: "FORD", model: "E-250" },
  { type: "car", year: 1984, make: "FORD", model: "E-350" },
  { type: "car", year: 1984, make: "FORD", model: "Escort" },
  { type: "car", year: 1984, make: "FORD", model: "F-150" },
  { type: "car", year: 1984, make: "FORD", model: "F-250" },
  { type: "car", year: 1984, make: "FORD", model: "F-350" },
  { type: "car", year: 1984, make: "FORD", model: "F-590" },
  { type: "car", year: 1984, make: "FORD", model: "F-600" },
  { type: "car", year: 1984, make: "FORD", model: "F-700" },
  { type: "car", year: 1984, make: "FORD", model: "F-800" },
  { type: "car", year: 1984, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1984, make: "FORD", model: "F6000" },
  { type: "car", year: 1984, make: "FORD", model: "F7000" },
  { type: "car", year: 1984, make: "FORD", model: "F8000" },
  { type: "car", year: 1984, make: "FORD", model: "FT800" },
  { type: "car", year: 1984, make: "FORD", model: "FT8000" },
  { type: "car", year: 1984, make: "FORD", model: "FT900" },
  { type: "car", year: 1984, make: "FORD", model: "L800" },
  { type: "car", year: 1984, make: "FORD", model: "L8000" },
  { type: "car", year: 1984, make: "FORD", model: "L9000" },
  { type: "car", year: 1984, make: "FORD", model: "L9513" },
  { type: "car", year: 1984, make: "FORD", model: "LA8000" },
  { type: "car", year: 1984, make: "FORD", model: "LA9000" },
  { type: "car", year: 1984, make: "FORD", model: "Laser" },
  { type: "car", year: 1984, make: "FORD", model: "LL9000" },
  { type: "car", year: 1984, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1984, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1984, make: "FORD", model: "LN600" },
  { type: "car", year: 1984, make: "FORD", model: "LN700" },
  { type: "car", year: 1984, make: "FORD", model: "LN7000" },
  { type: "car", year: 1984, make: "FORD", model: "LN800" },
  { type: "car", year: 1984, make: "FORD", model: "LN8000" },
  { type: "car", year: 1984, make: "FORD", model: "LN9000" },
  { type: "car", year: 1984, make: "FORD", model: "LNT800" },
  { type: "car", year: 1984, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1984, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1984, make: "FORD", model: "LS8000" },
  { type: "car", year: 1984, make: "FORD", model: "LS9000" },
  { type: "car", year: 1984, make: "FORD", model: "LT800" },
  { type: "car", year: 1984, make: "FORD", model: "LT8000" },
  { type: "car", year: 1984, make: "FORD", model: "LT8501" },
  { type: "car", year: 1984, make: "FORD", model: "LT8513" },
  { type: "car", year: 1984, make: "FORD", model: "LT9000" },
  { type: "car", year: 1984, make: "FORD", model: "LT9501" },
  { type: "car", year: 1984, make: "FORD", model: "LT9513" },
  { type: "car", year: 1984, make: "FORD", model: "LT9522" },
  { type: "car", year: 1984, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1984, make: "FORD", model: "LTD" },
  { type: "car", year: 1984, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1984, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1984, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1984, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1984, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1984, make: "FORD", model: "Mustang" },
  { type: "car", year: 1984, make: "FORD", model: "P600" },
  { type: "car", year: 1984, make: "FORD", model: "Ranger" },
  { type: "car", year: 1984, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1984, make: "FORD", model: "Tempo" },
  { type: "car", year: 1984, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1984, make: "GMC", model: "C/K Pickup" },
  { type: "car", year: 1984, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1984, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1984, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1984, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1984, make: "GMC", model: "Rally" },
  { type: "car", year: 1984, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1984, make: "GMC", model: "Suburban" },
  { type: "car", year: 1984, make: "HONDA", model: "Accord" },
  { type: "car", year: 1984, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1984, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1984, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1984, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1984, make: "ISUZU", model: "Trooper" },
  { type: "car", year: 1984, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1984, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1984, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1984, make: "JEEP", model: "CJ-7" },
  { type: "car", year: 1984, make: "JEEP", model: "CJ-8 Scrambler" },
  { type: "car", year: 1984, make: "JEEP", model: "Grand Wagoneer" },
  { type: "car", year: 1984, make: "JEEP", model: "J-10" },
  { type: "car", year: 1984, make: "JEEP", model: "J-20" },
  { type: "car", year: 1984, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1984, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1984, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1984, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1984, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1984, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1984, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1984, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1984, make: "MASERATI", model: "228" },
  { type: "car", year: 1984, make: "MASERATI", model: "430" },
  { type: "car", year: 1984, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1984, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1984, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1984, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1984, make: "MASERATI", model: "TC" },
  { type: "car", year: 1984, make: "MAZDA", model: "626" },
  { type: "car", year: 1984, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1984, make: "MAZDA", model: "GLC" },
  { type: "car", year: 1984, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "380" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1984, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1984, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1984, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1984, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1984, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1984, make: "MERCURY", model: "MARQUIS" },
  { type: "car", year: 1984, make: "MERCURY", model: "Topaz" },
  { type: "car", year: 1984, make: "MITSUBISHI", model: "Cordia" },
  { type: "car", year: 1984, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1984, make: "MITSUBISHI", model: "Tredia" },
  { type: "car", year: 1984, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1984, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1984, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1984, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1984, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1984, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1984, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Omega" },
  { type: "car", year: 1984, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1984, make: "PEUGEOT", model: "405" },
  { type: "car", year: 1984, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "Conquest" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1984, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1984, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Fiero" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Phoenix" },
  { type: "car", year: 1984, make: "PONTIAC", model: "Sunbird 2000" },
  { type: "car", year: 1984, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1984, make: "PORSCHE", model: "911" },
  { type: "car", year: 1984, make: "PORSCHE", model: "928" },
  { type: "car", year: 1984, make: "PORSCHE", model: "944" },
  { type: "car", year: 1984, make: "RENAULT", model: "18i" },
  { type: "car", year: 1984, make: "RENAULT", model: "Alliance" },
  { type: "car", year: 1984, make: "RENAULT", model: "Encore" },
  { type: "car", year: 1984, make: "RENAULT", model: "Fuego" },
  { type: "car", year: 1984, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1984, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1984, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1984, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1984, make: "SAAB", model: "900" },
  { type: "car", year: 1984, make: "SAAB", model: "9000" },
  { type: "car", year: 1984, make: "SUBARU", model: "Brat" },
  { type: "car", year: 1984, make: "SUBARU", model: "DL" },
  { type: "car", year: 1984, make: "SUBARU", model: "GL" },
  { type: "car", year: 1984, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1984, make: "TOYOTA", model: "4Runner" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Starlet" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1984, make: "TOYOTA", model: "Van" },
  { type: "car", year: 1984, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1984, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1984, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1984, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1983, make: "ALFA ROMEO", model: "GTV6" },
  { type: "car", year: 1983, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1983, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1983, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1983, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1983, make: "AUDI", model: "4000" },
  { type: "car", year: 1983, make: "AUDI", model: "5000" },
  { type: "car", year: 1983, make: "BMW", model: "318i" },
  { type: "car", year: 1983, make: "BMW", model: "318iC" },
  { type: "car", year: 1983, make: "BMW", model: "318iS" },
  { type: "car", year: 1983, make: "BMW", model: "318ti" },
  { type: "car", year: 1983, make: "BMW", model: "320i" },
  { type: "car", year: 1983, make: "BMW", model: "524td" },
  { type: "car", year: 1983, make: "BMW", model: "528e" },
  { type: "car", year: 1983, make: "BMW", model: "533i" },
  { type: "car", year: 1983, make: "BMW", model: "633 csi" },
  { type: "car", year: 1983, make: "BMW", model: "635CSi" },
  { type: "car", year: 1983, make: "BMW", model: "733i" },
  { type: "car", year: 1983, make: "BMW", model: "735i" },
  { type: "car", year: 1983, make: "BMW", model: "735iL" },
  { type: "car", year: 1983, make: "BMW", model: "840Ci" },
  { type: "car", year: 1983, make: "BMW", model: "850Ci" },
  { type: "car", year: 1983, make: "BMW", model: "850CSi" },
  { type: "car", year: 1983, make: "BMW", model: "L7" },
  { type: "car", year: 1983, make: "BMW", model: "M6" },
  { type: "car", year: 1983, make: "BUICK", model: "Century" },
  { type: "car", year: 1983, make: "BUICK", model: "Electra" },
  { type: "car", year: 1983, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1983, make: "BUICK", model: "Regal" },
  { type: "car", year: 1983, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1983, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1983, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1983, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1983, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1983, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1983, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1983, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Citation" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1983, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "Cordoba" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "E-CLASS" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "EXECUTIVE" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "Laser" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1983, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1983, make: "DATSUN", model: "280ZX" },
  { type: "car", year: 1983, make: "DELOREAN", model: "DMC-12" },
  { type: "car", year: 1983, make: "DODGE", model: "400" },
  { type: "car", year: 1983, make: "DODGE", model: "600" },
  { type: "car", year: 1983, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1983, make: "DODGE", model: "Challenger" },
  { type: "car", year: 1983, make: "DODGE", model: "Charger" },
  { type: "car", year: 1983, make: "DODGE", model: "Colt" },
  { type: "car", year: 1983, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1983, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1983, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1983, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1983, make: "DODGE", model: "Mirada" },
  { type: "car", year: 1983, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1983, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1983, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1983, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1983, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1983, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1983, make: "DODGE", model: "Shelby Charger" },
  { type: "car", year: 1983, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1983, make: "FERRARI", model: "308GTBi" },
  { type: "car", year: 1983, make: "FERRARI", model: "308GTSi" },
  { type: "car", year: 1983, make: "FERRARI", model: "Mondial 8" },
  { type: "car", year: 1983, make: "FORD", model: "A9513" },
  { type: "car", year: 1983, make: "FORD", model: "AT8513" },
  { type: "car", year: 1983, make: "FORD", model: "AT9513" },
  { type: "car", year: 1983, make: "FORD", model: "AT9522" },
  { type: "car", year: 1983, make: "FORD", model: "B600" },
  { type: "car", year: 1983, make: "FORD", model: "B700" },
  { type: "car", year: 1983, make: "FORD", model: "B7000" },
  { type: "car", year: 1983, make: "FORD", model: "Bronco" },
  { type: "car", year: 1983, make: "FORD", model: "Bronco II" },
  { type: "car", year: 1983, make: "FORD", model: "C600" },
  { type: "car", year: 1983, make: "FORD", model: "C700" },
  { type: "car", year: 1983, make: "FORD", model: "C7000" },
  { type: "car", year: 1983, make: "FORD", model: "C800" },
  { type: "car", year: 1983, make: "FORD", model: "C8000" },
  { type: "car", year: 1983, make: "FORD", model: "CF6000" },
  { type: "car", year: 1983, make: "FORD", model: "CF7000" },
  { type: "car", year: 1983, make: "FORD", model: "CF8000" },
  { type: "car", year: 1983, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1983, make: "FORD", model: "CL9000" },
  { type: "car", year: 1983, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1983, make: "FORD", model: "CT800" },
  { type: "car", year: 1983, make: "FORD", model: "CT8000" },
  { type: "car", year: 1983, make: "FORD", model: "E-100" },
  { type: "car", year: 1983, make: "FORD", model: "E-150" },
  { type: "car", year: 1983, make: "FORD", model: "E-250" },
  { type: "car", year: 1983, make: "FORD", model: "E-350" },
  { type: "car", year: 1983, make: "FORD", model: "Escort" },
  { type: "car", year: 1983, make: "FORD", model: "F-100" },
  { type: "car", year: 1983, make: "FORD", model: "F-150" },
  { type: "car", year: 1983, make: "FORD", model: "F-250" },
  { type: "car", year: 1983, make: "FORD", model: "F-350" },
  { type: "car", year: 1983, make: "FORD", model: "F-590" },
  { type: "car", year: 1983, make: "FORD", model: "F-600" },
  { type: "car", year: 1983, make: "FORD", model: "F-700" },
  { type: "car", year: 1983, make: "FORD", model: "F-800" },
  { type: "car", year: 1983, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1983, make: "FORD", model: "F6000" },
  { type: "car", year: 1983, make: "FORD", model: "F7000" },
  { type: "car", year: 1983, make: "FORD", model: "F8000" },
  { type: "car", year: 1983, make: "FORD", model: "Fairmont" },
  { type: "car", year: 1983, make: "FORD", model: "FT800" },
  { type: "car", year: 1983, make: "FORD", model: "FT8000" },
  { type: "car", year: 1983, make: "FORD", model: "FT900" },
  { type: "car", year: 1983, make: "FORD", model: "L800" },
  { type: "car", year: 1983, make: "FORD", model: "L8000" },
  { type: "car", year: 1983, make: "FORD", model: "L9000" },
  { type: "car", year: 1983, make: "FORD", model: "L9513" },
  { type: "car", year: 1983, make: "FORD", model: "LA8000" },
  { type: "car", year: 1983, make: "FORD", model: "LA9000" },
  { type: "car", year: 1983, make: "FORD", model: "Laser" },
  { type: "car", year: 1983, make: "FORD", model: "LL9000" },
  { type: "car", year: 1983, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1983, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1983, make: "FORD", model: "LN600" },
  { type: "car", year: 1983, make: "FORD", model: "LN700" },
  { type: "car", year: 1983, make: "FORD", model: "LN7000" },
  { type: "car", year: 1983, make: "FORD", model: "LN800" },
  { type: "car", year: 1983, make: "FORD", model: "LN8000" },
  { type: "car", year: 1983, make: "FORD", model: "LN9000" },
  { type: "car", year: 1983, make: "FORD", model: "LNT800" },
  { type: "car", year: 1983, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1983, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1983, make: "FORD", model: "LS8000" },
  { type: "car", year: 1983, make: "FORD", model: "LS9000" },
  { type: "car", year: 1983, make: "FORD", model: "LT800" },
  { type: "car", year: 1983, make: "FORD", model: "LT8000" },
  { type: "car", year: 1983, make: "FORD", model: "LT8501" },
  { type: "car", year: 1983, make: "FORD", model: "LT8513" },
  { type: "car", year: 1983, make: "FORD", model: "LT9000" },
  { type: "car", year: 1983, make: "FORD", model: "LT9501" },
  { type: "car", year: 1983, make: "FORD", model: "LT9513" },
  { type: "car", year: 1983, make: "FORD", model: "LT9522" },
  { type: "car", year: 1983, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1983, make: "FORD", model: "LTD" },
  { type: "car", year: 1983, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1983, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1983, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1983, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1983, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1983, make: "FORD", model: "Mustang" },
  { type: "car", year: 1983, make: "FORD", model: "P600" },
  { type: "car", year: 1983, make: "FORD", model: "Ranger" },
  { type: "car", year: 1983, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1983, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1983, make: "GMC", model: "C/K Pickup" },
  { type: "car", year: 1983, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1983, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1983, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1983, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1983, make: "GMC", model: "Rally" },
  { type: "car", year: 1983, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1983, make: "GMC", model: "Suburban" },
  { type: "car", year: 1983, make: "HONDA", model: "Accord" },
  { type: "car", year: 1983, make: "HONDA", model: "Civic" },
  { type: "car", year: 1983, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1983, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1983, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1983, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1983, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1983, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1983, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1983, make: "JEEP", model: "CJ-5" },
  { type: "car", year: 1983, make: "JEEP", model: "CJ-7" },
  { type: "car", year: 1983, make: "JEEP", model: "CJ-8 Scrambler" },
  { type: "car", year: 1983, make: "JEEP", model: "J-10" },
  { type: "car", year: 1983, make: "JEEP", model: "J-20" },
  { type: "car", year: 1983, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1983, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1983, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1983, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1983, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1983, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1983, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1983, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1983, make: "MASERATI", model: "228" },
  { type: "car", year: 1983, make: "MASERATI", model: "430" },
  { type: "car", year: 1983, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1983, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1983, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1983, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1983, make: "MASERATI", model: "TC" },
  { type: "car", year: 1983, make: "MAZDA", model: "626" },
  { type: "car", year: 1983, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1983, make: "MAZDA", model: "GLC" },
  { type: "car", year: 1983, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "190" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "240" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "260" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "350" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "380" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "420" },
  { type: "car", year: 1983, make: "MERCEDES-BENZ", model: "500" },
  { type: "car", year: 1983, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1983, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1983, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1983, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1983, make: "MERCURY", model: "MARQUIS" },
  { type: "car", year: 1983, make: "MERCURY", model: "Zephyr" },
  { type: "car", year: 1983, make: "MITSUBISHI", model: "Cordia" },
  { type: "car", year: 1983, make: "MITSUBISHI", model: "Starion" },
  { type: "car", year: 1983, make: "MITSUBISHI", model: "Tredia" },
  { type: "car", year: 1983, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1983, make: "NISSAN", model: "300ZX" },
  { type: "car", year: 1983, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1983, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1983, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1983, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1983, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Cutlass Cruiser" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Omega" },
  { type: "car", year: 1983, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1983, make: "PEUGEOT", model: "504" },
  { type: "car", year: 1983, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1983, make: "PEUGEOT", model: "604" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "Colt" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "Sapporo" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "Trailduster" },
  { type: "car", year: 1983, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1983, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Grand Lemans" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1983, make: "PONTIAC", model: "J2000" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1983, make: "PONTIAC", model: "Phoenix" },
  { type: "car", year: 1983, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1983, make: "PORSCHE", model: "911" },
  { type: "car", year: 1983, make: "PORSCHE", model: "928" },
  { type: "car", year: 1983, make: "PORSCHE", model: "944" },
  { type: "car", year: 1983, make: "RENAULT", model: "18i" },
  { type: "car", year: 1983, make: "RENAULT", model: "Alliance" },
  { type: "car", year: 1983, make: "RENAULT", model: "Fuego" },
  { type: "car", year: 1983, make: "RENAULT", model: "LeCar" },
  { type: "car", year: 1983, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1983, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1983, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1983, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1983, make: "SAAB", model: "900" },
  { type: "car", year: 1983, make: "SUBARU", model: "Brat" },
  { type: "car", year: 1983, make: "SUBARU", model: "DL" },
  { type: "car", year: 1983, make: "SUBARU", model: "GL" },
  { type: "car", year: 1983, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Camry" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Starlet" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1983, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1983, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1983, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1983, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1983, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1982, make: "ALFA ROMEO", model: "GTV6" },
  { type: "car", year: 1982, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1982, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1982, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1982, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1982, make: "AUDI", model: "4000" },
  { type: "car", year: 1982, make: "AUDI", model: "5000" },
  { type: "car", year: 1982, make: "BMW", model: "318i" },
  { type: "car", year: 1982, make: "BMW", model: "318iC" },
  { type: "car", year: 1982, make: "BMW", model: "318iS" },
  { type: "car", year: 1982, make: "BMW", model: "318ti" },
  { type: "car", year: 1982, make: "BMW", model: "320i" },
  { type: "car", year: 1982, make: "BMW", model: "524td" },
  { type: "car", year: 1982, make: "BMW", model: "528e" },
  { type: "car", year: 1982, make: "BMW", model: "533i" },
  { type: "car", year: 1982, make: "BMW", model: "633 csi" },
  { type: "car", year: 1982, make: "BMW", model: "635CSi" },
  { type: "car", year: 1982, make: "BMW", model: "733i" },
  { type: "car", year: 1982, make: "BMW", model: "735i" },
  { type: "car", year: 1982, make: "BMW", model: "735iL" },
  { type: "car", year: 1982, make: "BMW", model: "840Ci" },
  { type: "car", year: 1982, make: "BMW", model: "850Ci" },
  { type: "car", year: 1982, make: "BMW", model: "850CSi" },
  { type: "car", year: 1982, make: "BMW", model: "L7" },
  { type: "car", year: 1982, make: "BMW", model: "M6" },
  { type: "car", year: 1982, make: "BUICK", model: "Century" },
  { type: "car", year: 1982, make: "BUICK", model: "Electra" },
  { type: "car", year: 1982, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1982, make: "BUICK", model: "Regal" },
  { type: "car", year: 1982, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1982, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1982, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1982, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1982, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1982, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1982, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1982, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Citation" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "S-10 Pickup" },
  { type: "car", year: 1982, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "Cordoba" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "E-CLASS" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "EXECUTIVE" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "Laser" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1982, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1982, make: "DATSUN", model: "210" },
  { type: "car", year: 1982, make: "DATSUN", model: "280ZX" },
  { type: "car", year: 1982, make: "DATSUN", model: "310" },
  { type: "car", year: 1982, make: "DELOREAN", model: "DMC-12" },
  { type: "car", year: 1982, make: "DODGE", model: "400" },
  { type: "car", year: 1982, make: "DODGE", model: "600" },
  { type: "car", year: 1982, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1982, make: "DODGE", model: "Challenger" },
  { type: "car", year: 1982, make: "DODGE", model: "Colt" },
  { type: "car", year: 1982, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1982, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1982, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1982, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1982, make: "DODGE", model: "Mirada" },
  { type: "car", year: 1982, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1982, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1982, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1982, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1982, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1982, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1982, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1982, make: "FERRARI", model: "308GTBi" },
  { type: "car", year: 1982, make: "FERRARI", model: "308GTSi" },
  { type: "car", year: 1982, make: "FERRARI", model: "Mondial 8" },
  { type: "car", year: 1982, make: "FIAT", model: "Brava" },
  { type: "car", year: 1982, make: "FIAT", model: "Spider 2000" },
  { type: "car", year: 1982, make: "FIAT", model: "Strada" },
  { type: "car", year: 1982, make: "FIAT", model: "X 1/9" },
  { type: "car", year: 1982, make: "FORD", model: "A9513" },
  { type: "car", year: 1982, make: "FORD", model: "AT8513" },
  { type: "car", year: 1982, make: "FORD", model: "AT9513" },
  { type: "car", year: 1982, make: "FORD", model: "AT9522" },
  { type: "car", year: 1982, make: "FORD", model: "B600" },
  { type: "car", year: 1982, make: "FORD", model: "B700" },
  { type: "car", year: 1982, make: "FORD", model: "B7000" },
  { type: "car", year: 1982, make: "FORD", model: "Bronco" },
  { type: "car", year: 1982, make: "FORD", model: "C600" },
  { type: "car", year: 1982, make: "FORD", model: "C700" },
  { type: "car", year: 1982, make: "FORD", model: "C7000" },
  { type: "car", year: 1982, make: "FORD", model: "C800" },
  { type: "car", year: 1982, make: "FORD", model: "C8000" },
  { type: "car", year: 1982, make: "FORD", model: "CF6000" },
  { type: "car", year: 1982, make: "FORD", model: "CF7000" },
  { type: "car", year: 1982, make: "FORD", model: "CF8000" },
  { type: "car", year: 1982, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1982, make: "FORD", model: "CL9000" },
  { type: "car", year: 1982, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1982, make: "FORD", model: "CT800" },
  { type: "car", year: 1982, make: "FORD", model: "CT8000" },
  { type: "car", year: 1982, make: "FORD", model: "E-100" },
  { type: "car", year: 1982, make: "FORD", model: "E-150" },
  { type: "car", year: 1982, make: "FORD", model: "E-250" },
  { type: "car", year: 1982, make: "FORD", model: "E-350" },
  { type: "car", year: 1982, make: "FORD", model: "Escort" },
  { type: "car", year: 1982, make: "FORD", model: "F-100" },
  { type: "car", year: 1982, make: "FORD", model: "F-150" },
  { type: "car", year: 1982, make: "FORD", model: "F-250" },
  { type: "car", year: 1982, make: "FORD", model: "F-350" },
  { type: "car", year: 1982, make: "FORD", model: "F-590" },
  { type: "car", year: 1982, make: "FORD", model: "F-600" },
  { type: "car", year: 1982, make: "FORD", model: "F-700" },
  { type: "car", year: 1982, make: "FORD", model: "F-800" },
  { type: "car", year: 1982, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1982, make: "FORD", model: "F6000" },
  { type: "car", year: 1982, make: "FORD", model: "F7000" },
  { type: "car", year: 1982, make: "FORD", model: "F8000" },
  { type: "car", year: 1982, make: "FORD", model: "Fairmont" },
  { type: "car", year: 1982, make: "FORD", model: "FT800" },
  { type: "car", year: 1982, make: "FORD", model: "FT8000" },
  { type: "car", year: 1982, make: "FORD", model: "FT900" },
  { type: "car", year: 1982, make: "FORD", model: "Granada" },
  { type: "car", year: 1982, make: "FORD", model: "L800" },
  { type: "car", year: 1982, make: "FORD", model: "L8000" },
  { type: "car", year: 1982, make: "FORD", model: "L9000" },
  { type: "car", year: 1982, make: "FORD", model: "L9513" },
  { type: "car", year: 1982, make: "FORD", model: "LA8000" },
  { type: "car", year: 1982, make: "FORD", model: "LA9000" },
  { type: "car", year: 1982, make: "FORD", model: "Laser" },
  { type: "car", year: 1982, make: "FORD", model: "LL9000" },
  { type: "car", year: 1982, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1982, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1982, make: "FORD", model: "LN600" },
  { type: "car", year: 1982, make: "FORD", model: "LN700" },
  { type: "car", year: 1982, make: "FORD", model: "LN7000" },
  { type: "car", year: 1982, make: "FORD", model: "LN800" },
  { type: "car", year: 1982, make: "FORD", model: "LN8000" },
  { type: "car", year: 1982, make: "FORD", model: "LN9000" },
  { type: "car", year: 1982, make: "FORD", model: "LNT800" },
  { type: "car", year: 1982, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1982, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1982, make: "FORD", model: "LS8000" },
  { type: "car", year: 1982, make: "FORD", model: "LS9000" },
  { type: "car", year: 1982, make: "FORD", model: "LT800" },
  { type: "car", year: 1982, make: "FORD", model: "LT8000" },
  { type: "car", year: 1982, make: "FORD", model: "LT8501" },
  { type: "car", year: 1982, make: "FORD", model: "LT8513" },
  { type: "car", year: 1982, make: "FORD", model: "LT9000" },
  { type: "car", year: 1982, make: "FORD", model: "LT9501" },
  { type: "car", year: 1982, make: "FORD", model: "LT9513" },
  { type: "car", year: 1982, make: "FORD", model: "LT9522" },
  { type: "car", year: 1982, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1982, make: "FORD", model: "LTD" },
  { type: "car", year: 1982, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1982, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1982, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1982, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1982, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1982, make: "FORD", model: "Mustang" },
  { type: "car", year: 1982, make: "FORD", model: "P600" },
  { type: "car", year: 1982, make: "FORD", model: "Ranger" },
  { type: "car", year: 1982, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1982, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1982, make: "GMC", model: "C/K Pickup" },
  { type: "car", year: 1982, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1982, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1982, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1982, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1982, make: "GMC", model: "Rally" },
  { type: "car", year: 1982, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1982, make: "GMC", model: "Suburban" },
  { type: "car", year: 1982, make: "HONDA", model: "Accord" },
  { type: "car", year: 1982, make: "HONDA", model: "Civic" },
  { type: "car", year: 1982, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1982, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1982, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1982, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1982, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1982, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1982, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1982, make: "JEEP", model: "CJ-5" },
  { type: "car", year: 1982, make: "JEEP", model: "CJ-6" },
  { type: "car", year: 1982, make: "JEEP", model: "CJ-7" },
  { type: "car", year: 1982, make: "JEEP", model: "CJ-8 Scrambler" },
  { type: "car", year: 1982, make: "JEEP", model: "J-10" },
  { type: "car", year: 1982, make: "JEEP", model: "J-20" },
  { type: "car", year: 1982, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1982, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1982, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1982, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1982, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1982, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1982, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1982, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1982, make: "MASERATI", model: "228" },
  { type: "car", year: 1982, make: "MASERATI", model: "430" },
  { type: "car", year: 1982, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1982, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1982, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1982, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1982, make: "MASERATI", model: "TC" },
  { type: "car", year: 1982, make: "MAZDA", model: "626" },
  { type: "car", year: 1982, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1982, make: "MAZDA", model: "GLC" },
  { type: "car", year: 1982, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1982, make: "MERCEDES-BENZ", model: "240" },
  { type: "car", year: 1982, make: "MERCEDES-BENZ", model: "280" },
  { type: "car", year: 1982, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1982, make: "MERCEDES-BENZ", model: "380" },
  { type: "car", year: 1982, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1982, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1982, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1982, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1982, make: "MERCURY", model: "MARQUIS" },
  { type: "car", year: 1982, make: "MERCURY", model: "Zephyr" },
  { type: "car", year: 1982, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1982, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1982, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1982, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1982, make: "NISSAN", model: "Sentra" },
  { type: "car", year: 1982, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Cutlass Ciera" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Cutlass Cruiser" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Firenza" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Omega" },
  { type: "car", year: 1982, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1982, make: "PEUGEOT", model: "504" },
  { type: "car", year: 1982, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1982, make: "PEUGEOT", model: "604" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "Champ" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "Sapporo" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "Trailduster" },
  { type: "car", year: 1982, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1982, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Grand Lemans" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1982, make: "PONTIAC", model: "J2000" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1982, make: "PONTIAC", model: "Phoenix" },
  { type: "car", year: 1982, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1982, make: "PORSCHE", model: "911" },
  { type: "car", year: 1982, make: "PORSCHE", model: "924" },
  { type: "car", year: 1982, make: "PORSCHE", model: "928" },
  { type: "car", year: 1982, make: "PORSCHE", model: "944" },
  { type: "car", year: 1982, make: "RENAULT", model: "18i" },
  { type: "car", year: 1982, make: "RENAULT", model: "LeCar" },
  { type: "car", year: 1982, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1982, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1982, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1982, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1982, make: "SAAB", model: "900" },
  { type: "car", year: 1982, make: "SUBARU", model: "Brat" },
  { type: "car", year: 1982, make: "SUBARU", model: "DL" },
  { type: "car", year: 1982, make: "SUBARU", model: "GL" },
  { type: "car", year: 1982, make: "SUBARU", model: "GLF" },
  { type: "car", year: 1982, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Corona" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Starlet" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1982, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1982, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1982, make: "VOLVO", model: "260 Series" },
  { type: "car", year: 1982, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1982, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1982, make: "VOLVO", model: "780 Series" },
  { type: "car", year: 1981, make: "ALFA ROMEO", model: "GTV6" },
  { type: "car", year: 1981, make: "ALFA ROMEO", model: "Spider" },
  { type: "car", year: 1981, make: "ASTON MARTIN", model: "Lagonda" },
  { type: "car", year: 1981, make: "ASTON MARTIN", model: "V8" },
  { type: "car", year: 1981, make: "ASTON MARTIN", model: "V8 Vantage" },
  { type: "car", year: 1981, make: "AUDI", model: "4000" },
  { type: "car", year: 1981, make: "AUDI", model: "5000" },
  { type: "car", year: 1981, make: "BMW", model: "318i" },
  { type: "car", year: 1981, make: "BMW", model: "318iC" },
  { type: "car", year: 1981, make: "BMW", model: "318iS" },
  { type: "car", year: 1981, make: "BMW", model: "318ti" },
  { type: "car", year: 1981, make: "BMW", model: "320i" },
  { type: "car", year: 1981, make: "BMW", model: "524td" },
  { type: "car", year: 1981, make: "BMW", model: "528e" },
  { type: "car", year: 1981, make: "BMW", model: "528i" },
  { type: "car", year: 1981, make: "BMW", model: "533i" },
  { type: "car", year: 1981, make: "BMW", model: "633 csi" },
  { type: "car", year: 1981, make: "BMW", model: "635CSi" },
  { type: "car", year: 1981, make: "BMW", model: "733i" },
  { type: "car", year: 1981, make: "BMW", model: "735i" },
  { type: "car", year: 1981, make: "BMW", model: "735iL" },
  { type: "car", year: 1981, make: "BMW", model: "840Ci" },
  { type: "car", year: 1981, make: "BMW", model: "850Ci" },
  { type: "car", year: 1981, make: "BMW", model: "850CSi" },
  { type: "car", year: 1981, make: "BMW", model: "L7" },
  { type: "car", year: 1981, make: "BMW", model: "M6" },
  { type: "car", year: 1981, make: "BUICK", model: "Century" },
  { type: "car", year: 1981, make: "BUICK", model: "Electra" },
  { type: "car", year: 1981, make: "BUICK", model: "LeSabre" },
  { type: "car", year: 1981, make: "BUICK", model: "Regal" },
  { type: "car", year: 1981, make: "BUICK", model: "Riviera" },
  { type: "car", year: 1981, make: "BUICK", model: "Skyhawk" },
  { type: "car", year: 1981, make: "BUICK", model: "Skylark" },
  { type: "car", year: 1981, make: "CADILLAC", model: "Cimarron" },
  { type: "car", year: 1981, make: "CADILLAC", model: "Deville" },
  { type: "car", year: 1981, make: "CADILLAC", model: "Eldorado" },
  { type: "car", year: 1981, make: "CADILLAC", model: "Fleetwood" },
  { type: "car", year: 1981, make: "CADILLAC", model: "Seville" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Blazer" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Camaro" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Caprice" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Cavalier" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Chevette" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Citation" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Corvette" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "G-Series" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Impala" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Malibu" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Monte Carlo" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "P - Series" },
  { type: "car", year: 1981, make: "CHEVROLET", model: "Suburban" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "Cordoba" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "Dynasty" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "E-CLASS" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "EXECUTIVE" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "Imperial" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "Laser" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "LeBaron" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "New Yorker" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "NEWPORT" },
  { type: "car", year: 1981, make: "CHRYSLER", model: "SALON" },
  { type: "car", year: 1981, make: "DATSUN", model: "210" },
  { type: "car", year: 1981, make: "DATSUN", model: "280ZX" },
  { type: "car", year: 1981, make: "DATSUN", model: "310" },
  { type: "car", year: 1981, make: "DATSUN", model: "510" },
  { type: "car", year: 1981, make: "DELOREAN", model: "DMC-12" },
  { type: "car", year: 1981, make: "DODGE", model: "400" },
  { type: "car", year: 1981, make: "DODGE", model: "600" },
  { type: "car", year: 1981, make: "DODGE", model: "ARIES" },
  { type: "car", year: 1981, make: "DODGE", model: "Challenger" },
  { type: "car", year: 1981, make: "DODGE", model: "Colt" },
  { type: "car", year: 1981, make: "DODGE", model: "Conquest" },
  { type: "car", year: 1981, make: "DODGE", model: "D-Series" },
  { type: "car", year: 1981, make: "DODGE", model: "DIPLOMAT" },
  { type: "car", year: 1981, make: "DODGE", model: "Dynasty" },
  { type: "car", year: 1981, make: "DODGE", model: "LANCER" },
  { type: "car", year: 1981, make: "DODGE", model: "Mirada" },
  { type: "car", year: 1981, make: "DODGE", model: "Monaco" },
  { type: "car", year: 1981, make: "DODGE", model: "OMNI" },
  { type: "car", year: 1981, make: "DODGE", model: "Ram Chassis Cab" },
  { type: "car", year: 1981, make: "DODGE", model: "Ram Van" },
  { type: "car", year: 1981, make: "DODGE", model: "Ram Wagon" },
  { type: "car", year: 1981, make: "DODGE", model: "Ramcharger" },
  { type: "car", year: 1981, make: "DODGE", model: "ST.REGIS" },
  { type: "car", year: 1981, make: "DODGE", model: "W-Series" },
  { type: "car", year: 1981, make: "FERRARI", model: "308GTB" },
  { type: "car", year: 1981, make: "FERRARI", model: "308GTBi" },
  { type: "car", year: 1981, make: "FERRARI", model: "308GTS" },
  { type: "car", year: 1981, make: "FERRARI", model: "308GTSi" },
  { type: "car", year: 1981, make: "FERRARI", model: "Mondial 8" },
  { type: "car", year: 1981, make: "FIAT", model: "Brava" },
  { type: "car", year: 1981, make: "FIAT", model: "Spider 2000" },
  { type: "car", year: 1981, make: "FIAT", model: "Strada" },
  { type: "car", year: 1981, make: "FIAT", model: "X 1/9" },
  { type: "car", year: 1981, make: "FORD", model: "A9513" },
  { type: "car", year: 1981, make: "FORD", model: "AT8513" },
  { type: "car", year: 1981, make: "FORD", model: "AT9513" },
  { type: "car", year: 1981, make: "FORD", model: "AT9522" },
  { type: "car", year: 1981, make: "FORD", model: "B600" },
  { type: "car", year: 1981, make: "FORD", model: "B700" },
  { type: "car", year: 1981, make: "FORD", model: "B7000" },
  { type: "car", year: 1981, make: "FORD", model: "Bronco" },
  { type: "car", year: 1981, make: "FORD", model: "C600" },
  { type: "car", year: 1981, make: "FORD", model: "C700" },
  { type: "car", year: 1981, make: "FORD", model: "C7000" },
  { type: "car", year: 1981, make: "FORD", model: "C800" },
  { type: "car", year: 1981, make: "FORD", model: "C8000" },
  { type: "car", year: 1981, make: "FORD", model: "CF6000" },
  { type: "car", year: 1981, make: "FORD", model: "CF7000" },
  { type: "car", year: 1981, make: "FORD", model: "CF8000" },
  { type: "car", year: 1981, make: "FORD", model: "CFT8000" },
  { type: "car", year: 1981, make: "FORD", model: "CL9000" },
  { type: "car", year: 1981, make: "FORD", model: "CLT9000" },
  { type: "car", year: 1981, make: "FORD", model: "CT800" },
  { type: "car", year: 1981, make: "FORD", model: "CT8000" },
  { type: "car", year: 1981, make: "FORD", model: "E-100" },
  { type: "car", year: 1981, make: "FORD", model: "E-150" },
  { type: "car", year: 1981, make: "FORD", model: "E-250" },
  { type: "car", year: 1981, make: "FORD", model: "E-350" },
  { type: "car", year: 1981, make: "FORD", model: "Escort" },
  { type: "car", year: 1981, make: "FORD", model: "F-100" },
  { type: "car", year: 1981, make: "FORD", model: "F-150" },
  { type: "car", year: 1981, make: "FORD", model: "F-250" },
  { type: "car", year: 1981, make: "FORD", model: "F-350" },
  { type: "car", year: 1981, make: "FORD", model: "F-590" },
  { type: "car", year: 1981, make: "FORD", model: "F-600" },
  { type: "car", year: 1981, make: "FORD", model: "F-700" },
  { type: "car", year: 1981, make: "FORD", model: "F-800" },
  { type: "car", year: 1981, make: "FORD", model: "F-Super Duty" },
  { type: "car", year: 1981, make: "FORD", model: "F6000" },
  { type: "car", year: 1981, make: "FORD", model: "F7000" },
  { type: "car", year: 1981, make: "FORD", model: "F8000" },
  { type: "car", year: 1981, make: "FORD", model: "Fairmont" },
  { type: "car", year: 1981, make: "FORD", model: "FT800" },
  { type: "car", year: 1981, make: "FORD", model: "FT8000" },
  { type: "car", year: 1981, make: "FORD", model: "FT900" },
  { type: "car", year: 1981, make: "FORD", model: "Granada" },
  { type: "car", year: 1981, make: "FORD", model: "L800" },
  { type: "car", year: 1981, make: "FORD", model: "L8000" },
  { type: "car", year: 1981, make: "FORD", model: "L9000" },
  { type: "car", year: 1981, make: "FORD", model: "L9513" },
  { type: "car", year: 1981, make: "FORD", model: "LA8000" },
  { type: "car", year: 1981, make: "FORD", model: "LA9000" },
  { type: "car", year: 1981, make: "FORD", model: "Laser" },
  { type: "car", year: 1981, make: "FORD", model: "LL9000" },
  { type: "car", year: 1981, make: "FORD", model: "LLA9000" },
  { type: "car", year: 1981, make: "FORD", model: "LLS9000" },
  { type: "car", year: 1981, make: "FORD", model: "LN600" },
  { type: "car", year: 1981, make: "FORD", model: "LN700" },
  { type: "car", year: 1981, make: "FORD", model: "LN7000" },
  { type: "car", year: 1981, make: "FORD", model: "LN800" },
  { type: "car", year: 1981, make: "FORD", model: "LN8000" },
  { type: "car", year: 1981, make: "FORD", model: "LN9000" },
  { type: "car", year: 1981, make: "FORD", model: "LNT800" },
  { type: "car", year: 1981, make: "FORD", model: "LNT8000" },
  { type: "car", year: 1981, make: "FORD", model: "LNT9000" },
  { type: "car", year: 1981, make: "FORD", model: "LS8000" },
  { type: "car", year: 1981, make: "FORD", model: "LS9000" },
  { type: "car", year: 1981, make: "FORD", model: "LT800" },
  { type: "car", year: 1981, make: "FORD", model: "LT8000" },
  { type: "car", year: 1981, make: "FORD", model: "LT8501" },
  { type: "car", year: 1981, make: "FORD", model: "LT8513" },
  { type: "car", year: 1981, make: "FORD", model: "LT9000" },
  { type: "car", year: 1981, make: "FORD", model: "LT9501" },
  { type: "car", year: 1981, make: "FORD", model: "LT9513" },
  { type: "car", year: 1981, make: "FORD", model: "LT9522" },
  { type: "car", year: 1981, make: "FORD", model: "LTA9000" },
  { type: "car", year: 1981, make: "FORD", model: "LTD" },
  { type: "car", year: 1981, make: "FORD", model: "LTL9000" },
  { type: "car", year: 1981, make: "FORD", model: "LTLA9000" },
  { type: "car", year: 1981, make: "FORD", model: "LTLS9000" },
  { type: "car", year: 1981, make: "FORD", model: "LTS8000" },
  { type: "car", year: 1981, make: "FORD", model: "LTS9000" },
  { type: "car", year: 1981, make: "FORD", model: "Mustang" },
  { type: "car", year: 1981, make: "FORD", model: "P600" },
  { type: "car", year: 1981, make: "FORD", model: "Recreational Vehicle" },
  { type: "car", year: 1981, make: "FORD", model: "Thunderbird" },
  { type: "car", year: 1981, make: "GMC", model: "C/K Pickup" },
  { type: "car", year: 1981, make: "GMC", model: "Hi-Cube" },
  { type: "car", year: 1981, make: "GMC", model: "Jimmy Utility" },
  { type: "car", year: 1981, make: "GMC", model: "Motorhome Chassis" },
  { type: "car", year: 1981, make: "GMC", model: "P Truck Forward" },
  { type: "car", year: 1981, make: "GMC", model: "Rally" },
  { type: "car", year: 1981, make: "GMC", model: "S15 Utility" },
  { type: "car", year: 1981, make: "GMC", model: "Suburban" },
  { type: "car", year: 1981, make: "HONDA", model: "Accord" },
  { type: "car", year: 1981, make: "HONDA", model: "Civic" },
  { type: "car", year: 1981, make: "HONDA", model: "Prelude" },
  { type: "car", year: 1981, make: "ISUZU", model: "I-Mark" },
  { type: "car", year: 1981, make: "ISUZU", model: "IMPULSE" },
  { type: "car", year: 1981, make: "ISUZU", model: "Pickup" },
  { type: "car", year: 1981, make: "JAGUAR", model: "XJ6" },
  { type: "car", year: 1981, make: "JAGUAR", model: "XJS" },
  { type: "car", year: 1981, make: "JEEP", model: "Cherokee" },
  { type: "car", year: 1981, make: "JEEP", model: "CJ-5" },
  { type: "car", year: 1981, make: "JEEP", model: "CJ-6" },
  { type: "car", year: 1981, make: "JEEP", model: "CJ-7" },
  { type: "car", year: 1981, make: "JEEP", model: "CJ-8 Scrambler" },
  { type: "car", year: 1981, make: "JEEP", model: "J-10" },
  { type: "car", year: 1981, make: "JEEP", model: "J-20" },
  { type: "car", year: 1981, make: "JEEP", model: "Wagoneer" },
  { type: "car", year: 1981, make: "LINCOLN", model: "Continental" },
  { type: "car", year: 1981, make: "LINCOLN", model: "Mark" },
  { type: "car", year: 1981, make: "LINCOLN", model: "Town Car" },
  { type: "car", year: 1981, make: "LOTUS", model: "Eclat" },
  { type: "car", year: 1981, make: "LOTUS", model: "Elite" },
  { type: "car", year: 1981, make: "LOTUS", model: "Esprit" },
  { type: "car", year: 1981, make: "LOTUS", model: "Turbo Esprit" },
  { type: "car", year: 1981, make: "MASERATI", model: "228" },
  { type: "car", year: 1981, make: "MASERATI", model: "430" },
  { type: "car", year: 1981, make: "MASERATI", model: "Biturbo" },
  { type: "car", year: 1981, make: "MASERATI", model: "Merak" },
  { type: "car", year: 1981, make: "MASERATI", model: "Quattroporte" },
  { type: "car", year: 1981, make: "MASERATI", model: "Spyder" },
  { type: "car", year: 1981, make: "MASERATI", model: "TC" },
  { type: "car", year: 1981, make: "MAZDA", model: "626" },
  { type: "car", year: 1981, make: "MAZDA", model: "B-Series" },
  { type: "car", year: 1981, make: "MAZDA", model: "GLC" },
  { type: "car", year: 1981, make: "MAZDA", model: "RX-7" },
  { type: "car", year: 1981, make: "MERCEDES-BENZ", model: "240" },
  { type: "car", year: 1981, make: "MERCEDES-BENZ", model: "280" },
  { type: "car", year: 1981, make: "MERCEDES-BENZ", model: "300" },
  { type: "car", year: 1981, make: "MERCEDES-BENZ", model: "380" },
  { type: "car", year: 1981, make: "MERCURY", model: "Capri" },
  { type: "car", year: 1981, make: "MERCURY", model: "Cougar" },
  { type: "car", year: 1981, make: "MERCURY", model: "Grand Marquis" },
  { type: "car", year: 1981, make: "MERCURY", model: "Lynx" },
  { type: "car", year: 1981, make: "MERCURY", model: "MARQUIS" },
  { type: "car", year: 1981, make: "MERCURY", model: "Zephyr" },
  { type: "car", year: 1981, make: "NISSAN", model: "200SX" },
  { type: "car", year: 1981, make: "NISSAN", model: "Maxima" },
  { type: "car", year: 1981, make: "NISSAN", model: "Pickup" },
  { type: "car", year: 1981, make: "NISSAN", model: "PULSAR" },
  { type: "car", year: 1981, make: "NISSAN", model: "Stanza" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Custom Cruiser" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Cutlass" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Cutlass Calais" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Cutlass Cruiser" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Cutlass Supreme" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Delta 88" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Ninety Eight (98)" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Omega" },
  { type: "car", year: 1981, make: "OLDSMOBILE", model: "Toronado" },
  { type: "car", year: 1981, make: "PEUGEOT", model: "504" },
  { type: "car", year: 1981, make: "PEUGEOT", model: "505" },
  { type: "car", year: 1981, make: "PEUGEOT", model: "604" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "Acclaim" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "CARAVELLE" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "Champ" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "GRAN FURY" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "HORIZON" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "Reliant" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "Sapporo" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "Trailduster" },
  { type: "car", year: 1981, make: "PLYMOUTH", model: "Voyager" },
  { type: "car", year: 1981, make: "PONTIAC", model: "6000" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Acadian" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Bonneville" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Catalina" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Firebird" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Grand Lemans" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Grand Prix" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Laurentian" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Lemans" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Parisienne" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Phoenix" },
  { type: "car", year: 1981, make: "PONTIAC", model: "Sunbird 2000" },
  { type: "car", year: 1981, make: "PONTIAC", model: "T1000" },
  { type: "car", year: 1981, make: "PORSCHE", model: "911" },
  { type: "car", year: 1981, make: "PORSCHE", model: "924" },
  { type: "car", year: 1981, make: "PORSCHE", model: "928" },
  { type: "car", year: 1981, make: "PORSCHE", model: "944" },
  { type: "car", year: 1981, make: "RENAULT", model: "18i" },
  { type: "car", year: 1981, make: "RENAULT", model: "LeCar" },
  { type: "car", year: 1981, make: "ROLLS-ROYCE", model: "Camargue" },
  { type: "car", year: 1981, make: "ROLLS-ROYCE", model: "Corniche" },
  { type: "car", year: 1981, make: "ROLLS-ROYCE", model: "Silver Spirit" },
  { type: "car", year: 1981, make: "ROLLS-ROYCE", model: "Silver Spur" },
  { type: "car", year: 1981, make: "SAAB", model: "900" },
  { type: "car", year: 1981, make: "SUBARU", model: "Brat" },
  { type: "car", year: 1981, make: "SUBARU", model: "DL" },
  { type: "car", year: 1981, make: "SUBARU", model: "GL" },
  { type: "car", year: 1981, make: "SUBARU", model: "GLF" },
  { type: "car", year: 1981, make: "SUBARU", model: "Standard" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Celica" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Corolla" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Corona" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Cressida" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Land Cruiser" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Pick-Up" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Starlet" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Supra" },
  { type: "car", year: 1981, make: "TOYOTA", model: "Tercel" },
  { type: "car", year: 1981, make: "TRIUMPH", model: "TR7" },
  { type: "car", year: 1981, make: "TRIUMPH", model: "TR8" },
  { type: "car", year: 1981, make: "VOLVO", model: "240 Series" },
  { type: "car", year: 1981, make: "VOLVO", model: "260 Series" },
  { type: "car", year: 1981, make: "VOLVO", model: "740 Series" },
  { type: "car", year: 1981, make: "VOLVO", model: "760 Series" },
  { type: "car", year: 1981, make: "VOLVO", model: "780 Series" },
  { type: "motorcycle", year: 2015, make: "HONDA", model: "PCX150" },
  { type: "motorcycle", year: 2015, make: "SUZUKI", model: "TU250X" },
  { type: "motorcycle", year: 2015, make: "VICTORY", model: "GUNNER" },
  { type: "motorcycle", year: 2015, make: "YAMAHA", model: "SR400" },
  { type: "motorcycle", year: 2014, make: "APRILIA", model: "CAPONORD 1200" },
  { type: "motorcycle", year: 2014, make: "APRILIA", model: "SHIVER 750" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "C600 SPORT" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "C650GT" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "F700GS" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "F800GS ADVENTURE" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "F800GT" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "G650GS" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "G650GS SERTAO" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "HP4" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "K1300S" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "K1600GT" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "K1600GTL" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "K1600GTL EXCLUSIVE" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "S1000R" },
  { type: "motorcycle", year: 2014, make: "BMW", model: "S1000RR" },
  { type: "motorcycle", year: 2014, make: "DUCATI", model: "1199 PANIGALE" },
  { type: "motorcycle", year: 2014, make: "DUCATI", model: "1199 PANIGALE S" },
  { type: "motorcycle", year: 2014, make: "DUCATI", model: "899 PANIGALE" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLD SWITCHBACK" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLHTK ELECTRA GLIDE ULTRA LIMITED" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLHXS STREET GLIDE SPECIAL" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLS SOFTAIL SLIM" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "FXSB BREAKOUT" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "VRSCF V-ROD MUSCLE" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "XL1200V SEVENTY-TWO" },
  { type: "motorcycle", year: 2014, make: "HARLEY DAVIDSON", model: "XL1200X FORTY-EIGHT" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CB1000R" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CB1100" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CB500F" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CB500X" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CBR500R" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CBR650F" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CRF250L" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "CTX700N" },
  { type: "motorcycle", year: 2014, make: "HONDA", model: "NC700X" },
  { type: "motorcycle", year: 2014, make: "HUSABERG", model: "FE450" },
  { type: "motorcycle", year: 2014, make: "HUSABERG", model: "FE501" },
  { type: "motorcycle", year: 2014, make: "HUSABERG", model: "TE250" },
  { type: "motorcycle", year: 2014, make: "HUSABERG", model: "TE300" },
  { type: "motorcycle", year: 2014, make: "HUSQVARNA", model: "FE250" },
  { type: "motorcycle", year: 2014, make: "HUSQVARNA", model: "FE350" },
  { type: "motorcycle", year: 2014, make: "HUSQVARNA", model: "FE501" },
  { type: "motorcycle", year: 2014, make: "HUSQVARNA", model: "TE125" },
  { type: "motorcycle", year: 2014, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2014, make: "HUSQVARNA", model: "TE300" },
  { type: "motorcycle", year: 2014, make: "INDIAN", model: "CHIEF CLASSIC" },
  { type: "motorcycle", year: 2014, make: "INDIAN", model: "CHIEF VINTAGE" },
  { type: "motorcycle", year: 2014, make: "INDIAN", model: "CHIEFTAIN" },
  { type: "motorcycle", year: 2014, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2014, make: "KTM", model: "1190 ADVENTURE" },
  { type: "motorcycle", year: 2014, make: "KTM", model: "1190 ADVENTURE R" },
  { type: "motorcycle", year: 2014, make: "KTM", model: "690 ENDURO R" },
  { type: "motorcycle", year: 2014, make: "KYMCO", model: "AGILITY 125" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "SFV650" },
  { type: "motorcycle", year: 2014, make: "SUZUKI", model: "TU250X" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "ROCKET III ROADSTER" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "ROCKET III TOURING" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "TIGER EXPLORER" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "TIGER EXPLORER XC" },
  { type: "motorcycle", year: 2014, make: "TRIUMPH", model: "TROPHY SE" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "BOARDWALK" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "CROSS COUNTRY" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "HIGH-BALL" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "JACKPOT" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "JUDGE" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2014, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "FZ6R" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2014, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2013, make: "APRILIA", model: "SHIVER 750" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "C600 SPORT" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "C650GT" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "F700GS" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "F800GT" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "F800R" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "G650GS" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "G650GS SERTAO" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "HP4" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "K1300S" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "K1600GT" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "K1600GTL" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2013, make: "BMW", model: "S1000RR" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "1199 PANIGALE" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "1199 PANIGALE S" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "DIAVEL" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "DIAVEL CARBON" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "DIAVEL STRADA" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "HYPERMOTARD" },
  { type: "motorcycle", year: 2013, make: "DUCATI", model: "MULTISTRADA 1200" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLD SWITCHBACK" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLHTK ELECTRA GLIDE ULTRA LIMITED" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLS SOFTAIL SLIM" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FLTRX ROAD GLIDE CUSTOM" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FXS BLACKLINE" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "FXSB BREAKOUT" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "VRSCF V-ROD MUSCLE" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "XL1200V SEVENTY-TWO" },
  { type: "motorcycle", year: 2013, make: "HARLEY DAVIDSON", model: "XL1200X FORTY-EIGHT" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CB1000R" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CB1100" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CB500F" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CB500X" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CBR250R" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CBR500R" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CRF250L" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "NC700X" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "PCX150" },
  { type: "motorcycle", year: 2013, make: "HONDA", model: "VFR1200F" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "FE250" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "FE350" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "FE450" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "FE501" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "TE125" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "TE250" },
  { type: "motorcycle", year: 2013, make: "HUSABERG", model: "TE300" },
  { type: "motorcycle", year: 2013, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2013, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2013, make: "HYOSUNG", model: "ST7" },
  { type: "motorcycle", year: 2013, make: "INDIAN", model: "CHIEF CLASSIC" },
  { type: "motorcycle", year: 2013, make: "INDIAN", model: "CHIEF DARK HORSE" },
  { type: "motorcycle", year: 2013, make: "INDIAN", model: "CHIEF VINTAGE" },
  { type: "motorcycle", year: 2013, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2013, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2013, make: "KTM", model: "690 DUKE" },
  { type: "motorcycle", year: 2013, make: "KTM", model: "690 ENDURO R" },
  { type: "motorcycle", year: 2013, make: "KTM", model: "990 SUPERMOTO T" },
  { type: "motorcycle", year: 2013, make: "MOTO GUZZI", model: "CALIFORNIA 1400 TOURING" },
  { type: "motorcycle", year: 2013, make: "MOTO GUZZI", model: "V7 RACER" },
  { type: "motorcycle", year: 2013, make: "MOTO GUZZI", model: "V7 SPECIAL" },
  { type: "motorcycle", year: 2013, make: "MOTO GUZZI", model: "V7 STONE" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "BRUTALE 1090" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "BRUTALE 1090RR" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "BRUTALE 675" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "BRUTALE 800" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "F3 675" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "F4" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "F4R" },
  { type: "motorcycle", year: 2013, make: "MV AGUSTA", model: "F4RR" },
  { type: "motorcycle", year: 2013, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2013, make: "PIAGGIO", model: "MP3 500" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "GW250" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2013, make: "SUZUKI", model: "TU250X" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "ROCKET III ROADSTER" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "ROCKET III TOURING" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "STREET TRIPLE R" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "TIGER EXPLORER" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "TIGER EXPLORER XC" },
  { type: "motorcycle", year: 2013, make: "TRIUMPH", model: "TROPHY SE" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "BOARDWALK" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "CROSS COUNTRY" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "HARD-BALL" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "HIGH-BALL" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "JUDGE" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2013, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "FZ6R" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "FZ8" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2013, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2012, make: "APRILIA", model: "DORSODURO 1200" },
  { type: "motorcycle", year: 2012, make: "APRILIA", model: "DORSODURO 750" },
  { type: "motorcycle", year: 2012, make: "APRILIA", model: "MANA 850" },
  { type: "motorcycle", year: 2012, make: "APRILIA", model: "SHIVER 750" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "F800R" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "G650GS" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "G650GS SERTAO" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "K1300S" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "K1600GT" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "K1600GTL" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2012, make: "BMW", model: "S1000RR" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "1199 PANIGALE" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "1199 PANIGALE S" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "DIAVEL" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "DIAVEL AMG" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "DIAVEL CARBON" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "HYPERMOTARD 796" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "MULTISTRADA 1200" },
  { type: "motorcycle", year: 2012, make: "DUCATI", model: "STREETFIGHTER S" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLD SWITCHBACK" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLHTK ELECTRA GLIDE ULTRA LIMITED" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLS SOFTAIL SLIM" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FLTRX ROAD GLIDE CUSTOM" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "FXS BLACKLINE" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "VRSCF V-ROD MUSCLE" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "XL1200V SEVENTY-TWO" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "XL1200X FORTY-EIGHT" },
  { type: "motorcycle", year: 2012, make: "HARLEY DAVIDSON", model: "XR1200X" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CB1000R" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CBR250R" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "NC700X" },
  { type: "motorcycle", year: 2012, make: "HONDA", model: "VFR1200F" },
  { type: "motorcycle", year: 2012, make: "HUSABERG", model: "FE390" },
  { type: "motorcycle", year: 2012, make: "HUSABERG", model: "FE450" },
  { type: "motorcycle", year: 2012, make: "HUSABERG", model: "FE570" },
  { type: "motorcycle", year: 2012, make: "HUSABERG", model: "TE125" },
  { type: "motorcycle", year: 2012, make: "HUSABERG", model: "TE250" },
  { type: "motorcycle", year: 2012, make: "HUSABERG", model: "TE300" },
  { type: "motorcycle", year: 2012, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2012, make: "HUSQVARNA", model: "TE310" },
  { type: "motorcycle", year: 2012, make: "HUSQVARNA", model: "TE449" },
  { type: "motorcycle", year: 2012, make: "HUSQVARNA", model: "TE511" },
  { type: "motorcycle", year: 2012, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2012, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2012, make: "HYOSUNG", model: "ST7" },
  { type: "motorcycle", year: 2012, make: "INDIAN", model: "CHIEF CLASSIC" },
  { type: "motorcycle", year: 2012, make: "INDIAN", model: "CHIEF DARK HORSE" },
  { type: "motorcycle", year: 2012, make: "INDIAN", model: "CHIEF VINTAGE" },
  { type: "motorcycle", year: 2012, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2012, make: "KAWASAKI", model: "KLX450R" },
  { type: "motorcycle", year: 2012, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2012, make: "KTM", model: "690 ENDURO R" },
  { type: "motorcycle", year: 2012, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2012, make: "MOTO GUZZI", model: "V7 CLASSIC" },
  { type: "motorcycle", year: 2012, make: "MOTO GUZZI", model: "V7 RACER" },
  { type: "motorcycle", year: 2012, make: "MV AGUSTA", model: "F3 675" },
  { type: "motorcycle", year: 2012, make: "MV AGUSTA", model: "F4" },
  { type: "motorcycle", year: 2012, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2012, make: "PIAGGIO", model: "MP3 500" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2012, make: "SUZUKI", model: "TU250X" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "ROCKET III ROADSTER" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "ROCKET III TOURING" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "STREET TRIPLE R" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2012, make: "TRIUMPH", model: "TIGER EXPLORER" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "CROSS COUNTRY" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "CROSS ROADS" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "HARD-BALL" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "HIGH-BALL" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2012, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "FZ6R" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "FZ8" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2012, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2011, make: "APRILIA", model: "DORSODURO 1200" },
  { type: "motorcycle", year: 2011, make: "APRILIA", model: "DORSODURO 750" },
  { type: "motorcycle", year: 2011, make: "APRILIA", model: "MANA 850" },
  { type: "motorcycle", year: 2011, make: "APRILIA", model: "SHIVER 750" },
  { type: "motorcycle", year: 2011, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2011, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2011, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "F800R" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "G650GS" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "K1300R" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "K1300S" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "K1600GT" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "K1600GTL" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2011, make: "BMW", model: "S1000RR" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "1198" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "HYPERMOTARD 796" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "MONSTER 1100" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "MONSTER 696" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "MONSTER 750" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "MONSTER 796" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "STREETFIGHTER" },
  { type: "motorcycle", year: 2011, make: "DUCATI", model: "STREETFIGHTER S" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLHTK ELECTRA GLIDE ULTRA LIMITED" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLSTSB CROSS BONES" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FLTRX ROAD GLIDE CUSTOM" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FXCWC ROCKER C" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "FXS BLACKLINE" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "VRSCF V-ROD MUSCLE" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "XL1200X FORTY-EIGHT" },
  { type: "motorcycle", year: 2011, make: "HARLEY DAVIDSON", model: "XR1200X" },
  { type: "motorcycle", year: 2011, make: "HONDA", model: "CB1000R" },
  { type: "motorcycle", year: 2011, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2011, make: "HONDA", model: "CBR250R" },
  { type: "motorcycle", year: 2011, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2011, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2011, make: "HONDA", model: "PCX125" },
  { type: "motorcycle", year: 2011, make: "HUSABERG", model: "FE390" },
  { type: "motorcycle", year: 2011, make: "HUSABERG", model: "FE450" },
  { type: "motorcycle", year: 2011, make: "HUSABERG", model: "FE570" },
  { type: "motorcycle", year: 2011, make: "HUSABERG", model: "FS570" },
  { type: "motorcycle", year: 2011, make: "HUSABERG", model: "TE250" },
  { type: "motorcycle", year: 2011, make: "HUSABERG", model: "TE300" },
  { type: "motorcycle", year: 2011, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2011, make: "HUSQVARNA", model: "TE310" },
  { type: "motorcycle", year: 2011, make: "HUSQVARNA", model: "TE449" },
  { type: "motorcycle", year: 2011, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2011, make: "HUSQVARNA", model: "TE511" },
  { type: "motorcycle", year: 2011, make: "HUSQVARNA", model: "TE630" },
  { type: "motorcycle", year: 2011, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2011, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2011, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2011, make: "HYOSUNG", model: "GV650" },
  { type: "motorcycle", year: 2011, make: "HYOSUNG", model: "ST7" },
  { type: "motorcycle", year: 2011, make: "INDIAN", model: "CHIEF CLASSIC" },
  { type: "motorcycle", year: 2011, make: "INDIAN", model: "CHIEF DARK HORSE" },
  { type: "motorcycle", year: 2011, make: "INDIAN", model: "CHIEF ROADMASTER" },
  { type: "motorcycle", year: 2011, make: "INDIAN", model: "CHIEF VINTAGE" },
  { type: "motorcycle", year: 2011, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2011, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2011, make: "KAWASAKI", model: "Z750" },
  { type: "motorcycle", year: 2011, make: "KAWASAKI", model: "Z750R" },
  { type: "motorcycle", year: 2011, make: "KTM", model: "690 DUKE" },
  { type: "motorcycle", year: 2011, make: "KTM", model: "690 ENDURO R" },
  { type: "motorcycle", year: 2011, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2011, make: "KTM", model: "990 SUPERMOTO" },
  { type: "motorcycle", year: 2011, make: "KTM", model: "990 SUPERMOTO T" },
  { type: "motorcycle", year: 2011, make: "KYMCO", model: "AGILITY 125" },
  { type: "motorcycle", year: 2011, make: "MOTO GUZZI", model: "STELVIO 1200" },
  { type: "motorcycle", year: 2011, make: "MOTO GUZZI", model: "V7 CLASSIC" },
  { type: "motorcycle", year: 2011, make: "MV AGUSTA", model: "BRUTALE 1090RR" },
  { type: "motorcycle", year: 2011, make: "MV AGUSTA", model: "BRUTALE 990R" },
  { type: "motorcycle", year: 2011, make: "MV AGUSTA", model: "F4" },
  { type: "motorcycle", year: 2011, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2011, make: "PIAGGIO", model: "MP3 500" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "GSX1250FA" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2011, make: "SUZUKI", model: "TU250" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "ROCKET III ROADSTER" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "STREET TRIPLE R" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "THUNDERBIRD STORM" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2011, make: "TRIUMPH", model: "TIGER 800" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "CROSS COUNTRY" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "CROSS ROADS" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "HIGH-BALL" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2011, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "FZ6R" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "FZ8" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "WR250X" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2011, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2010, make: "APRILIA", model: "DORSODURO 750" },
  { type: "motorcycle", year: 2010, make: "APRILIA", model: "MANA 850" },
  { type: "motorcycle", year: 2010, make: "APRILIA", model: "RSV4 FACTORY" },
  { type: "motorcycle", year: 2010, make: "APRILIA", model: "SHIVER 750" },
  { type: "motorcycle", year: 2010, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2010, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2010, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "F800R" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "G450X" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "G650GS" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "HP2 SPORT" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "K1300GT" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "K1300R" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "K1300S" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2010, make: "BMW", model: "S1000RR" },
  { type: "motorcycle", year: 2010, make: "BUELL", model: "1125CR" },
  { type: "motorcycle", year: 2010, make: "BUELL", model: "1125R" },
  { type: "motorcycle", year: 2010, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2010, make: "BUELL", model: "XB12X ULYSSES" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "1198" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "848" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "GT1000" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "HYPERMOTARD 796" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "MONSTER 1100" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "MONSTER 696" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "MONSTER 750" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "MULTISTRADA 1200" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "STREETFIGHTER" },
  { type: "motorcycle", year: 2010, make: "DUCATI", model: "STREETFIGHTER S" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHTK ELECTRA GLIDE ULTRA LIMITED" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLHXSE CVO STREET GLIDE" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLSTSB CROSS BONES" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FLTRX ROAD GLIDE CUSTOM" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FXCWC ROCKER C" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "FXSTC SOFTAIL CUSTOM" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "VRSCAW V-ROD" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "VRSCF V-ROD MUSCLE" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "XL1200X FORTY-EIGHT" },
  { type: "motorcycle", year: 2010, make: "HARLEY DAVIDSON", model: "XR1200" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "CBF1000A" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "NT700V" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2010, make: "HONDA", model: "VFR1200F" },
  { type: "motorcycle", year: 2010, make: "HUSABERG", model: "FE390" },
  { type: "motorcycle", year: 2010, make: "HUSABERG", model: "FE450" },
  { type: "motorcycle", year: 2010, make: "HUSABERG", model: "FE570" },
  { type: "motorcycle", year: 2010, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2010, make: "HUSQVARNA", model: "TE310" },
  { type: "motorcycle", year: 2010, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2010, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2010, make: "HUSQVARNA", model: "TE630" },
  { type: "motorcycle", year: 2010, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2010, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2010, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2010, make: "HYOSUNG", model: "GV650" },
  { type: "motorcycle", year: 2010, make: "HYOSUNG", model: "ST7" },
  { type: "motorcycle", year: 2010, make: "INDIAN", model: "CHIEF CLASSIC" },
  { type: "motorcycle", year: 2010, make: "INDIAN", model: "CHIEF DARK HORSE" },
  { type: "motorcycle", year: 2010, make: "INDIAN", model: "CHIEF ROADMASTER" },
  { type: "motorcycle", year: 2010, make: "INDIAN", model: "CHIEF VINTAGE" },
  { type: "motorcycle", year: 2010, make: "KAWASAKI", model: "ER-6N" },
  { type: "motorcycle", year: 2010, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2010, make: "KAWASAKI", model: "KLX450R" },
  { type: "motorcycle", year: 2010, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2010, make: "KAWASAKI", model: "Z750" },
  { type: "motorcycle", year: 2010, make: "KTM", model: "450SX" },
  { type: "motorcycle", year: 2010, make: "KTM", model: "690 DUKE" },
  { type: "motorcycle", year: 2010, make: "KTM", model: "690 ENDURO R" },
  { type: "motorcycle", year: 2010, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2010, make: "KTM", model: "990 SUPERMOTO T" },
  { type: "motorcycle", year: 2010, make: "MOTO GUZZI", model: "CALIFORNIA VINTAGE" },
  { type: "motorcycle", year: 2010, make: "MOTO GUZZI", model: "GRISO 1200" },
  { type: "motorcycle", year: 2010, make: "MOTO GUZZI", model: "STELVIO 1200" },
  { type: "motorcycle", year: 2010, make: "MOTO GUZZI", model: "V7 CLASSIC" },
  { type: "motorcycle", year: 2010, make: "MV AGUSTA", model: "BRUTALE 990R" },
  { type: "motorcycle", year: 2010, make: "MV AGUSTA", model: "F4" },
  { type: "motorcycle", year: 2010, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2010, make: "PIAGGIO", model: "MP3 500" },
  { type: "motorcycle", year: 2010, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2010, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "STREET TRIPLE R" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2010, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "CROSS COUNTRY" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "CROSS ROADS" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2010, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "FZ6R" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "WR250X" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2010, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2009, make: "APRILIA", model: "MANA 850" },
  { type: "motorcycle", year: 2009, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2009, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2009, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "F800R" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "G450X" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "G650 XCOUNTRY" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "G650GS" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "HP2 MEGAMOTO" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "HP2 SPORT" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "K1300R" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "K1300S" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2009, make: "BMW", model: "S1000RR" },
  { type: "motorcycle", year: 2009, make: "BUELL", model: "1125CR" },
  { type: "motorcycle", year: 2009, make: "BUELL", model: "1125R" },
  { type: "motorcycle", year: 2009, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2009, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2009, make: "BUELL", model: "XB12X ULYSSES" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "1198" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "848" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "GT1000" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "HYPERMOTARD 1100" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "MONSTER 1100" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "MONSTER 696" },
  { type: "motorcycle", year: 2009, make: "DUCATI", model: "MULTISTRADA 1100" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLSTSB CROSS BONES" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FLTR ROAD GLIDE" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXCW ROCKER" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXCWC ROCKER C" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "FXSTC SOFTAIL CUSTOM" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "VRSCAW V-ROD" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "VRSCF V-ROD MUSCLE" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2009, make: "HARLEY DAVIDSON", model: "XR1200" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "CBF1000A" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2009, make: "HONDA", model: "VTX1300C" },
  { type: "motorcycle", year: 2009, make: "HUSABERG", model: "FE450" },
  { type: "motorcycle", year: 2009, make: "HUSABERG", model: "FE570" },
  { type: "motorcycle", year: 2009, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2009, make: "HUSQVARNA", model: "TE310" },
  { type: "motorcycle", year: 2009, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2009, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2009, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2009, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2009, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2009, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2009, make: "HYOSUNG", model: "GV650" },
  { type: "motorcycle", year: 2009, make: "INDIAN", model: "CHIEF ROADMASTER" },
  { type: "motorcycle", year: 2009, make: "INDIAN", model: "CHIEF VINTAGE" },
  { type: "motorcycle", year: 2009, make: "KAWASAKI", model: "ER-6N" },
  { type: "motorcycle", year: 2009, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2009, make: "KAWASAKI", model: "KLX450R" },
  { type: "motorcycle", year: 2009, make: "KAWASAKI", model: "Z750" },
  { type: "motorcycle", year: 2009, make: "KTM", model: "450SX" },
  { type: "motorcycle", year: 2009, make: "KTM", model: "690 DUKE" },
  { type: "motorcycle", year: 2009, make: "KTM", model: "690 ENDURO R" },
  { type: "motorcycle", year: 2009, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2009, make: "MOTO GUZZI", model: "CALIFORNIA VINTAGE" },
  { type: "motorcycle", year: 2009, make: "MOTO GUZZI", model: "GRISO 1200" },
  { type: "motorcycle", year: 2009, make: "MOTO GUZZI", model: "NORGE 1200" },
  { type: "motorcycle", year: 2009, make: "MOTO GUZZI", model: "STELVIO 1200" },
  { type: "motorcycle", year: 2009, make: "MOTO GUZZI", model: "V7 CLASSIC" },
  { type: "motorcycle", year: 2009, make: "MV AGUSTA", model: "BRUTALE 1078RR" },
  { type: "motorcycle", year: 2009, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2009, make: "PIAGGIO", model: "MP3 500" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GS500F" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GSX650F" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2009, make: "SUZUKI", model: "TU250X" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "ROCKET III CLASSIC" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "STREET TRIPLE R" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2009, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2009, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2009, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2009, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2009, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2009, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "FJR1300AE" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "FZ6R" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "WR250X" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2009, make: "YAMAHA", model: "YZF-R6S" },
  { type: "motorcycle", year: 2008, make: "APRILIA", model: "MANA 850" },
  { type: "motorcycle", year: 2008, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2008, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2008, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "F800GS" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "F800S" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "G450X" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "G650 XCOUNTRY" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "HP2 MEGAMOTO" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "HP2 SPORT" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "K1200GT" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "K1200R" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "K1200R SPORT" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "K1200S" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2008, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2008, make: "BUELL", model: "1125R" },
  { type: "motorcycle", year: 2008, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2008, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2008, make: "BUELL", model: "XB12S LIGHTNING" },
  { type: "motorcycle", year: 2008, make: "BUELL", model: "XB12X ULYSSES" },
  { type: "motorcycle", year: 2008, make: "DUCATI", model: "1098" },
  { type: "motorcycle", year: 2008, make: "DUCATI", model: "848" },
  { type: "motorcycle", year: 2008, make: "DUCATI", model: "GT1000" },
  { type: "motorcycle", year: 2008, make: "DUCATI", model: "HYPERMOTARD 1100" },
  { type: "motorcycle", year: 2008, make: "DUCATI", model: "MONSTER 696" },
  { type: "motorcycle", year: 2008, make: "DUCATI", model: "MULTISTRADA 1100" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLSTSB CROSS BONES" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FLTR ROAD GLIDE" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXCW ROCKER" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXCWC ROCKER C" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXDF FAT BOB" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "FXSTC SOFTAIL CUSTOM" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "VRSCAW V-ROD" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "VRSCD NIGHT ROD" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2008, make: "HARLEY DAVIDSON", model: "XL883 SPORTSTER" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "VTX1300C" },
  { type: "motorcycle", year: 2008, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2008, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2008, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2008, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2008, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2008, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2008, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2008, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2008, make: "HYOSUNG", model: "GV650" },
  { type: "motorcycle", year: 2008, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2008, make: "KAWASAKI", model: "KLX450R" },
  { type: "motorcycle", year: 2008, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2008, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2008, make: "KTM", model: "950 SUPERMOTO" },
  { type: "motorcycle", year: 2008, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2008, make: "KYMCO", model: "XCITING 500" },
  { type: "motorcycle", year: 2008, make: "MOTO GUZZI", model: "BREVA 1100" },
  { type: "motorcycle", year: 2008, make: "MOTO GUZZI", model: "CALIFORNIA VINTAGE" },
  { type: "motorcycle", year: 2008, make: "MOTO GUZZI", model: "GRISO 1100" },
  { type: "motorcycle", year: 2008, make: "MOTO GUZZI", model: "NORGE 1200" },
  { type: "motorcycle", year: 2008, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2008, make: "PIAGGIO", model: "MP3 500" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GS500F" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GSX650F" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2008, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "ROCKET III CLASSIC" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2008, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2008, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2008, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2008, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2008, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2008, make: "VICTORY", model: "VISION TOUR" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "FJR1300AE" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "WR250R" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "WR250X" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "XT250" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2008, make: "YAMAHA", model: "YZF-R6S" },
  { type: "motorcycle", year: 2007, make: "APRILIA", model: "PEGASO 650" },
  { type: "motorcycle", year: 2007, make: "APRILIA", model: "PEGASO 650 TRAIL" },
  { type: "motorcycle", year: 2007, make: "BIG DOG", model: "CHOPPER" },
  { type: "motorcycle", year: 2007, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2007, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "F800S" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "G650 XCHALLENGE" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "G650 XCOUNTRY" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "G650 XMOTO" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "K1200GT" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "K1200R" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "K1200R SPORT" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "K1200S" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "R1200S" },
  { type: "motorcycle", year: 2007, make: "BMW", model: "R1200ST" },
  { type: "motorcycle", year: 2007, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2007, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2007, make: "BUELL", model: "XB12S LIGHTNING" },
  { type: "motorcycle", year: 2007, make: "BUELL", model: "XB12X ULYSSES" },
  { type: "motorcycle", year: 2007, make: "DUCATI", model: "1098" },
  { type: "motorcycle", year: 2007, make: "DUCATI", model: "GT1000" },
  { type: "motorcycle", year: 2007, make: "DUCATI", model: "MULTISTRADA 1100" },
  { type: "motorcycle", year: 2007, make: "DUCATI", model: "ST3" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLHRC ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLHRS ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLHTCU ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FLTR ROAD GLIDE" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXDB STREET BOB" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXSTC SOFTAIL CUSTOM" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "VRSCAW V-ROD" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "VRSCD NIGHT ROD" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "VRSCDX NIGHT ROD SPECIAL" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "VRSCR STREET ROD" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2007, make: "HARLEY DAVIDSON", model: "XL883 SPORTSTER" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "VTX1300C" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "VTX1300S" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2007, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2007, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2007, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2007, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2007, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2007, make: "HYOSUNG", model: "GT250" },
  { type: "motorcycle", year: 2007, make: "HYOSUNG", model: "GT650" },
  { type: "motorcycle", year: 2007, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2007, make: "HYOSUNG", model: "GV650" },
  { type: "motorcycle", year: 2007, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2007, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2007, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2007, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2007, make: "KTM", model: "950 SUPERMOTO" },
  { type: "motorcycle", year: 2007, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2007, make: "KYMCO", model: "XCITING 500" },
  { type: "motorcycle", year: 2007, make: "MOTO GUZZI", model: "BREVA 1100" },
  { type: "motorcycle", year: 2007, make: "MOTO GUZZI", model: "CALIFORNIA VINTAGE" },
  { type: "motorcycle", year: 2007, make: "MOTO GUZZI", model: "GRISO 1100" },
  { type: "motorcycle", year: 2007, make: "MOTO GUZZI", model: "NORGE 1200" },
  { type: "motorcycle", year: 2007, make: "MV AGUSTA", model: "F4-1000R" },
  { type: "motorcycle", year: 2007, make: "PIAGGIO", model: "MP3 250" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "GS500F" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2007, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "ROCKET III CLASSIC" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2007, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2007, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2007, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2007, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2007, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "FJR1300AE" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YZF-R6S" },
  { type: "motorcycle", year: 2007, make: "YAMAHA", model: "YZF600R" },
  { type: "motorcycle", year: 2006, make: "APRILIA", model: "PEGASO 650 TRAIL" },
  { type: "motorcycle", year: 2006, make: "APRILIA", model: "SCARABEO 250" },
  { type: "motorcycle", year: 2006, make: "BIG DOG", model: "CHOPPER" },
  { type: "motorcycle", year: 2006, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2006, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2006, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "F650CS" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "F800S" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "F800ST" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "K1200GT" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "K1200R" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "K1200S" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1150R" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1200GS ADVENTURE" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1200R" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1200S" },
  { type: "motorcycle", year: 2006, make: "BMW", model: "R1200ST" },
  { type: "motorcycle", year: 2006, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2006, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2006, make: "BUELL", model: "XB12S LIGHTNING" },
  { type: "motorcycle", year: 2006, make: "BUELL", model: "XB12X ULYSSES" },
  { type: "motorcycle", year: 2006, make: "DUCATI", model: "999" },
  { type: "motorcycle", year: 2006, make: "DUCATI", model: "999R" },
  { type: "motorcycle", year: 2006, make: "DUCATI", model: "999S" },
  { type: "motorcycle", year: 2006, make: "DUCATI", model: "MONSTER S2R" },
  { type: "motorcycle", year: 2006, make: "DUCATI", model: "MULTISTRADA 620" },
  { type: "motorcycle", year: 2006, make: "DUCATI", model: "ST3" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHRCI ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHRI ROAD KING" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHRS ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHRSI ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHTCI ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHTCUI ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHX STREET GLIDE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLHXI STREET GLIDE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLSTFI FAT BOY" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLSTI HERITAGE SOFTAIL" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLSTNI SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FLTRI ROAD GLIDE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXDI DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXDLI DYNA LOW RIDER" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXDWGI DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXSTBI NIGHT TRAIN" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXSTDI SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXSTI SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "FXSTS SPRINGER SOFTAIL" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "VRSCA V-ROD" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "VRSCD NIGHT ROD" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "VRSCR STREET ROD" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2006, make: "HARLEY DAVIDSON", model: "XL883 SPORTSTER" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CR125R" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CR250R" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "CRF450X" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "VTX1300C" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "VTX1300S" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "VTX1800S" },
  { type: "motorcycle", year: 2006, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2006, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2006, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2006, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2006, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2006, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2006, make: "HYOSUNG", model: "GV650" },
  { type: "motorcycle", year: 2006, make: "KAWASAKI", model: "KDX200" },
  { type: "motorcycle", year: 2006, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2006, make: "KAWASAKI", model: "KLX125" },
  { type: "motorcycle", year: 2006, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2006, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2006, make: "KAWASAKI", model: "Z750S" },
  { type: "motorcycle", year: 2006, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2006, make: "KTM", model: "950 SUPERMOTO" },
  { type: "motorcycle", year: 2006, make: "KTM", model: "990 ADVENTURE" },
  { type: "motorcycle", year: 2006, make: "KYMCO", model: "XCITING 500" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "GS500F" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2006, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "DAYTONA 675" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "DAYTONA 955I" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "ROCKET III CLASSIC" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "SCRAMBLER" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "SPEED FOUR" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2006, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2006, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2006, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2006, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2006, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "FJR1300AE" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "TTR250" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YZF-R6S" },
  { type: "motorcycle", year: 2006, make: "YAMAHA", model: "YZF600R" },
  { type: "motorcycle", year: 2005, make: "APRILIA", model: "SCARABEO 250" },
  { type: "motorcycle", year: 2005, make: "APRILIA", model: "TUONO 125" },
  { type: "motorcycle", year: 2005, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2005, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2005, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "F650CS" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "K1200GT" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "K1200R" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "K1200RS" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "K1200S" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1100S" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1150GS ADVENTURE" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1150R" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1150RT" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1200RT" },
  { type: "motorcycle", year: 2005, make: "BMW", model: "R1200ST" },
  { type: "motorcycle", year: 2005, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2005, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2005, make: "BUELL", model: "XB12S LIGHTNING" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "749" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "749R" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "749S" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "999" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "999R" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "999S" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "MONSTER S2R" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "MULTISTRADA 620" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "ST3" },
  { type: "motorcycle", year: 2005, make: "DUCATI", model: "ST4S" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHRCI ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHRI ROAD KING" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHRS ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHRSI ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHTCI ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLHTCUI ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLSTFI FAT BOY" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLSTN SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLSTNI SOFTAIL DELUXE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FLTRI ROAD GLIDE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXDI DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXDLI DYNA LOW RIDER" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXDWGI DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXSTBI NIGHT TRAIN" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXSTDI SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXSTI SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "FXSTS SPRINGER SOFTAIL" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "VRSCA V-ROD" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "VRSCB V-ROD" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2005, make: "HARLEY DAVIDSON", model: "XL883 SPORTSTER" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CR125R" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CR250R" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "CRF450X" },
  { type: "car", year: 2010, make: "AUDI", model: "A1" },
{ type: "car", year: 2011, make: "AUDI", model: "A1" },
{ type: "car", year: 2012, make: "AUDI", model: "A1" },
{ type: "car", year: 2013, make: "AUDI", model: "A1" },
{ type: "car", year: 2014, make: "AUDI", model: "A1" },
{ type: "car", year: 2015, make: "AUDI", model: "A1" },
{ type: "car", year: 2016, make: "AUDI", model: "A1" },
{ type: "car", year: 2017, make: "AUDI", model: "A1" },
{ type: "car", year: 2018, make: "AUDI", model: "A1" },
{ type: "car", year: 2019, make: "AUDI", model: "A1" },
{ type: "car", year: 2020, make: "AUDI", model: "A1" },
{ type: "car", year: 2021, make: "AUDI", model: "A1" },
{ type: "car", year: 2022, make: "AUDI", model: "A1" },
{ type: "car", year: 2023, make: "AUDI", model: "A1" },
{ type: "car", year: 2024, make: "AUDI", model: "A1" },
{ type: "car", year: 2025, make: "AUDI", model: "A1" },
{ type: "car", year: 2026, make: "AUDI", model: "A1" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "VTX1300C" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "VTX1300S" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "VTX1800S" },
  { type: "motorcycle", year: 2005, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2005, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2005, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2005, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2005, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2005, make: "HUSQVARNA", model: "WR125" },
  { type: "motorcycle", year: 2005, make: "HYOSUNG", model: "GV250" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "KDX200" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "KLR250" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "KLX125" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "KX125" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2005, make: "KAWASAKI", model: "Z750S" },
  { type: "motorcycle", year: 2005, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2005, make: "KTM", model: "640 SUPERMOTO" },
  { type: "motorcycle", year: 2005, make: "KTM", model: "950 ADVENTURE" },
  { type: "motorcycle", year: 2005, make: "KTM", model: "950 ADVENTURE S" },
  { type: "motorcycle", year: 2005, make: "KTM", model: "950 SUPERMOTO" },
  { type: "motorcycle", year: 2005, make: "KYMCO", model: "XCITING 500" },
  { type: "motorcycle", year: 2005, make: "MOTO GUZZI", model: "CALIFORNIA EV" },
  { type: "motorcycle", year: 2005, make: "PIAGGIO", model: "TYPHOON" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "DR-Z400SM" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "GS500F" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2005, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "BONNEVILLE T100" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "DAYTONA 955I" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "SPEED FOUR" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2005, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2005, make: "VICTORY", model: "HAMMER" },
  { type: "motorcycle", year: 2005, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2005, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2005, make: "VICTORY", model: "VEGAS 8-BALL" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "FJR1300" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "FJR1300AE" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "TTR250" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "YP400 MAJESTY" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2005, make: "YAMAHA", model: "YZF600R" },
  { type: "motorcycle", year: 2004, make: "APRILIA", model: "ATLANTIC 500" },
  { type: "motorcycle", year: 2004, make: "APRILIA", model: "RSV MILLE" },
  { type: "motorcycle", year: 2004, make: "APRILIA", model: "SCARABEO 250" },
  { type: "motorcycle", year: 2004, make: "APRILIA", model: "TUONO 125" },
  { type: "motorcycle", year: 2004, make: "BIG DOG", model: "CHOPPER" },
  { type: "motorcycle", year: 2004, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2004, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2004, make: "BIG DOG", model: "RIDGEBACK" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "F650CS" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "K1200GT" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "K1200RS" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1100S" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1150GS" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1150GS ADVENTURE" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1150R" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1150RS" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1150RT" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1200C INDEPENDENT" },
  { type: "motorcycle", year: 2004, make: "BMW", model: "R1200GS" },
  { type: "motorcycle", year: 2004, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2004, make: "BUELL", model: "XB12R FIREBOLT" },
  { type: "motorcycle", year: 2004, make: "BUELL", model: "XB12S LIGHTNING" },
  { type: "motorcycle", year: 2004, make: "BUELL", model: "XB9S LIGHTNING" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "749" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "749R" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "749S" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "999" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "999R" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "999S" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "MONSTER 800" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "ST3" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "ST4" },
  { type: "motorcycle", year: 2004, make: "DUCATI", model: "ST4S" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHRCI ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHRI ROAD KING" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHRS ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHRSI ROAD KING CUSTOM" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHTCI ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLHTCUI ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLSTFI FAT BOY" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FLTRI ROAD GLIDE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXDI DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXDLI DYNA LOW RIDER" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXDWGI DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXSTBI NIGHT TRAIN" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXSTDI SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXSTI SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "FXSTS SPRINGER SOFTAIL" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "VRSCA V-ROD" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "VRSCB V-ROD" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2004, make: "HARLEY DAVIDSON", model: "XL883 SPORTSTER" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "CBR1000RR" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "CR125R" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "CR250R" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "CRF250R" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "CRF250X" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "VTX1300C" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "VTX1300S" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "VTX1800S" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "XR250R" },
  { type: "motorcycle", year: 2004, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2004, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2004, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2004, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2004, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2004, make: "HUSQVARNA", model: "WR125" },
  { type: "motorcycle", year: 2004, make: "HUSQVARNA", model: "WR250" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "KDX200" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "KLR250" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "KLX125" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "KX125" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2004, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2004, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2004, make: "KTM", model: "640 SUPERMOTO" },
  { type: "motorcycle", year: 2004, make: "KTM", model: "950 ADVENTURE" },
  { type: "motorcycle", year: 2004, make: "KTM", model: "950 ADVENTURE S" },
  { type: "motorcycle", year: 2004, make: "MOTO GUZZI", model: "CALIFORNIA EV" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "DR-Z400" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "GS500F" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "LS650 SAVAGE" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "RMZ250" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2004, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "DAYTONA 600" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "DAYTONA 955I" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "ROCKET III" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "SPEED FOUR" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "SPRINT RS" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "THRUXTON" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "THUNDERBIRD SPORT" },
  { type: "motorcycle", year: 2004, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2004, make: "VICTORY", model: "KINGPIN" },
  { type: "motorcycle", year: 2004, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "FJR1300" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "TTR250" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2004, make: "YAMAHA", model: "YZF600R" },
  { type: "motorcycle", year: 2003, make: "APRILIA", model: "ATLANTIC 500" },
  { type: "motorcycle", year: 2003, make: "APRILIA", model: "RSV MILLE" },
  { type: "motorcycle", year: 2003, make: "BIG DOG", model: "CHOPPER" },
  { type: "motorcycle", year: 2003, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2003, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "F650CS" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "K1200GT" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "K1200RS" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1100S" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1150GS" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1150GS ADVENTURE" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1150R" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1150RS" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1150RT" },
  { type: "motorcycle", year: 2003, make: "BMW", model: "R1200C INDEPENDENT" },
  { type: "motorcycle", year: 2003, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2003, make: "BUELL", model: "XB9S LIGHTNING" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "749" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "749S" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "996S" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "999" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "999R" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "999S" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "ST2" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "ST4" },
  { type: "motorcycle", year: 2003, make: "DUCATI", model: "ST4S" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLHRCI ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLHRI ROAD KING" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLHTCI ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLHTCUI ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLSTFI FAT BOY" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FLTRI ROAD GLIDE" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXSTBI NIGHT TRAIN" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXSTDI SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXSTI SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "FXSTS SPRINGER SOFTAIL" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "VRSCA V-ROD" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "XLH1200" },
  { type: "motorcycle", year: 2003, make: "HARLEY DAVIDSON", model: "XLH883" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "CBR600RR" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "CBR954RR" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "CR125R" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "CR250R" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "ST1100" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "ST1300" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "VTX1300S" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "VTX1800S" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "XR250R" },
  { type: "motorcycle", year: 2003, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2003, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2003, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2003, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2003, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2003, make: "HUSQVARNA", model: "WR125" },
  { type: "motorcycle", year: 2003, make: "HUSQVARNA", model: "WR250" },
  { type: "motorcycle", year: 2003, make: "INDIAN", model: "CHIEF" },
  { type: "motorcycle", year: 2003, make: "INDIAN", model: "SCOUT" },
  { type: "motorcycle", year: 2003, make: "INDIAN", model: "SPIRIT" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "KDX200" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "KLR250" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "KLX125" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "KX125" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2003, make: "KAWASAKI", model: "Z1000" },
  { type: "motorcycle", year: 2003, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2003, make: "KTM", model: "640 SUPERMOTO" },
  { type: "motorcycle", year: 2003, make: "KTM", model: "950 ADVENTURE" },
  { type: "motorcycle", year: 2003, make: "MOTO GUZZI", model: "CALIFORNIA EV" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "AN400 BURGMAN" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "DR-Z400" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "LS650 SAVAGE" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "SV650S" },
  { type: "motorcycle", year: 2003, make: "SUZUKI", model: "TL1000R" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "DAYTONA 600" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "DAYTONA 955I" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "SPEED FOUR" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "SPEEDMASTER" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "SPRINT RS" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "THUNDERBIRD SPORT" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "TROPHY 1200" },
  { type: "motorcycle", year: 2003, make: "TRIUMPH", model: "TT600" },
  { type: "motorcycle", year: 2003, make: "VICTORY", model: "VEGAS" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "FJR1300" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "TTR250" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "WR450F" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2003, make: "YAMAHA", model: "YZF600R" },
  { type: "motorcycle", year: 2002, make: "APRILIA", model: "ATLANTIC 500" },
  { type: "motorcycle", year: 2002, make: "APRILIA", model: "PEGASO 650" },
  { type: "motorcycle", year: 2002, make: "APRILIA", model: "RSV MILLE" },
  { type: "motorcycle", year: 2002, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2002, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "F650CS" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "K1200RS" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1100S" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1150GS" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1150GS ADVENTURE" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1150R" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1150RS" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1150RT" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1200C" },
  { type: "motorcycle", year: 2002, make: "BMW", model: "R1200C INDEPENDENT" },
  { type: "motorcycle", year: 2002, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2002, make: "BUELL", model: "M2 CYCLONE" },
  { type: "motorcycle", year: 2002, make: "BUELL", model: "X1 LIGHTNING" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "748" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "748R" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "748S" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "750" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "750 SPORT" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "900" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "996" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "996S" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "998R" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "998S" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "MH900E" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "MONSTER 750" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "MONSTER 900" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "MONSTER S4" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "ST2" },
  { type: "motorcycle", year: 2002, make: "DUCATI", model: "ST4S" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLHRCI ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLHRI ROAD KING" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLHTCI ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLHTCUI ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLSTFI FAT BOY" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLTR ROAD GLIDE" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FLTRI ROAD GLIDE" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXSTBI NIGHT TRAIN" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXSTDI SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXSTI SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "FXSTS SPRINGER SOFTAIL" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "VRSCA V-ROD" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "XLH1200" },
  { type: "motorcycle", year: 2002, make: "HARLEY DAVIDSON", model: "XLH883" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "CBR954RR" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "CR125R" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "CR250R" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "PASSPORT" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "ST1100" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "VTX1800C" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "VTX1800S" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "XR200R" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "XR250R" },
  { type: "motorcycle", year: 2002, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "TE250" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "TE450" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "TE510" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "TE570" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "WR125" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "WR250" },
  { type: "motorcycle", year: 2002, make: "HUSQVARNA", model: "WR360" },
  { type: "motorcycle", year: 2002, make: "INDIAN", model: "CHIEF" },
  { type: "motorcycle", year: 2002, make: "INDIAN", model: "SCOUT" },
  { type: "motorcycle", year: 2002, make: "INDIAN", model: "SPIRIT" },
  { type: "motorcycle", year: 2002, make: "KAWASAKI", model: "KDX200" },
  { type: "motorcycle", year: 2002, make: "KAWASAKI", model: "KLR250" },
  { type: "motorcycle", year: 2002, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2002, make: "KAWASAKI", model: "KX125" },
  { type: "motorcycle", year: 2002, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2002, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2002, make: "KTM", model: "640 SUPERMOTO" },
  { type: "motorcycle", year: 2002, make: "MOTO GUZZI", model: "CALIFORNIA EV" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "DR-Z400" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "GS500" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "LS650 SAVAGE" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2002, make: "SUZUKI", model: "TL1000R" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "AMERICA" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "DAYTONA 955I" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "SPEED FOUR" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "SPRINT RS" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "THUNDERBIRD SPORT" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "TROPHY 1200" },
  { type: "motorcycle", year: 2002, make: "TRIUMPH", model: "TT600" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "TTR250" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2002, make: "YAMAHA", model: "YZF600R" },
  { type: "motorcycle", year: 2001, make: "APRILIA", model: "ATLANTIC 500" },
  { type: "motorcycle", year: 2001, make: "APRILIA", model: "PEGASO 650" },
  { type: "motorcycle", year: 2001, make: "APRILIA", model: "RSV MILLE" },
  { type: "motorcycle", year: 2001, make: "BIG DOG", model: "MASTIFF" },
  { type: "motorcycle", year: 2001, make: "BIG DOG", model: "PITBULL" },
  { type: "motorcycle", year: 2001, make: "BIMOTA", model: "SB8R" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "F650CS" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "F650GS" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "F650GS DAKAR" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "K1200LT" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "K1200RS" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1100RT" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1100S" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1150GS" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1150R" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1150RS" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1150RT" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1200C" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R1200C INDEPENDENT" },
  { type: "motorcycle", year: 2001, make: "BMW", model: "R850R" },
  { type: "motorcycle", year: 2001, make: "BUELL", model: "BLAST" },
  { type: "motorcycle", year: 2001, make: "BUELL", model: "M2 CYCLONE" },
  { type: "motorcycle", year: 2001, make: "BUELL", model: "S3 THUNDERBOLT" },
  { type: "motorcycle", year: 2001, make: "BUELL", model: "X1 LIGHTNING" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "748" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "748R" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "748S" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "750 SPORT" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "900" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "996 BIPOSTO" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "996S" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "MH900E" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "MONSTER 750" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "MONSTER 900" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "MONSTER S4" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "ST2" },
  { type: "motorcycle", year: 2001, make: "DUCATI", model: "ST4" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLHR ROAD KING" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLHRCI ROAD KING CLASSIC" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLHRI ROAD KING" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLHTC ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLHTCI ELECTRA GLIDE CLASSIC" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLHTCUI ELECTRA GLIDE ULTRA CLASSIC" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLSTC HERITAGE SOFTAIL CLASSIC" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLSTF FAT BOY" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLSTFI FAT BOY" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLTR ROAD GLIDE" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FLTRI ROAD GLIDE" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXD DYNA SUPER GLIDE" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXDL DYNA LOW RIDER" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXDWG DYNA WIDE GLIDE" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXST SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXSTB NIGHT TRAIN" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXSTBI NIGHT TRAIN" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXSTD SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXSTDI SOFTAIL DEUCE" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXSTI SOFTAIL STANDARD" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "FXSTS SPRINGER SOFTAIL" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "XL1200C SPORTSTER 1200 CUSTOM" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "XLH1200" },
  { type: "motorcycle", year: 2001, make: "HARLEY DAVIDSON", model: "XLH883" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "CR125R" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "CR250R" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "CR500R" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "PASSPORT" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "ST1100" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "XR200R" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "XR250R" },
  { type: "motorcycle", year: 2001, make: "HONDA", model: "XR650R" },
  { type: "motorcycle", year: 2001, make: "HUSQVARNA", model: "TE400" },
  { type: "motorcycle", year: 2001, make: "HUSQVARNA", model: "TE570" },
  { type: "motorcycle", year: 2001, make: "HUSQVARNA", model: "TE610" },
  { type: "motorcycle", year: 2001, make: "HUSQVARNA", model: "WR125" },
  { type: "motorcycle", year: 2001, make: "HUSQVARNA", model: "WR250" },
  { type: "motorcycle", year: 2001, make: "HUSQVARNA", model: "WR360" },
  { type: "motorcycle", year: 2001, make: "INDIAN", model: "CHIEF" },
  { type: "motorcycle", year: 2001, make: "INDIAN", model: "SCOUT" },
  { type: "motorcycle", year: 2001, make: "INDIAN", model: "SPIRIT" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "KDX200" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "KE100" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "KLR250" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "KLR650" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "KX125" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "KX250" },
  { type: "motorcycle", year: 2001, make: "KAWASAKI", model: "W650" },
  { type: "motorcycle", year: 2001, make: "KTM", model: "640 ADVENTURE" },
  { type: "motorcycle", year: 2001, make: "KTM", model: "640 SUPERMOTO" },
  { type: "motorcycle", year: 2001, make: "MOTO GUZZI", model: "CALIFORNIA EV" },
  { type: "motorcycle", year: 2001, make: "MOTO GUZZI", model: "V11 SPORT" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "DR-Z400" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "DR-Z400S" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "DR650SE" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "GS500" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "GSX-R1000" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "GSX-R600" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "GSX-R750" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "GSX1300R HAYABUSA" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "GZ250" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "LS650 SAVAGE" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "RM125" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "RM250" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "SV650" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "TL1000R" },
  { type: "motorcycle", year: 2001, make: "SUZUKI", model: "TL1000S" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "ADVENTURER" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "BONNEVILLE" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "DAYTONA 955I" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "LEGEND TT" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "SPEED TRIPLE" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "SPRINT RS" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "SPRINT ST" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "THUNDERBIRD" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "THUNDERBIRD SPORT" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "TIGER" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "TROPHY 1200" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "TROPHY 900" },
  { type: "motorcycle", year: 2001, make: "TRIUMPH", model: "TT600" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "TTR250" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "TW200" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "WR250F" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "XV250 VIRAGO" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "XVZ1300TF ROYAL STAR VENTURE" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "YZ125" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "YZ250" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "YZF-R1" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "YZF-R6" },
  { type: "motorcycle", year: 2001, make: "YAMAHA", model: "YZF600R" }
];